
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kPxjF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $31TvY = parcelRequire("31TvY");

const $dd3be42c2d7fc81b$export$cfa3cd08d675e56e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { variableName: variableName, value: value } = t0;
    const t1 = `#${(0, $31TvY.gridRootId)} { ${variableName}: ${value}px }`;
    let t2;
    if ($[0] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style", null, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    return t2;
} : ({ variableName: variableName, value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style", null, `#${(0, $31TvY.gridRootId)} { ${variableName}: ${value}px }`);
module.exports["HoistCssVarToLocalGrid"] = $dd3be42c2d7fc81b$export$cfa3cd08d675e56e;

});

parcelRegister("31TvY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");











var $bB0i2 = parcelRequire("bB0i2");


var $3fPCt = parcelRequire("3fPCt");

/**
 * Layers that are registered without a namespace are grouped under this fallback namespace.
 */ const $955c54956ec6c42a$var$noNamespaceSymbol = Symbol('no-namespace');
/**
 * Returns the number of open layers across all namespaces.
 * It calculates the sum of the set sizes in the map, which corresponds to the number of open layers.
 */ function $955c54956ec6c42a$var$getTotalOpenLayerCount(registry) {
    return Array.from(registry.values()).reduce((acc, listeners)=>acc + listeners.size, 0);
}
/**
 * Returns the number of layers in the set that match the type filter.
 */ function $955c54956ec6c42a$var$getLayerCountWithFilter({ layers: layers, type: type }) {
    return Array.from(layers.values()).filter((layer)=>layer.type === type).length;
}
/**
 * Returns the layer count change listeners set for the namespace.
 * If there are no listeners registered for the namespace yet, it creates a new set
 * and adds it to the registry, then returns the new set.
 */ function $955c54956ec6c42a$var$getListeners({ registry: registry, namespace: namespace }) {
    // 1. If there are existing listeners for this namespace, return the existing set.
    const existingListeners = registry.get(namespace);
    if (existingListeners) return existingListeners;
    // 2. If there are no existing listeners for this namespace, create a new set for this namespace
    // and add it to the registry, then return the new set.
    const newSet = new Set();
    registry.set(namespace, newSet);
    return newSet;
}
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $955c54956ec6c42a$var$createInternalAPI() {
    /**
   * The layer count change listeners for each namespace.
   */ const namespaceToChangeListenerRegistry = new Map();
    /**
   * The registered layers for each namespace.
   * Each layer registers with an `onClose` callback, and optionally with a layer type (`type`).
   * **When the layer is open**, its `onClose`
   * callback is registered in this set along with its type.
   *
   * This data structure is also used determine the number of open layers.
   */ const namespaceToLayerRegistry = new Map();
    /**
   * Calls the appropriate layer count change listeners after the number of open layers has changed.
   */ function callChangeListeners({ namespace: namespace, newCount: newCount }) {
        // 1. Call listeners registered to the specific namespace
        if (namespace) {
            const listenersForNamespace = namespaceToChangeListenerRegistry.get(namespace);
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(listenersForNamespace ?? []).forEach((listener)=>listener({
                    count: newCount
                }));
        }
        // 2. Call listeners registered without a specific namespace
        const noNamespaceListeners = namespaceToChangeListenerRegistry.get($955c54956ec6c42a$var$noNamespaceSymbol);
        // Return early if no listeners
        if (!noNamespaceListeners) return;
        // For the listeners without a specific namespace, we need to provide the sum of all namespace counts
        // as the callback `count` arg.
        const totalCount = $955c54956ec6c42a$var$getTotalOpenLayerCount(namespaceToLayerRegistry);
        Array.from(noNamespaceListeners).forEach((listener)=>listener({
                count: totalCount
            }));
    }
    /**
   * Returns the current count of open layers.
   *
   * - If a namespace is provided, the count for that namespace is returned.
   * - If a type is provided, only layers of that type are counted.
   * - If both are provided, only layers matching both criteria are counted.
   * - Otherwise, the sum of all namespace counts is returned.
   */ function getCount({ namespace: namespace, type: type } = {}) {
        if (namespace) {
            // 1. A namespace was requested, so we count only layers in that namespace
            const layersForNamespace = namespaceToLayerRegistry.get(namespace);
            if (!layersForNamespace) return 0;
            if (type) // Count layers in the namespace that match the type filter
            return $955c54956ec6c42a$var$getLayerCountWithFilter({
                layers: layersForNamespace,
                type: type
            });
            // No type filter - just return the size of the set
            return layersForNamespace.size;
        }
        // 2. A specific namespace was not requested, so we count across all namespaces
        if (type) // Count layers in each namespace that match the type filter
        return Array.from(namespaceToLayerRegistry.values()).reduce((acc, layers)=>acc + $955c54956ec6c42a$var$getLayerCountWithFilter({
                layers: layers,
                type: type
            }), 0);
        // No type filter - count all layers across all namespaces
        return $955c54956ec6c42a$var$getTotalOpenLayerCount(namespaceToLayerRegistry);
    }
    /**
   * Adds a listener that will be called when the number of open layers changes.
   *
   * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
   */ function onChange(listener, { namespace: providedNamespace } = {}) {
        /**
     * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
     * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
     * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
     */ function wrapped(...args) {
            listener(...args);
        }
        const namespace = providedNamespace ?? $955c54956ec6c42a$var$noNamespaceSymbol;
        const listenersForNamespace = $955c54956ec6c42a$var$getListeners({
            namespace: namespace,
            registry: namespaceToChangeListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToChangeListenerRegistry.delete(namespace);
        };
    }
    /**
   * Adds a listener to the registry that tells the observer how to close the layer component.
   * The listener should only be added if the layer is open. This is handled by `useNotifyOpenLayerObserver`.
   *
   * All close listeners will be called by the observer when `closeLayers` is called.
   *
   * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
   */ function onClose(listener, { namespace: providedNamespace, type: type }) {
        const wrapped = {
            listener: listener,
            type: type
        };
        const namespace = providedNamespace ?? $955c54956ec6c42a$var$noNamespaceSymbol;
        const listenersForNamespace = $955c54956ec6c42a$var$getListeners({
            namespace: namespace,
            registry: namespaceToLayerRegistry
        });
        listenersForNamespace.add(wrapped);
        callChangeListeners({
            namespace: providedNamespace,
            newCount: listenersForNamespace.size
        });
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            callChangeListeners({
                namespace: providedNamespace,
                newCount: listenersForNamespace.size
            });
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToLayerRegistry.delete(namespace);
        };
    }
    /**
   * Closes all open layers registered across all namespaces.
   */ function closeLayers() {
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(namespaceToLayerRegistry.values()).forEach((listeners)=>{
            Array.from(listeners).forEach(({ listener: listener })=>listener());
        });
    }
    const internalAPI = {
        getCount: getCount,
        onChange: onChange,
        onClose: onClose,
        closeLayers: closeLayers
    };
    return internalAPI;
}
const $955c54956ec6c42a$export$97afddda23bcd287 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function OpenLayerObserver(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    const [internalAPI] = (0, $cozmU.useState)($955c54956ec6c42a$var$_temp);
    const parentContext = (0, $cozmU.useContext)((0, $3fPCt.OpenLayerObserverContext));
    (0, $bB0i2.default)(parentContext === null, "`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.");
    let t1;
    if ($[0] !== children || $[1] !== internalAPI) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3fPCt.OpenLayerObserverContext).Provider, {
            value: internalAPI
        }, children);
        $[0] = children;
        $[1] = internalAPI;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function OpenLayerObserver({ children: children }) {
    // Using state to ensure a stable reference to a single instance.
    const [internalAPI] = (0, $cozmU.useState)(()=>$955c54956ec6c42a$var$createInternalAPI());
    const parentContext = (0, $cozmU.useContext)((0, $3fPCt.OpenLayerObserverContext));
    // We don't expect a parent context. If there is one, that means this component is nested within another `OpenLayerObserver`
    // - which we don't support.
    (0, $bB0i2.default)(parentContext === null, '`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3fPCt.OpenLayerObserverContext).Provider, {
        value: internalAPI
    }, children);
};
function $955c54956ec6c42a$var$_temp() {
    return $955c54956ec6c42a$var$createInternalAPI();
}



var $iDrrr = parcelRequire("iDrrr");


























var $4aRua = parcelRequire("4aRua");

















var $7vK9E = parcelRequire("7vK9E");


var $cbY7C = parcelRequire("cbY7C");

function $118b693fb78df8fe$export$5fed9cc43865dc7e(element) {
    /**
   * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
   * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
   *
   * Our slots are not interactive, so this is required.
   *
   * In the future we may want to check if there is an existing `tabindex` attribute,
   * as custom skip linked elements might already have one.
   */ element.setAttribute('tabindex', '-1');
    /**
   * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
   *
   * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
   *
   * - mess with click events
   * - potentially cause a focus ring to be always visible
   */ (0, $cbY7C.bind)(element, {
        type: 'blur',
        listener () {
            element.removeAttribute('tabindex');
        },
        options: {
            // Using a one-time listener so it cleans itself up
            once: true
        }
    });
    /**
   * Move focus to the slot or custom target.
   *
   * Calling `.focus()` will also scroll the element into view:
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
   */ element.focus({
        // Forces the focus ring to appear after moving focus to the slot
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
        focusVisible: true
    });
}


const $107958281b57732e$var$styles = {
    skipLinkListItem: "_43nrzTPgdg",
    skipLinkListItemNew: "_4c065U2ADO"
};
const $107958281b57732e$export$ef95c37428582a65 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { id: id, children: children, onBeforeNavigate: onBeforeNavigate, navigate: navigate } = t0;
    const href = `#${id}`;
    let t1;
    if ($[0] !== id || $[1] !== navigate || $[2] !== onBeforeNavigate) {
        t1 = (event)=>{
            event.preventDefault();
            if (navigate && (0, $iDrrr.fg)("platform_dst_nav4_skip_link_a11y_1")) navigate();
            else {
                const target = document.getElementById(id);
                if (!target) return;
                if (!(0, $iDrrr.fg)("platform_dst_nav4_skip_link_a11y_1")) onBeforeNavigate?.();
                (0, $118b693fb78df8fe$export$5fed9cc43865dc7e)(target);
            }
            window.scrollTo(0, 0);
        };
        $[0] = id;
        $[1] = navigate;
        $[2] = onBeforeNavigate;
        $[3] = t1;
    } else t1 = $[3];
    const handleClick = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $107958281b57732e$var$styles.skipLinkListItem,
            (0, $iDrrr.fg)("platform_dst_nav4_skip_link_a11y_1") && $107958281b57732e$var$styles.skipLinkListItemNew
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== children || $[6] !== handleClick || $[7] !== href) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            className: t2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            tabIndex: 0,
            href: href,
            onClick: handleClick
        }, children));
        $[5] = children;
        $[6] = handleClick;
        $[7] = href;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ id: id, children: children, onBeforeNavigate: onBeforeNavigate, navigate: navigate })=>{
    const href = `#${id}`;
    const handleClick = (0, $cozmU.useCallback)((event)=>{
        event.preventDefault();
        if (navigate && (0, $iDrrr.fg)('platform_dst_nav4_skip_link_a11y_1')) /**
       * The consumer takes over the navigation effect (e.g. expanding the
       * side nav and focusing the first nav item). The universal pre/post
       * work below (e.g. `window.scrollTo`) still runs around it.
       */ navigate();
        else {
            // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
            const target = document.getElementById(id);
            if (!target) return;
             /**
         * Legacy `onBeforeNavigate` hook. Intentionally NOT called when
         * `platform_dst_nav4_skip_link_a11y_1` is enabled — under the gate the
         * gate-on path delegates state mutation + focus management to `navigate`,
         * and `SkipLinksPopup` injects its popup-close behavior into the
         * `navigate` wrapper instead of relying on this hook.
         *
         * This callback can be removed entirely on gate cleanup.
         */ 
            if (!(0, $iDrrr.fg)('platform_dst_nav4_skip_link_a11y_1')) onBeforeNavigate?.();
            (0, $118b693fb78df8fe$export$5fed9cc43865dc7e)(target);
        }
        /**
     * We should look into removing this, or only calling it in specific cases.
     *
     * It means if the skip link element is in the window scroll container
     * then it might not get scrolled into view properly.
     *
     * This is not an issue for the default slots on desktop, but could break custom skip links or
     * even `Aside` on mobile.
     *
     * Keeping existing behavior for now because resetting the window scroll is actually good for some cases.
     * E.g. jumping to main / aside it makes sense to look at the start of the content.
     */ window.scrollTo(0, 0);
    }, [
        id,
        onBeforeNavigate,
        navigate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
        className: (0, $hekY6.default)([
            $107958281b57732e$var$styles.skipLinkListItem,
            (0, $iDrrr.fg)('platform_dst_nav4_skip_link_a11y_1') && $107958281b57732e$var$styles.skipLinkListItemNew
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor /**
            * It looks like Safari handles link clicks during `pointerdown` unless it has an explicit `tabIndex={0}` :/
            *
            * Adding this explicitly makes the behavior consistent between browsers and lets us `event.preventDefault()`
            * in the `onClick` handler.
            */ ), {
        tabIndex: 0,
        href: href,
        onClick: handleClick
    }, children));
};















var $9kbTQ = parcelRequire("9kbTQ");


var $ad7Ou = parcelRequire("ad7Ou");


var $lmzCg = parcelRequire("lmzCg");


var $5wHqn = parcelRequire("5wHqn");



const $a165234097fd20b4$var$contentStyles = {
    root: "_4c065U2ADO _2Y7lL45zaO _3iDTPbQ4SZ _0aFT5vbt8w _42Yu6BGYeU",
    skipLinkList: "_3iDTPbQ4SZ _0aFT5vbt8w _4zmD5lTNeH _0aNu0LYbGa _43nrzTPgdg _0LQT5EPgdg",
    label: "_2sNsIgd8bj _4c065U2ADO _1UtDYzZpcK"
};
const $a165234097fd20b4$var$triggerStyles = {
    root: "_0bjKvDKxmn _3hxITiYbGa _1mT5xdy1CL _3iC0zd8HPE _2I62gz8HPE _42Yu6BvQQr _1YKVNsdnbC _0KLXruoI2d _0j9PH9GYeU _0O4CrC7dHp",
    isOpen: "_1YKVNsdnbC _1VJPca0OLL"
};
const $a165234097fd20b4$var$popupOffset = [
    0,
    0
]; /**
                                               * Skip links shown behind `platform_dst_nav4_skip_link_a11y_1`: a single focus-revealed
                                               * control opens a dialog listing skip targets.
                                               */ 
const $a165234097fd20b4$export$759eb47efaee9eec = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SkipLinksPopup(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { label: title, triggerLabel: triggerLabel, testId: testId, links: links } = t0;
    const titleId = (0, $cozmU.useId)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const triggerRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setIsOpen(true);
        };
        $[0] = t1;
    } else t1 = $[0];
    const openPopup = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            (0, $9kbTQ.flushSync)(()=>{
                setIsOpen(false);
            });
        };
        $[1] = t2;
    } else t2 = $[1];
    const closePopup = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            closePopup();
            if (document.activeElement === document.body) triggerRef.current?.focus();
        };
        $[2] = t3;
    } else t3 = $[2];
    const onClose = t3;
    const t4 = testId ? `${testId}--skip-links-container` : undefined;
    let t5;
    if ($[3] !== links || $[4] !== testId || $[5] !== title || $[6] !== titleId) {
        t5 = ()=>/*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $a165234097fd20b4$var$contentStyles.root
                ])
            }, /*#__PURE__*/ $cozmU.createElement("div", {
                "data-testid": testId ? `${testId}--skip-links-container--label` : undefined,
                id: titleId,
                className: (0, $hekY6.default)([
                    $a165234097fd20b4$var$contentStyles.label
                ])
            }, title), /*#__PURE__*/ $cozmU.createElement("ol", {
                className: (0, $hekY6.default)([
                    $a165234097fd20b4$var$contentStyles.skipLinkList
                ])
            }, links.map((t6)=>{
                const { id: id, label: label, navigate: navigate } = t6;
                return /*#__PURE__*/ $cozmU.createElement((0, $107958281b57732e$export$ef95c37428582a65), {
                    key: id,
                    id: id,
                    navigate: ()=>{
                        closePopup();
                        if (navigate) {
                            navigate();
                            return;
                        }
                        const target = document.getElementById(id);
                        if (target) (0, $118b693fb78df8fe$export$5fed9cc43865dc7e)(target);
                    }
                }, label);
            })));
        $[3] = links;
        $[4] = testId;
        $[5] = title;
        $[6] = titleId;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== isOpen || $[9] !== testId || $[10] !== triggerLabel) {
        t6 = (triggerProps)=>/*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $a165234097fd20b4$var$triggerStyles.root,
                    isOpen && $a165234097fd20b4$var$triggerStyles.isOpen
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                ...triggerProps,
                ref: (0, $lmzCg.default)([
                    triggerProps.ref,
                    triggerRef
                ]),
                appearance: "primary",
                isSelected: isOpen,
                testId: testId ? `${testId}--skip-links-trigger` : undefined,
                onClick: openPopup
            }, triggerLabel));
        $[8] = isOpen;
        $[9] = testId;
        $[10] = triggerLabel;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== isOpen || $[13] !== t4 || $[14] !== t5 || $[15] !== t6 || $[16] !== titleId) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $5wHqn.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-start",
            shouldRenderToParent: true,
            shouldReturnFocus: false,
            role: "dialog",
            titleId: titleId,
            testId: t4,
            offset: $a165234097fd20b4$var$popupOffset,
            content: t5,
            trigger: t6
        });
        $[12] = isOpen;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
        $[16] = titleId;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : function SkipLinksPopup({ label: title, triggerLabel: triggerLabel, testId: testId, links: links }) {
    const titleId = (0, $cozmU.useId)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const triggerRef = (0, $cozmU.useRef)(null);
    const openPopup = (0, $cozmU.useCallback)(()=>{
        setIsOpen(true);
    }, []); /**
           * Closes the popup.
           *
           * Uses `flushSync` to avoid issues with focus management.
           * This ensures the popup's focus lock is fully released by the time skip links or our `onClose` try to move focus.
           */ 
    const closePopup = (0, $cozmU.useCallback)(()=>{
        (0, $9kbTQ.flushSync)(()=>{
            setIsOpen(false);
        });
    }, []); /**
           * Restores focus to the trigger on close, if it hasn't moved to another element, such as when Esc is pressed instead of a skip link.
           *
           * We need this because using the standard `shouldReturnFocus` on the popup would break the skip link focus behaviour,
           * as focus would always move back to the trigger.
           */ 
    const onClose = (0, $cozmU.useCallback)(()=>{
        closePopup(); // Focus on the body implies a skip link was not clicked
        if (document.activeElement === document.body) triggerRef.current?.focus();
    }, [
        closePopup
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $5wHqn.default), {
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        shouldRenderToParent: true,
        shouldReturnFocus: false,
        role: "dialog",
        titleId: titleId,
        testId: testId ? `${testId}--skip-links-container` : undefined,
        offset: $a165234097fd20b4$var$popupOffset,
        content: ()=>/*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $a165234097fd20b4$var$contentStyles.root
                ])
            }, /*#__PURE__*/ $cozmU.createElement("div", {
                "data-testid": testId ? `${testId}--skip-links-container--label` : undefined,
                id: titleId,
                className: (0, $hekY6.default)([
                    $a165234097fd20b4$var$contentStyles.label
                ])
            }, title), /*#__PURE__*/ $cozmU.createElement("ol", {
                className: (0, $hekY6.default)([
                    $a165234097fd20b4$var$contentStyles.skipLinkList
                ])
            }, links.map(({ id: id, label: label, navigate: navigate })=>/*#__PURE__*/ $cozmU.createElement((0, $107958281b57732e$export$ef95c37428582a65), {
                    key: id,
                    id: id,
                    navigate: ()=>{
                        closePopup();
                        if (navigate) {
                            navigate();
                            return;
                        } // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
                        const target = document.getElementById(id);
                        if (target) (0, $118b693fb78df8fe$export$5fed9cc43865dc7e)(target);
                    }
                }, label)))),
        trigger: (triggerProps)=>/*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $a165234097fd20b4$var$triggerStyles.root,
                    isOpen && $a165234097fd20b4$var$triggerStyles.isOpen
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                ...triggerProps,
                ref: (0, $lmzCg.default)([
                    triggerProps.ref,
                    triggerRef
                ]),
                appearance: "primary",
                isSelected: isOpen,
                testId: testId ? `${testId}--skip-links-trigger` : undefined,
                onClick: openPopup
            }, triggerLabel))
    });
};


const $c988999b182dd3b7$var$styles = {
    root: "_2mHwu81Y8M _0bjKvDKxmn _4c065U8HPE _2Y7lL48HPE _3iDTPbQ4SZ _0aFT5vbt8w _1mT5xdy1CL _3iC0zdkG2W _2I62gzkG2W _0KLXruoI2d _2OUyjtGk8v _42Yu6BvQQr _1YKVNsdnbC _1pp6NdYbGa _3gBTfLGYeU _3Tg68S7dHp _2VJVb2IZbP",
    skipLinkList: "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w _4zmD5lTNeH _0aNu0LYbGa _43nrzTPgdg _0LQT5EPgdg"
}; /**
    * Keydown handler to hide the skip links when escape is pressed.
    *
    * TODO: consider removing this, it doesn't make a lot of sense.
    * The skip links look like a popup but in reality they aren't.
    * Even though we hide them when the user presses Escape, when
    * they press TAB it will reopen the list and move to the next one...
    *
    * One potential option is to use a tree walker to focus on the
    * next focusable element in the DOM (outside the skip links
    * container).
    */ 
const $c988999b182dd3b7$var$closeOnEscape = (event)=>{
    if (event.key !== 'Escape') return;
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) activeElement.blur();
};
const $c988999b182dd3b7$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $c988999b182dd3b7$var$assignIndex(num + 1, arr);
}; /**
    * Sorts an array of skip links by list indexes.
    *
    * Skip links with custom list indexes are positioned first, followed by regular skip links,
    * which are automatically assigned available index positions to avoid conflicts.
    */ 
function $c988999b182dd3b7$var$sortSkipLinks(arr) {
    const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
    if (customLinks.length === 0) return arr;
    const usedIndexes = customLinks.map((a)=>a.listIndex);
    const regularLinksWithIndex = arr.filter((link)=>link.listIndex === undefined).map((link, index)=>{
        const listIndex = $c988999b182dd3b7$var$assignIndex(index, usedIndexes);
        usedIndexes.push(listIndex);
        return {
            ...link,
            listIndex: listIndex
        };
    });
    return [
        ...customLinks,
        ...regularLinksWithIndex
    ].sort((a, b)=>a.listIndex - b.listIndex);
}
const $c988999b182dd3b7$var$isOnlyWhitespaceRegex = /^\s*$/; /**
                                        * A container element for the skip links.
                                        *
                                        * The container element is always rendered in the DOM, but is only visible when
                                        * focus is within the container.
                                        *
                                        * The label is used as the heading of the skip links container. If the provided label is a string
                                        * comprised only of only whitespace (e.g. '' or ' '), the skip link heading element will be removed.
                                        *
                                        * When `platform_dst_nav4_skip_link_a11y_1` is enabled, rendering is delegated to `SkipLinksPopup`.
                                        */ 
const $c988999b182dd3b7$export$fce25a0c32fbc1e1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SkipLinksContainer(t0) {
    const $ = (0, $bDgLe.c)(23);
    const { label: label, triggerLabel: triggerLabel, testId: testId, links: links } = t0;
    let t1;
    if ($[0] !== links) {
        t1 = $c988999b182dd3b7$var$sortSkipLinks(links);
        $[0] = links;
        $[1] = t1;
    } else t1 = $[1];
    const sortedLinks = t1;
    if (sortedLinks.length === 0) return null;
    let t2;
    if ($[2] !== label) {
        t2 = $c988999b182dd3b7$var$isOnlyWhitespaceRegex.test(label);
        $[2] = label;
        $[3] = t2;
    } else t2 = $[3];
    const isEmptyLabel = t2;
    if ((0, $iDrrr.fg)("platform_dst_nav4_skip_link_a11y_1")) {
        let t3;
        if ($[4] !== label || $[5] !== sortedLinks || $[6] !== testId || $[7] !== triggerLabel) {
            t3 = /*#__PURE__*/ $cozmU.createElement((0, $a165234097fd20b4$export$759eb47efaee9eec), {
                label: label,
                triggerLabel: triggerLabel,
                testId: testId,
                links: sortedLinks
            });
            $[4] = label;
            $[5] = sortedLinks;
            $[6] = testId;
            $[7] = triggerLabel;
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    const t3 = testId ? `${testId}--skip-links-container` : undefined;
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            $c988999b182dd3b7$var$styles.root
        ]);
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== isEmptyLabel || $[11] !== label || $[12] !== testId) {
        t5 = !isEmptyLabel && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: "bold",
            testId: testId ? `${testId}--skip-links-container--label` : undefined
        }, label);
        $[10] = isEmptyLabel;
        $[11] = label;
        $[12] = testId;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            $c988999b182dd3b7$var$styles.skipLinkList
        ]);
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== sortedLinks) {
        t7 = sortedLinks.map($c988999b182dd3b7$var$_temp);
        $[15] = sortedLinks;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement("ol", {
            className: t6
        }, t7);
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== t3 || $[20] !== t5 || $[21] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement("div", {
            onKeyDown: $c988999b182dd3b7$var$closeOnEscape,
            "data-testid": t3,
            className: t4
        }, t5, t8);
        $[19] = t3;
        $[20] = t5;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
} : function SkipLinksContainer({ label: label, triggerLabel: triggerLabel, testId: testId, links: links }) {
    const sortedLinks = (0, $cozmU.useMemo)(()=>{
        return $c988999b182dd3b7$var$sortSkipLinks(links);
    }, [
        links
    ]);
    if (sortedLinks.length === 0) return null;
    const isEmptyLabel = $c988999b182dd3b7$var$isOnlyWhitespaceRegex.test(label);
    if ((0, $iDrrr.fg)('platform_dst_nav4_skip_link_a11y_1')) return /*#__PURE__*/ $cozmU.createElement((0, $a165234097fd20b4$export$759eb47efaee9eec), {
        label: label,
        triggerLabel: triggerLabel,
        testId: testId,
        links: sortedLinks
    });
    return /*#__PURE__*/ $cozmU.createElement("div", {
        onKeyDown: $c988999b182dd3b7$var$closeOnEscape,
        "data-testid": testId ? `${testId}--skip-links-container` : undefined,
        className: (0, $hekY6.default)([
            $c988999b182dd3b7$var$styles.root
        ])
    }, !isEmptyLabel && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "bold",
        testId: testId ? `${testId}--skip-links-container--label` : undefined
    }, label), /*#__PURE__*/ $cozmU.createElement("ol", {
        className: (0, $hekY6.default)([
            $c988999b182dd3b7$var$styles.skipLinkList
        ])
    }, sortedLinks.map(({ id: id, label: label_0, onBeforeNavigate: onBeforeNavigate })=>/*#__PURE__*/ $cozmU.createElement((0, $107958281b57732e$export$ef95c37428582a65), {
            key: id,
            id: id,
            onBeforeNavigate: onBeforeNavigate
        }, label_0))));
};
function $c988999b182dd3b7$var$_temp(t0) {
    const { id: id, label: label_0, onBeforeNavigate: onBeforeNavigate } = t0;
    return /*#__PURE__*/ $cozmU.createElement((0, $107958281b57732e$export$ef95c37428582a65), {
        key: id,
        id: id,
        onBeforeNavigate: onBeforeNavigate
    }, label_0);
}



var $7vxJx = parcelRequire("7vxJx");

const $97e6348f917990d2$var$getByDomOrderSortFunction = ()=>{
    const layoutSlots = Array.from(document.querySelectorAll(`[data-layout-slot]`));
    return (a, b)=>{
        const indexA = a.listIndex ?? layoutSlots.indexOf(document.getElementById(a.id));
        const indexB = b.listIndex ?? layoutSlots.indexOf(document.getElementById(b.id));
        /**
     * If they are tied it is because one (or both) is
     * a custom skiplink with a set index.
     *
     * Give the custom skiplink priority.
     */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
const $97e6348f917990d2$export$fe514f9f7b03d46f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SkipLinksProvider(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { children: children, label: label, triggerLabel: triggerLabel, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [links, setLinks] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (skipLinkData)=>{
            setLinks((oldLinks)=>{
                if (oldLinks.some((t3)=>{
                    const { id: id } = t3;
                    return id === skipLinkData.id;
                })) return oldLinks;
                return [
                    ...oldLinks,
                    skipLinkData
                ].sort($97e6348f917990d2$var$getByDomOrderSortFunction());
            });
        };
        $[1] = t2;
    } else t2 = $[1];
    const registerSkipLink = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (id_0)=>{
            setLinks((links_0)=>links_0.filter((link)=>link.id !== id_0));
        };
        $[2] = t3;
    } else t3 = $[2];
    const unregisterSkipLink = t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        $[3] = t4;
    } else t4 = $[3];
    const data = t4;
    const contextValue = data;
    let t5;
    if ($[4] !== label || $[5] !== links || $[6] !== testId || $[7] !== triggerLabel) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c988999b182dd3b7$export$fce25a0c32fbc1e1), {
            label: label,
            triggerLabel: triggerLabel,
            testId: testId,
            links: links
        });
        $[4] = label;
        $[5] = links;
        $[6] = testId;
        $[7] = triggerLabel;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== children || $[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vxJx.SkipLinksContext).Provider, {
            value: contextValue
        }, t5, children);
        $[9] = children;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : function SkipLinksProvider({ children: children, label: label, triggerLabel: triggerLabel, testId: testId }) {
    const [links, setLinks] = (0, $cozmU.useState)([]);
    const registerSkipLink = (0, $cozmU.useCallback)((skipLinkData)=>{
        // Don't add duplicate skip links
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($97e6348f917990d2$var$getByDomOrderSortFunction());
        });
    }, []);
    const unregisterSkipLink = (0, $cozmU.useCallback)((id_0)=>{
        setLinks((links_0)=>links_0.filter((link)=>link.id !== id_0));
    }, []);
    const contextValue = (0, $cozmU.useMemo)(()=>{
        const data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vxJx.SkipLinksContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c988999b182dd3b7$export$fce25a0c32fbc1e1), {
        label: label,
        triggerLabel: triggerLabel,
        testId: testId,
        links: links
    }), children);
};












var $2iFcu = parcelRequire("2iFcu");


var $a5Bb1 = parcelRequire("a5Bb1");

const $567e8fe5f1497905$export$bc9d0ad0bce43e75 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = t0;
    const [element, setElement] = (0, $cozmU.useState)(null);
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2iFcu.TopNavStartAttachRef).Provider, {
            value: setElement
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== element || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5Bb1.TopNavStartElement).Provider, {
            value: element
        }, t1);
        $[2] = element;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children })=>{
    const [element, setElement] = (0, $cozmU.useState)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5Bb1.TopNavStartElement).Provider, {
        value: element
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2iFcu.TopNavStartAttachRef).Provider, {
        value: setElement
    }, children));
};



var $b24kF = parcelRequire("b24kF");











var $iaSOX = parcelRequire("iaSOX");

const $3869ab4d6e98a6a8$export$f76029d097da8c58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IsSideNavShortcutEnabledProvider(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children, isSideNavShortcutEnabled: isSideNavShortcutEnabled } = t0;
    let t1;
    if ($[0] !== children || $[1] !== isSideNavShortcutEnabled) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iaSOX.IsSideNavShortcutEnabledContext).Provider, {
            value: isSideNavShortcutEnabled
        }, children);
        $[0] = children;
        $[1] = isSideNavShortcutEnabled;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function IsSideNavShortcutEnabledProvider({ children: children, isSideNavShortcutEnabled: isSideNavShortcutEnabled }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iaSOX.IsSideNavShortcutEnabledContext).Provider, {
        value: isSideNavShortcutEnabled
    }, children);
};












var $aQh3x = parcelRequire("aQh3x");

const $4442d689cd9ffa0b$export$85c1ff84bbf6e6dc = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SideNavElementProvider(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    const sideNavRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aQh3x.SideNavRefContext).Provider, {
            value: sideNavRef
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function SideNavElementProvider({ children: children }) {
    const sideNavRef = (0, $cozmU.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aQh3x.SideNavRefContext).Provider, {
        value: sideNavRef
    }, children);
};












var $lu8mP = parcelRequire("lu8mP");


var $2E6Hq = parcelRequire("2E6Hq");

const $f99525a0c1a42085$export$ceb8e60e9790fc0f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = t0;
    const [element, setElement] = (0, $cozmU.useState)(null);
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lu8mP.SideNavToggleButtonAttachRef).Provider, {
            value: setElement
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== element || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2E6Hq.SideNavToggleButtonElement).Provider, {
            value: element
        }, t1);
        $[2] = element;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children })=>{
    const [element, setElement] = (0, $cozmU.useState)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2E6Hq.SideNavToggleButtonElement).Provider, {
        value: element
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lu8mP.SideNavToggleButtonAttachRef).Provider, {
        value: setElement
    }, children));
};












var $2udoJ = parcelRequire("2udoJ");


var $5rNCB = parcelRequire("5rNCB");

const $26d15bf9ab703556$export$aac8e996360f6ad9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, defaultCollapsed: defaultCollapsed } = t0;
    let t1;
    if ($[0] !== defaultCollapsed) {
        t1 = typeof defaultCollapsed === "boolean" ? {
            desktop: defaultCollapsed ? "collapsed" : "expanded",
            mobile: "collapsed",
            flyout: "closed",
            lastTrigger: null
        } : null;
        $[0] = defaultCollapsed;
        $[1] = t1;
    } else t1 = $[1];
    const initialState = t1;
    const [sideNavState, setSideNavState] = (0, $cozmU.useState)(initialState);
    let t2;
    if ($[2] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2udoJ.SetSideNavVisibilityState).Provider, {
            value: setSideNavState
        }, children);
        $[2] = children;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== sideNavState || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5rNCB.SideNavVisibilityState).Provider, {
            value: sideNavState
        }, t2);
        $[4] = sideNavState;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ children: children, defaultCollapsed: defaultCollapsed })=>{
    const initialState = typeof defaultCollapsed === 'boolean' ? {
        desktop: defaultCollapsed ? 'collapsed' : 'expanded',
        mobile: 'collapsed',
        flyout: 'closed',
        lastTrigger: null
    } : null;
    // Defaults to null so we can determine if the value has been set yet (for SSR)
    const [sideNavState, setSideNavState] = (0, $cozmU.useState)(initialState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5rNCB.SideNavVisibilityState).Provider, {
        value: sideNavState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2udoJ.SetSideNavVisibilityState).Provider, {
        value: setSideNavState
    }, children));
};


const $d16a42eb0666e0f8$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
const $d16a42eb0666e0f8$var$styles = {
    root: "_3iDTPbgBM8 _4kiQYAWP8C _3NN0tOsKlt _2iEGP28wUV _0ca6V72ulg _2xgI2Ymk5d _2yz9PXk6i4 _4cQPhCuAep _2dnLWx2dcB _1h2oUBk6i4 _1YDlQuSe0G",
    safetyRail: "_3cypjiOiJt",
    safetyRailWithTopLayer: "_4lA8aSOiJt",
    panelUplift: "_4bt5LAoWuR _2WAcuGoWuR"
}; /**
    * The root component of the navigation system. It wraps the underlying components with the necessary contexts allowing to use certain data and hooks
    * @param skipLinksLabel - The very first element of the layout is a skip links container that can be accessed by pressing Tab button and holds the links to the other sections of the layout thus improving accessibility. This parameter defines the header text for this container
    */ 
const $d16a42eb0666e0f8$export$be92b6f5f03c0fe9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Root(t0) {
    const $ = (0, $bDgLe.c)(22);
    const { children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: t1, skipLinksLabel: t2, skipLinksTriggerLabel: t3, testId: testId, defaultSideNavCollapsed: defaultSideNavCollapsed, isSideNavShortcutEnabled: t4 } = t0;
    const UNSAFE_dangerouslyHoistSlotSizes = t1 === undefined ? false : t1;
    const skipLinksLabel = t2 === undefined ? (0, $iDrrr.fg)("platform_dst_nav4_skip_link_a11y_1") ? "Skip to" : "Skip to:" : t2;
    const skipLinksTriggerLabel = t3 === undefined ? "Skip to" : t3;
    const isSideNavShortcutEnabled = t4 === undefined ? false : t4;
    const ref = (0, $cozmU.useRef)(null);
    let t5;
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{};
        t6 = [];
        $[0] = t5;
        $[1] = t6;
    } else {
        t5 = $[0];
        t6 = $[1];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[2] !== xcss) {
        t7 = (0, $hekY6.default)([
            $d16a42eb0666e0f8$var$styles.root,
            (0, $iDrrr.fg)("platform-dst-motion-uplift-panel") && $d16a42eb0666e0f8$var$styles.panelUplift,
            (0, $iDrrr.fg)("platform-dst-top-layer") ? $d16a42eb0666e0f8$var$styles.safetyRailWithTopLayer : $d16a42eb0666e0f8$var$styles.safetyRail,
            xcss
        ]);
        $[2] = xcss;
        $[3] = t7;
    } else t7 = $[3];
    let t8;
    if ($[4] !== children || $[5] !== t7 || $[6] !== testId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: ref,
            className: t7,
            id: $d16a42eb0666e0f8$export$a6d827031bcb31d1,
            "data-testid": testId
        }, children);
        $[4] = children;
        $[5] = t7;
        $[6] = testId;
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] !== skipLinksLabel || $[9] !== skipLinksTriggerLabel || $[10] !== t8 || $[11] !== testId) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97e6348f917990d2$export$fe514f9f7b03d46f), {
            label: skipLinksLabel,
            triggerLabel: skipLinksTriggerLabel,
            testId: testId
        }, t8);
        $[8] = skipLinksLabel;
        $[9] = skipLinksTriggerLabel;
        $[10] = t8;
        $[11] = testId;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== UNSAFE_dangerouslyHoistSlotSizes || $[14] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $567e8fe5f1497905$export$bc9d0ad0bce43e75), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $955c54956ec6c42a$export$97afddda23bcd287), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b24kF.DangerouslyHoistSlotSizes).Provider, {
            value: UNSAFE_dangerouslyHoistSlotSizes
        }, t9)));
        $[13] = UNSAFE_dangerouslyHoistSlotSizes;
        $[14] = t9;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== isSideNavShortcutEnabled || $[17] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f99525a0c1a42085$export$ceb8e60e9790fc0f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4442d689cd9ffa0b$export$85c1ff84bbf6e6dc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3869ab4d6e98a6a8$export$f76029d097da8c58), {
            isSideNavShortcutEnabled: isSideNavShortcutEnabled
        }, t10)));
        $[16] = isSideNavShortcutEnabled;
        $[17] = t10;
        $[18] = t11;
    } else t11 = $[18];
    let t12;
    if ($[19] !== defaultSideNavCollapsed || $[20] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $26d15bf9ab703556$export$aac8e996360f6ad9), {
            defaultCollapsed: defaultSideNavCollapsed
        }, t11);
        $[19] = defaultSideNavCollapsed;
        $[20] = t11;
        $[21] = t12;
    } else t12 = $[21];
    return t12;
} : function Root({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false, skipLinksLabel: skipLinksLabel = (0, $iDrrr.fg)('platform_dst_nav4_skip_link_a11y_1') ? 'Skip to' : 'Skip to:', skipLinksTriggerLabel: skipLinksTriggerLabel = 'Skip to', testId: testId, defaultSideNavCollapsed: defaultSideNavCollapsed, isSideNavShortcutEnabled: isSideNavShortcutEnabled = false }) {
    const ref = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{}, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $26d15bf9ab703556$export$aac8e996360f6ad9), {
        defaultCollapsed: defaultSideNavCollapsed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f99525a0c1a42085$export$ceb8e60e9790fc0f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4442d689cd9ffa0b$export$85c1ff84bbf6e6dc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3869ab4d6e98a6a8$export$f76029d097da8c58), {
        isSideNavShortcutEnabled: isSideNavShortcutEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $567e8fe5f1497905$export$bc9d0ad0bce43e75), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $955c54956ec6c42a$export$97afddda23bcd287), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b24kF.DangerouslyHoistSlotSizes).Provider, {
        value: UNSAFE_dangerouslyHoistSlotSizes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97e6348f917990d2$export$fe514f9f7b03d46f), {
        label: skipLinksLabel,
        triggerLabel: skipLinksTriggerLabel,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        className: (0, $hekY6.default)([
            $d16a42eb0666e0f8$var$styles.root,
            (0, $iDrrr.fg)('platform-dst-motion-uplift-panel') && $d16a42eb0666e0f8$var$styles.panelUplift,
            (0, $iDrrr.fg)('platform-dst-top-layer') ? $d16a42eb0666e0f8$var$styles.safetyRailWithTopLayer : $d16a42eb0666e0f8$var$styles.safetyRail,
            xcss
        ]),
        id: $d16a42eb0666e0f8$export$a6d827031bcb31d1,
        "data-testid": testId
    }, children)))))))));
};
module.exports["gridRootId"] = $d16a42eb0666e0f8$export$a6d827031bcb31d1;
module.exports["Root"] = $d16a42eb0666e0f8$export$be92b6f5f03c0fe9;

});

parcelRegister("dyjRd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");








var $eaAhc = parcelRequire("eaAhc");

const $01843401577e3f77$export$89d9323301efc7d6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (id, label, listIndex)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] !== id || $[1] !== label || $[2] !== listIndex) {
        t0 = {
            id: id,
            label: label,
            listIndex: listIndex
        };
        $[0] = id;
        $[1] = label;
        $[2] = listIndex;
        $[3] = t0;
    } else t0 = $[3];
    (0, $eaAhc.useSkipLinkInternal)(t0);
} : (id, label, listIndex)=>{
    (0, $eaAhc.useSkipLinkInternal)({
        id: id,
        label: label,
        listIndex: listIndex
    });
};



var $eyPWA = parcelRequire("eyPWA");

const $8596264f7fa42469$var$mainElementStyles = {
    root: "_1xC2CJOQJL _4bt5LAIZbP _2WAcuGIZbP _2YgrGrP0S5 _2I62gzgiHs _0jFU0VlOMI _1M50CAIZbP _2DiRUzHE3j"
}; /**
    * Use the Main area for the main page content. It has a fluid width and will expand to fill available space.
    */ 
const $8596264f7fa42469$export$861edd1ccea2f746 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Main(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { children: children, xcss: xcss, skipLinkLabel: t1, testId: testId, id: providedId } = t0;
    const skipLinkLabel = t1 === undefined ? (0, $iDrrr.fg)("platform_dst_nav4_skip_link_a11y_1") ? "Main content" : "Main Content" : t1;
    let t2;
    if ($[0] !== providedId) {
        t2 = {
            providedId: providedId
        };
        $[0] = providedId;
        $[1] = t2;
    } else t2 = $[1];
    const id = (0, $eyPWA.useLayoutId)(t2);
    (0, $01843401577e3f77$export$89d9323301efc7d6)(id, skipLinkLabel);
    let t3;
    if ($[2] !== xcss) {
        t3 = (0, $hekY6.default)([
            $8596264f7fa42469$var$mainElementStyles.root,
            xcss
        ]);
        $[2] = xcss;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== children || $[5] !== id || $[6] !== t3 || $[7] !== testId) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("div", {
            id: id,
            "data-layout-slot": true,
            className: t3,
            role: "main",
            "data-testid": testId
        }, children));
        $[4] = children;
        $[5] = id;
        $[6] = t3;
        $[7] = testId;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function Main({ children: children, xcss: xcss, skipLinkLabel: skipLinkLabel = (0, $iDrrr.fg)('platform_dst_nav4_skip_link_a11y_1') ? 'Main content' : 'Main Content', testId: testId, id: providedId }) {
    const id = (0, $eyPWA.useLayoutId)({
        providedId: providedId
    });
    (0, $01843401577e3f77$export$89d9323301efc7d6)(id, skipLinkLabel);
    return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $hekY6.default)([
            $8596264f7fa42469$var$mainElementStyles.root,
            xcss
        ]),
        role: "main",
        "data-testid": testId
    }, children));
};
module.exports["Main"] = $8596264f7fa42469$export$861edd1ccea2f746;

});

parcelRegister("ej46P", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jLnA6 = parcelRequire("jLnA6");

const $49cb1cdeb1dbc099$var$MAX_NOTIFICATIONS_COUNT = 9;
const $49cb1cdeb1dbc099$var$NAVIGATION_CHANNEL = 'navigation';
class $49cb1cdeb1dbc099$var$NotificationIndicator extends (0, $cozmU.Component) {
    async componentDidMount() {
        this.notificationLogProvider = await this.props.notificationLogProvider;
        this.refresh('mount');
        this.updateInterval();
        if (typeof document !== 'undefined') document.addEventListener('visibilitychange', this.onVisibilityChange);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.refreshRate !== this.props.refreshRate) this.updateInterval();
    }
    componentWillUnmount() {
        if (this.intervalId) clearInterval(this.intervalId);
        if (typeof document !== 'undefined') document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
    updateInterval() {
        const { refreshRate: refreshRate } = this.props;
        if (this.intervalId) clearInterval(this.intervalId);
        if (refreshRate && refreshRate > 0) this.intervalId = window.setInterval(this.timerTick, refreshRate);
    }
    render() {
        const { count: count } = this.state;
        const { appearance: appearance, max: max } = this.props;
        return count ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-test-selector": "NotificationIndicator"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLnA6.default), {
            testId: "notification-indicator-badge",
            max: max,
            appearance: appearance
        }, count)) : null;
    }
    constructor(...args){
        super(...args);
        this.intervalId = void 0;
        this.visibilityChangesSinceTimer = 0;
        this.notificationLogProvider = void 0;
        this.state = {
            count: this.props.ssrInitialValue || null
        };
        this.onVisibilityChange = ()=>{
            if (this.props.refreshOnVisibilityChange && this.shouldRefresh()) {
                this.visibilityChangesSinceTimer++;
                this.refresh('visibility');
            }
        };
        this.shouldRefresh = ()=>{
            return typeof document !== 'undefined' && !document.hidden || this.props.refreshOnHidden;
        };
        this.timerTick = ()=>{
            this.visibilityChangesSinceTimer = 0;
            this.refresh('timer');
        };
        this.handleAnalytics = (countUpdateProperties)=>{
            const { newCount: newCount, oldCount: oldCount, source: source } = countUpdateProperties;
            // Only fire an 'activating' analytics event if the notification indicator is 'activating' for the first time
            // ie going from a number of 0 (the indicator is not visible)
            // to a number > 0 (the indicator becomes visible)
            if (this.props.createAnalyticsEvent && newCount > 0 && oldCount === 0) {
                const event = this.props.createAnalyticsEvent({
                    actionSubject: 'notificationIndicator',
                    action: 'activated',
                    attributes: {
                        badgeCount: newCount,
                        refreshSource: source
                    }
                });
                event.fire($49cb1cdeb1dbc099$var$NAVIGATION_CHANNEL);
            }
            if (this.props.createAnalyticsEvent && newCount !== oldCount) {
                const event = this.props.createAnalyticsEvent({
                    actionSubject: 'notificationIndicator',
                    action: 'updated',
                    attributes: {
                        oldCount: oldCount,
                        newCount: newCount,
                        refreshSource: source
                    }
                });
                event.fire($49cb1cdeb1dbc099$var$NAVIGATION_CHANNEL);
            }
        };
        this.refresh = async (source)=>{
            // Provider should be available by this point, if not, we exit.
            if (!this.notificationLogProvider) return;
            // If user is not viewing the webpage, then skip this refresh to avoid unnecessary request.
            if (!this.shouldRefresh()) return;
            const visibilityChangesSinceTimer = this.visibilityChangesSinceTimer;
            const updatingEvent = {
                source: source,
                visibilityChangesSinceTimer: visibilityChangesSinceTimer
            };
            const updatingResult = this.props.onCountUpdating && this.props.onCountUpdating(updatingEvent) || {};
            if (updatingResult.skip) return;
            try {
                const count = updatingResult.countOverride || (await this.notificationLogProvider.countUnseenNotifications({
                    queryParams: {
                        currentCount: this.state.count || 0
                    }
                })).count;
                if (this.state.count === null || this.state.count !== count) {
                    const countUpdateProperties = {
                        oldCount: this.state.count || 0,
                        newCount: count,
                        source: source
                    };
                    this.handleAnalytics(countUpdateProperties);
                    if (this.props.onCountUpdated) this.props.onCountUpdated(countUpdateProperties);
                    this.setState({
                        count: count
                    });
                }
            } catch (e) {
            // Do nothing
            }
        };
    }
}
$49cb1cdeb1dbc099$var$NotificationIndicator.defaultProps = {
    appearance: 'dangerBold',
    max: $49cb1cdeb1dbc099$var$MAX_NOTIFICATIONS_COUNT,
    refreshRate: 0,
    refreshOnHidden: false,
    refreshOnVisibilityChange: true
};
var $49cb1cdeb1dbc099$export$2e2bcd8739ae039 = $49cb1cdeb1dbc099$var$NotificationIndicator;



var $lzgC6 = parcelRequire("lzgC6");

const $427348c386f0b231$export$208fd20af21dc523 = (0, $lzgC6.default)()((0, $49cb1cdeb1dbc099$export$2e2bcd8739ae039));
module.exports["NotificationIndicator"] = $427348c386f0b231$export$208fd20af21dc523;

});

parcelRegister("2E1ay", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $rECdA = parcelRequire("rECdA");


var $eaAhc = parcelRequire("eaAhc");


var $1fHIr = parcelRequire("1fHIr");


var $6cyWf = parcelRequire("6cyWf");


var $f8DhE = parcelRequire("f8DhE");





var $oHJVG = parcelRequire("oHJVG");

/**
 * Removes sRGB gamma correction from the provided channel.
 * The resulting linear channel directly corresponds to subpixel intensity.
 *
 * Expects a normalized sRGB value (between 0 and 1)
 *
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $3aaf5208aef18d7a$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $3aaf5208aef18d7a$var$relativeLuminanceW3C({ r: r, g: g, b: b }) {
    /**
   * Normalized sRGB - each channel is between 0 and 1
   */ const normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
   * linear RGB - the gamma correction of sRGB is removed and
   * the channels correspond directly to subpixel intensity
   */ const linear = {
        r: $3aaf5208aef18d7a$var$linearizeRGBChannel(normal.r),
        g: $3aaf5208aef18d7a$var$linearizeRGBChannel(normal.g),
        b: $3aaf5208aef18d7a$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    const L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ const $3aaf5208aef18d7a$var$flipLuminance = 0.179129;
function $3aaf5208aef18d7a$export$44af652f4cca9039(color) {
    return $3aaf5208aef18d7a$var$relativeLuminanceW3C(color) >= $3aaf5208aef18d7a$var$flipLuminance;
}
function $3aaf5208aef18d7a$export$5573a5bab3e074b5(backgroundColor) {
    if ($3aaf5208aef18d7a$var$relativeLuminanceW3C(backgroundColor) >= $3aaf5208aef18d7a$var$flipLuminance) return 'light';
    return 'dark';
}
const $3aaf5208aef18d7a$var$textColor = {
    light: {
        hex: '#000',
        rgb: {
            r: 0,
            g: 0,
            b: 0
        }
    },
    dark: {
        hex: '#FFF',
        rgb: {
            r: 255,
            g: 255,
            b: 255
        }
    }
};
function $3aaf5208aef18d7a$export$5357fe757c335c0d(backgroundColor) {
    const colorMode = $3aaf5208aef18d7a$export$5573a5bab3e074b5(backgroundColor);
    return $3aaf5208aef18d7a$var$textColor[colorMode];
}
function $3aaf5208aef18d7a$export$e5e64c30bee1469b({ background: background, foreground: foreground }) {
    return {
        r: foreground.a * foreground.r + background.r * (1 - foreground.a),
        g: foreground.a * foreground.g + background.g * (1 - foreground.a),
        b: foreground.a * foreground.b + background.b * (1 - foreground.a)
    };
}



var $k3d9G = parcelRequire("k3d9G");

const $48d465b83572c770$export$eaad8caa32d2521d = {
    'DarkNeutral-100': '#111213',
    'DarkNeutral-100A': '#01040475',
    DarkNeutral0: '#18191A',
    DarkNeutral100: '#1F1F21',
    DarkNeutral100A: '#BDBDBD0A',
    DarkNeutral200: '#242528',
    DarkNeutral200A: '#CECED912',
    DarkNeutral250: '#2B2C2F',
    DarkNeutral250A: '#D9DAE71A',
    DarkNeutral300: '#303134',
    DarkNeutral300A: '#E3E4F21F',
    DarkNeutral350: '#3D3F43',
    DarkNeutral350A: '#E8EDFD2E',
    DarkNeutral400: '#4B4D51',
    DarkNeutral400A: '#E5E9F640',
    DarkNeutral500: '#63666B',
    DarkNeutral500A: '#E9F0FB5C',
    DarkNeutral600: '#7E8188',
    DarkNeutral700: '#96999E',
    DarkNeutral800: '#A9ABAF',
    DarkNeutral900: '#BFC1C4',
    DarkNeutral1000: '#CECFD2',
    DarkNeutral1100: '#E2E3E4',
    Neutral0: '#FFFFFF',
    Neutral100: '#F8F8F8',
    Neutral100A: '#17171708',
    Neutral200: '#F0F1F2',
    Neutral200A: '#0515240F',
    Neutral300: '#DDDEE1',
    Neutral300A: '#0B120E24',
    Neutral400: '#B7B9BE',
    Neutral400A: '#080F214A',
    Neutral500: '#8C8F97',
    Neutral500A: '#050C1F75',
    Neutral600: '#7D818A',
    Neutral700: '#6B6E76',
    Neutral800: '#505258',
    Neutral900: '#3B3D42',
    Neutral1000: '#292A2E',
    Neutral1100: '#1E1F21'
};


const $8a5734e83b5ae7c5$export$c9b84419dae66a82 = {
    DarkNeutral300A: {
        r: 0xe3,
        g: 0xe4,
        b: 0xf2,
        a: 0x1f / 255
    },
    Neutral300A: {
        r: 0x0b,
        g: 0x12,
        b: 0x0e,
        a: 0x24 / 255
    }
};



var $4Ucqd = parcelRequire("4Ucqd");

function $31fb2c14e57663d5$var$toRGBString({ r: r, g: g, b: b }) {
    return `rgb(${r}, ${g}, ${b})`;
}
function $31fb2c14e57663d5$var$toRGBAString({ r: r, g: g, b: b, a: a }) {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
const $31fb2c14e57663d5$var$buttonStyles = {
    light: {
        ['--ds-top-bar-button-background']: 'transparent',
        ['--ds-top-bar-button-background-hovered']: (0, $48d465b83572c770$export$eaad8caa32d2521d).Neutral200A,
        ['--ds-top-bar-button-background-pressed']: (0, $48d465b83572c770$export$eaad8caa32d2521d).Neutral300A,
        ['--ds-top-bar-button-border']: (0, $48d465b83572c770$export$eaad8caa32d2521d).Neutral300A,
        ['--ds-top-bar-button-selected-background']: (0, $48d465b83572c770$export$eaad8caa32d2521d).Neutral300A,
        ['--ds-top-bar-button-selected-background-hovered']: (0, $48d465b83572c770$export$eaad8caa32d2521d).Neutral400A,
        ['--ds-top-bar-button-selected-background-pressed']: (0, $48d465b83572c770$export$eaad8caa32d2521d).Neutral500A,
        ['--ds-top-bar-button-disabled-text']: (0, $48d465b83572c770$export$eaad8caa32d2521d).Neutral400A,
        ['--ds-top-bar-button-disabled-background']: (0, $48d465b83572c770$export$eaad8caa32d2521d).Neutral100A
    },
    dark: {
        ['--ds-top-bar-button-background']: 'transparent',
        ['--ds-top-bar-button-background-hovered']: (0, $48d465b83572c770$export$eaad8caa32d2521d).DarkNeutral200A,
        ['--ds-top-bar-button-background-pressed']: (0, $48d465b83572c770$export$eaad8caa32d2521d).DarkNeutral300A,
        ['--ds-top-bar-button-border']: (0, $48d465b83572c770$export$eaad8caa32d2521d).DarkNeutral300A,
        ['--ds-top-bar-button-selected-background']: (0, $48d465b83572c770$export$eaad8caa32d2521d).DarkNeutral300A,
        ['--ds-top-bar-button-selected-background-hovered']: (0, $48d465b83572c770$export$eaad8caa32d2521d).DarkNeutral400A,
        ['--ds-top-bar-button-selected-background-pressed']: (0, $48d465b83572c770$export$eaad8caa32d2521d).DarkNeutral500A,
        ['--ds-top-bar-button-disabled-text']: (0, $48d465b83572c770$export$eaad8caa32d2521d).DarkNeutral400A,
        ['--ds-top-bar-button-disabled-background']: (0, $48d465b83572c770$export$eaad8caa32d2521d).DarkNeutral100A
    }
};
const $31fb2c14e57663d5$var$logoStyles = {
    light: {
        ['--ds-top-bar-logo-icon']: (0, $48d465b83572c770$export$eaad8caa32d2521d).DarkNeutral0,
        ['--ds-top-bar-logo-text']: (0, $48d465b83572c770$export$eaad8caa32d2521d).DarkNeutral0
    },
    dark: {
        [(0, $oHJVG.themedLogoIcon)]: (0, $48d465b83572c770$export$eaad8caa32d2521d).Neutral0,
        [(0, $oHJVG.themedLogoText)]: (0, $48d465b83572c770$export$eaad8caa32d2521d).Neutral0
    }
};
function $31fb2c14e57663d5$export$3986d75fe2da3239({ backgroundColor: backgroundColor, highlightColor: highlightColor }) {
    const backgroundRgb = typeof backgroundColor === 'string' ? (0, $k3d9G.parseHex)(backgroundColor) : backgroundColor;
    const highlightRgb = typeof highlightColor === 'string' ? (0, $k3d9G.parseHex)(highlightColor) : highlightColor;
    if (!backgroundRgb || !highlightRgb) return null;
    const textColor = (0, $3aaf5208aef18d7a$export$5357fe757c335c0d)(backgroundRgb);
    const colorMode = (0, $3aaf5208aef18d7a$export$5573a5bab3e074b5)(backgroundRgb);
    const highlightTextColor = (0, $3aaf5208aef18d7a$export$5357fe757c335c0d)(highlightRgb);
    return {
        backgroundColor: $31fb2c14e57663d5$var$toRGBString(backgroundRgb),
        color: textColor.hex,
        ...$31fb2c14e57663d5$var$buttonStyles[colorMode],
        ...$31fb2c14e57663d5$var$logoStyles[colorMode],
        ...$31fb2c14e57663d5$var$getSelectedStyles({
            backgroundColor: backgroundRgb,
            colorMode: colorMode
        }),
        /**
     * Search colors are the same as Nav 3
     */ [(0, $4Ucqd.themedSearchBorder)]: $31fb2c14e57663d5$var$toRGBAString({
            ...textColor.rgb,
            a: 0.5
        }),
        [(0, $4Ucqd.themedSearchBorderFocused)]: $31fb2c14e57663d5$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        /**
     * Primary button colors are the same as Nav 3,
     * except the text color which can sometimes differ because we're
     * now following WCAG
     */ ['--ds-top-bar-button-primary-background']: $31fb2c14e57663d5$var$toRGBString(highlightRgb),
        ['--ds-top-bar-button-primary-background-hovered']: $31fb2c14e57663d5$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        ['--ds-top-bar-button-primary-background-pressed']: $31fb2c14e57663d5$var$toRGBAString({
            ...highlightRgb,
            a: 0.65
        }),
        ['--ds-top-bar-button-primary-text']: highlightTextColor.hex
    };
}
/**
 * Precomputed RGBA values for the selected backgrounds
 */ const $31fb2c14e57663d5$var$selectedBackgroundRGBA = {
    light: (0, $8a5734e83b5ae7c5$export$c9b84419dae66a82).Neutral300A,
    dark: (0, $8a5734e83b5ae7c5$export$c9b84419dae66a82).DarkNeutral300A
};
function $31fb2c14e57663d5$var$getSelectedStyles({ backgroundColor: backgroundColor, colorMode: colorMode }) {
    /**
   * The background color of the selected button in its default state.
   *
   * We are referring to this as a foreground color because it is semi-transparent,
   * so is not the actual color displayed when the button is on top of a background color.
   */ const foregroundColor = $31fb2c14e57663d5$var$selectedBackgroundRGBA[colorMode];
    /**
   * The blended color seen when the selected background is over the top bar.
   */ const blendedBackground = (0, $3aaf5208aef18d7a$export$e5e64c30bee1469b)({
        background: backgroundColor,
        foreground: foregroundColor
    });
    return {
        ['--ds-top-bar-button-selected-text']: (0, $3aaf5208aef18d7a$export$5357fe757c335c0d)(blendedBackground).hex,
        // Border colors are chosen to match the text, while remaining in the palette
        ['--ds-top-bar-button-selected-border']: (0, $3aaf5208aef18d7a$export$44af652f4cca9039)(blendedBackground) ? (0, $48d465b83572c770$export$eaad8caa32d2521d).Neutral1100 : (0, $48d465b83572c770$export$eaad8caa32d2521d).DarkNeutral1100
    };
}


function $6f3f6718c2fdc3dd$export$c0c5f5b297b77726(theme) {
    const value_0 = (0, $cozmU.useMemo)(()=>{
        if (!theme?.backgroundColor || !theme?.highlightColor) return {
            isEnabled: false
        };
        /**
     * Re-creating the `theme` object from it's pieces.
     *
     * _Technically_ we could just use `theme`, but that would involve an eslint opt out
     * as we would be leveraging a value (`theme`) not in the dependency array.
     *
     * The current approach is the most correct™️ and avoids foot guns.
     * We are only using values in the effect that are defined in the dependency array 🙌
     */ const value = {
            backgroundColor: theme.backgroundColor,
            highlightColor: theme.highlightColor
        };
        const style = (0, $31fb2c14e57663d5$export$3986d75fe2da3239)(value);
        if (!style) // Either the `backgroundColor` or `highlightColor` could not be parsed
        return {
            isEnabled: false
        };
        return {
            isEnabled: true,
            style: style
        };
    }, // Using individual properties as keys for improved memoization.
    // Now this effect will only run if the values change rather than
    // the reference to the object (which might be new on every call)
    [
        theme?.backgroundColor,
        theme?.highlightColor
    ]);
    return value_0;
}












var $2ltBS = parcelRequire("2ltBS");


var $89bON = parcelRequire("89bON");





function $4bc3706370e59ce2$var$toRGBString({ r: r, g: g, b: b }) {
    return `rgb(${r}, ${g}, ${b})`;
}
const $4bc3706370e59ce2$export$92ae7a8762fba89e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useCustomThemeNew(theme) {
    const $ = (0, $bDgLe.c)(6);
    const value = (0, $6f3f6718c2fdc3dd$export$c0c5f5b297b77726)(theme);
    const colorMode = (0, $2ltBS.useColorMode)();
    let t0;
    bb0: {
        if (!value.isEnabled) {
            t0 = true;
            break bb0;
        }
        let t1;
        if ($[0] !== colorMode || $[1] !== value.style) {
            const defaultBackground = (0, $k3d9G.parseHex)((0, $89bON.default)("elevation.surface", colorMode === "light" ? "#FFFFFF" : "#1F1F21"));
            t1 = defaultBackground ? value.style.backgroundColor === $4bc3706370e59ce2$var$toRGBString(defaultBackground) : true;
            $[0] = colorMode;
            $[1] = value.style;
            $[2] = t1;
        } else t1 = $[2];
        t0 = t1;
    }
    const hasDefaultBackground = t0;
    if (value.isEnabled) {
        let t1;
        if ($[3] !== hasDefaultBackground || $[4] !== value) {
            t1 = {
                ...value,
                hasDefaultBackground: hasDefaultBackground
            };
            $[3] = hasDefaultBackground;
            $[4] = value;
            $[5] = t1;
        } else t1 = $[5];
        return t1;
    }
    return value;
} : function useCustomThemeNew(theme) {
    const value = (0, $6f3f6718c2fdc3dd$export$c0c5f5b297b77726)(theme);
    /**
   * We use the color mode to determine the default background color for the top nav.
   * We need to use the hook because the user could change their color mode preference.
   */ const colorMode = (0, $2ltBS.useColorMode)();
    const hasDefaultBackground = (0, $cozmU.useMemo)(()=>{
        if (!value.isEnabled) return true;
        const defaultBackground = (0, $k3d9G.parseHex)((0, $89bON.default)('elevation.surface', colorMode === 'light' ? '#FFFFFF' : '#1F1F21'));
        return defaultBackground ? value.style.backgroundColor === $4bc3706370e59ce2$var$toRGBString(defaultBackground) : true;
    }, [
        value,
        colorMode
    ]);
    if (value.isEnabled) return {
        ...value,
        hasDefaultBackground: hasDefaultBackground
    };
    return value;
};



var $liCgE = parcelRequire("liCgE");


var $4aMCy = parcelRequire("4aMCy");


var $kPxjF = parcelRequire("kPxjF");


var $b24kF = parcelRequire("b24kF");


var $gjVTm = parcelRequire("gjVTm");


var $eyPWA = parcelRequire("eyPWA");

const $d60c692a52442d30$var$styles = {
    root: "_1xC2CJ8ySg _2mHwu82ADO _2Y7lL48HPE _2R4pr3OeNX _3iDTPbgBM8 _2iEGP292QF _0hPCNLDIqT _0KLXrulfZc _24h04i2Njc _0jFU0VmTzZ _2I62gza2UD _1mT5xdHE3j _42Yu6B8OLE _0RYKppcK7c _3E0AG2ifeC",
    fullHeightSidebar: "_2Y7lL4Pgdg _2R4pr3YbGa _1pp6NdIZbP _0KLXrulfZc _42Yu6B7LI7 _0GBAIrogpp _2WYcYGWVPG _3ufiZDdnbC _3erkSQdnbC _13xWvlCZMv _3813f2NvrM _1ZWG3o6wH8 _3dLjQS9r67 _1FQBgZ8HPE",
    fullHeightSidebarExpanded: "_4cQPhC2a2F _1hGA1nifeC",
    fullHeightSidebarCustomTheming: "_3PYyoLYbGa"
};
const $d60c692a52442d30$var$TopNavOld = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TopNavOld(t0) {
    const $ = (0, $bDgLe.c)(26);
    const { children: children, xcss: xcss, height: heightProp, skipLinkLabel: t1, testId: testId, id: providedId, customTheme: customThemeConfig } = t0;
    const skipLinkLabel = t1 === undefined ? "Top Bar" : t1;
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const dangerouslyHoistSlotSizes = (0, $cozmU.useContext)((0, $b24kF.DangerouslyHoistSlotSizes));
    let t2;
    if ($[0] !== providedId) {
        t2 = {
            providedId: providedId
        };
        $[0] = providedId;
        $[1] = t2;
    } else t2 = $[1];
    const id = (0, $eyPWA.useLayoutId)(t2);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $iDrrr.fg)("platform_dst_nav4_skip_link_a11y_1");
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== id || $[4] !== skipLinkLabel) {
        t4 = {
            id: id,
            label: skipLinkLabel,
            isHidden: t3
        };
        $[3] = id;
        $[4] = skipLinkLabel;
        $[5] = t4;
    } else t4 = $[5];
    (0, $eaAhc.useSkipLinkInternal)(t4);
    const height = heightProp ?? (isFhsEnabled || (0, $iDrrr.fg)("platform_dst_ads_appswitcher_improvements") ? 56 : 48);
    const customTheme = (0, $6f3f6718c2fdc3dd$export$c0c5f5b297b77726)(customThemeConfig);
    const { isExpandedOnDesktop: isExpandedOnDesktop } = (0, $gjVTm.useSideNavVisibility)();
    const t5 = customTheme.isEnabled;
    const t6 = isFhsEnabled && $d60c692a52442d30$var$styles.fullHeightSidebar;
    const t7 = isExpandedOnDesktop && isFhsEnabled && $d60c692a52442d30$var$styles.fullHeightSidebarExpanded;
    let t8;
    if ($[6] !== t6 || $[7] !== t7 || $[8] !== xcss) {
        t8 = (0, $hekY6.default)([
            $d60c692a52442d30$var$styles.root,
            t6,
            t7,
            xcss
        ]);
        $[6] = t6;
        $[7] = t7;
        $[8] = xcss;
        $[9] = t8;
    } else t8 = $[9];
    const t9 = customTheme.isEnabled ? customTheme.style : undefined;
    let t10;
    if ($[10] !== height) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $kPxjF.HoistCssVarToLocalGrid), {
            variableName: (0, $liCgE.topNavMountedVar),
            value: height
        });
        $[10] = height;
        $[11] = t10;
    } else t10 = $[11];
    let t11;
    if ($[12] !== dangerouslyHoistSlotSizes || $[13] !== height) {
        t11 = dangerouslyHoistSlotSizes && /*#__PURE__*/ $cozmU.createElement((0, $4aMCy.DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, $liCgE.UNSAFE_topNavVar),
            value: height
        });
        $[12] = dangerouslyHoistSlotSizes;
        $[13] = height;
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] !== children || $[16] !== id || $[17] !== t10 || $[18] !== t11 || $[19] !== t8 || $[20] !== t9 || $[21] !== testId) {
        t12 = /*#__PURE__*/ $cozmU.createElement("header", {
            id: id,
            "data-layout-slot": true,
            className: t8,
            "data-testid": testId,
            style: t9
        }, t10, t11, children);
        $[15] = children;
        $[16] = id;
        $[17] = t10;
        $[18] = t11;
        $[19] = t8;
        $[20] = t9;
        $[21] = testId;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] !== customTheme.isEnabled || $[24] !== t12) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $6cyWf.HasCustomThemeContext).Provider, {
            value: t5
        }, t12);
        $[23] = customTheme.isEnabled;
        $[24] = t12;
        $[25] = t13;
    } else t13 = $[25];
    return t13;
} : function TopNavOld({ children: children, xcss: xcss, height: heightProp, skipLinkLabel: skipLinkLabel = 'Top Bar', testId: testId, id: providedId, customTheme: customThemeConfig }) {
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const dangerouslyHoistSlotSizes = (0, $cozmU.useContext)((0, $b24kF.DangerouslyHoistSlotSizes));
    const id = (0, $eyPWA.useLayoutId)({
        providedId: providedId
    });
    (0, $eaAhc.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: (0, $iDrrr.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    const height = heightProp ?? (isFhsEnabled || (0, $iDrrr.fg)('platform_dst_ads_appswitcher_improvements') ? 56 : 48);
    const customTheme = (0, $6f3f6718c2fdc3dd$export$c0c5f5b297b77726)(customThemeConfig);
    const { isExpandedOnDesktop: isExpandedOnDesktop } = (0, $gjVTm.useSideNavVisibility)();
    return /*#__PURE__*/ $cozmU.createElement((0, $6cyWf.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled
    }, /*#__PURE__*/ $cozmU.createElement("header", {
        id: id,
        "data-layout-slot": true,
        className: (0, $hekY6.default)([
            $d60c692a52442d30$var$styles.root,
            isFhsEnabled && $d60c692a52442d30$var$styles.fullHeightSidebar,
            isExpandedOnDesktop && isFhsEnabled && $d60c692a52442d30$var$styles.fullHeightSidebarExpanded,
            xcss
        ]),
        "data-testid": testId,
        style: customTheme.isEnabled ? customTheme.style : undefined
    }, /*#__PURE__*/ $cozmU.createElement((0, $kPxjF.HoistCssVarToLocalGrid), {
        variableName: (0, $liCgE.topNavMountedVar),
        value: height
    }), dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ $cozmU.createElement((0, $4aMCy.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $liCgE.UNSAFE_topNavVar),
        value: height
    }), children));
};
/**
 * The top nav layout area. It will display at the top of the screen, below the banner if one is present.
 */ const $d60c692a52442d30$var$TopNavNew = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TopNavNew(t0) {
    const $ = (0, $bDgLe.c)(31);
    const { children: children, xcss: xcss, height: heightProp, skipLinkLabel: t1, testId: testId, id: providedId, customTheme: customThemeConfig } = t0;
    const skipLinkLabel = t1 === undefined ? "Top Bar" : t1;
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const dangerouslyHoistSlotSizes = (0, $cozmU.useContext)((0, $b24kF.DangerouslyHoistSlotSizes));
    let t2;
    if ($[0] !== providedId) {
        t2 = {
            providedId: providedId
        };
        $[0] = providedId;
        $[1] = t2;
    } else t2 = $[1];
    const id = (0, $eyPWA.useLayoutId)(t2);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $iDrrr.fg)("platform_dst_nav4_skip_link_a11y_1");
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== id || $[4] !== skipLinkLabel) {
        t4 = {
            id: id,
            label: skipLinkLabel,
            isHidden: t3
        };
        $[3] = id;
        $[4] = skipLinkLabel;
        $[5] = t4;
    } else t4 = $[5];
    (0, $eaAhc.useSkipLinkInternal)(t4);
    const height = heightProp ?? (isFhsEnabled || (0, $iDrrr.fg)("platform_dst_ads_appswitcher_improvements") ? 56 : 48);
    const customTheme = (0, $4bc3706370e59ce2$export$92ae7a8762fba89e)(customThemeConfig);
    const hasDefaultBackground = customTheme.isEnabled ? customTheme.hasDefaultBackground : true;
    const { isExpandedOnDesktop: isExpandedOnDesktop } = (0, $gjVTm.useSideNavVisibility)();
    const t5 = customTheme.isEnabled;
    const t6 = isFhsEnabled && $d60c692a52442d30$var$styles.fullHeightSidebar;
    const t7 = isExpandedOnDesktop && isFhsEnabled && $d60c692a52442d30$var$styles.fullHeightSidebarExpanded;
    let t8;
    if ($[6] !== customTheme.isEnabled || $[7] !== hasDefaultBackground || $[8] !== t6 || $[9] !== t7 || $[10] !== xcss) {
        t8 = (0, $hekY6.default)([
            $d60c692a52442d30$var$styles.root,
            t6,
            t7,
            customTheme.isEnabled && !hasDefaultBackground && (0, $iDrrr.fg)("platform_dst_nav4_custom_theming_fhs_1") && $d60c692a52442d30$var$styles.fullHeightSidebarCustomTheming,
            xcss
        ]);
        $[6] = customTheme.isEnabled;
        $[7] = hasDefaultBackground;
        $[8] = t6;
        $[9] = t7;
        $[10] = xcss;
        $[11] = t8;
    } else t8 = $[11];
    const t9 = customTheme.isEnabled ? customTheme.style : undefined;
    let t10;
    if ($[12] !== height) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $kPxjF.HoistCssVarToLocalGrid), {
            variableName: (0, $liCgE.topNavMountedVar),
            value: height
        });
        $[12] = height;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== dangerouslyHoistSlotSizes || $[15] !== height) {
        t11 = dangerouslyHoistSlotSizes && /*#__PURE__*/ $cozmU.createElement((0, $4aMCy.DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, $liCgE.UNSAFE_topNavVar),
            value: height
        });
        $[14] = dangerouslyHoistSlotSizes;
        $[15] = height;
        $[16] = t11;
    } else t11 = $[16];
    let t12;
    if ($[17] !== children || $[18] !== id || $[19] !== t10 || $[20] !== t11 || $[21] !== t8 || $[22] !== t9 || $[23] !== testId) {
        t12 = /*#__PURE__*/ $cozmU.createElement("header", {
            id: id,
            "data-layout-slot": true,
            className: t8,
            "data-testid": testId,
            style: t9
        }, t10, t11, children);
        $[17] = children;
        $[18] = id;
        $[19] = t10;
        $[20] = t11;
        $[21] = t8;
        $[22] = t9;
        $[23] = testId;
        $[24] = t12;
    } else t12 = $[24];
    let t13;
    if ($[25] !== hasDefaultBackground || $[26] !== t12) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $f8DhE.HasDefaultBackgroundColorContext).Provider, {
            value: hasDefaultBackground
        }, t12);
        $[25] = hasDefaultBackground;
        $[26] = t12;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== customTheme.isEnabled || $[29] !== t13) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $6cyWf.HasCustomThemeContext).Provider, {
            value: t5
        }, t13);
        $[28] = customTheme.isEnabled;
        $[29] = t13;
        $[30] = t14;
    } else t14 = $[30];
    return t14;
} : function TopNavNew({ children: children, xcss: xcss, height: heightProp, skipLinkLabel: skipLinkLabel = 'Top Bar', testId: testId, id: providedId, customTheme: customThemeConfig }) {
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const dangerouslyHoistSlotSizes = (0, $cozmU.useContext)((0, $b24kF.DangerouslyHoistSlotSizes));
    const id = (0, $eyPWA.useLayoutId)({
        providedId: providedId
    });
    (0, $eaAhc.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: (0, $iDrrr.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    const height = heightProp ?? (isFhsEnabled || (0, $iDrrr.fg)('platform_dst_ads_appswitcher_improvements') ? 56 : 48);
    const customTheme = (0, $4bc3706370e59ce2$export$92ae7a8762fba89e)(customThemeConfig);
    const hasDefaultBackground = customTheme.isEnabled ? customTheme.hasDefaultBackground : true;
    const { isExpandedOnDesktop: isExpandedOnDesktop } = (0, $gjVTm.useSideNavVisibility)();
    return /*#__PURE__*/ $cozmU.createElement((0, $6cyWf.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled
    }, /*#__PURE__*/ $cozmU.createElement((0, $f8DhE.HasDefaultBackgroundColorContext).Provider, {
        value: hasDefaultBackground
    }, /*#__PURE__*/ $cozmU.createElement("header", {
        id: id,
        "data-layout-slot": true,
        className: (0, $hekY6.default)([
            $d60c692a52442d30$var$styles.root,
            isFhsEnabled && $d60c692a52442d30$var$styles.fullHeightSidebar,
            isExpandedOnDesktop && isFhsEnabled && $d60c692a52442d30$var$styles.fullHeightSidebarExpanded,
            customTheme.isEnabled && !hasDefaultBackground && (0, $iDrrr.fg)('platform_dst_nav4_custom_theming_fhs_1') && $d60c692a52442d30$var$styles.fullHeightSidebarCustomTheming,
            xcss
        ]),
        "data-testid": testId,
        style: customTheme.isEnabled ? customTheme.style : undefined
    }, /*#__PURE__*/ $cozmU.createElement((0, $kPxjF.HoistCssVarToLocalGrid), {
        variableName: (0, $liCgE.topNavMountedVar),
        value: height
    }), dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ $cozmU.createElement((0, $4aMCy.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $liCgE.UNSAFE_topNavVar),
        value: height
    }), children)));
};
const $d60c692a52442d30$export$41d0d88a6b0e456f = (0, $rECdA.componentWithFG)('platform_dst_nav4_custom_theming_fhs_1', $d60c692a52442d30$var$TopNavNew, $d60c692a52442d30$var$TopNavOld);
module.exports["TopNav"] = $d60c692a52442d30$export$41d0d88a6b0e456f;

});

parcelRegister("k3d9G", function(module, exports) {
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
const $c64bb2ddccdd4e0c$var$isValidHex = (hex)=>// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex);
function $c64bb2ddccdd4e0c$export$103711ef09c6edec(color) {
    if (!$c64bb2ddccdd4e0c$var$isValidHex(color)) return null;
    let channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}
module.exports["parseHex"] = $c64bb2ddccdd4e0c$export$103711ef09c6edec;

});

parcelRegister("9Y4qw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $1NWCx = parcelRequire("1NWCx");


var $6TaGl = parcelRequire("6TaGl");


var $1IrNk = parcelRequire("1IrNk");


var $5wHqn = parcelRequire("5wHqn");


var $jg3tF = parcelRequire("jg3tF");

/* list.tsx generated by @compiled/babel-plugin v2.0.0 */ 


function $137c75d085a7c784$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ $cozmU.createElement("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId
    }, children));
}
const $137c75d085a7c784$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $cozmU.forwardRef)($137c75d085a7c784$var$_List);



var $1fHIr = parcelRequire("1fHIr");


var $6cyWf = parcelRequire("6cyWf");


var $bZTfQ = parcelRequire("bZTfQ");


var $liCgE = parcelRequire("liCgE");

const $756a03199878852d$var$containerStyles = {
    root: "_2j3gqA7LI7 _3iDTPbQ4SZ _37wbyuF05b _4ouGXIUofl _3eQEqqW9qI _15X6MhW9qI _04KkHPBmSS _3tZeuj2Njc _1xHhlhF05b",
    fullHeightSidebar: "_03SyCP8HPE"
};
const $756a03199878852d$var$listStyles = {
    root: "_2mHwu81Y8M _0hPCNLDIqT _3iDTPbQ4SZ",
    hideOnSmallViewport: "_3iDTPbYbGa _2UeR8bQ4SZ",
    popupContainer: "_4FKVYE2ADO"
}; /**
    * __TopNavEnd__
    *
    * Wrapper for the top navigation actions on the inline-end (right) side of the top navigation.
    *
    * On small viewports, the children will be placed inside a popup, and a button will be rendered to open the popup.
    * This is to prevent the actions from overflowing the top navigation.
    */ 
const $756a03199878852d$export$8b7a38b70a3c9839 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TopNavEnd(t0) {
    const $ = (0, $bDgLe.c)(16);
    const { children: children, label: t1, showMoreButtonLabel: t2 } = t0;
    const label = t1 === undefined ? "Actions" : t1;
    const showMoreButtonLabel = t2 === undefined ? "Show more" : t2;
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [isMobile, setIsMobile] = (0, $cozmU.useState)(false);
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = function onChange(event) {
            setIsMobile(event.matches);
            setIsOpen(false);
        };
        $[0] = t3;
    } else t3 = $[0];
    const query = (0, $jg3tF.UNSAFE_useMediaQuery)("below.sm", t3);
    let t4;
    if ($[1] !== query?.matches) {
        t4 = ()=>{
            setIsMobile(query?.matches ?? false);
        };
        $[1] = query?.matches;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== query) {
        t5 = [
            query
        ];
        $[3] = query;
        $[4] = t5;
    } else t5 = $[4];
    (0, $1NWCx.useLayoutEffect)(t4, t5);
    const t6 = isFhsEnabled && $756a03199878852d$var$containerStyles.fullHeightSidebar;
    let t7;
    if ($[5] !== t6) {
        t7 = (0, $hekY6.default)([
            $756a03199878852d$var$containerStyles.root,
            t6
        ]);
        $[5] = t6;
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== children || $[8] !== isMobile || $[9] !== isOpen || $[10] !== showMoreButtonLabel) {
        t8 = isMobile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-start",
            shouldRenderToParent: true,
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cyWf.HasCustomThemeContext).Provider, {
                    value: false
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $137c75d085a7c784$export$54c2e3dc7acea9f5), {
                    xcss: (0, $k12R1.cx)($756a03199878852d$var$listStyles.root, $756a03199878852d$var$listStyles.popupContainer)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1IrNk.OpenLayerObserverNamespaceProvider), {
                    namespace: (0, $liCgE.openLayerObserverTopNavEndNamespace)
                }, children))),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZTfQ.IconButton), {
                    ...triggerProps,
                    label: showMoreButtonLabel,
                    isSelected: isOpen,
                    onClick: ()=>setIsOpen(!isOpen),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                    isTooltipDisabled: false
                })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $137c75d085a7c784$export$54c2e3dc7acea9f5), {
            xcss: (0, $k12R1.cx)($756a03199878852d$var$listStyles.root, $756a03199878852d$var$listStyles.hideOnSmallViewport)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1IrNk.OpenLayerObserverNamespaceProvider), {
            namespace: (0, $liCgE.openLayerObserverTopNavEndNamespace)
        }, children));
        $[7] = children;
        $[8] = isMobile;
        $[9] = isOpen;
        $[10] = showMoreButtonLabel;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== label || $[13] !== t7 || $[14] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("nav", {
            "aria-label": label,
            className: t7
        }, t8);
        $[12] = label;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
    } else t9 = $[15];
    return t9;
} : function TopNavEnd({ children: children, label: label = 'Actions', showMoreButtonLabel: showMoreButtonLabel = 'Show more' }) {
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false); // Always setting to `false` for the initial render (will flip in an effect for mobile)
    const [isMobile, setIsMobile] = (0, $cozmU.useState)(false); // Note: `query` is a stable value between renders
    const query = (0, $jg3tF.UNSAFE_useMediaQuery)('below.sm', function onChange(event) {
        setIsMobile(event.matches); // Any time we shift between mobile and desktop
        // We always close the popup
        setIsOpen(false);
    });
    (0, $1NWCx.useLayoutEffect)(()=>{
        // The default is `false`, and desktop will remain as `false` (no re-render).
        // Mobile will flip from `false` to `true`.
        setIsMobile(query?.matches ?? false);
    }, [
        query
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("nav", {
        "aria-label": label,
        className: (0, $hekY6.default)([
            $756a03199878852d$var$containerStyles.root,
            isFhsEnabled && $756a03199878852d$var$containerStyles.fullHeightSidebar
        ])
    }, isMobile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        shouldRenderToParent: true,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cyWf.HasCustomThemeContext).Provider, {
                value: false
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $137c75d085a7c784$export$54c2e3dc7acea9f5), {
                xcss: (0, $k12R1.cx)($756a03199878852d$var$listStyles.root, $756a03199878852d$var$listStyles.popupContainer)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1IrNk.OpenLayerObserverNamespaceProvider), {
                namespace: (0, $liCgE.openLayerObserverTopNavEndNamespace)
            }, children))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZTfQ.IconButton), {
                ...triggerProps,
                label: showMoreButtonLabel,
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                isTooltipDisabled: false
            })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $137c75d085a7c784$export$54c2e3dc7acea9f5), {
        xcss: (0, $k12R1.cx)($756a03199878852d$var$listStyles.root, $756a03199878852d$var$listStyles.hideOnSmallViewport)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1IrNk.OpenLayerObserverNamespaceProvider), {
        namespace: (0, $liCgE.openLayerObserverTopNavEndNamespace)
    }, children)));
};
module.exports["TopNavEnd"] = $756a03199878852d$export$8b7a38b70a3c9839;

});

parcelRegister("kGTRV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $1IrNk = parcelRequire("1IrNk");


var $liCgE = parcelRequire("liCgE");

const $fba4eedc22aa5c92$var$styles = {
    root: "_2mHwu82ADO _2j3gqAiZR3 _39xV02N91d _0hPCNLDIqT _3iDTPbQ4SZ _37wbyuF05b _2UeR8bgBM8 _3E0AG21EBl _1p7Awjbt8w _4itPyXW9qI _2x7hvAF05b"
}; /**
    * __TopNavMiddle__
    *
    * Wrapper for the actions in the middle of the top navigation.
    *
    * Expects that the search bar is the first child.
    * If it is not, you might see unexpected layout behavior.
    */ 
const $fba4eedc22aa5c92$export$88836ac6da0f492f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TopNavMiddle(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $fba4eedc22aa5c92$var$styles.root
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1IrNk.OpenLayerObserverNamespaceProvider), {
            namespace: (0, $liCgE.openLayerObserverTopNavMiddleNamespace)
        }, children));
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function TopNavMiddle({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $fba4eedc22aa5c92$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1IrNk.OpenLayerObserverNamespaceProvider), {
        namespace: (0, $liCgE.openLayerObserverTopNavMiddleNamespace)
    }, children));
};
module.exports["TopNavMiddle"] = $fba4eedc22aa5c92$export$88836ac6da0f492f;

});

parcelRegister("anG8x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $jyAY3 = parcelRequire("jyAY3");


var $1IrNk = parcelRequire("1IrNk");


var $iDrrr = parcelRequire("iDrrr");


var $jg3tF = parcelRequire("jg3tF");


var $2iFcu = parcelRequire("2iFcu");


var $1fHIr = parcelRequire("1fHIr");


var $6cyWf = parcelRequire("6cyWf");


var $f8DhE = parcelRequire("f8DhE");


var $liCgE = parcelRequire("liCgE");


var $5rNCB = parcelRequire("5rNCB");


var $gjVTm = parcelRequire("gjVTm");

let $fca1197362f739a6$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1; // Placed in a variable, as the value is used in the translateX value for the children wrapper animation.
const $fca1197362f739a6$var$flexGap = "var(--ds-space-050, 4px)"; /**
                                             * Styles for the TopNavStart element.
                                             *
                                             * When `useIsFhsEnabled` is true this is the styling for the inner element,
                                             * which re-enables pointer events.
                                             */ 
const $fca1197362f739a6$var$innerStyles = {
    root: "_2mHwu81Y8M _2j3gqA7dHp _0jFU0VN91d _0hPCNLDIqT _3iDTPbQ4SZ _15X6MhW9qI _04KkHPBmSS _3tZeuj2Njc",
    fullHeightSidebarExpanded: "_04KkHPZqHV _15X6MhN91d"
}; /**
    * Styles for the outer element, that does not have re-enabled pointer events and spans the entire
    * width of the TopNavStart area.
    *
    * This wrapper element is only rendered when `useIsFhsEnabled` is true.
    */ 
const $fca1197362f739a6$var$wrapperStyles = {
    root: "_24h04i2Njc _0LQT5E8HPE _0jFU0VN91d _2DiRUzRAKS _3LGMrXogpp _1jgrOPWVPG _4si1UwdnbC _2Q6odvdnbC _0W5cBndnbC _3L4Jl0NvrM _0hPRjj6wH8 _0gJ73r9r67 _1sRjPqdnbC",
    fullHeightSidebarExpanded: "_15X6MheXXS _0Z95yk8HPE _0hAebtlfZc _1sRjPq7dHp",
    fullHeightSidebarBorderTransition: "_1x6R3U9v2r _28kFy52HTN _1ga5wYDgop",
    fullHeightSidebarCustomTheming: "_0hAebtDHe6 _3PYyoLYbGa"
}; /**
    * We use a fixed translateX offset for the slide animation (used when the TopNavStart children elements are reordered).
    * This fixed offset makes the elements appear to animate smoothly from the old to the new position.
    * This offset is calculated based on:
    * - 32px (2rem) width of the side nav toggle button (IconButton)
    * - 4px gap ('space.050' token) of the flex container
    *
    * The benefit of hardcoding this offset is that we don't need to calculate it using JS each time the sidebar is toggled.
    * However, it could become out of sync if the width of IconButton changes.
    *
    * The alternative is using JS to store the previous position of the children wrapper element, and calculate the offset based on
    * the new position, and then transforming using that offset. This would prevent the animation from going out of sync.
    */ 
const $fca1197362f739a6$var$childrenWrapperAnimationOffset = `calc(2rem + ${$fca1197362f739a6$var$flexGap})`;
const $fca1197362f739a6$var$childrenWrapperStyles = {
    root: "_2mHwu8OLYo _3iDTPbOLYo _0hPCNLDIqT _4ouGXIdnbC _2LGtmL7dHp _0pbPskvQQr",
    animationBaseStyles: "_2qDx9mC67X",
    finalPosition: "_1uhENMlna5 _03Q0ee2HTN",
    expandAnimationStartPosition: "_1uhENMghmk",
    collapseAnimationStartPosition: "_1uhENMgZsO"
}; /**
    * We use a fixed translateX offset for the toggle button slide animation (used when the TopNavStart children elements are reordered).
    * The specific value doesn't matter too much for the toggle button animation, so we are using `100%`, which will match the toggle button width.
    *
    * By combining the `translateX` animation with an `opacity` fade, the feel and experience is actually quite similar to animating the
    * element from the exact old position (offset), and it avoids the additional complexity of needing to track and calculate the exact offset.
    */ 
const $fca1197362f739a6$var$toggleButtonWrapperStyles = {
    root: "_2LGtmL7dHp _0pbPskvQQr _2qDx9m0a1V",
    finalPosition: "_1uhENMlna5 _03Q0ee2HTN _0KUEEl7dHp",
    expandAnimationStartPosition: "_1uhENMJF1Y _0KUEEldnbC",
    collapseAnimationStartPosition: "_1uhENMpSHp _0KUEEldnbC",
    expandAnimationTimingFunction: "_4BklsuN8t6",
    collapseAnimationTimingFunction: "_4BklsuUtCU",
    alignEnd: "_0GTcwRIZbP"
}; /**
    * The consistent key used for the side nav toggle button to ensure it does not get remounted
    * when it is reordered.
    *
    * This ensures we get focus restoration for free.
    */ 
const $fca1197362f739a6$var$sideNavToggleButtonKey = 'side-nav-toggle-button';
const $fca1197362f739a6$var$TopNavStartInnerOld = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function TopNavStartInner(t0, ref) {
    const $ = (0, $bDgLe.c)(5);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $fca1197362f739a6$var$innerStyles.root
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== ref || $[3] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: ref,
            "data-testid": testId,
            className: t1
        }, children);
        $[1] = children;
        $[2] = ref;
        $[3] = testId;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function TopNavStartInner({ children: children, testId: testId }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $fca1197362f739a6$var$innerStyles.root
        ])
    }, children);
});
const $fca1197362f739a6$var$TopNavStartInnerFHS = /*#__PURE__*/ (0, $cozmU.forwardRef)(function TopNavStartInnerFHS({ children: children, testId: testId }, ref) {
    // This needs the real `defaultCollapsed` state or will not SSR properly
    // TODO: lift `defaultCollapsed` state to `Root` (DSP-23683)
    // then context value will be correct in SSR / from initial render
    const { isExpandedOnDesktop: isExpandedOnDesktop } = (0, $gjVTm.useSideNavVisibility)({
        defaultCollapsed: true
    });
    const sideNavState = (0, $cozmU.useContext)((0, $5rNCB.SideNavVisibilityState));
    const isFirstRenderRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        // Ignore renders until the side nav state is initialized
        // So that apps using the legacy API for setting side nav default state do not see
        // animations when they shouldn't
        if (sideNavState === null) return;
        if (isFirstRenderRef.current) isFirstRenderRef.current = false;
    }, [
        sideNavState
    ]);
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const hasDefaultBackgroundColor = (0, $cozmU.useContext)((0, $f8DhE.HasDefaultBackgroundColorContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $fca1197362f739a6$var$wrapperStyles.root,
            isExpandedOnDesktop && $fca1197362f739a6$var$wrapperStyles.fullHeightSidebarExpanded,
            !isFirstRenderRef.current && isExpandedOnDesktop && $fca1197362f739a6$var$wrapperStyles.fullHeightSidebarBorderTransition,
            hasCustomTheme && !hasDefaultBackgroundColor && (0, $iDrrr.fg)('platform_dst_nav4_custom_theming_fhs_1') && $fca1197362f739a6$var$wrapperStyles.fullHeightSidebarCustomTheming
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $fca1197362f739a6$var$innerStyles.root,
            isExpandedOnDesktop && $fca1197362f739a6$var$innerStyles.fullHeightSidebarExpanded
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1IrNk.OpenLayerObserverNamespaceProvider), {
        namespace: (0, $liCgE.openLayerObserverTopNavStartNamespace)
    }, children)));
}); /**
     * __TopNavStart__
     *
     * Wrapper for the top navigation actions on the inline-start (left) side of the top navigation.
     */ 
const $fca1197362f739a6$export$4c15269b98c5129 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TopNavStart(t0) {
    const $ = (0, $bDgLe.c)(39);
    const { children: children, testId: testId, sideNavToggleButton: sideNavToggleButton } = t0;
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const ref = (0, $cozmU.useContext)((0, $2iFcu.TopNavStartAttachRef));
    const elementRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== ref) {
        t1 = ()=>{
            ref(elementRef.current);
        };
        t2 = [
            elementRef,
            ref
        ];
        $[0] = ref;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            defaultCollapsed: true
        };
        $[3] = t3;
    } else t3 = $[3];
    const { isExpandedOnDesktop: isExpandedOnDesktop } = (0, $gjVTm.useSideNavVisibility)(t3);
    const [isDesktop, setIsDesktop] = (0, $cozmU.useState)(true);
    let t4;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            if (typeof window !== "undefined" && typeof window.matchMedia === "function") setIsDesktop(window.matchMedia("(min-width: 64rem)").matches);
        };
        t5 = [];
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    (0, $cozmU.useLayoutEffect)(t4, t5);
    (0, $jg3tF.UNSAFE_useMediaQuery)("above.md", (event)=>{
        setIsDesktop(event.matches);
    });
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            type: "idle"
        };
        $[6] = t6;
    } else t6 = $[6];
    const [animationState, setAnimationState] = (0, $cozmU.useState)(t6);
    const isFirstRenderRef = (0, $cozmU.useRef)(true);
    const sideNavState = (0, $cozmU.useContext)((0, $5rNCB.SideNavVisibilityState));
    let t7;
    let t8;
    if ($[7] !== isFhsEnabled || $[8] !== sideNavState) {
        t7 = ()=>{
            if (!isFhsEnabled) return;
            if (sideNavState === null) return;
            if (isFirstRenderRef.current) isFirstRenderRef.current = false;
        };
        t8 = [
            isFhsEnabled,
            sideNavState
        ];
        $[7] = isFhsEnabled;
        $[8] = sideNavState;
        $[9] = t7;
        $[10] = t8;
    } else {
        t7 = $[9];
        t8 = $[10];
    }
    (0, $cozmU.useEffect)(t7, t8);
    const sideNavToggleButtonStableRef = (0, $jyAY3.default)(sideNavToggleButton);
    let t10;
    let t9;
    if ($[11] !== isExpandedOnDesktop || $[12] !== isFhsEnabled || $[13] !== sideNavToggleButtonStableRef) {
        t9 = ()=>{
            if (!isFhsEnabled) return;
            if (isFirstRenderRef.current) return;
            if (!sideNavToggleButtonStableRef.current) return;
            setAnimationState({
                type: isExpandedOnDesktop ? "expand" : "collapse"
            });
            requestAnimationFrame(()=>{
                setAnimationState({
                    type: "idle"
                });
            });
        };
        t10 = [
            isExpandedOnDesktop,
            isFhsEnabled,
            sideNavToggleButtonStableRef
        ];
        $[11] = isExpandedOnDesktop;
        $[12] = isFhsEnabled;
        $[13] = sideNavToggleButtonStableRef;
        $[14] = t10;
        $[15] = t9;
    } else {
        t10 = $[14];
        t9 = $[15];
    }
    (0, $cozmU.useLayoutEffect)(t9, t10);
    const TopNavStartInner = isFhsEnabled ? $fca1197362f739a6$var$TopNavStartInnerFHS : $fca1197362f739a6$var$TopNavStartInnerOld;
    const t11 = !isFhsEnabled && sideNavToggleButton;
    let t12;
    if ($[16] !== animationState || $[17] !== isDesktop || $[18] !== isExpandedOnDesktop || $[19] !== isFhsEnabled || $[20] !== sideNavToggleButton) {
        t12 = sideNavToggleButton && (!isDesktop || !isExpandedOnDesktop) && isFhsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: $fca1197362f739a6$var$sideNavToggleButtonKey,
            className: (0, $hekY6.default)([
                !$fca1197362f739a6$var$isFirefox && $fca1197362f739a6$var$toggleButtonWrapperStyles.root,
                !$fca1197362f739a6$var$isFirefox && animationState.type === "idle" && $fca1197362f739a6$var$toggleButtonWrapperStyles.finalPosition,
                !$fca1197362f739a6$var$isFirefox && animationState.type === "idle" && $fca1197362f739a6$var$toggleButtonWrapperStyles.collapseAnimationTimingFunction,
                !$fca1197362f739a6$var$isFirefox && animationState.type === "collapse" && $fca1197362f739a6$var$toggleButtonWrapperStyles.collapseAnimationStartPosition
            ])
        }, sideNavToggleButton);
        $[16] = animationState;
        $[17] = isDesktop;
        $[18] = isExpandedOnDesktop;
        $[19] = isFhsEnabled;
        $[20] = sideNavToggleButton;
        $[21] = t12;
    } else t12 = $[21];
    let t13;
    if ($[22] !== animationState || $[23] !== children || $[24] !== isFhsEnabled) {
        t13 = isFhsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $fca1197362f739a6$var$childrenWrapperStyles.root,
                !$fca1197362f739a6$var$isFirefox && $fca1197362f739a6$var$childrenWrapperStyles.animationBaseStyles,
                !$fca1197362f739a6$var$isFirefox && animationState.type === "idle" && $fca1197362f739a6$var$childrenWrapperStyles.finalPosition,
                !$fca1197362f739a6$var$isFirefox && animationState.type === "expand" && $fca1197362f739a6$var$childrenWrapperStyles.expandAnimationStartPosition,
                !$fca1197362f739a6$var$isFirefox && animationState.type === "collapse" && $fca1197362f739a6$var$childrenWrapperStyles.collapseAnimationStartPosition
            ])
        }, children) : children;
        $[22] = animationState;
        $[23] = children;
        $[24] = isFhsEnabled;
        $[25] = t13;
    } else t13 = $[25];
    let t14;
    if ($[26] !== animationState || $[27] !== isDesktop || $[28] !== isExpandedOnDesktop || $[29] !== isFhsEnabled || $[30] !== sideNavToggleButton) {
        t14 = sideNavToggleButton && isDesktop && isExpandedOnDesktop && isFhsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: $fca1197362f739a6$var$sideNavToggleButtonKey,
            className: (0, $hekY6.default)([
                !$fca1197362f739a6$var$isFirefox && $fca1197362f739a6$var$toggleButtonWrapperStyles.root,
                $fca1197362f739a6$var$toggleButtonWrapperStyles.alignEnd,
                !$fca1197362f739a6$var$isFirefox && animationState.type === "idle" && $fca1197362f739a6$var$toggleButtonWrapperStyles.finalPosition,
                !$fca1197362f739a6$var$isFirefox && animationState.type === "idle" && $fca1197362f739a6$var$toggleButtonWrapperStyles.expandAnimationTimingFunction,
                !$fca1197362f739a6$var$isFirefox && animationState.type === "expand" && $fca1197362f739a6$var$toggleButtonWrapperStyles.expandAnimationStartPosition
            ])
        }, sideNavToggleButton);
        $[26] = animationState;
        $[27] = isDesktop;
        $[28] = isExpandedOnDesktop;
        $[29] = isFhsEnabled;
        $[30] = sideNavToggleButton;
        $[31] = t14;
    } else t14 = $[31];
    let t15;
    if ($[32] !== TopNavStartInner || $[33] !== t11 || $[34] !== t12 || $[35] !== t13 || $[36] !== t14 || $[37] !== testId) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(TopNavStartInner, {
            ref: elementRef,
            testId: testId
        }, t11, t12, t13, t14);
        $[32] = TopNavStartInner;
        $[33] = t11;
        $[34] = t12;
        $[35] = t13;
        $[36] = t14;
        $[37] = testId;
        $[38] = t15;
    } else t15 = $[38];
    return t15;
} : function TopNavStart({ children: children, testId: testId, sideNavToggleButton: sideNavToggleButton }) {
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const ref = (0, $cozmU.useContext)((0, $2iFcu.TopNavStartAttachRef));
    const elementRef = (0, $cozmU.useRef)(null); // FIXME: unsafe pattern with Suspense, should use callback ref / store in state
    // Should handle the underlying HTMLElement changing without a remount
    (0, $cozmU.useEffect)(()=>{
        ref(elementRef.current);
    }, [
        elementRef,
        ref
    ]); // This needs the real `defaultCollapsed` state or will not SSR properly
    // TODO: lift `defaultCollapsed` state to `Root` (DSP-23683)
    // then context value will be correct in SSR / from initial render
    const { isExpandedOnDesktop: isExpandedOnDesktop } = (0, $gjVTm.useSideNavVisibility)({
        defaultCollapsed: true
    }); // For SSR assume desktop
    const [isDesktop, setIsDesktop] = (0, $cozmU.useState)(true); // Set state to real value on client
    // This could result in some visible shift on mobile when hydrating SSR
    // TODO: review and improve SSR behavior as necessary (DSP-23817)
    (0, $cozmU.useLayoutEffect)(()=>{
        // Checking this to avoid breaking tests when `matchMedia` is not mocked
        // Ideally we wouldn't cater to test environments, but this avoids introducing unnecessary friction
        if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') setIsDesktop(window.matchMedia('(min-width: 64rem)').matches);
    }, []);
    (0, $jg3tF.UNSAFE_useMediaQuery)('above.md', (event)=>{
        setIsDesktop(event.matches);
    });
    const [animationState, setAnimationState] = (0, $cozmU.useState)({
        type: 'idle'
    }); // Used to prevent the reorder animations from running on the initial render.
    const isFirstRenderRef = (0, $cozmU.useRef)(true);
    const sideNavState = (0, $cozmU.useContext)((0, $5rNCB.SideNavVisibilityState));
    (0, $cozmU.useEffect)(()=>{
        if (!isFhsEnabled) return;
         // Ignore renders until the side nav state is initialized
        // So that apps using the legacy API for setting side nav default state do not see
        // animations when they shouldn't
        if (sideNavState === null) return;
        if (isFirstRenderRef.current) isFirstRenderRef.current = false;
    }, [
        isFhsEnabled,
        sideNavState
    ]); // Using a stable ref to avoid re-running the animation layout effect when the toggle button prop value changes, which
    // can happen a lot (e.g. if the parent re-renders)
    const sideNavToggleButtonStableRef = (0, $jyAY3.default)(sideNavToggleButton);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!isFhsEnabled) return;
         /**
       * This layout effect is used to animate the TopNavStart children elements to their new position after being reordered.
       * It is called when the sidebar's desktop expansion state changes.
       *
       * It works by first setting a translateX offset on the elements, used as the start position of the slide animation.
       * - For the toggle button, it's a fixed offset. It's combined with an opacity, so the exact offset doesn't matter too much.
       * - For the children wrapper (wrapping everything except the toggle button), an offset was chosen to make the animation
       * start position the exact same as the element's old position. See comments for `childrenWrapperStyles` for more details.
       *
       * On the next frame, the translateX offset is cleared, triggering the animation to the new position.
       */ 
        if (isFirstRenderRef.current) // No animations on initial render.
        return;
        if (!sideNavToggleButtonStableRef.current) // If there is no toggle button, there should be no re-order animations.
        return;
         // Set the translateX offsets so elements are ready to animate to their actual new position after being reordered
        setAnimationState({
            type: isExpandedOnDesktop ? 'expand' : 'collapse'
        });
        requestAnimationFrame(()=>{
            // Clear translateX offsets on next frame to trigger animation to new position in a re-render
            setAnimationState({
                type: 'idle'
            });
        }); // This layout effect is called when the sidebar's desktop expansion state changes.
    }, [
        isExpandedOnDesktop,
        isFhsEnabled,
        sideNavToggleButtonStableRef
    ]);
    const TopNavStartInner = isFhsEnabled ? $fca1197362f739a6$var$TopNavStartInnerFHS : $fca1197362f739a6$var$TopNavStartInnerOld;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(TopNavStartInner, {
        ref: elementRef,
        testId: testId
    }, !isFhsEnabled && sideNavToggleButton, sideNavToggleButton && (!isDesktop || !isExpandedOnDesktop) && isFhsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        key: $fca1197362f739a6$var$sideNavToggleButtonKey,
        className: (0, $hekY6.default)([
            !$fca1197362f739a6$var$isFirefox && $fca1197362f739a6$var$toggleButtonWrapperStyles.root,
            !$fca1197362f739a6$var$isFirefox && animationState.type === 'idle' && $fca1197362f739a6$var$toggleButtonWrapperStyles.finalPosition,
            !$fca1197362f739a6$var$isFirefox && // Timing function is applied when the browser animates to the idle position.
            animationState.type === 'idle' && $fca1197362f739a6$var$toggleButtonWrapperStyles.collapseAnimationTimingFunction,
            !$fca1197362f739a6$var$isFirefox && animationState.type === 'collapse' && $fca1197362f739a6$var$toggleButtonWrapperStyles.collapseAnimationStartPosition
        ])
    }, sideNavToggleButton), isFhsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $fca1197362f739a6$var$childrenWrapperStyles.root,
            !$fca1197362f739a6$var$isFirefox && $fca1197362f739a6$var$childrenWrapperStyles.animationBaseStyles,
            !$fca1197362f739a6$var$isFirefox && animationState.type === 'idle' && $fca1197362f739a6$var$childrenWrapperStyles.finalPosition,
            !$fca1197362f739a6$var$isFirefox && animationState.type === 'expand' && $fca1197362f739a6$var$childrenWrapperStyles.expandAnimationStartPosition,
            !$fca1197362f739a6$var$isFirefox && animationState.type === 'collapse' && $fca1197362f739a6$var$childrenWrapperStyles.collapseAnimationStartPosition
        ])
    }, children) : children, sideNavToggleButton && isDesktop && isExpandedOnDesktop && isFhsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        key: $fca1197362f739a6$var$sideNavToggleButtonKey,
        className: (0, $hekY6.default)([
            !$fca1197362f739a6$var$isFirefox && $fca1197362f739a6$var$toggleButtonWrapperStyles.root,
            $fca1197362f739a6$var$toggleButtonWrapperStyles.alignEnd,
            !$fca1197362f739a6$var$isFirefox && animationState.type === 'idle' && $fca1197362f739a6$var$toggleButtonWrapperStyles.finalPosition,
            !$fca1197362f739a6$var$isFirefox && // Timing function is applied when the browser animates to the idle position.
            animationState.type === 'idle' && $fca1197362f739a6$var$toggleButtonWrapperStyles.expandAnimationTimingFunction,
            !$fca1197362f739a6$var$isFirefox && animationState.type === 'expand' && $fca1197362f739a6$var$toggleButtonWrapperStyles.expandAnimationStartPosition
        ])
    }, sideNavToggleButton));
};
module.exports["TopNavStart"] = $fca1197362f739a6$export$4c15269b98c5129;

});

parcelRegister("eBBZq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4n1IT = parcelRequire("4n1IT");


var $9DHhW = parcelRequire("9DHhW");


var $gyUf8 = parcelRequire("gyUf8");


var $hzOq6 = parcelRequire("hzOq6");





var $kmQhR = parcelRequire("kmQhR");


var $3pwdT = parcelRequire("3pwdT");


var $b10hq = parcelRequire("b10hq");


var $fqcDI = parcelRequire("fqcDI");

var $abcd96fcf4fe6cd2$export$2e2bcd8739ae039 = ()=>{
    (0, $fqcDI.loadAtlassianSwitcher)();
    return (0, $fqcDI.loadGenericSwitcher)();
};



var $aAAmd = parcelRequire("aAAmd");


var $1xyxN = parcelRequire("1xyxN");

const $ff36a0cd9ad04cdd$export$aba5d6cf034db22e = (props)=>{
    const { cloudId: cloudId, product: product } = props;
    (0, $abcd96fcf4fe6cd2$export$2e2bcd8739ae039)();
    (0, $aAAmd.prefetchFlightDeck)({});
    (0, $3pwdT.prefetchAvailableProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $1xyxN.prefetchThirdPartyProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $b10hq.prefetchJoinableSites)(props.joinableSitesDataProvider);
};



var $6M59K = parcelRequire("6M59K");


var $bLbuQ = parcelRequire("bLbuQ");
var $eq1BO = parcelRequire("eq1BO");
var $852mP = parcelRequire("852mP");
var $lzgC6 = parcelRequire("lzgC6");


var $veDrf = parcelRequire("veDrf");

const $d402efd71d770038$var$THROTTLE_EXPIRES = 60000; // 60 seconds
const $d402efd71d770038$var$THROTTLE_OPTIONS = {
    leading: true,
    trailing: false
};
const $d402efd71d770038$var$TRIGGER_CONTEXT = {
    componentName: (0, $bLbuQ.TRIGGER_COMPONENT),
    ...(0, $veDrf.default)
};
class $d402efd71d770038$var$PrefetchTrigger extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { children: children, Container: Container = 'div' } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Container, {
            onFocus: this.handleMouseEnter,
            onMouseEnter: this.handleMouseEnter,
            onClick: this.handleMouseClick
        }, children);
    }
    constructor(...args){
        super(...args);
        this.lastEnteredAt = void 0;
        this.fireOperationalEvent = (payload)=>{
            if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                actionSubject: (0, $bLbuQ.TRIGGER_SUBJECT),
                ...payload
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
        };
        this.triggerPrefetch = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(()=>{
            (0, $ff36a0cd9ad04cdd$export$aba5d6cf034db22e)(this.props);
            this.fireOperationalEvent({
                action: 'triggered'
            });
        }, $d402efd71d770038$var$THROTTLE_EXPIRES, $d402efd71d770038$var$THROTTLE_OPTIONS);
        this.handleMouseEnter = ()=>{
            this.triggerPrefetch();
            this.lastEnteredAt = (0, $6M59K.performanceNow)();
        };
        this.handleMouseClick = ()=>{
            if (this.lastEnteredAt) {
                const hoverToClick = Math.round((0, $6M59K.performanceNow)() - this.lastEnteredAt);
                this.fireOperationalEvent({
                    action: 'clicked',
                    attributes: {
                        hoverToClick: hoverToClick
                    }
                });
            }
        };
    }
}
const $d402efd71d770038$var$PrefetchTriggerWithEvents = (0, $lzgC6.default)()($d402efd71d770038$var$PrefetchTrigger);
var $d402efd71d770038$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eq1BO.NavigationAnalyticsContext), {
        data: $d402efd71d770038$var$TRIGGER_CONTEXT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d402efd71d770038$var$PrefetchTriggerWithEvents, props));



var $1hcxO = parcelRequire("1hcxO");


var $dPJCf = parcelRequire("dPJCf");


var $56QzY = parcelRequire("56QzY");


var $bQm3c = parcelRequire("bQm3c");




/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable no-restricted-imports */ 
var $8aG6j = parcelRequire("8aG6j");





var $hekY6 = parcelRequire("hekY6");


var $cXtTj = parcelRequire("cXtTj");


var $9NPFC = parcelRequire("9NPFC");


var $gtMdU = parcelRequire("gtMdU");










const $6ae6c26522a72ef8$export$a4c96b4ef1bf8976 = 'optout_all_messages';
const $6ae6c26522a72ef8$export$f64870f8abb59f0b = 'optout_all_messages_user';
const $6ae6c26522a72ef8$export$48e1d3fa57b0a2d5 = 'optoutAllMessages';
const $6ae6c26522a72ef8$export$5ede056addcc7dcf = `${$6ae6c26522a72ef8$export$48e1d3fa57b0a2d5}.fetchSiteOptout succeeded`;
const $6ae6c26522a72ef8$export$a16c0f38ba8f83e8 = `${$6ae6c26522a72ef8$export$48e1d3fa57b0a2d5}.fetchSiteOptout failed`;
const $6ae6c26522a72ef8$export$2b6f8d7fd154b638 = `${$6ae6c26522a72ef8$export$48e1d3fa57b0a2d5}.fetchSiteUserOptout succeeded`;
const $6ae6c26522a72ef8$export$74a38b22acdaeea2 = `${$6ae6c26522a72ef8$export$48e1d3fa57b0a2d5}.fetchSiteUserOptout failed`;
const $6ae6c26522a72ef8$export$85183a312807388d = 'postOffice';
const $6ae6c26522a72ef8$export$947dac6c72b26f81 = 'track';
const $6ae6c26522a72ef8$export$338a9c38f183f620 = 100; // 0.1 second


const $8ff9bae60bf52a82$var$getTraceId = (response)=>{
    const traceIdHeader = [
        'atl-traceid',
        'x-trace-id'
    ].find((header)=>response.headers?.has(header));
    return traceIdHeader === undefined ? undefined : response.headers.get(traceIdHeader) ?? undefined;
};
class $8ff9bae60bf52a82$var$FetchError extends Error {
    constructor(statusCode, message, traceId, originalResponse){
        super(message || `Fetch call failed with status code: ${statusCode}`);
        this.skipSentry = void 0;
        this.statusCode = void 0;
        this.traceId = void 0;
        this.originalResponse = void 0;
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.originalResponse = originalResponse;
        this.skipSentry = statusCode === 401;
        if (traceId) this.traceId = traceId;
    }
}
const $8ff9bae60bf52a82$var$getDevHostname = ()=>{
    const envDns = undefined;
    return typeof envDns === 'string' && envDns.trim() ? envDns.trim() : 'localhost';
};
const $8ff9bae60bf52a82$var$getProxyServerPort = ()=>{
    return 9000;
};
const $8ff9bae60bf52a82$var$LOCAL_URL = new URL(`${'http'}://${$8ff9bae60bf52a82$var$getDevHostname()}:${$8ff9bae60bf52a82$var$getProxyServerPort()}`);
const $8ff9bae60bf52a82$var$getReroutableURL = (pathOrURL)=>{
    var e;
    return pathOrURL;
};
const $8ff9bae60bf52a82$var$defaultOptions = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
};
let $8ff9bae60bf52a82$var$cachedFetches = {};
let $8ff9bae60bf52a82$var$siteOptoutStatuses = {};
let $8ff9bae60bf52a82$var$siteUserOptoutStatuses = {};
let $8ff9bae60bf52a82$var$firedAnalyticsEvents = {};
let $8ff9bae60bf52a82$var$isAnalyticsDebounceEnabled = true;
const $8ff9bae60bf52a82$export$d2adf65b87e47523 = ()=>{
    $8ff9bae60bf52a82$var$siteOptoutStatuses = {};
    $8ff9bae60bf52a82$var$siteUserOptoutStatuses = {};
    $8ff9bae60bf52a82$var$cachedFetches = {};
};
const $8ff9bae60bf52a82$var$clearFetchCacheForUrl = (url)=>{
    delete $8ff9bae60bf52a82$var$cachedFetches[url];
};
const $8ff9bae60bf52a82$var$fetchJsonWithCache = (url, options = {})=>{
    let fetchPromise = $8ff9bae60bf52a82$var$cachedFetches[url];
    if (fetchPromise) return fetchPromise;
    fetchPromise = fetch($8ff9bae60bf52a82$var$getReroutableURL(url), {
        ...$8ff9bae60bf52a82$var$defaultOptions,
        ...options
    });
    $8ff9bae60bf52a82$var$cachedFetches[url] = fetchPromise;
    return fetchPromise;
};
const $8ff9bae60bf52a82$var$fetchJson = (url, options = {})=>$8ff9bae60bf52a82$var$fetchJsonWithCache(url, options).then((response)=>{
        if (!response.ok) {
            const traceId = $8ff9bae60bf52a82$var$getTraceId(response);
            if (traceId !== undefined && traceId.length > 0) throw new $8ff9bae60bf52a82$var$FetchError(response.status, `Fetch call failed with status code: ${response.status}`, traceId, response);
            else throw new $8ff9bae60bf52a82$var$FetchError(response.status, undefined, undefined, response);
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return response.clone().json();
    });
const $8ff9bae60bf52a82$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $8ff9bae60bf52a82$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $8ff9bae60bf52a82$var$parseOptoutTraitStatus = (attributes, attributeName)=>{
    const optoutValue = attributes.find(({ name: name })=>name === attributeName)?.value;
    return optoutValue ? 'is-opted-out' : 'no-opt-out';
};
const $8ff9bae60bf52a82$var$parseSiteOptoutTraitStatus = (attributes)=>{
    return $8ff9bae60bf52a82$var$parseOptoutTraitStatus(attributes, (0, $6ae6c26522a72ef8$export$a4c96b4ef1bf8976));
};
const $8ff9bae60bf52a82$var$parseSiteUserOptoutTraitStatus = (attributes)=>{
    return $8ff9bae60bf52a82$var$parseOptoutTraitStatus(attributes, (0, $6ae6c26522a72ef8$export$f64870f8abb59f0b));
};
const $8ff9bae60bf52a82$var$fetchSiteTraitData = async (cloudId)=>{
    if (Boolean($8ff9bae60bf52a82$var$siteOptoutStatuses[cloudId]) && ($8ff9bae60bf52a82$var$siteOptoutStatuses[cloudId] === 'is-opted-out' || $8ff9bae60bf52a82$var$siteOptoutStatuses[cloudId] === 'no-opt-out')) return {
        optoutStatus: $8ff9bae60bf52a82$var$siteOptoutStatuses[cloudId],
        cached: true
    };
    try {
        const url = $8ff9bae60bf52a82$var$getPersonalizationSiteTraitsUrl(cloudId);
        if ($8ff9bae60bf52a82$var$siteOptoutStatuses[cloudId] === 'error') $8ff9bae60bf52a82$var$clearFetchCacheForUrl(url);
        const { attributes: attributes } = await $8ff9bae60bf52a82$var$fetchJson(url, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'x-atlassian-mau-ignore': 'true'
            }
        });
        $8ff9bae60bf52a82$var$siteOptoutStatuses[cloudId] = $8ff9bae60bf52a82$var$parseSiteOptoutTraitStatus(attributes);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching site personalization:', error);
        $8ff9bae60bf52a82$var$siteOptoutStatuses[cloudId] = 'error';
        throw error;
    }
    return {
        optoutStatus: $8ff9bae60bf52a82$var$siteOptoutStatuses[cloudId],
        cached: false
    };
};
const $8ff9bae60bf52a82$var$fetchSiteUserTraitData = async (cloudId, userId)=>{
    if (Boolean($8ff9bae60bf52a82$var$siteUserOptoutStatuses[cloudId]?.[userId]) && ($8ff9bae60bf52a82$var$siteUserOptoutStatuses[cloudId]?.[userId] === 'is-opted-out' || $8ff9bae60bf52a82$var$siteUserOptoutStatuses[cloudId]?.[userId] === 'no-opt-out')) return {
        optoutStatus: $8ff9bae60bf52a82$var$siteUserOptoutStatuses[cloudId]?.[userId],
        cached: true
    };
    try {
        const url = $8ff9bae60bf52a82$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId);
        if ($8ff9bae60bf52a82$var$siteUserOptoutStatuses[cloudId]?.[userId] === 'error') $8ff9bae60bf52a82$var$clearFetchCacheForUrl(url);
        const { attributes: attributes } = await $8ff9bae60bf52a82$var$fetchJson(url, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'x-atlassian-mau-ignore': 'true'
            }
        });
        $8ff9bae60bf52a82$var$siteUserOptoutStatuses[cloudId] = {
            ...$8ff9bae60bf52a82$var$siteUserOptoutStatuses[cloudId] ?? {},
            [userId]: $8ff9bae60bf52a82$var$parseSiteUserOptoutTraitStatus(attributes)
        };
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching site user personalization:', error);
        $8ff9bae60bf52a82$var$siteUserOptoutStatuses[cloudId] = {
            ...$8ff9bae60bf52a82$var$siteUserOptoutStatuses[cloudId] ?? {},
            [userId]: 'error'
        };
        throw error;
    }
    return {
        optoutStatus: $8ff9bae60bf52a82$var$siteUserOptoutStatuses[cloudId][userId],
        cached: false
    };
};
/**
 * | Site / Site user | initial      | is-opted-out | no-opt-out   | error        |
 * |------------------|--------------|--------------|--------------|--------------|
 * | initial          | initial      | is-opted-out | initial      | initial      |
 * | is-opted-out     | is-opted-out | is-opted-out | is-opted-out | is-opted-out |
 * | no-opt-out       | initial      | is-opted-out | no-opt-out   | error        |
 * | error            | initial      | is-opted-out | error        | error        |
 * @param siteOptoutValue
 * @param siteUserOptoutValue
 */ const $8ff9bae60bf52a82$var$combineOptoutValue = (siteOptoutValue, siteUserOptoutValue)=>{
    const matrix = {
        initial: {
            initial: 'initial',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'initial',
            error: 'initial'
        },
        'is-opted-out': {
            initial: 'is-opted-out',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'is-opted-out',
            error: 'is-opted-out'
        },
        'no-opt-out': {
            initial: 'initial',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'no-opt-out',
            error: 'error'
        },
        error: {
            initial: 'initial',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'error',
            error: 'error'
        }
    };
    return matrix[siteOptoutValue][siteUserOptoutValue] || 'initial';
};
const $8ff9bae60bf52a82$export$433d05f24f06f81a = (enabled)=>{
    $8ff9bae60bf52a82$var$isAnalyticsDebounceEnabled = enabled;
};
const $8ff9bae60bf52a82$var$isAnalyticsEventFiredWithinDebounceWindow = (eventName, touchpointId)=>{
    const currentTime = Date.now();
    const lastFiredTime = $8ff9bae60bf52a82$var$firedAnalyticsEvents[eventName]?.[touchpointId] ?? 0;
    if (currentTime - lastFiredTime < (0, $6ae6c26522a72ef8$export$338a9c38f183f620)) return true;
    $8ff9bae60bf52a82$var$firedAnalyticsEvents[eventName] = {
        ...$8ff9bae60bf52a82$var$firedAnalyticsEvents[eventName] ?? {},
        [touchpointId]: currentTime
    };
    return false;
};
const $8ff9bae60bf52a82$var$fireTrackAnalytics = (analyticsEvent, eventName, attributes)=>{
    if ($8ff9bae60bf52a82$var$isAnalyticsDebounceEnabled && attributes.touchpointId && $8ff9bae60bf52a82$var$isAnalyticsEventFiredWithinDebounceWindow(eventName, attributes.touchpointId)) return;
    const clonedEvent = analyticsEvent.clone();
    if (clonedEvent) {
        const [actionSubject, action] = eventName.split(' ');
        clonedEvent.update({
            eventType: (0, $6ae6c26522a72ef8$export$947dac6c72b26f81),
            actionSubject: actionSubject,
            action: action,
            attributes: {
                ...clonedEvent.payload?.attributes ?? {},
                ...attributes ?? {}
            }
        });
        clonedEvent.fire((0, $6ae6c26522a72ef8$export$85183a312807388d));
    }
};
const $8ff9bae60bf52a82$export$9af97c6b33df5bae = async (touchpointId, cloudId, analyticsEvent, options)=>{
    let optoutStatus = 'initial';
    try {
        const fetchResult = await $8ff9bae60bf52a82$var$fetchSiteTraitData(cloudId);
        optoutStatus = fetchResult.optoutStatus;
        if (analyticsEvent) $8ff9bae60bf52a82$var$fireTrackAnalytics(analyticsEvent, (0, $6ae6c26522a72ef8$export$5ede056addcc7dcf), {
            cloudId: cloudId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus,
            cached: fetchResult.cached
        });
    } catch (error) {
        if (analyticsEvent) $8ff9bae60bf52a82$var$fireTrackAnalytics(analyticsEvent, (0, $6ae6c26522a72ef8$export$a16c0f38ba8f83e8), {
            error: error instanceof $8ff9bae60bf52a82$var$FetchError ? error.message : 'Unknown error',
            traceId: error instanceof $8ff9bae60bf52a82$var$FetchError ? error.traceId : undefined,
            cloudId: cloudId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus
        });
        options?.onError?.(error);
        return {
            optoutStatus: 'error'
        };
    }
    return {
        optoutStatus: optoutStatus
    };
};
const $8ff9bae60bf52a82$export$a9e7c50f402a03d2 = async (touchpointId, cloudId, userId, analyticsEvent, options)=>{
    let optoutStatus = 'initial';
    try {
        const fetchResult = await $8ff9bae60bf52a82$var$fetchSiteUserTraitData(cloudId, userId);
        optoutStatus = fetchResult.optoutStatus;
        if (analyticsEvent) $8ff9bae60bf52a82$var$fireTrackAnalytics(analyticsEvent, (0, $6ae6c26522a72ef8$export$2b6f8d7fd154b638), {
            cloudId: cloudId,
            userId: userId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus,
            cached: fetchResult.cached
        });
    } catch (error) {
        if (analyticsEvent) $8ff9bae60bf52a82$var$fireTrackAnalytics(analyticsEvent, (0, $6ae6c26522a72ef8$export$74a38b22acdaeea2), {
            error: error instanceof $8ff9bae60bf52a82$var$FetchError ? error.message : 'Unknown error',
            traceId: error instanceof $8ff9bae60bf52a82$var$FetchError ? error.traceId : undefined,
            cloudId: cloudId,
            userId: userId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus
        });
        options?.onError?.(error);
        return {
            optoutStatus: 'error'
        };
    }
    return {
        optoutStatus: optoutStatus
    };
};
const $8ff9bae60bf52a82$export$aa440d3a24a2d79a = async (touchpointId, cloudId, userId, analyticsEvent, options)=>{
    if (userId) {
        const [siteOptoutPayload, siteUserOptoutPayload] = await Promise.all([
            $8ff9bae60bf52a82$export$9af97c6b33df5bae(touchpointId, cloudId, analyticsEvent, options),
            $8ff9bae60bf52a82$export$a9e7c50f402a03d2(touchpointId, cloudId, userId, analyticsEvent, options)
        ]);
        try {
            return {
                optoutStatus: $8ff9bae60bf52a82$var$combineOptoutValue(siteOptoutPayload.optoutStatus, siteUserOptoutPayload.optoutStatus)
            };
        } catch (error) {
            options?.onError?.(error);
            return {
                optoutStatus: 'error'
            };
        }
    }
    return $8ff9bae60bf52a82$export$9af97c6b33df5bae(touchpointId, cloudId, analyticsEvent, options);
};
const $8ff9bae60bf52a82$export$ef6308b7e747ceec = (0, $gtMdU.isReactCompilerActivePlatform)() ? (touchpointId, cloudId, options)=>{
    const $ = (0, $bDgLe.c)(14);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isDisabled = options?.isDisabled ?? false;
    const onError = options?.onError ?? null;
    const siteTraits = options?.siteTraits ?? null;
    const hasSiteTraits = siteTraits !== null && siteTraits !== undefined;
    let t0;
    if ($[0] !== hasSiteTraits || $[1] !== siteTraits) {
        t0 = hasSiteTraits ? $8ff9bae60bf52a82$var$parseSiteOptoutTraitStatus(siteTraits) : "initial";
        $[0] = hasSiteTraits;
        $[1] = siteTraits;
        $[2] = t0;
    } else t0 = $[2];
    const derivedSiteOptoutStatus = t0;
    const [optoutStatus, setOptoutStatus] = (0, $cozmU.useState)(derivedSiteOptoutStatus);
    let t1;
    let t2;
    if ($[3] !== cloudId || $[4] !== createAnalyticsEvent || $[5] !== derivedSiteOptoutStatus || $[6] !== hasSiteTraits || $[7] !== isDisabled || $[8] !== onError || $[9] !== touchpointId) {
        t1 = ()=>{
            if (hasSiteTraits) {
                $8ff9bae60bf52a82$var$siteOptoutStatuses[cloudId] = derivedSiteOptoutStatus;
                setOptoutStatus(derivedSiteOptoutStatus);
                return;
            }
            if (!isDisabled) $8ff9bae60bf52a82$export$9af97c6b33df5bae(touchpointId, cloudId, createAnalyticsEvent({}), {
                onError: onError
            }).then((t3)=>{
                const { optoutStatus: status } = t3;
                setOptoutStatus(status);
            });
        };
        t2 = [
            cloudId,
            isDisabled,
            touchpointId,
            createAnalyticsEvent,
            onError,
            hasSiteTraits,
            derivedSiteOptoutStatus
        ];
        $[3] = cloudId;
        $[4] = createAnalyticsEvent;
        $[5] = derivedSiteOptoutStatus;
        $[6] = hasSiteTraits;
        $[7] = isDisabled;
        $[8] = onError;
        $[9] = touchpointId;
        $[10] = t1;
        $[11] = t2;
    } else {
        t1 = $[10];
        t2 = $[11];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[12] !== optoutStatus) {
        t3 = {
            optoutStatus: optoutStatus
        };
        $[12] = optoutStatus;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : (touchpointId, cloudId, options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isDisabled = options?.isDisabled ?? false;
    const onError = options?.onError ?? null;
    const siteTraits = options?.siteTraits ?? null;
    const hasSiteTraits = siteTraits !== null && siteTraits !== undefined;
    const derivedSiteOptoutStatus = hasSiteTraits ? $8ff9bae60bf52a82$var$parseSiteOptoutTraitStatus(siteTraits) : 'initial';
    const [optoutStatus, setOptoutStatus] = (0, $cozmU.useState)(derivedSiteOptoutStatus);
    (0, $cozmU.useEffect)(()=>{
        if (hasSiteTraits) {
            $8ff9bae60bf52a82$var$siteOptoutStatuses[cloudId] = derivedSiteOptoutStatus;
            setOptoutStatus(derivedSiteOptoutStatus);
            return;
        }
        if (!isDisabled) $8ff9bae60bf52a82$export$9af97c6b33df5bae(touchpointId, cloudId, createAnalyticsEvent({}), {
            onError: onError
        }).then(({ optoutStatus: status })=>{
            setOptoutStatus(status);
        });
    }, [
        cloudId,
        isDisabled,
        touchpointId,
        createAnalyticsEvent,
        onError,
        hasSiteTraits,
        derivedSiteOptoutStatus
    ]);
    return {
        optoutStatus: optoutStatus
    };
};
const $8ff9bae60bf52a82$export$e5b57ebc3eed2ecb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (touchpointId, cloudId, userId, options)=>{
    const $ = (0, $bDgLe.c)(15);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isDisabled = options?.isDisabled ?? false;
    const onError = options?.onError ?? null;
    const siteUserTraits = options?.siteUserTraits ?? null;
    const hasSiteUserTraits = siteUserTraits !== null && siteUserTraits !== undefined;
    let t0;
    if ($[0] !== hasSiteUserTraits || $[1] !== siteUserTraits) {
        t0 = hasSiteUserTraits ? $8ff9bae60bf52a82$var$parseSiteUserOptoutTraitStatus(siteUserTraits) : "initial";
        $[0] = hasSiteUserTraits;
        $[1] = siteUserTraits;
        $[2] = t0;
    } else t0 = $[2];
    const derivedSiteUserOptoutStatus = t0;
    const [optoutStatus, setOptoutStatus] = (0, $cozmU.useState)(derivedSiteUserOptoutStatus);
    let t1;
    let t2;
    if ($[3] !== cloudId || $[4] !== createAnalyticsEvent || $[5] !== derivedSiteUserOptoutStatus || $[6] !== hasSiteUserTraits || $[7] !== isDisabled || $[8] !== onError || $[9] !== touchpointId || $[10] !== userId) {
        t1 = ()=>{
            if (hasSiteUserTraits) {
                $8ff9bae60bf52a82$var$siteUserOptoutStatuses[cloudId] = {
                    ...$8ff9bae60bf52a82$var$siteUserOptoutStatuses[cloudId] ?? {},
                    [userId]: derivedSiteUserOptoutStatus
                };
                setOptoutStatus(derivedSiteUserOptoutStatus);
                return;
            }
            if (!isDisabled) $8ff9bae60bf52a82$export$a9e7c50f402a03d2(touchpointId, cloudId, userId, createAnalyticsEvent({}), {
                onError: onError
            }).then((t3)=>{
                const { optoutStatus: status } = t3;
                setOptoutStatus(status);
            });
        };
        t2 = [
            cloudId,
            userId,
            isDisabled,
            touchpointId,
            createAnalyticsEvent,
            onError,
            hasSiteUserTraits,
            derivedSiteUserOptoutStatus
        ];
        $[3] = cloudId;
        $[4] = createAnalyticsEvent;
        $[5] = derivedSiteUserOptoutStatus;
        $[6] = hasSiteUserTraits;
        $[7] = isDisabled;
        $[8] = onError;
        $[9] = touchpointId;
        $[10] = userId;
        $[11] = t1;
        $[12] = t2;
    } else {
        t1 = $[11];
        t2 = $[12];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[13] !== optoutStatus) {
        t3 = {
            optoutStatus: optoutStatus
        };
        $[13] = optoutStatus;
        $[14] = t3;
    } else t3 = $[14];
    return t3;
} : (touchpointId, cloudId, userId, options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isDisabled = options?.isDisabled ?? false;
    const onError = options?.onError ?? null;
    const siteUserTraits = options?.siteUserTraits ?? null;
    const hasSiteUserTraits = siteUserTraits !== null && siteUserTraits !== undefined;
    const derivedSiteUserOptoutStatus = hasSiteUserTraits ? $8ff9bae60bf52a82$var$parseSiteUserOptoutTraitStatus(siteUserTraits) : 'initial';
    const [optoutStatus, setOptoutStatus] = (0, $cozmU.useState)(derivedSiteUserOptoutStatus);
    (0, $cozmU.useEffect)(()=>{
        if (hasSiteUserTraits) {
            $8ff9bae60bf52a82$var$siteUserOptoutStatuses[cloudId] = {
                ...$8ff9bae60bf52a82$var$siteUserOptoutStatuses[cloudId] ?? {},
                [userId]: derivedSiteUserOptoutStatus
            };
            setOptoutStatus(derivedSiteUserOptoutStatus);
            return;
        }
        if (!isDisabled) $8ff9bae60bf52a82$export$a9e7c50f402a03d2(touchpointId, cloudId, userId, createAnalyticsEvent({}), {
            onError: onError
        }).then(({ optoutStatus: status })=>{
            setOptoutStatus(status);
        });
    }, [
        cloudId,
        userId,
        isDisabled,
        touchpointId,
        createAnalyticsEvent,
        onError,
        hasSiteUserTraits,
        derivedSiteUserOptoutStatus
    ]);
    return {
        optoutStatus: optoutStatus
    };
};
const $8ff9bae60bf52a82$export$7d4c6b519725ba3b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (touchpointId, cloudId, userId, options)=>{
    const $ = (0, $bDgLe.c)(24);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isDisabled = options?.isDisabled ?? false;
    const onError = options?.onError ?? null;
    const siteTraits = options?.siteTraits ?? null;
    const siteUserTraits = options?.siteUserTraits ?? null;
    const hasSiteTraits = siteTraits !== null && siteTraits !== undefined;
    const hasSiteUserTraits = siteUserTraits !== null && siteUserTraits !== undefined;
    const requiresSiteUser = Boolean(userId);
    const canDeriveFromTraits = hasSiteTraits && (!requiresSiteUser || hasSiteUserTraits);
    let derivedSiteOptoutStatus;
    let derivedSiteUserOptoutStatus;
    let t0;
    if ($[0] !== canDeriveFromTraits || $[1] !== hasSiteTraits || $[2] !== hasSiteUserTraits || $[3] !== requiresSiteUser || $[4] !== siteTraits || $[5] !== siteUserTraits) {
        derivedSiteOptoutStatus = hasSiteTraits ? $8ff9bae60bf52a82$var$parseSiteOptoutTraitStatus(siteTraits) : "initial";
        derivedSiteUserOptoutStatus = hasSiteUserTraits ? $8ff9bae60bf52a82$var$parseSiteUserOptoutTraitStatus(siteUserTraits) : "initial";
        t0 = canDeriveFromTraits ? requiresSiteUser ? $8ff9bae60bf52a82$var$combineOptoutValue(derivedSiteOptoutStatus, derivedSiteUserOptoutStatus) : derivedSiteOptoutStatus : "initial";
        $[0] = canDeriveFromTraits;
        $[1] = hasSiteTraits;
        $[2] = hasSiteUserTraits;
        $[3] = requiresSiteUser;
        $[4] = siteTraits;
        $[5] = siteUserTraits;
        $[6] = derivedSiteOptoutStatus;
        $[7] = derivedSiteUserOptoutStatus;
        $[8] = t0;
    } else {
        derivedSiteOptoutStatus = $[6];
        derivedSiteUserOptoutStatus = $[7];
        t0 = $[8];
    }
    const derivedOptoutStatus = t0;
    const [optoutStatus, setOptoutStatus] = (0, $cozmU.useState)(derivedOptoutStatus);
    let t1;
    let t2;
    if ($[9] !== canDeriveFromTraits || $[10] !== cloudId || $[11] !== createAnalyticsEvent || $[12] !== derivedOptoutStatus || $[13] !== derivedSiteOptoutStatus || $[14] !== derivedSiteUserOptoutStatus || $[15] !== isDisabled || $[16] !== onError || $[17] !== requiresSiteUser || $[18] !== touchpointId || $[19] !== userId) {
        t1 = ()=>{
            if (canDeriveFromTraits) {
                $8ff9bae60bf52a82$var$siteOptoutStatuses[cloudId] = derivedSiteOptoutStatus;
                if (requiresSiteUser && userId) $8ff9bae60bf52a82$var$siteUserOptoutStatuses[cloudId] = {
                    ...$8ff9bae60bf52a82$var$siteUserOptoutStatuses[cloudId] ?? {},
                    [userId]: derivedSiteUserOptoutStatus
                };
                setOptoutStatus(derivedOptoutStatus);
                return;
            }
            if (!isDisabled) $8ff9bae60bf52a82$export$aa440d3a24a2d79a(touchpointId, cloudId, userId, createAnalyticsEvent({}), {
                onError: onError
            }).then((t3)=>{
                const { optoutStatus: status } = t3;
                setOptoutStatus(status);
            }).catch((error)=>{
                onError?.(error);
            });
        };
        t2 = [
            cloudId,
            userId,
            isDisabled,
            touchpointId,
            createAnalyticsEvent,
            onError,
            canDeriveFromTraits,
            requiresSiteUser,
            derivedSiteOptoutStatus,
            derivedSiteUserOptoutStatus,
            derivedOptoutStatus
        ];
        $[9] = canDeriveFromTraits;
        $[10] = cloudId;
        $[11] = createAnalyticsEvent;
        $[12] = derivedOptoutStatus;
        $[13] = derivedSiteOptoutStatus;
        $[14] = derivedSiteUserOptoutStatus;
        $[15] = isDisabled;
        $[16] = onError;
        $[17] = requiresSiteUser;
        $[18] = touchpointId;
        $[19] = userId;
        $[20] = t1;
        $[21] = t2;
    } else {
        t1 = $[20];
        t2 = $[21];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[22] !== optoutStatus) {
        t3 = {
            optoutStatus: optoutStatus
        };
        $[22] = optoutStatus;
        $[23] = t3;
    } else t3 = $[23];
    return t3;
} : (touchpointId, cloudId, userId, options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isDisabled = options?.isDisabled ?? false;
    const onError = options?.onError ?? null;
    const siteTraits = options?.siteTraits ?? null;
    const siteUserTraits = options?.siteUserTraits ?? null;
    const hasSiteTraits = siteTraits !== null && siteTraits !== undefined;
    const hasSiteUserTraits = siteUserTraits !== null && siteUserTraits !== undefined;
    const requiresSiteUser = Boolean(userId);
    const canDeriveFromTraits = hasSiteTraits && (!requiresSiteUser || hasSiteUserTraits);
    const derivedSiteOptoutStatus = hasSiteTraits ? $8ff9bae60bf52a82$var$parseSiteOptoutTraitStatus(siteTraits) : 'initial';
    const derivedSiteUserOptoutStatus = hasSiteUserTraits ? $8ff9bae60bf52a82$var$parseSiteUserOptoutTraitStatus(siteUserTraits) : 'initial';
    const derivedOptoutStatus = canDeriveFromTraits ? requiresSiteUser ? $8ff9bae60bf52a82$var$combineOptoutValue(derivedSiteOptoutStatus, derivedSiteUserOptoutStatus) : derivedSiteOptoutStatus : 'initial';
    const [optoutStatus, setOptoutStatus] = (0, $cozmU.useState)(derivedOptoutStatus);
    (0, $cozmU.useEffect)(()=>{
        if (canDeriveFromTraits) {
            $8ff9bae60bf52a82$var$siteOptoutStatuses[cloudId] = derivedSiteOptoutStatus;
            if (requiresSiteUser && userId) $8ff9bae60bf52a82$var$siteUserOptoutStatuses[cloudId] = {
                ...$8ff9bae60bf52a82$var$siteUserOptoutStatuses[cloudId] ?? {},
                [userId]: derivedSiteUserOptoutStatus
            };
            setOptoutStatus(derivedOptoutStatus);
            return;
        }
        if (!isDisabled) $8ff9bae60bf52a82$export$aa440d3a24a2d79a(touchpointId, cloudId, userId, createAnalyticsEvent({}), {
            onError: onError
        }).then(({ optoutStatus: status })=>{
            setOptoutStatus(status);
        }).catch((error)=>{
            onError?.(error);
        });
    }, [
        cloudId,
        userId,
        isDisabled,
        touchpointId,
        createAnalyticsEvent,
        onError,
        canDeriveFromTraits,
        requiresSiteUser,
        derivedSiteOptoutStatus,
        derivedSiteUserOptoutStatus,
        derivedOptoutStatus
    ]);
    return {
        optoutStatus: optoutStatus
    };
};



var $bGVJw = parcelRequire("bGVJw");

var $jdpvF = parcelRequire("jdpvF");


var $b5YqG = parcelRequire("b5YqG");


var $2A9d7 = parcelRequire("2A9d7");

var $geOrq = parcelRequire("geOrq");

var $a2EbF = parcelRequire("a2EbF");


var $8aJgK = parcelRequire("8aJgK");


var $63sT2 = parcelRequire("63sT2");


var $9TNXZ = parcelRequire("9TNXZ");


var $6a9Mm = parcelRequire("6a9Mm");


var $6U5eU = parcelRequire("6U5eU");


var $5KMtM = parcelRequire("5KMtM");








var $a2foB = parcelRequire("a2foB");

var $lqtHz = parcelRequire("lqtHz");


var $chu6R = parcelRequire("chu6R");













/* wac-toast.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $l3wuH = parcelRequire("l3wuH");




const $9c3dd9104c8f4893$var$mainContainerStyle = null;
const $9c3dd9104c8f4893$var$closedToastStyle = null;
const $9c3dd9104c8f4893$var$contentSectionStyle = null;
const $9c3dd9104c8f4893$var$imageSectionStyle = null;
const $9c3dd9104c8f4893$var$showToastAnimationStyle = null;
const $9c3dd9104c8f4893$var$titleStyle = null;
const $9c3dd9104c8f4893$var$descriptionStyle = null;
const $9c3dd9104c8f4893$var$closePanelIconContainerStyle = null;
const $9c3dd9104c8f4893$export$df43802f8a343160 = (props)=>{
    const { title: title, description: description, onDismissed: onDismissed } = props;
    const [shouldAnimate, setShouldAnimate] = (0, $cozmU.useState)(false);
    const [isClosed, setIsClosed] = (0, $cozmU.useState)(false);
    const intl = (0, $kSwu1.useIntl)();
    const dismissToastAriaLabel = intl.formatMessage({
        id: "growth.app-switcher-discovery-section.wac-toast.close.aria-label",
        defaultMessage: "Dismiss toast"
    });
    (0, $cozmU.useEffect)(()=>{
        setTimeout(()=>{
            setShouldAnimate(true);
        }, 100);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        // auto dismiss
        setTimeout(()=>{
            closeToastCard();
        }, 8000);
    }, []);
    const closeToastCard = ()=>{
        setIsClosed(true);
    };
    const handleOnCloseClick = ()=>{
        closeToastCard();
        setTimeout(()=>{
            onDismissed && onDismissed();
        }, 800);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _1YKVNsdnbC _2OUyjtLhxk _39xV02ehCh _0KLXrulfZc _1VJPcabpzh _49IHO6N91d _3SszAWrxnk",
            shouldAnimate && "_23rrnHN4Ya _1YKVNs7dHp _1VJPcaBj0j _3SszAWH5LG",
            isClosed && "_23rrnHoGHg _1YKVNsdnbC _1VJPcaBXdv _49IHO6N91d _3SszAWxS0E"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            className: (0, $hekY6.default)([
                "_0bjKvDKxmn _4FKVYENHnM _3iDTPbQ4SZ _0aFT5vbt8w _0KLXrulfZc _2fwxA5ecOK"
            ]),
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                    className: (0, $hekY6.default)([
                        "_3iDTPbQ4SZ _0aFT5v1qpb _37wbyuI7V3"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)($9c3dd9104c8f4893$var$SuccessIcon, {}),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("button", {
                            id: "toast-close-button",
                            onClick: handleOnCloseClick,
                            "aria-label": dismissToastAriaLabel,
                            className: (0, $hekY6.default)([
                                "_0KLXrujOvk _30huDKdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0wOv4Q7zJH _3iDTPbQ4SZ _0hPCNLDIqT"
                            ]),
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                                label: dismissToastAriaLabel,
                                size: "small"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("h3", {
                    className: (0, $hekY6.default)([
                        "_1kk5Tk3fRC _26BoRwVlDr _0WKd3GOLYo _4ya3eE9DVM _3138425zaO _1DCdHi2ADO"
                    ]),
                    children: title
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("p", {
                    className: (0, $hekY6.default)([
                        "_2XghbEdDL8"
                    ]),
                    children: description
                })
            ]
        })
    });
};
const $9c3dd9104c8f4893$var$SuccessIcon = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0ZM27.8668 16.2282C28.4316 15.6086 28.4144 14.648 27.8154 14.049L27.7617 13.9977C27.142 13.4329 26.1815 13.45 25.5825 14.049L17.2709 22.3606L14.4176 19.5074L14.3639 19.4561C13.7442 18.8913 12.7837 18.9084 12.1847 19.5074C11.568 20.124 11.568 21.1237 12.1847 21.7404L16.1544 25.7101L16.2082 25.7614C16.8278 26.3262 17.7883 26.3091 18.3873 25.7101L27.8154 16.282L27.8668 16.2282Z",
            fill: "#82B536"
        })
    });


const $81aee1c227109dc6$export$f9a3c275d8ffdac0 = (messageId)=>(currentMessageIds)=>currentMessageIds.filter((id)=>id !== messageId);


// /**--Title--**/
const $64b81a1bcdde0c60$var$Title = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
        id: "growth.app-switcher-discovery-section.flag.title",
        defaultMessage: "Got it, thanks for letting us know"
    });
// /**--Description--**/
const $64b81a1bcdde0c60$var$Description = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
        id: "growth.app-switcher-discovery-section.flag.description",
        defaultMessage: "You won\u2019t see this here as often."
    });
const $64b81a1bcdde0c60$export$a309243da00b18dc = ({ dismissedMessageIds: dismissedMessageIds, handleDismissFlag: handleDismissFlag })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const isInWacContext = (0, $6a9Mm.useIsWacContext)();
    const onDismissed = (messageId)=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsFlagClose'
        });
        handleDismissFlag(messageId);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
        children: dismissedMessageIds.map((messageId)=>isInWacContext ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9c3dd9104c8f4893$export$df43802f8a343160), {
                title: /*#__PURE__*/ (0, $8aG6j.jsx)($64b81a1bcdde0c60$var$Title, {}),
                description: /*#__PURE__*/ (0, $8aG6j.jsx)($64b81a1bcdde0c60$var$Description, {}),
                onDismissed: ()=>onDismissed(messageId)
            }, messageId) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a2foB.default), {
                icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                    spacing: "spacious",
                    color: "var(--ds-icon-success, #00875A)",
                    label: "Success"
                }),
                description: /*#__PURE__*/ (0, $8aG6j.jsx)($64b81a1bcdde0c60$var$Description, {}),
                id: messageId,
                title: /*#__PURE__*/ (0, $8aG6j.jsx)($64b81a1bcdde0c60$var$Title, {}),
                appearance: 'normal',
                onDismissed: ()=>onDismissed(messageId)
            }, messageId))
    });
};
const $64b81a1bcdde0c60$export$887afb916153c3fb = ()=>{
    const [dismissedMessageIds, setDismissedMessageIds] = (0, $cozmU.useState)([]);
    return {
        dismissedMessageIds: dismissedMessageIds,
        showFlag: (dismissedMessageId)=>setDismissedMessageIds((current)=>[
                    ...current,
                    dismissedMessageId
                ]),
        handleDismissFlag: (dismissedMessageId)=>setDismissedMessageIds((0, $81aee1c227109dc6$export$f9a3c275d8ffdac0)(dismissedMessageId))
    };
};








const $d062fcc223d18c2d$export$9658cfa596f93312 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
    id: "app-switcher-discovery-section.atlassian-store",
    defaultMessage: "Marketplace apps"
});
const $d062fcc223d18c2d$export$34d5d78df355fe77 = 'https://marketplace-store.atlassian.com';
const $d062fcc223d18c2d$export$92f5a604acc49617 = 'https://store.stg.atlassian.com';
const $d062fcc223d18c2d$export$fefa3910018b8cc0 = new Set([
    'staging'
]);
const $d062fcc223d18c2d$export$1a4fc652fea4c9cb = (currentEnv, orgId, cloudId, product)=>{
    let storeUrl = $d062fcc223d18c2d$export$fefa3910018b8cc0.has(currentEnv) ? $d062fcc223d18c2d$export$92f5a604acc49617 : $d062fcc223d18c2d$export$34d5d78df355fe77;
    if (orgId) storeUrl = `${storeUrl}/o/${orgId}`;
    const queryParams = [];
    if (cloudId) queryParams.push(`cloudId=${cloudId}`);
    if (product && typeof window !== 'undefined') try {
        const sourceUrl = new URL(`${window.location.origin}${window.location.pathname}`);
        sourceUrl.searchParams.set('source_product', product);
        sourceUrl.searchParams.set('entry_point', 'app_switcher');
        queryParams.push(`source=${encodeURIComponent(sourceUrl.toString())}`);
    } catch (e) {
    // ignore URL parsing errors
    }
    if (queryParams.length > 0) storeUrl = `${storeUrl}?${queryParams.join('&')}`;
    return storeUrl;
};
const $d062fcc223d18c2d$export$53b2e35922a3bc0e = ()=>/*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M5 9L6.5 5H18.5L20 9C20 9.3283 19.9353 9.65339 19.8097 9.95671C19.6841 10.26 19.4999 10.5356 19.2678 10.7678C19.0356 10.9999 18.76 11.1841 18.4567 11.3097C18.1534 11.4353 17.8283 11.5 17.5 11.5C17.1717 11.5 16.8466 11.4353 16.5433 11.3097C16.24 11.1841 15.9644 10.9999 15.7322 10.7678C15.5001 10.5356 15.3159 10.26 15.1903 9.95671C15.0647 9.65339 15 9.3283 15 9C15 9.3283 14.9353 9.65339 14.8097 9.95671C14.6841 10.26 14.4999 10.5356 14.2678 10.7678C14.0356 10.9999 13.76 11.1841 13.4567 11.3097C13.1534 11.4353 12.8283 11.5 12.5 11.5C12.1717 11.5 11.8466 11.4353 11.5433 11.3097C11.24 11.1841 10.9644 10.9999 10.7322 10.7678C10.5001 10.5356 10.3159 10.26 10.1903 9.95671C10.0647 9.65339 10 9.3283 10 9C10 9.3283 9.93534 9.65339 9.8097 9.95671C9.68406 10.26 9.49991 10.5356 9.26777 10.7678C9.03562 10.9999 8.76002 11.1841 8.45671 11.3097C8.15339 11.4353 7.8283 11.5 7.5 11.5C7.1717 11.5 6.84661 11.4353 6.54329 11.3097C6.23998 11.1841 5.96438 10.9999 5.73223 10.7678C5.50009 10.5356 5.31594 10.26 5.1903 9.95671C5.06466 9.65339 5 9.3283 5 9Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M9.03073 12.6956C9.3799 12.5509 9.70612 12.3579 10 12.1226C10.2939 12.3579 10.6201 12.5509 10.9693 12.6956C11.4546 12.8966 11.9747 13.0001 12.5 13.0001C13.0253 13.0001 13.5454 12.8966 14.0307 12.6956C14.3799 12.5509 14.7061 12.3579 15 12.1226C15.2939 12.3579 15.6201 12.5509 15.9693 12.6956C16.4546 12.8966 16.9747 13.0001 17.5 13.0001C17.8381 13.0001 18.1741 12.9572 18.5 12.873V19.0001H14.5V14.5001H10.5V19.0001H6.5V12.873C6.82592 12.9572 7.1619 13.0001 7.5 13.0001C8.02529 13.0001 8.54543 12.8966 9.03073 12.6956Z",
                fill: "#101214"
            })
        ]
    });


/* skeleton-item.tsx generated by @compiled/babel-plugin v2.0.0 */ 


parcelRequire("cozmU");





var $5T9cw = parcelRequire("5T9cw");

const $99b15adf45305a19$var$iconSkeletonStyles = null;
const $99b15adf45305a19$var$lineSkeletonStyles = null;
const $99b15adf45305a19$var$iconSkeleton = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
    className: (0, $hekY6.default)([
        "_0bjKvD8fU6 _3iDTPbvbI6 _39xV02Uofl _0jFU0VUofl _0KLXruGsB2"
    ])
});
const $99b15adf45305a19$var$lineSkeleton = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
    className: (0, $hekY6.default)([
        "_0bjKvDzXzM _3iDTPbvbI6 _39xV02sKne _0jFU0VuFDC _0KLXruGsB2"
    ])
}); // TODO: Export this as a primitive from Switcher instead of creating it here
const $99b15adf45305a19$export$d281ba7ce1dcaa47 = ()=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5T9cw.default), {
        tag: "li",
        icon: $99b15adf45305a19$var$iconSkeleton,
        isDisabled: true,
        children: $99b15adf45305a19$var$lineSkeleton
    });
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 



var $2tp0D = parcelRequire("2tp0D");















const $7ee8bf1340110ffe$export$e30378e28ad3e6ab = {
    'message-template-template': (0, $cozmU.lazy)(()=>(parcelRequire("cnXyf"))),
    'recommendation-atlas': (0, $cozmU.lazy)(()=>(parcelRequire("9huZ8"))),
    'recommendation-confluence': (0, $cozmU.lazy)(()=>(parcelRequire("3MLtk"))),
    'recommendation-jpd': (0, $cozmU.lazy)(()=>(parcelRequire("er7VU"))),
    'recommendation-jsm': (0, $cozmU.lazy)(()=>(parcelRequire("gpigJ"))),
    'recommendation-jsw': (0, $cozmU.lazy)(()=>(parcelRequire("7IGW9"))),
    'recommendation-jsw-jtbd': (0, $cozmU.lazy)(()=>(parcelRequire("hyia5"))),
    'recommendation-jwm': (0, $cozmU.lazy)(()=>(parcelRequire("atoRk"))),
    'recommendation-loom': (0, $cozmU.lazy)(()=>(parcelRequire("2Zk3H"))),
    'recommendation-opsgenie': (0, $cozmU.lazy)(()=>(parcelRequire("bsU9z"))),
    'recommendation-twc': (0, $cozmU.lazy)(()=>(parcelRequire("39FyK"))),
    'test-message-inapp': (0, $cozmU.lazy)(()=>(parcelRequire("55Kux"))),
    'test-message-inapp-engagement': (0, $cozmU.lazy)(()=>(parcelRequire("44Ci1"))),
    'test-message-marketing': (0, $cozmU.lazy)(()=>(parcelRequire("9Jv6I")))
};
const $7ee8bf1340110ffe$var$messageRenderer = (0, $2tp0D.asMessageRenderer)($7ee8bf1340110ffe$export$e30378e28ad3e6ab, 'app-switcher-discovery-section');
const $7ee8bf1340110ffe$export$bce4e5106d86e473 = $7ee8bf1340110ffe$var$messageRenderer.initializeMessageRenderer;
const $7ee8bf1340110ffe$export$2df1250b8f917a59 = $7ee8bf1340110ffe$var$messageRenderer.MessageRenderer;


/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $l24yD = parcelRequire("l24yD");


var $9l5Wa = parcelRequire("9l5Wa");


var $eaqtE = parcelRequire("eaqtE");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $h5VH3 = parcelRequire("h5VH3");


var $cUcPn = parcelRequire("cUcPn");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $03a74cfe02b00a36$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $03a74cfe02b00a36$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("4ngEZ")));
        case 'da':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("b7yt9")));
        case 'de':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("5UkiO")));
        case 'en-GB':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("i8gVe")));
        case 'en-US':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("j8LPM")));
        case 'en-XA':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("8AId7")));
        case 'en-XB':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("3V0Ug")));
        case 'en-ZZ':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("exgCq")));
        case 'en':
            return $03a74cfe02b00a36$var$importHelper(await Promise.resolve((parcelRequire("h5VH3"))));
        case 'es':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("fhx7R")));
        case 'et':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("6n8A6")));
        case 'fi':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("jSUAm")));
        case 'fr':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("9tcEy")));
        case 'hr':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("l36rh")));
        case 'hu':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("1miw5")));
        case 'it':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("7GTVh")));
        case 'ja':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("iPj3F")));
        case 'ko':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("bAqCy")));
        case 'nb':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("6HUw8")));
        case 'nl':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("iJTTu")));
        case 'pl':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("jSqU0")));
        case 'pt-BR':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("8L3mt")));
        case 'ro':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("kyUN0")));
        case 'ru':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("kmxaJ")));
        case 'sl':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("hx1vI")));
        case 'sr-RS':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("5Z0GS")));
        case 'sr-YR':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("fZDBp")));
        case 'sr':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("cAxqr")));
        case 'sv':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("iN4pl")));
        case 'th':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("9uJOz")));
        case 'tr':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("3Qc9A")));
        case 'uk':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("l1yFU")));
        case 'vi':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("eZvR2")));
        case 'zh-CN':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("civeX")));
        case 'zh-TW':
            return $03a74cfe02b00a36$var$importHelper(await (parcelRequire("4iJNL")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($h5VH3));
    }
};



var $jUaOQ = parcelRequire("jUaOQ");

const $4502354f682dc6c7$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $9l5Wa.messagesLoader)(locale),
        (0, $eaqtE.messagesLoader)(locale),
        (0, $03a74cfe02b00a36$export$720676d8cac8fbb)(locale),
        (0, $jUaOQ.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $4502354f682dc6c7$export$b73a0b4f9b1b8821 = (Component)=>{
    return (0, $l24yD.withIntlProvider)({
        messagesLoader: $4502354f682dc6c7$export$d5a462ce7bd04520
    }, Component);
};


const $8f5ec46d5072c902$var$adminSwitcherItemStyle = null;
const $8f5ec46d5072c902$var$MoreAtlassianAppsIcon = ({ size: size = 'medium', label: label = '', testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default), {
        label: label,
        size: size,
        isInset: false,
        backgroundColor: "white",
        testId: testId,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
            height: "100%",
            viewBox: "0 0 24 24",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    fill: "#dddee1",
                    d: "M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    fill: "#101214",
                    d: "M11.13 5.88H5.88v5.25h5.25zm0 7H5.88v5.25h5.25zm1.75-7h5.25v5.25h-5.25zm5.25 7h-5.25v5.25h5.25z"
                })
            ]
        })
    });
const $8f5ec46d5072c902$var$discoverMoreProductsTitle = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
    id: "app-switcher-discovery-section.discover-more-products",
    defaultMessage: "Discover more apps"
});
const $8f5ec46d5072c902$var$recommendedForYourTeamTitle = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
    id: "app-switcher-discovery-section.recommended-for-your-team",
    defaultMessage: "Recommended for your team"
});
const $8f5ec46d5072c902$var$moreAtlassianProducts = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
    id: "app-switcher-discovery-section.more-atlassian-products",
    defaultMessage: "More Atlassian apps"
});
const $8f5ec46d5072c902$var$CROSS_FLOW_SOURCE_COMPONENT = 'atlassian-switcher';
const $8f5ec46d5072c902$var$CROSS_FLOW_SOURCE_CONTEXT = 'more';
const $8f5ec46d5072c902$var$marketplaceAppsLozenges = [
    'new'
];
const $8f5ec46d5072c902$var$PLACEMENT_ID = 'app-switcher-discovery-section'; // Jira Local Consumption - MessageRenderer is typed as 'React.FC<any>' as otherwise it fails typecheck within Jira with the below error:
const $8f5ec46d5072c902$export$2df1250b8f917a59 = (0, $7ee8bf1340110ffe$export$bce4e5106d86e473)();
const $8f5ec46d5072c902$export$6b2f07b528cc1aa5 = (0, $4502354f682dc6c7$export$b73a0b4f9b1b8821)((0, $6U5eU.createPlacementComponent)($8f5ec46d5072c902$var$PLACEMENT_ID, ({ initialData: initialData, extraAnalyticsAttributes: extraAnalyticsAttributes })=>{
    const initialDataState = (0, $5KMtM.useInitialData)(initialData);
    const crossFlow = (0, $63sT2.useCrossFlow)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const isInWacContext = (0, $6a9Mm.useIsWacContext)();
    const { currentEnv: currentEnv } = (0, $jdpvF.usePostOfficeEnvironment)();
    const handleClickMoreAtlassianProducts = (0, $cozmU.useCallback)(async ()=>{
        if (crossFlow.isEnabled) {
            fireAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'listItem',
                actionSubjectId: 'discoverMoreAtlassianProductsButton'
            });
            await crossFlow.api.open({
                journey: (0, $63sT2.Journeys).DISCOVER,
                sourceComponent: $8f5ec46d5072c902$var$CROSS_FLOW_SOURCE_COMPONENT,
                sourceContext: $8f5ec46d5072c902$var$CROSS_FLOW_SOURCE_CONTEXT
            });
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [dismissedMessageInstanceIds, setDismissedMessageInstanceIds] = (0, $cozmU.useState)([]);
    const { dismissedMessageIds: dismissedMessageIds, showFlag: showFlag, handleDismissFlag: handleDismissFlag } = (0, $64b81a1bcdde0c60$export$887afb916153c3fb)();
    const { fireViewedUIEvent: fireViewedUIEvent } = (0, $b5YqG.useFireCrossFlowAnalyticsEvents)();
    const { isSiteAdmin: isSiteAdmin, tenantId: tenantId, orgId: orgId, product: product } = (0, $bGVJw.usePostOfficeContext)();
    const handleOnDismissed = (0, $cozmU.useCallback)((dismissedMessageInstanceId)=>{
        setDismissedMessageInstanceIds([
            ...dismissedMessageInstanceIds,
            dismissedMessageInstanceId
        ]);
        showFlag(dismissedMessageInstanceId);
    }, [
        dismissedMessageInstanceIds,
        showFlag
    ]);
    const { optoutStatus: optoutStatus } = (0, $8ff9bae60bf52a82$export$7d4c6b519725ba3b)('app-switcher-discovery-section', tenantId || '', initialDataState.data?.atlassianAccountId, {
        isDisabled: !(0, $cXtTj.default).checkGate('optout_all_messages_app_switcher_discovery')
    });
    const isOptedOut = (0, $cXtTj.default).checkGate('optout_all_messages_app_switcher_discovery') && optoutStatus !== 'no-opt-out';
    const isSwitcherUnifiedInstrumentationEnabled = (0, $cXtTj.default).checkGate('navx-app-switcher-unified-instrumentation-fe');
    (0, $cozmU.useEffect)(()=>{
        if (initialDataState.data?.messages) {
            const productIds = initialDataState.data.messages.map((message)=>$8f5ec46d5072c902$var$getProductIdFromMessageTemplateId(message.messageTemplateId)).filter(Boolean);
            fireViewedUIEvent({
                action: 'viewed',
                actionSubject: 'section',
                actionSubjectId: 'atlassianSwitcherDiscoverProducts'
            }, {
                source: 'atlassianSwitcherDiscoverProductsSection',
                recommendedProductIds: productIds
            }, {
                isSiteAdmin: isSiteAdmin
            }); // Notify switcher that discovery section is rendering with content via custom DOM event
            if (isSwitcherUnifiedInstrumentationEnabled) {
                const messageList = initialDataState.data?.messages ?? [];
                if (!initialDataState.isLoading && !(messageList.length === 0 && isOptedOut)) (0, $8aJgK.notifyDiscoverySectionRendered)(true);
            }
        }
    }, [
        fireViewedUIEvent,
        initialDataState.data?.messages,
        initialDataState.isLoading,
        isOptedOut,
        isSiteAdmin,
        isSwitcherUnifiedInstrumentationEnabled
    ]);
    if (initialDataState.error) {
        if (isSwitcherUnifiedInstrumentationEnabled) (0, $8aJgK.notifyDiscoverySectionRendered)(false);
        return null;
    }
    if (initialDataState.isLoading) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $geOrq.default), {});
    const messages = initialDataState?.data?.messages; // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
    const messagesWithoutDismissed = messages.filter(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
    (message)=>!dismissedMessageInstanceIds.includes(message.messageInstanceId));
    const decideTitle = ()=>{
        if (isInWacContext && messagesWithoutDismissed.length === 0) return null;
        return messagesWithoutDismissed.length > 0 ? $8f5ec46d5072c902$var$recommendedForYourTeamTitle : $8f5ec46d5072c902$var$discoverMoreProductsTitle;
    };
    const title = decideTitle();
    const isJiraOrConfluence = product === 'jira' || product === 'confluence';
    const isMarketplaceAppsEnabled = isJiraOrConfluence && (0, $cXtTj.default).checkGate('enable_store_experience_experiment_gate') && (0, $cXtTj.default).checkGate('navx-app-switcher-store-app') && (0, $cXtTj.default).getExperimentValue('enable_store_experience_experiment', 'isEnabled', false, {
        fireExperimentExposure: false
    });
    if (messages.length === 0 && isOptedOut) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2A9d7.SectionContainer), {
        sectionId: "discover",
        title: title,
        children: [
            messagesWithoutDismissed.map((message)=>// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                /*#__PURE__*/ (0, $8aG6j.jsx)($8f5ec46d5072c902$export$2df1250b8f917a59 // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                , {
                    ...message,
                    onDismissed: handleOnDismissed,
                    loadingFallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $99b15adf45305a19$export$d281ba7ce1dcaa47), {}),
                    extraAnalyticsAttributes: extraAnalyticsAttributes
                }, message.messageInstanceId)),
            isInWacContext ? null : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a2EbF.default), {
                        onClick: handleClickMoreAtlassianProducts,
                        icon: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            className: (0, $hekY6.default)([
                                "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _0KLXruDMqu _1UtDYzKGUX _3iDTPbQ4SZ _39xV02Va5s _0jFU0VVa5s _0hPCNLDIqT _37wbyuDIqT"
                            ]),
                            children: $8f5ec46d5072c902$var$MoreAtlassianAppsIcon({
                                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                                label: 'Discover More',
                                testId: 'app-switcher-discover-more-section__icon'
                            })
                        }),
                        children: $8f5ec46d5072c902$var$moreAtlassianProducts
                    }),
                    isMarketplaceAppsEnabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a2EbF.default), {
                        href: (0, $d062fcc223d18c2d$export$1a4fc652fea4c9cb)(currentEnv, orgId, tenantId, product),
                        icon: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            className: (0, $hekY6.default)([
                                "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _0KLXruDMqu _1UtDYzKGUX _3iDTPbQ4SZ _39xV02Va5s _0jFU0VVa5s _0hPCNLDIqT _37wbyuDIqT"
                            ]),
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d062fcc223d18c2d$export$53b2e35922a3bc0e), {})
                        }),
                        lozenges: $8f5ec46d5072c902$var$marketplaceAppsLozenges,
                        testId: "app-switcher-marketplace-apps-link",
                        children: (0, $d062fcc223d18c2d$export$9658cfa596f93312)
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $64b81a1bcdde0c60$export$a309243da00b18dc), {
                dismissedMessageIds: dismissedMessageIds,
                handleDismissFlag: handleDismissFlag
            })
        ]
    });
}, {
    choreographer: {
        isDefaultEnabled: false
    },
    hideInIsolatedCloud: true
}));
const $8f5ec46d5072c902$var$MESSAGE_TEMPLATE_ID_TO_PRODUCT_ID_MAP = {
    'recommendation-atlas': '7c917705-866d-4b6b-b266-0fc7633e8342',
    'recommendation-confluence': '6aab3f4e-cc71-474d-8d28-abef8b057808',
    'recommendation-jpd': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    'recommendation-jsm': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    'recommendation-jsw': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    'recommendation-jwm': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    'recommendation-loom': '7683a73e-423d-41a1-b43f-d497656f8b5d',
    'recommendation-opsgenie': 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    'recommendation-rovo': '91ae3e3f-138e-43be-98cc-48df03d13c32',
    // TWC message instances
    'recommendation-twc': '3503c251-c247-4b55-a6ed-d4c8c3257b8b'
}; // This is a temporary mapping for this placement to contribute to go/crossflowfunnel
// It will be fixed in the future by updating the dashboard to read directly from PO analytics
const $8f5ec46d5072c902$var$getProductIdFromMessageTemplateId = (messageTemplateId)=>{
    return $8f5ec46d5072c902$var$MESSAGE_TEMPLATE_ID_TO_PRODUCT_ID_MAP[messageTemplateId];
};
var $8f5ec46d5072c902$export$2e2bcd8739ae039 = $8f5ec46d5072c902$export$6b2f07b528cc1aa5;



var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");





var $7avaU = parcelRequire("7avaU");


var $fb5K7 = parcelRequire("fb5K7");


var $eug7u = parcelRequire("eug7u");

/* Joinable Sites API was replaced by Product Recommendations API as part of productionizing the Joinable Sites
   experimental API. This code maps Product Recommendations API results into Joinable Sites API results for
   compatibility with existing UI elements.
 */ function $d60d5102cac83913$var$productRecommendationsUrl(baseUrl) {
    return baseUrl + '/v1/product-recommendations' + '?product=jira-software&product=jira-servicedesk&product=confluence&product=jira-product-discovery';
}
/*
	Experiment API endpoint used to get collaborators to provided products
	https://bitbucket.org/atlassian/experiment-api/src/master/src/experiments/cross-join-switcher/
*/ const $d60d5102cac83913$var$collaboratorsUrl = '/gateway/api/growth/cross-join-switcher/get-eligible-collaborators';
// tenantedProducts and nonTenantedProducts used to identify which ARIs contain cloudId
// Also used to convert resourceOwner strings to JoinableSites product strings
const $d60d5102cac83913$var$supportedTenantedProducts = {
    confluence: (0, $eug7u.ProductKey).CONFLUENCE,
    'jira-software': (0, $eug7u.ProductKey).JIRA_SOFTWARE,
    'jira-product-discovery': (0, $eug7u.ProductKey).JIRA_PRODUCT_DISCOVERY,
    'jira-servicedesk': (0, $eug7u.ProductKey).JIRA_SERVICE_DESK
};
const $d60d5102cac83913$var$tenantedProductsToProduct = {
    [(0, $eug7u.ProductKey).CONFLUENCE]: 'confluence',
    [(0, $eug7u.ProductKey).JIRA_SOFTWARE]: 'jira-software',
    [(0, $eug7u.ProductKey).JIRA_PRODUCT_DISCOVERY]: (0, $eug7u.ProductKey).JIRA_PRODUCT_DISCOVERY,
    [(0, $eug7u.ProductKey).JIRA_SERVICE_DESK]: 'jira-servicedesk'
};
function $d60d5102cac83913$var$handleCapabilities(capabilities) {
    return capabilities?.filter((inputResource)=>{
        const parsedAri = (0, $7avaU.AnyAri).parse(inputResource.resourceId);
        return $d60d5102cac83913$var$supportedTenantedProducts[parsedAri.resourceOwner] && parsedAri.resourceType === 'site';
    }).reduce((sites, inputValue, index)=>{
        const ari = (0, $7avaU.AnyAri).parse(inputValue.resourceId);
        const sitesProducts = sites[ari.resourceId]?.products;
        if (sitesProducts) {
            sitesProducts[$d60d5102cac83913$var$supportedTenantedProducts[ari.resourceOwner]] = {
                collaborators: [],
                productUrl: inputValue.url,
                capability: inputValue.capability
            };
            return sites;
        }
        try {
            // Add site with this product
            const url = new URL(inputValue.url);
            const products = {};
            products[$d60d5102cac83913$var$supportedTenantedProducts[ari.resourceOwner]] = {
                collaborators: [],
                productUrl: inputValue.url,
                capability: inputValue.capability
            };
            sites[ari.resourceId] = {
                cloudId: ari.resourceId,
                url: url.origin,
                displayName: inputValue.displayName,
                products: products,
                relevance: Math.max(1000 - index, 0)
            };
            return sites;
        } catch (e) {
            return sites;
        }
    }, {});
}
function $d60d5102cac83913$var$convertProductRecommendationsResponseToJoinableSitesResponse(input) {
    const joinedCapabilities = $d60d5102cac83913$var$handleCapabilities(input.capability?.DIRECT_ACCESS.map((site)=>({
            ...site,
            capability: 'DIRECT_ACCESS'
        })).concat(input.capability?.REQUEST_ACCESS.map((site)=>({
            ...site,
            capability: 'REQUEST_ACCESS'
        }))));
    return {
        sites: Object.values(joinedCapabilities)
    };
}
function $d60d5102cac83913$var$isPublicEmailDomainError(body) {
    // Public Email Domain Error returns a body with the following content:
    // {"code":"email-public-domain","message":"Request requires a domain which is not public"}
    return body?.code === 'email-public-domain';
}
const $d60d5102cac83913$var$emptyProductRecommendationResponse = {
    capability: {
        DIRECT_ACCESS: [],
        REQUEST_ACCESS: []
    }
};
const $d60d5102cac83913$export$194985100c06d296 = (url, init)=>fetch(url, {
        credentials: 'include',
        ...init
    }).then(async (response)=>{
        const jsonPromise = response.json();
        if (response.ok) return jsonPromise;
        if (response.status === 400) {
            const json = await jsonPromise;
            if ($d60d5102cac83913$var$isPublicEmailDomainError(json)) return $d60d5102cac83913$var$emptyProductRecommendationResponse;
        }
        throw new (0, $fb5K7.FetchError)(`Unable to fetch ${url} ${response.status} ${response.statusText}`, response.status);
    }).catch(()=>{
        throw new (0, $fb5K7.FetchError)('Network Error', undefined);
    });
async function $d60d5102cac83913$export$3273ac3481dc0616(cloudId = '', baseUrl = '') {
    const response = await $d60d5102cac83913$export$194985100c06d296($d60d5102cac83913$var$productRecommendationsUrl(baseUrl), {
        method: 'get'
    });
    const sitesResponse = $d60d5102cac83913$var$convertProductRecommendationsResponseToJoinableSitesResponse(response);
    if (!cloudId) return sitesResponse;
    const filteredSites = sitesResponse?.sites?.filter((site)=>site.cloudId === cloudId);
    // This mapping is required for calling the get-eligible-collaborators endpoint
    const flattenedProducts = filteredSites?.flatMap((site)=>Object.keys(site.products || []).map((productName)=>$d60d5102cac83913$var$tenantedProductsToProduct[productName]));
    if (!filteredSites || filteredSites?.length === 0 || flattenedProducts?.length === 0) return {
        sites: filteredSites
    };
    const collaboratorsResponse = await fetch($d60d5102cac83913$var$collaboratorsUrl, {
        method: 'POST',
        body: JSON.stringify({
            products: flattenedProducts,
            cloudId: cloudId
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!collaboratorsResponse.ok) return {
        sites: filteredSites
    };
    const collaboratorsJson = await collaboratorsResponse.json();
    // Renames key with tenantedProducts and filters out empty responses
    const updatedProductCollaborators = Object.fromEntries(Object.entries(collaboratorsJson).filter((item)=>Array.isArray(item[1]) && item[1]?.length !== 0).map((item)=>{
        return [
            $d60d5102cac83913$var$supportedTenantedProducts[item[0]] || item[0],
            item[1].map(({ userProfile: userProfile })=>({
                    displayName: userProfile?.name || '',
                    avatarUrl: userProfile?.picture || ''
                }))
        ];
    }));
    const updatedProductCollaboratorsKeys = Object.keys(updatedProductCollaborators);
    // Inject collaborators with each related product
    // Inject users with each site.
    const sitesWithCollaborators = filteredSites.map((site)=>{
        updatedProductCollaboratorsKeys.forEach((collaboratorProductKey)=>{
            if (site?.products?.[collaboratorProductKey]) site.products[collaboratorProductKey].collaborators = updatedProductCollaborators[collaboratorProductKey];
        });
        site.users = Object.keys(site?.products || {}).reduce((users, product)=>{
            users[product] = updatedProductCollaborators[product] || [];
            return users;
        }, {});
        return site;
    });
    const updatedSiteResponse = {
        sites: sitesWithCollaborators
    };
    return updatedSiteResponse;
}
const $d60d5102cac83913$export$30ea0038b891f1cf = (baseUrl)=>({ cloudId: cloudId })=>$d60d5102cac83913$export$3273ac3481dc0616(cloudId, baseUrl);



var $3ezGS = parcelRequire("3ezGS");


var $5kbLE = parcelRequire("5kbLE");





var $7aRa9 = parcelRequire("7aRa9");

const $9486f2e1dfc1398c$var$appearanceMappedToConfluenceFlagType = (appearance)=>{
    switch(appearance){
        case 'normal':
        case 'success':
            return 'success-circle';
        default:
            return appearance;
    }
};
const $9486f2e1dfc1398c$export$90897e206b3c86f5 = (flags)=>(flag)=>{
        const { title: title, description: description, appearance: appearance, actions: actions } = flag;
        flags.showFlag({
            type: $9486f2e1dfc1398c$var$appearanceMappedToConfluenceFlagType(appearance),
            title: title,
            description: description,
            close: 'auto',
            actions: actions
        });
    };


const $a17e741d85380f31$var$maxHeightWrapper = (0, $buxP3.xcss)({
    maxHeight: 'calc(100vh - 100px)'
});
const $a17e741d85380f31$var$joinableProductsInSwitcherProvider = (0, $3ezGS.createJoinableSitesProvider)((0, $d60d5102cac83913$export$30ea0038b891f1cf)('/gateway/api/invitations'));
const $a17e741d85380f31$export$635f95e4f8a4fd7c = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const customShowFlagMemo = (0, $cozmU.useMemo)(()=>(0, $9486f2e1dfc1398c$export$90897e206b3c86f5)(flags), [
        flags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $a17e741d85380f31$var$maxHeightWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fqcDI.AtlassianSwitcherLoader), {
        product: "confluence",
        cloudId: cloudId,
        atlassianAccountId: userId ?? undefined,
        joinableSitesDataProvider: $a17e741d85380f31$var$joinableProductsInSwitcherProvider,
        showFlag: customShowFlagMemo,
        discoverySection: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5kbLE.default), {
            placementId: "app-switcher-discovery-section",
            PlacementComponent: (0, $8f5ec46d5072c902$export$2e2bcd8739ae039)
        })
    }));
});


const $4ea98e6e25820b6e$export$66169bdb3eb9897d = ()=>{
    const $ = (0, $bDgLe.c)(13);
    const intl = (0, $kSwu1.useIntl)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== isOpen || $[2] !== routeDataRef) {
        t0 = ()=>{
            if (!isOpen) (0, $1hcxO.setSwitcherRenderStartMark)();
            setIsOpen(!isOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "globalNavigation",
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "atlassianSwitcher",
                    attributes: {
                        selectedItemPageContext: routeDataRef.current?.routeName,
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: "4",
                        navdexPointType: (0, $56QzY.START_TOUCH)
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isOpen;
        $[2] = routeDataRef;
        $[3] = t0;
    } else t0 = $[3];
    const onClick = t0;
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setIsOpen(false);
        };
        $[4] = t1;
    } else t1 = $[4];
    const onClose = t1;
    let t2;
    if ($[5] !== cloudId || $[6] !== intl || $[7] !== isOpen || $[8] !== onClick) {
        t2 = (t3)=>{
            const { ref: ref, ...triggerProps } = t3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d402efd71d770038$export$2e2bcd8739ae039), {
                cloudId: cloudId,
                product: "confluence"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hzOq6.AppSwitcher), {
                ref: ref,
                ...triggerProps,
                label: intl.formatMessage($4ea98e6e25820b6e$var$i18n.switcher),
                isSelected: isOpen,
                onClick: onClick,
                interactionName: "confluence_app_switcher"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gyUf8.default), {
                testId: "app-switcher-button",
                isTinted: false,
                shouldAllowClickThrough: !isOpen,
                onBlanketClicked: onClose
            })));
        };
        $[5] = cloudId;
        $[6] = intl;
        $[7] = isOpen;
        $[8] = onClick;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== isOpen || $[11] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            isOpen: isOpen,
            onClose: onClose,
            content: $4ea98e6e25820b6e$var$_temp,
            trigger: t2,
            placement: "bottom-start",
            rootBoundary: "document"
        });
        $[10] = isOpen;
        $[11] = t2;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
};
const $4ea98e6e25820b6e$var$i18n = (0, $kSwu1.defineMessages)({
    switcher: {
        id: "app-navigation.top-navigation.app-switcher",
        defaultMessage: "Switch sites or apps"
    }
});
function $4ea98e6e25820b6e$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a17e741d85380f31$export$635f95e4f8a4fd7c), null);
}
module.exports["AppSwitcherButton"] = $4ea98e6e25820b6e$export$66169bdb3eb9897d;

});

parcelRegister("3pwdT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eeq36 = parcelRequire("eeq36");


var $3sOoJ = parcelRequire("3sOoJ");


var $ellLO = parcelRequire("ellLO");

const $ae4e0bc872b2095a$export$f36bb44a614923a8 = '/gateway/api/app-switcher/api/available-products';
const $ae4e0bc872b2095a$export$1096efb00c5f8afc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    return await (0, $3sOoJ.fetchJsonWithNetworkRetries)(`${$ae4e0bc872b2095a$export$f36bb44a614923a8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
};
const $ae4e0bc872b2095a$export$7fd9c7ae7afb494c = ()=>{
    return (0, $eeq36.createProviderWithCustomFetchData)('appSwitcherBffAvailableProducts', (0, $ellLO.ExperienceMark).API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS, $ae4e0bc872b2095a$export$1096efb00c5f8afc);
};


const { fetchMethod: $3253dd4033bc5982$var$fetchAppSwitcherBffAvailableProducts, ProviderComponent: $3253dd4033bc5982$var$DefaultBffDataProviderComponent } = (0, $ae4e0bc872b2095a$export$7fd9c7ae7afb494c)();
const $3253dd4033bc5982$export$4c169257ef988618 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { cloudId: cloudId, product: product, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== cloudId || $[2] !== product) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3253dd4033bc5982$var$DefaultBffDataProviderComponent, {
            cloudId: cloudId,
            product: product
        }, children);
        $[0] = children;
        $[1] = cloudId;
        $[2] = product;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ cloudId: cloudId, product: product, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3253dd4033bc5982$var$DefaultBffDataProviderComponent, {
        cloudId: cloudId,
        product: product
    }, children);
const $3253dd4033bc5982$export$1c5684a3ba697d80 = $3253dd4033bc5982$var$fetchAppSwitcherBffAvailableProducts;
const $3253dd4033bc5982$export$cd9fc41c59711bdd = ()=>$3253dd4033bc5982$var$fetchAppSwitcherBffAvailableProducts.reset();
module.exports["AvailableProductsProvider"] = $3253dd4033bc5982$export$4c169257ef988618;
module.exports["prefetchAvailableProducts"] = $3253dd4033bc5982$export$1c5684a3ba697d80;

});

parcelRegister("eeq36", function(module, exports) {

var $g0Lgx = parcelRequire("g0Lgx");


var $3sOoJ = parcelRequire("3sOoJ");

const $584a41a8a11c1a15$export$d4d4b402ab64e2f4 = 5000;
const $584a41a8a11c1a15$var$isPromise = (p)=>{
    return typeof p.then === 'function' && typeof p.catch === 'function';
};
const $584a41a8a11c1a15$export$7f51828d6b6af163 = (fn)=>{
    const resultCache = new Map();
    const promiseCache = new Map();
    function getCacheKey(...args) {
        return JSON.stringify(args);
    }
    const cached = (...args)=>{
        const cacheKey = getCacheKey(...args);
        return resultCache.get(cacheKey);
    };
    const reset = ()=>{
        resultCache.clear();
        promiseCache.clear();
    };
    const execute = (...args)=>{
        const cacheKey = getCacheKey(...args);
        const cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        const maybePromise = fn(...args);
        promiseCache.set(cacheKey, maybePromise);
        if ($584a41a8a11c1a15$var$isPromise(maybePromise)) maybePromise.then((result)=>{
            resultCache.set(cacheKey, result);
            setTimeout(()=>promiseCache.delete(cacheKey), $584a41a8a11c1a15$export$d4d4b402ab64e2f4);
        }).catch(()=>{
            promiseCache.delete(cacheKey);
        });
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};


const $a8576acaeede6e4b$export$500fbc0cd14cdbaa = (name, experienceMark, url)=>{
    const fetchMethod = (0, $584a41a8a11c1a15$export$7f51828d6b6af163)((param)=>(0, $3sOoJ.fetchJson)(url));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $g0Lgx.default)(name, experienceMark, fetchMethod, fetchMethod.cached, // fetch will only throw on a network exception,
        // so we can safely retry on all exceptions
        {
            shouldRetryOnException: ()=>true,
            intervalsMS: [
                50,
                200,
                1000
            ]
        })
    };
};
const $a8576acaeede6e4b$export$310e48be95687c2f = (name, experienceMark, fetchData, retryConfig)=>{
    const fetchMethod = (0, $584a41a8a11c1a15$export$7f51828d6b6af163)((param)=>fetchData(param));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $g0Lgx.default)(name, experienceMark, fetchMethod, fetchMethod.cached, retryConfig)
    };
};
module.exports["createProviderWithCustomFetchData"] = $a8576acaeede6e4b$export$310e48be95687c2f;

});

parcelRegister("g0Lgx", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7121bf88385395b$export$2e2bcd8739ae039);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bLbuQ = parcelRequire("bLbuQ");
var $852mP = parcelRequire("852mP");


var $lzgC6 = parcelRequire("lzgC6");


var $9QZAl = parcelRequire("9QZAl");


var $bOMi3 = parcelRequire("bOMi3");


var $gOJC3 = parcelRequire("gOJC3");

const $c7121bf88385395b$var$DATA_PROVIDER_SUBJECT = 'atlassianSwitcherDataProvider';
var $c7121bf88385395b$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["LOADING"] = "loading";
    Status["COMPLETE"] = "complete";
    Status["ERROR"] = "error";
    return Status;
}({});
const $c7121bf88385395b$export$947ceca65da0e7a6 = (data)=>({
        status: "complete",
        data: data
    });
const $c7121bf88385395b$export$9569565a7ac14e8e = (result)=>result.status === "complete";
const $c7121bf88385395b$export$e6127cc7fe7395c3 = (result)=>result.status === "error";
const $c7121bf88385395b$export$20bb0d907fbbe433 = (result)=>result.status === "loading";
const $c7121bf88385395b$export$5fce62f50756dbf = (result)=>result.status !== "loading";
function $c7121bf88385395b$export$2e2bcd8739ae039(name, experienceMark, mapPropsToPromise, mapPropsToInitialValue, retryConfig, shouldUpdate) {
    const getInitialState = (props)=>{
        if (mapPropsToInitialValue) {
            const initialValue = mapPropsToInitialValue(props);
            if (initialValue !== undefined) return {
                status: "complete",
                data: initialValue
            };
        }
        return {
            status: "loading",
            data: null
        };
    };
    class DataProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
        componentWillUnmount() {
            /**
       * Promise resolved after component is unmounted to be ignored
       */ this.acceptResults = false;
        }
        componentDidMount() {
            this.props.experienceTracker.markStart(experienceMark);
            this.fetchData();
        }
        componentDidUpdate(prevProps) {
            if (shouldUpdate?.(prevProps.params, this.props.params)) this.fetchData();
        }
        fetchData() {
            (0, $bOMi3.retryOnException)(()=>mapPropsToPromise(this.props.params), {
                intervalsMS: retryConfig?.intervalsMS || [],
                shouldRetryOnException: retryConfig?.shouldRetryOnException,
                onRetry: (previousException, retryCount)=>{
                    this.onRetry(previousException, retryCount);
                }
            }).then((result)=>{
                this.onResult(result);
            }).catch((error)=>{
                this.onError(error);
            });
        }
        onResult(value) {
            if (this.acceptResults) this.setState({
                data: value,
                status: "complete"
            });
            this.props.experienceTracker.markEnd(experienceMark);
            this.fireOperationalEvent({
                action: 'receivedResult',
                actionSubjectId: name,
                attributes: {
                    provider: name
                }
            });
        }
        onRetry(error, retryCount) {
            this.fireOperationalEvent({
                action: 'retried',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: retryConfig?.customErrorToReason ? retryConfig.customErrorToReason(error) : (0, $9QZAl.errorToReason)(error),
                    retryCount: retryCount
                }
            });
        }
        onError(error) {
            /**
       * Do not transition from "complete" state to "error"
       */ if (this.acceptResults && !$c7121bf88385395b$export$9569565a7ac14e8e(this.state)) this.setState({
                error: error,
                status: "error",
                data: null
            });
            this.fireOperationalEvent({
                action: 'failed',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: (0, $9QZAl.errorToReason)(error)
                }
            });
        }
        render() {
            return this.props.children(this.state);
        }
        constructor(...args){
            super(...args);
            this.acceptResults = true;
            this.state = getInitialState(this.props.params);
            this.fireOperationalEvent = (payload)=>{
                if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    actionSubject: $c7121bf88385395b$var$DATA_PROVIDER_SUBJECT,
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        outdated: !this.acceptResults
                    }
                }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
            };
        }
    }
    // In prefetch, we start with empty args {}, but when getting data from the cache in the data provider, extra args are injected by HOC withAnalyticsEvents and withExperienceTracker
    // This results in a cache miss due to a key mismatch.
    // The workaround here is to use a wrapper (OuterComponent) that passes the original props as a separate prop(params) to the underlying component(InnerComponent).
    // For more info: https://product-fabric.atlassian.net/browse/CXP-2697
    DataProvider.displayName = `DataProvider(${name})`;
    const InnerComponent = (0, $lzgC6.default)()((0, $gOJC3.withExperienceTracker)(DataProvider));
    const OuterComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
        const $ = (0, $bDgLe.c)(6);
        let children;
        let params;
        if ($[0] !== t0) {
            ({ children: children, ...params } = t0);
            $[0] = t0;
            $[1] = children;
            $[2] = params;
        } else {
            children = $[1];
            params = $[2];
        }
        const t1 = params;
        let t2;
        if ($[3] !== children || $[4] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                params: t1
            }, children);
            $[3] = children;
            $[4] = t1;
            $[5] = t2;
        } else t2 = $[5];
        return t2;
    } : ({ children: children, ...params })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
            params: params
        }, children);
    };
    return OuterComponent;
}
module.exports["Status"] = $c7121bf88385395b$export$96e9906d6d93a972;
module.exports["isComplete"] = $c7121bf88385395b$export$9569565a7ac14e8e;
module.exports["isError"] = $c7121bf88385395b$export$e6127cc7fe7395c3;
module.exports["isLoading"] = $c7121bf88385395b$export$20bb0d907fbbe433;
module.exports["hasLoaded"] = $c7121bf88385395b$export$5fce62f50756dbf;

});

parcelRegister("bLbuQ", function(module, exports) {
$parcel$export(module.exports, "withAnalyticsEvents", () => (parcelRequire("lzgC6")).default);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("eq1BO")).NavigationAnalyticsContext);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => (parcelRequire("852mP")).OPERATIONAL_EVENT_TYPE);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => (parcelRequire("852mP")).UI_EVENT_TYPE);

var $cozmU = parcelRequire("cozmU");


var $eq1BO = parcelRequire("eq1BO");


var $2iGHk = parcelRequire("2iGHk");

var $lzgC6 = parcelRequire("lzgC6");


var $852mP = parcelRequire("852mP");


var $g0Lgx = parcelRequire("g0Lgx");


var $9Q3kT = parcelRequire("9Q3kT");

const $b2734103d0e27db2$var$INFINITY = '+Inf';
const $b2734103d0e27db2$export$e59c24bc0768d568 = [
    1000,
    900,
    800,
    700,
    600,
    500
];
const $b2734103d0e27db2$export$b59492d26971ae92 = (metricValue, buckets)=>{
    return metricValue >= 0 ? buckets.reduce((lowestBucket, currentBucket)=>{
        return metricValue <= currentBucket ? currentBucket.toString() : lowestBucket.toString();
    }, $b2734103d0e27db2$var$INFINITY) : null;
};


const $6fcfd6478a64f762$export$515664faa1398f37 = 'navigation';
const $6fcfd6478a64f762$export$17ff9c46e41eb585 = 'atlassianSwitcher';
const $6fcfd6478a64f762$export$7598b001981cfda5 = 'atlassianSwitcherItem';
const $6fcfd6478a64f762$export$c3c93e13b09d3ad9 = 'atlassianSwitcherItemLozenges';
const $6fcfd6478a64f762$export$7d4d527df0e3789c = 'atlassianSwitcherChildItem';
const $6fcfd6478a64f762$export$16cf10618135eb24 = 'atlassianSwitcherItemExpand';
const $6fcfd6478a64f762$export$2b570fc112cbca = 'atlassianSwitcher';
const $6fcfd6478a64f762$export$5ed36c4d23de5568 = 'atlassianSwitcher';
const $6fcfd6478a64f762$export$8d2f933bbd9e4f09 = 'atlassianSwitcherPrefetch';
const $6fcfd6478a64f762$export$d7029a5dc66b0736 = 'atlassianSwitcherPrefetch';
const $6fcfd6478a64f762$export$4649adbfda1b6a66 = 'atlassianSwitcherPartialResultError';
const $6fcfd6478a64f762$export$6dd696c9ad636a67 = 'atlassianSwitcherOrgItem';
const $6fcfd6478a64f762$export$53f2256589c0fa08 = 'atlassianSwitcherOrgNameExpandPanel';
const $6fcfd6478a64f762$export$d9d2f872f3b91169 = 'atlassianSwitcherOrganisationsList';
const $6fcfd6478a64f762$export$5724539c9b1a3a5d = 'atlassianSwitcherJoinableSites';
const $6fcfd6478a64f762$export$22f5f827d9934254 = 'atlassianSwitcherAvailableProducts';
const $6fcfd6478a64f762$var$SWITCHER_CUSTOM_LINKS = 'atlassianSwitcherCustomLinks';
const $6fcfd6478a64f762$var$RENDERED_ACTION = 'rendered';
const $6fcfd6478a64f762$var$NOT_RENDERED_ACTION = 'not_rendered';
const $6fcfd6478a64f762$var$VIEWED_ACTION = 'viewed';
const $6fcfd6478a64f762$export$884b1a4c7ac9dd14 = (0, $2iGHk.default)($6fcfd6478a64f762$export$515664faa1398f37);
const $6fcfd6478a64f762$export$a305f130b289b818 = (attributes)=>({
        attributes: attributes
    });
const $6fcfd6478a64f762$export$97ebdd8e7274f18a = function(mapPropsToContext) {
    return function(WrappedComponent) {
        return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eq1BO.NavigationAnalyticsContext), {
                data: mapPropsToContext(props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, props));
    };
};
const $6fcfd6478a64f762$var$isValidDuration = (duration)=>{
    return duration !== null && duration !== undefined && duration >= 0;
};
const $6fcfd6478a64f762$export$e09ad93c2b74b853 = (0, $lzgC6.default)({
    onRender: (createAnalyticsEvent, props)=>{
        const duration = props.data?.duration;
        return createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            action: $6fcfd6478a64f762$var$RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: {
                ...props.data,
                ...$6fcfd6478a64f762$var$isValidDuration(duration) && {
                    bucket: (0, $b2734103d0e27db2$export$b59492d26971ae92)(duration, (0, $b2734103d0e27db2$export$e59c24bc0768d568))
                }
            }
        }).fire($6fcfd6478a64f762$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $6fcfd6478a64f762$export$95b1f1a72cad0dcb = (0, $lzgC6.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            action: $6fcfd6478a64f762$var$NOT_RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($6fcfd6478a64f762$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $6fcfd6478a64f762$export$b3fd6624b6a6d057 = (0, $lzgC6.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: $6fcfd6478a64f762$var$VIEWED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($6fcfd6478a64f762$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $6fcfd6478a64f762$var$renderTrackerWithReason = ({ subject: subject, notRenderedReason: notRenderedReason, emptyRenderExpected: emptyRenderExpected, data: data })=>{
    if (notRenderedReason) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6fcfd6478a64f762$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            notRenderedReason: notRenderedReason
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6fcfd6478a64f762$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $6fcfd6478a64f762$var$renderTracker = ({ subject: subject, providerFailed: providerFailed, emptyRenderExpected: emptyRenderExpected, linksRendered: linksRendered, data: data })=>{
    if (providerFailed || linksRendered.length === 0 && !emptyRenderExpected) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6fcfd6478a64f762$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            providerFailed: providerFailed
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6fcfd6478a64f762$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $6fcfd6478a64f762$export$e823e937102b322b = (providerResult, joinableSiteLinks, data)=>{
    if (!(0, $g0Lgx.hasLoaded)(providerResult)) return null;
    if (providerResult.data && !providerResult.data.sites) return null;
    // The render is considered failed when either the provider failed, or the provider returned a non-empty result but nothing was rendered
    const emptyRenderExpected = Boolean(providerResult.data && providerResult.data.sites && providerResult.data.sites.length === 0);
    return $6fcfd6478a64f762$var$renderTracker({
        subject: $6fcfd6478a64f762$export$5724539c9b1a3a5d,
        providerFailed: providerResult.data === null,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: joinableSiteLinks,
        data: data
    });
};
const $6fcfd6478a64f762$export$d75a4f56d85f67ea = (customLinksProviderResult, userSiteDataProviderResult, customLinks, data)=>{
    // The render is only considered failed when one of the providers failed, and empty render is a valid case
    if (!customLinksProviderResult) return;
    const emptyRenderExpected = customLinks.length === 0;
    function getNotRenderedReason() {
        if (customLinksProviderResult?.status === (0, $g0Lgx.Status).ERROR) return 'custom_links_api_error';
        const error = userSiteDataProviderResult.error;
        if (!error) return null;
        if (error instanceof (0, $9Q3kT.UserSiteDataError)) return error.reason;
        else return 'usd_unknown';
    }
    const notRenderedReason = getNotRenderedReason();
    return $6fcfd6478a64f762$var$renderTrackerWithReason({
        subject: $6fcfd6478a64f762$var$SWITCHER_CUSTOM_LINKS,
        notRenderedReason: notRenderedReason,
        emptyRenderExpected: emptyRenderExpected,
        data: data
    });
};
const $6fcfd6478a64f762$export$6489efba2ca85102 = (groupIndex, id, type, productType, extraAttributes)=>({
        ...$6fcfd6478a64f762$export$a305f130b289b818({
            groupIndex: groupIndex,
            itemId: id,
            itemType: type,
            productType: productType,
            ...extraAttributes
        })
    });
module.exports["NAVIGATION_CHANNEL"] = $6fcfd6478a64f762$export$515664faa1398f37;
module.exports["SWITCHER_SUBJECT"] = $6fcfd6478a64f762$export$17ff9c46e41eb585;
module.exports["SWITCHER_ITEM_LOZENGES_SUBJECT"] = $6fcfd6478a64f762$export$c3c93e13b09d3ad9;
module.exports["SWITCHER_COMPONENT"] = $6fcfd6478a64f762$export$2b570fc112cbca;
module.exports["SWITCHER_SOURCE"] = $6fcfd6478a64f762$export$5ed36c4d23de5568;
module.exports["TRIGGER_COMPONENT"] = $6fcfd6478a64f762$export$8d2f933bbd9e4f09;
module.exports["TRIGGER_SUBJECT"] = $6fcfd6478a64f762$export$d7029a5dc66b0736;
module.exports["SWITCHER_PARTIAL_RESULTS"] = $6fcfd6478a64f762$export$4649adbfda1b6a66;
module.exports["SWITCHER_JOINABLE_SITES"] = $6fcfd6478a64f762$export$5724539c9b1a3a5d;
module.exports["SWITCHER_AVAILABLE_PRODUCTS"] = $6fcfd6478a64f762$export$22f5f827d9934254;
module.exports["analyticsAttributes"] = $6fcfd6478a64f762$export$a305f130b289b818;
module.exports["withAnalyticsContextData"] = $6fcfd6478a64f762$export$97ebdd8e7274f18a;
module.exports["RenderTracker"] = $6fcfd6478a64f762$export$e09ad93c2b74b853;
module.exports["NotRenderedTracker"] = $6fcfd6478a64f762$export$95b1f1a72cad0dcb;
module.exports["ViewedTracker"] = $6fcfd6478a64f762$export$b3fd6624b6a6d057;
module.exports["getCustomLinksRenderTracker"] = $6fcfd6478a64f762$export$d75a4f56d85f67ea;
module.exports["getItemAnalyticsContext"] = $6fcfd6478a64f762$export$6489efba2ca85102;

});

parcelRegister("9Q3kT", function(module, exports) {
var $5bc992ef1d353b66$export$b08600051ba52198 = /*#__PURE__*/ function(UserSiteDataErrorReason) {
    UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
    UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
    UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
    return UserSiteDataErrorReason;
}({});
class $5bc992ef1d353b66$export$c460344055e97b1 extends Error {
    constructor(reason, message){
        super(message);
        this.reason = void 0;
        this.name = 'UserSiteDataError';
        this.reason = reason;
    }
}
module.exports["UserSiteDataErrorReason"] = $5bc992ef1d353b66$export$b08600051ba52198;
module.exports["UserSiteDataError"] = $5bc992ef1d353b66$export$c460344055e97b1;

});

parcelRegister("gOJC3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $aaf5556ace093621$var$noop = ()=>{};
const $aaf5556ace093621$export$3f3eebb4b8116461 = /*#__PURE__*/ (0, $cozmU.createContext)({
    start: $aaf5556ace093621$var$noop,
    success: $aaf5556ace093621$var$noop,
    failure: $aaf5556ace093621$var$noop,
    failureAll: $aaf5556ace093621$var$noop,
    abort: $aaf5556ace093621$var$noop,
    abortAll: $aaf5556ace093621$var$noop,
    markStart: $aaf5556ace093621$var$noop,
    markEnd: $aaf5556ace093621$var$noop
});
const $aaf5556ace093621$export$cdefb2a8b53f879f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($aaf5556ace093621$export$3f3eebb4b8116461);
} : ()=>(0, $cozmU.useContext)($aaf5556ace093621$export$3f3eebb4b8116461);
const $aaf5556ace093621$export$f88dde183f4d31cb = (Component)=>{
    const WithExperienceTracker = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
        const $ = (0, $bDgLe.c)(3);
        const experienceTracker = $aaf5556ace093621$export$cdefb2a8b53f879f();
        let t0;
        if ($[0] !== experienceTracker || $[1] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                ...props,
                experienceTracker: experienceTracker
            });
            $[0] = experienceTracker;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props)=>{
        const experienceTracker = $aaf5556ace093621$export$cdefb2a8b53f879f();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...props,
            experienceTracker: experienceTracker
        });
    };
    WithExperienceTracker.displayName = `WithExperienceTracker(${Component.displayName})`;
    return WithExperienceTracker;
};
module.exports["SwitcherExperienceTrackerContext"] = $aaf5556ace093621$export$3f3eebb4b8116461;
module.exports["useExperienceTracker"] = $aaf5556ace093621$export$cdefb2a8b53f879f;
module.exports["withExperienceTracker"] = $aaf5556ace093621$export$f88dde183f4d31cb;

});

parcelRegister("3sOoJ", function(module, exports) {

var $fb5K7 = parcelRequire("fb5K7");


var $bOMi3 = parcelRequire("bOMi3");


var $veDrf = parcelRequire("veDrf");

const $3b355d2da1ab4fe0$var$extraJsonFromResponse = (response)=>{
    if (response.ok) return response.json();
    throw new (0, $fb5K7.FetchError)(`Unable to fetch ${response.url} ${response.status} ${response.statusText}`, response.status);
};
const $3b355d2da1ab4fe0$export$6d71b655afe1638d = (url, init, emptyResponse)=>fetch(url, {
        credentials: 'include',
        ...init,
        headers: {
            'Atl-App-Switcher-Version': (0, $veDrf.default).packageVersion,
            ...init?.headers
        }
    }).then(!emptyResponse ? $3b355d2da1ab4fe0$var$extraJsonFromResponse : ()=>{});
const $3b355d2da1ab4fe0$export$16566b750080153d = (url, retryConfig, init)=>{
    return (0, $bOMi3.retryOnException)(()=>fetch(url, {
            credentials: 'include',
            ...init,
            headers: {
                'Atl-App-Switcher-Version': (0, $veDrf.default).packageVersion,
                ...init?.headers
            }
        }), retryConfig).then($3b355d2da1ab4fe0$var$extraJsonFromResponse);
};
const $3b355d2da1ab4fe0$export$c776284ef4b1209a = (url, data, emptyResponse)=>$3b355d2da1ab4fe0$export$6d71b655afe1638d(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }, emptyResponse);
module.exports["fetchJson"] = $3b355d2da1ab4fe0$export$6d71b655afe1638d;
module.exports["fetchJsonWithNetworkRetries"] = $3b355d2da1ab4fe0$export$16566b750080153d;
module.exports["postJson"] = $3b355d2da1ab4fe0$export$c776284ef4b1209a;

});

parcelRegister("ellLO", function(module, exports) {

var $gZFfs = parcelRequire("gZFfs");

function $601653c7aaa54218$export$c371a74fe5222b3(record) {
    const invertedRecord = {};
    Object.entries(record).forEach(([key, values])=>{
        values.forEach((value)=>{
            if (!invertedRecord[value]) invertedRecord[value] = [];
            invertedRecord[value].push(key);
        });
    });
    return invertedRecord;
}


var $c6922af21df15933$export$c90b54e658fc4d7c = /*#__PURE__*/ function(Experience) {
    Experience["RENDER_CUSTOM_LINKS_SECTION"] = "render-custom-links-section";
    Experience["RENDER_SWITCH_TO_SECTION"] = "render-switch-to-section";
    Experience["RENDER_SWITCHER_EMPTY_STATE"] = "render-switcher-empty-state";
    Experience["RENDER_THIRD_PARTY_SECTION"] = "render-third-party-section";
    return Experience;
}({});
const $c6922af21df15933$export$d54d7a2744fdf647 = {
    ["render-custom-links-section"]: {
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switch-to-section"]: {
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switcher-empty-state"]: {
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-third-party-section"]: {
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad
    }
};
var $c6922af21df15933$export$cbf1e672c3e37474 = /*#__PURE__*/ function(ExperienceMark) {
    ExperienceMark["API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS"] = "api-app-switcher-bff-available-products";
    ExperienceMark["API_APP_SWITCHER_BFF_GLOBAL_APPS"] = "api-app-switcher-bff-global-apps";
    ExperienceMark["API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS"] = "api-app-switcher-bff-third-party-products";
    ExperienceMark["API_CONFLUENCE_CUSTOM_LINKS"] = "api-confluence-custom-links";
    ExperienceMark["API_FLIGHT_DECK"] = "api-flight-deck";
    ExperienceMark["API_JIRA_CUSTOM_LINKS"] = "api-jira-custom-links";
    ExperienceMark["API_JOINABLE_SITES"] = "api-joinable-sites";
    ExperienceMark["API_PERMISSIONS"] = "api-permissions";
    ExperienceMark["SWITCHER_INITIAL_MOUNT"] = "switcher-initial-mount";
    ExperienceMark["SWITCHER_SKELETON_MOUNT"] = "switcher-skeleton-mount";
    // Mock for tests
    ExperienceMark["TEST_MARK"] = "test-mark";
    return ExperienceMark;
}({});
const $c6922af21df15933$var$allNonTestExperienceMarks = Object.values($c6922af21df15933$export$cbf1e672c3e37474).filter((mark)=>mark !== "test-mark");
const $c6922af21df15933$export$755e75afbd377bc4 = {
    ["render-custom-links-section"]: $c6922af21df15933$var$allNonTestExperienceMarks,
    ["render-switch-to-section"]: $c6922af21df15933$var$allNonTestExperienceMarks,
    ["render-switcher-empty-state"]: $c6922af21df15933$var$allNonTestExperienceMarks,
    ["render-third-party-section"]: $c6922af21df15933$var$allNonTestExperienceMarks
};
const $c6922af21df15933$export$805ed806e0769ee4 = (0, $601653c7aaa54218$export$c371a74fe5222b3)($c6922af21df15933$export$755e75afbd377bc4);
var $c6922af21df15933$export$ec8391a70bbdbe59 = /*#__PURE__*/ function(ExperienceMarkPhase) {
    ExperienceMarkPhase["START"] = "start";
    ExperienceMarkPhase["END"] = "end";
    return ExperienceMarkPhase;
}({});
var $c6922af21df15933$export$279d6315a97b520d = /*#__PURE__*/ function(AbortReason) {
    AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
    AbortReason["WINDOW_UNLOADING"] = "window-unloading";
    return AbortReason;
}({});
const $c6922af21df15933$export$86919b84f9a64054 = 'atlassianSwitcher.render.start';
module.exports["Experience"] = $c6922af21df15933$export$c90b54e658fc4d7c;
module.exports["EXPERIENCE_CONFIGS"] = $c6922af21df15933$export$d54d7a2744fdf647;
module.exports["ExperienceMark"] = $c6922af21df15933$export$cbf1e672c3e37474;
module.exports["EXPERIENCES_TO_MARKS"] = $c6922af21df15933$export$755e75afbd377bc4;
module.exports["MARKS_TO_EXPERIENCES"] = $c6922af21df15933$export$805ed806e0769ee4;
module.exports["ExperienceMarkPhase"] = $c6922af21df15933$export$ec8391a70bbdbe59;
module.exports["AbortReason"] = $c6922af21df15933$export$279d6315a97b520d;
module.exports["SWITCHER_RENDER_START_PERFORMANCE_MARK"] = $c6922af21df15933$export$86919b84f9a64054;

});

parcelRegister("b10hq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3ezGS = parcelRequire("3ezGS");

const { fetchMethod: $b73302e615368a53$var$fetchJoinableSites, ProviderComponent: $b73302e615368a53$var$DefaultDataProviderComponent } = (0, $3ezGS.createJoinableSitesProvider)();
const $b73302e615368a53$export$70da68d3b04f82d0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, joinableSitesDataProvider: joinableSitesDataProvider, cloudId: cloudId } = t0;
    const CustomDataProviderComponent = joinableSitesDataProvider && joinableSitesDataProvider.ProviderComponent;
    const DataProviderComponent = CustomDataProviderComponent || $b73302e615368a53$var$DefaultDataProviderComponent;
    let t1;
    if ($[0] !== DataProviderComponent || $[1] !== children || $[2] !== cloudId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DataProviderComponent, {
            cloudId: cloudId
        }, children);
        $[0] = DataProviderComponent;
        $[1] = children;
        $[2] = cloudId;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children, joinableSitesDataProvider: joinableSitesDataProvider, cloudId: cloudId })=>{
    const CustomDataProviderComponent = joinableSitesDataProvider && joinableSitesDataProvider.ProviderComponent;
    const DataProviderComponent = CustomDataProviderComponent || $b73302e615368a53$var$DefaultDataProviderComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DataProviderComponent, {
        cloudId: cloudId
    }, children);
};
const $b73302e615368a53$export$2aed3ef1595b4d9 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod({});
        return;
    }
    $b73302e615368a53$var$fetchJoinableSites({});
};
const $b73302e615368a53$export$4ba2a997caa6db74 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod.reset();
        return;
    }
    $b73302e615368a53$var$fetchJoinableSites.reset();
};
module.exports["JoinableSitesProvider"] = $b73302e615368a53$export$70da68d3b04f82d0;
module.exports["prefetchJoinableSites"] = $b73302e615368a53$export$2aed3ef1595b4d9;

});

parcelRegister("fqcDI", function(module, exports) {

var $4wH3g = parcelRequire("4wH3g");


var $cozmU = parcelRequire("cozmU");


var $geOrq = parcelRequire("geOrq");


const $a5ba7decb8b0bc5a$export$6c6894dd831bfacb = ()=>(parcelRequire("9moNy")).then((module)=>module.default);

const $a5ba7decb8b0bc5a$export$64191a36345a6b2b = ()=>(parcelRequire("bLH3G")).then((module)=>module.default);
const $a5ba7decb8b0bc5a$export$25f16f9fee84a840 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "SZcx1",
    name: "AtlassianSwitcherLoader",
    loader: $a5ba7decb8b0bc5a$export$6c6894dd831bfacb,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $geOrq.default), null)
});
const $a5ba7decb8b0bc5a$export$8c21d1a0c59fc17e = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "xoErk",
    name: "GenericSwitcherLoader",
    loader: $a5ba7decb8b0bc5a$export$64191a36345a6b2b,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $geOrq.default), null)
});
module.exports["loadAtlassianSwitcher"] = $a5ba7decb8b0bc5a$export$6c6894dd831bfacb;
module.exports["loadGenericSwitcher"] = $a5ba7decb8b0bc5a$export$64191a36345a6b2b;
module.exports["AtlassianSwitcherLoader"] = $a5ba7decb8b0bc5a$export$25f16f9fee84a840;
module.exports["GenericSwitcherLoader"] = $a5ba7decb8b0bc5a$export$8c21d1a0c59fc17e;

});

parcelRegister("geOrq", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a059babb1572447$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $ellLO = parcelRequire("ellLO");

var $c1PQo = parcelRequire("c1PQo");


var $kSwu1 = parcelRequire("kSwu1");


var $4oYn7 = parcelRequire("4oYn7");

const $8a059babb1572447$var$iconSkeleton = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
    style: {
        display: 'inline-block',
        width: 32,
        height: 32,
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        borderRadius: "var(--ds-radius-large, 8px)",
        marginRight: "var(--ds-space-100, 8px)"
    }
});
const $8a059babb1572447$var$lineSkeleton = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
    style: {
        display: 'inline-block',
        width: 260,
        height: 10,
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        borderRadius: "var(--ds-radius-small, 4px)"
    }
});
var $8a059babb1572447$export$2e2bcd8739ae039 = ()=>{
    (0, $c1PQo.useExperienceRenderAndMountMark)((0, $ellLO.ExperienceMark).SWITCHER_SKELETON_MOUNT);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const items = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        "aria-hidden": "true",
        style: {
            display: 'flex',
            paddingInline: "var(--ds-space-200, 16px)",
            paddingBlock: "var(--ds-space-100, 8px)",
            alignItems: 'center'
        }
    }, $8a059babb1572447$var$iconSkeleton, $8a059babb1572447$var$lineSkeleton);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "section",
        style: {
            width: '343px',
            height: '80vh'
        },
        role: "alert",
        "aria-label": formatMessage((0, $4oYn7.default).skeletonLoaderAriaLabel),
        testId: "skeleton"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        "aria-hidden": "true",
        style: {
            paddingInline: "var(--ds-space-200, 16px)",
            paddingTop: "var(--ds-space-300, 24px)",
            paddingBottom: "var(--ds-space-100, 8px)"
        }
    }, $8a059babb1572447$var$lineSkeleton), items, items, items);
};

});

parcelRegister("c1PQo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $gOJC3 = parcelRequire("gOJC3");


var $cozmU = parcelRequire("cozmU");


var $5L9W1 = parcelRequire("5L9W1");

const $e8040e7099aeb07a$export$675e0d25df38d426 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useExperienceStart(experienceName, customStartTime) {
    const $ = (0, $bDgLe.c)(4);
    const experienceTracker = (0, $gOJC3.useExperienceTracker)();
    let t0;
    if ($[0] !== customStartTime || $[1] !== experienceName || $[2] !== experienceTracker) {
        t0 = ()=>experienceTracker.start(experienceName, customStartTime);
        $[0] = customStartTime;
        $[1] = experienceName;
        $[2] = experienceTracker;
        $[3] = t0;
    } else t0 = $[3];
    (0, $5L9W1.useOnceImmediately)(t0);
} : function useExperienceStart(experienceName, customStartTime) {
    const experienceTracker = (0, $gOJC3.useExperienceTracker)();
    (0, $5L9W1.useOnceImmediately)(()=>experienceTracker.start(experienceName, customStartTime));
};
function $e8040e7099aeb07a$export$e94f0da4fc0603c6(experience, attributes) {
    const experienceTracker = (0, $gOJC3.useExperienceTracker)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $cozmU.useLayoutEffect)(()=>experienceTracker.success(experience, attributes), []);
}
function $e8040e7099aeb07a$export$fb30551804b67d63(mark) {
    const experienceTracker = (0, $gOJC3.useExperienceTracker)();
    (0, $5L9W1.useOnceImmediately)(()=>experienceTracker.markStart(mark));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $cozmU.useLayoutEffect)(()=>experienceTracker.markEnd(mark), []);
}
module.exports["useExperienceSuccess"] = $e8040e7099aeb07a$export$e94f0da4fc0603c6;
module.exports["useExperienceRenderAndMountMark"] = $e8040e7099aeb07a$export$fb30551804b67d63;

});

parcelRegister("5L9W1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $b2bfae3c9d1656fd$export$abf4268d2dd55708(builder) {
    const ref = (0, $cozmU.useRef)();
    if (!ref.current) ref.current = builder();
    return ref.current;
}
function $b2bfae3c9d1656fd$export$ad4f8d0eee7a0e24(callback) {
    const wasCalledRef = (0, $cozmU.useRef)(false);
    const result = (0, $cozmU.useRef)();
    if (!wasCalledRef.current) {
        wasCalledRef.current = true;
        result.current = callback();
    }
    return result.current;
}
module.exports["useSingleton"] = $b2bfae3c9d1656fd$export$abf4268d2dd55708;
module.exports["useOnceImmediately"] = $b2bfae3c9d1656fd$export$ad4f8d0eee7a0e24;

});

parcelRegister("4oYn7", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $8bab30db45ab48c6$var$messages = (0, $kSwu1.defineMessages)({
    newLozenge: {
        id: "fabric.atlassianSwitcher.newLozenge",
        defaultMessage: "New"
    },
    tryLozenge: {
        id: "fabric.atlassianSwitcher.tryLozenge",
        defaultMessage: "Try"
    },
    sites: {
        id: "fabric.atlassianSwitcher.sites",
        defaultMessage: "{productName} {numSites, plural, one {site} other {sites}}"
    },
    skeletonLoaderAriaLabel: {
        id: "fabric.atlassianSwitcher.skeletonLoaderAriaLabel",
        defaultMessage: "The App Switcher is loading"
    },
    skeleton3pLoaderAriaLabel: {
        id: "fabric.atlassianSwitcher.skeleton3pLoaderAriaLabel",
        defaultMessage: "The App Switcher third party section is loading"
    },
    reorderItemDropdown: {
        id: "fabric.atlassianSwitcher.reorderItemDropdown",
        defaultMessage: "Reorder menu item"
    },
    moveItemUp: {
        id: "fabric.atlassianSwitcher.moveItemUp",
        defaultMessage: "Move up"
    },
    moveItemDown: {
        id: "fabric.atlassianSwitcher.moveItemDown",
        defaultMessage: "Move down"
    },
    moveItemToTop: {
        id: "fabric.atlassianSwitcher.moveItemToTop",
        defaultMessage: "Move to top"
    },
    moveItemToBottom: {
        id: "fabric.atlassianSwitcher.moveItemToBottom",
        defaultMessage: "Move to bottom"
    }
});
var $8bab30db45ab48c6$export$2e2bcd8739ae039 = $8bab30db45ab48c6$var$messages;
module.exports["default"] = $8bab30db45ab48c6$export$2e2bcd8739ae039;

});

parcelRegister("9moNy", function(module, exports) {

let $6d09678a24b3e299$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6d09678a24b3e299$var$load("dhv2I").then(()=>parcelRequire('7aaPm'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("bLH3G", function(module, exports) {

let $89157c01f1271129$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $89157c01f1271129$var$load("8RMwa"),
    $89157c01f1271129$var$load("fHb94"),
    $89157c01f1271129$var$load("llPQO"),
    $89157c01f1271129$var$load("6wr18"),
    $89157c01f1271129$var$load("aPaBe"),
    $89157c01f1271129$var$load("ffEVr"),
    $89157c01f1271129$var$load("eH9NY"),
    $89157c01f1271129$var$load("4x9Jx"),
    $89157c01f1271129$var$load("FbUOF")
]).then(()=>parcelRequire('2Gx4q'));

});

parcelRegister("aAAmd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hp074 = parcelRequire("hp074");


var $eeq36 = parcelRequire("eeq36");


var $ellLO = parcelRequire("ellLO");


var $j9OyN = parcelRequire("j9OyN");


var $jH9cM = parcelRequire("jH9cM");


var $7yzXP = parcelRequire("7yzXP");


var $05jWx = parcelRequire("05jWx");

const $9de3a0dada572f85$var$client = new (0, $hp074.default)('atlassian-switcher', {
    handlers: {},
    // Switch the FD default storage from localStorage to sessionStorage to avoid issues related to GDPR policy.
    // The storageEngine option isn't exposed directly by the FD SDK, but you can still pass it in
    // https://hello.jira.atlassian.cloud/browse/NAVX-658
    //@ts-ignore
    storageEngine: 'sessionStorage'
});
const { fetchMethod: $9de3a0dada572f85$var$fetchFlightDeck, ProviderComponent: $9de3a0dada572f85$var$DefaultFlightDeckProviderComponent } = (0, $eeq36.createProviderWithCustomFetchData)('flightDeck', (0, $ellLO.ExperienceMark).API_FLIGHT_DECK, async ()=>{
    const artifact = await $9de3a0dada572f85$var$client.fetchConfigFromFlightDeck({
        name: 'app-switcher-fe',
        dimensions: {
            environmentType: 'prod',
            perimeter: (0, $jH9cM.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
        }
    });
    return $9de3a0dada572f85$var$transformFlightDeckArtifactToProductConfiguration(artifact);
});
const $9de3a0dada572f85$var$transformFlightDeckArtifactToProductConfiguration = (artifact)=>{
    const artifactMap = new Map();
    for (const product of artifact.products){
        const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey } = product;
        artifactMap.set(apsKey, {
            key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
            href: siteUrlSuffix,
            ordinal: ordinal,
            label: (0, $j9OyN.formatLabel)(displayName),
            description: (0, $j9OyN.formatDescription)(subtitle),
            iconKey: iconKey
        });
        // TODO: remove this once Asset app becomes standalone app
        if (apsKey === 'JIRA_SERVICE_DESK' && !artifactMap.has((0, $7yzXP.ASSETS_APP_KEY))) artifactMap.set((0, $7yzXP.ASSETS_APP_KEY), {
            key: (0, $7yzXP.ASSETS_APP_KEY),
            href: '/jira/assets',
            ordinal: ordinal + 0.1,
            // make sure assets is below jsm
            label: (0, $j9OyN.formatLabel)((0, $05jWx.default).assets),
            iconKey: 'assets'
        });
    }
    return {
        products: Object.fromEntries(artifactMap),
        links: Object.fromEntries(artifact.links.map(({ apsKey: apsKey, ...link })=>[
                apsKey,
                {
                    ...link,
                    key: apsKey.toLowerCase(),
                    href: link.url,
                    label: (0, $j9OyN.formatLabel)(link.displayName),
                    description: (0, $j9OyN.formatDescription)(link.subtitle),
                    iconKey: 'admin'
                }
            ]))
    };
};
const $9de3a0dada572f85$export$56da85ac9d40dbcd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9de3a0dada572f85$var$DefaultFlightDeckProviderComponent, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9de3a0dada572f85$var$DefaultFlightDeckProviderComponent, null, children);
const $9de3a0dada572f85$export$7d2a567d3e50224 = $9de3a0dada572f85$var$fetchFlightDeck;
module.exports["FlightDeckProvider"] = $9de3a0dada572f85$export$56da85ac9d40dbcd;
module.exports["prefetchFlightDeck"] = $9de3a0dada572f85$export$7d2a567d3e50224;

});

parcelRegister("j9OyN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $9eeca3884abb5638$export$957d7daebd899f12 = (label)=>{
    return typeof label === 'string' ? label : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label);
};
const $9eeca3884abb5638$export$f731e929548061dc = (description)=>{
    return typeof description === 'string' ? description : description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), description) : null;
};
module.exports["formatLabel"] = $9eeca3884abb5638$export$957d7daebd899f12;
module.exports["formatDescription"] = $9eeca3884abb5638$export$f731e929548061dc;

});

parcelRegister("7yzXP", function(module, exports) {
const $82b2976abf944d9a$export$45e63649edff1e2a = 'ASSETS';
const $82b2976abf944d9a$export$eb7589a4ee50c678 = 'tenantless';
const $82b2976abf944d9a$export$6f92d09c286cf429 = 72;
const $82b2976abf944d9a$export$d2c7e5e95defb918 = 268;
const $82b2976abf944d9a$export$2da11670386fd083 = 400;
const $82b2976abf944d9a$export$febc40c444660d15 = 136;
const $82b2976abf944d9a$export$f2c028b92293dc86 = 336;
const $82b2976abf944d9a$export$b5f11d495c6a880f = 1000;
const $82b2976abf944d9a$export$44866a86c1339131 = 'AS_ORG_SELECTOR_WIDTH';
const $82b2976abf944d9a$export$170fd582d3fdd1a1 = (widthFromStorage)=>{
    const parsed = widthFromStorage ? parseInt(widthFromStorage, 10) : NaN;
    return Number.isFinite(parsed) ? Math.min(Math.max(parsed, $82b2976abf944d9a$export$6f92d09c286cf429), $82b2976abf944d9a$export$2da11670386fd083) : $82b2976abf944d9a$export$d2c7e5e95defb918;
};
module.exports["ASSETS_APP_KEY"] = $82b2976abf944d9a$export$45e63649edff1e2a;
module.exports["TENANTLESS_ORG_ID"] = $82b2976abf944d9a$export$eb7589a4ee50c678;
module.exports["ORG_UNIT_RAIL_COLLAPSED_WIDTH"] = $82b2976abf944d9a$export$6f92d09c286cf429;
module.exports["ORG_UNIT_RAIL_DEFAULT_WIDTH"] = $82b2976abf944d9a$export$d2c7e5e95defb918;
module.exports["ORG_UNIT_RAIL_MAX_WIDTH"] = $82b2976abf944d9a$export$2da11670386fd083;
module.exports["ORG_UNIT_RAIL_MIN_EXPAND_WIDTH"] = $82b2976abf944d9a$export$febc40c444660d15;
module.exports["ORG_UNIT_RESIZE_TOOLTIP_DELAY_MS"] = $82b2976abf944d9a$export$b5f11d495c6a880f;
module.exports["ORG_UNIT_RAIL_WIDTH_LS_KEY"] = $82b2976abf944d9a$export$44866a86c1339131;
module.exports["getPersistedRailWidth"] = $82b2976abf944d9a$export$170fd582d3fdd1a1;

});

parcelRegister("05jWx", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0dba7fdcc48c1791$var$messages = (0, $kSwu1.defineMessages)({
    emptyStateExploreProductsTitle: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.title",
        defaultMessage: "Get started with cloud"
    },
    emptyStateExploreProductsBody: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.body",
        defaultMessage: "Try a product to start collaborating with your team."
    },
    emptyStateExploreProductsLink: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.link",
        defaultMessage: "Explore products"
    },
    home: {
        id: "fabric.atlassianSwitcher.atlassianHome",
        defaultMessage: "Home"
    },
    rovo: {
        id: "fabric.atlassianSwitcher.rovo-home",
        defaultMessage: "Rovo Home"
    },
    administration: {
        id: "fabric.atlassianSwitcher.administration",
        defaultMessage: "Administration"
    },
    atlassianStart: {
        id: "fabric.atlassianSwitcher.start",
        defaultMessage: "Atlassian Start"
    },
    assets: {
        id: "fabric.atlassianSwitcher.assets",
        defaultMessage: "Assets"
    },
    analytics: {
        id: "fabric.atlassianSwitcher.analytics",
        defaultMessage: "Analytics"
    },
    companyHub: {
        id: "fabric.atlassianSwitcher.companyHub",
        defaultMessage: "Company Hub"
    },
    goals: {
        id: "fabric.atlassianSwitcher.goals",
        defaultMessage: "Goals"
    },
    projects: {
        id: "fabric.atlassianSwitcher.projects",
        defaultMessage: "Projects"
    },
    teams: {
        id: "fabric.atlassianSwitcher.teams",
        defaultMessage: "Teams"
    },
    search: {
        id: "fabric.atlassianSwitcher.search",
        defaultMessage: "Search"
    },
    chat: {
        id: "fabric.atlassianSwitcher.chat",
        defaultMessage: "Chat"
    },
    studio: {
        id: "fabric.atlassianSwitcher.studio",
        defaultMessage: "Studio"
    },
    rovoSearch: {
        id: "fabric.atlassianSwitcher.rovo-search",
        defaultMessage: "Rovo Search"
    },
    rovoChat: {
        id: "fabric.atlassianSwitcher.rovo-chat",
        defaultMessage: "Rovo Chat"
    },
    rovoStudio: {
        id: "fabric.atlassianSwitcher.rovo-studio",
        defaultMessage: "Rovo Studio"
    },
    manageList: {
        id: "fabric.atlassianSwitcher.manageList",
        defaultMessage: "Manage list"
    },
    errorEmptyPartialResults: {
        id: "fabric.atlassianSwitcher.errorEmptyPartialResults",
        defaultMessage: "We can't display your apps right now."
    },
    errorHeading: {
        id: "fabric.atlassianSwitcher.errorHeading",
        defaultMessage: "Something\u2019s gone wrong"
    },
    errorText: {
        id: "fabric.atlassianSwitcher.errorText",
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things"
    },
    errorImageAltText: {
        id: "fabric.atlassianSwitcher.errorImageAltText",
        defaultMessage: "A broken robot and a number of people busy fixing it."
    },
    errorTextNetwork: {
        id: "fabric.atlassianSwitcher.errorTextNetwork",
        defaultMessage: "We couldn\u2019t load this list. Please reload the page and try again."
    },
    errorHeadingLoggedOut: {
        id: "fabric.atlassianSwitcher.errorHeadingLoggedOut",
        defaultMessage: "Your Atlassian account is logged out"
    },
    errorHeadingUnverified: {
        id: "fabric.atlassianSwitcher.errorHeadingUnverified",
        defaultMessage: "Your account is unverified"
    },
    errorPartialResults: {
        id: "fabric.atlassianSwitcher.errorPartialResults",
        defaultMessage: "We can't display some of your apps right now."
    },
    errorPartialResultsRefresh: {
        id: "fabric.atlassianSwitcher.errorPartialResultsRefresh",
        defaultMessage: "Refresh the page, or try again later."
    },
    errorTextUnverified: {
        id: "fabric.atlassianSwitcher.errorTextUnverified",
        defaultMessage: "Please confirm your email address to view a list of available products."
    },
    productDescriptionConfluence: {
        id: "fabric.atlassianSwitcher.product.description.confluence",
        defaultMessage: "Document collaboration"
    },
    productDescriptionJiraServiceManagement: {
        id: "fabric.atlassianSwitcher.product.description.jsm",
        defaultMessage: "Collaborative IT service management"
    },
    productDescriptionJiraSoftware: {
        id: "fabric.atlassianSwitcher.product.description.jsw",
        defaultMessage: "Project and issue tracking"
    },
    productDescriptionOpsgenie: {
        id: "fabric.atlassianSwitcher.product.description.opsgenie",
        defaultMessage: "Modern incident management"
    },
    productDescriptionCompass: {
        id: "fabric.atlassianSwitcher.product.description.compass",
        defaultMessage: "Component manager"
    },
    join: {
        id: "fabric.atlassianSwitcher.join",
        defaultMessage: "Join"
    },
    expandProductList: {
        id: "fabric.atlassianSwitcher.expandProductList",
        defaultMessage: "{numItems} more"
    },
    collapseProductList: {
        id: "fabric.atlassianSwitcher.contractProductList",
        defaultMessage: "Less"
    },
    emptyStateExploreProductsBodyAppify: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.body-appify",
        defaultMessage: "Try an app to start collaborating with your team."
    },
    emptyStateExploreProductsLinkAppify: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.link-appify",
        defaultMessage: "Explore apps"
    },
    errorTextUnverifiedAppify: {
        id: "fabric.atlassianSwitcher.errorTextUnverified-appify",
        defaultMessage: "Please confirm your email address to view a list of available apps."
    },
    customLinksSectionTitle: {
        id: "fabric.atlassianSwitcher.customLinksSectionTitle",
        defaultMessage: "Custom links"
    },
    thirdPartySectionTitle: {
        id: "fabric.atlassianSwitcher.thirdPartySectionTitle",
        defaultMessage: "Integrations"
    }
});
var $0dba7fdcc48c1791$export$2e2bcd8739ae039 = $0dba7fdcc48c1791$var$messages;
module.exports["default"] = $0dba7fdcc48c1791$export$2e2bcd8739ae039;

});

parcelRegister("1xyxN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eeq36 = parcelRequire("eeq36");


var $3sOoJ = parcelRequire("3sOoJ");


var $ellLO = parcelRequire("ellLO");

const $19bb64c9ab3ac73a$export$7cf62b3dbe96f5e8 = '/gateway/api/app-switcher/api/app-switcher/v1/third-party-products';
const $19bb64c9ab3ac73a$export$c39ca0fbc2221bcc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    return await (0, $3sOoJ.fetchJsonWithNetworkRetries)(`${$19bb64c9ab3ac73a$export$7cf62b3dbe96f5e8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
};
const $19bb64c9ab3ac73a$export$1a41882ddb3a9c38 = ()=>{
    return (0, $eeq36.createProviderWithCustomFetchData)('appSwitcherBffThirdPartyProducts', (0, $ellLO.ExperienceMark).API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS, $19bb64c9ab3ac73a$export$c39ca0fbc2221bcc);
};


const { fetchMethod: $eea32afc295dd597$var$fetchAppSwitcherBffThirdPartyProducts, ProviderComponent: $eea32afc295dd597$var$DefaultBffThirdPartyProductsDataProvider } = (0, $19bb64c9ab3ac73a$export$1a41882ddb3a9c38)();
const $eea32afc295dd597$export$a7ffda257898c103 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { cloudId: cloudId, children: children, product: product } = t0;
    let t1;
    if ($[0] !== children || $[1] !== cloudId || $[2] !== product) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eea32afc295dd597$var$DefaultBffThirdPartyProductsDataProvider, {
            cloudId: cloudId,
            product: product
        }, children);
        $[0] = children;
        $[1] = cloudId;
        $[2] = product;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ cloudId: cloudId, children: children, product: product })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eea32afc295dd597$var$DefaultBffThirdPartyProductsDataProvider, {
        cloudId: cloudId,
        product: product
    }, children);
const $eea32afc295dd597$export$ba83558707df5bbe = $eea32afc295dd597$var$fetchAppSwitcherBffThirdPartyProducts;
const $eea32afc295dd597$export$fdb5fe543e39bc7a = ()=>$eea32afc295dd597$var$fetchAppSwitcherBffThirdPartyProducts.reset();
module.exports["ThirdPartyProductsProvider"] = $eea32afc295dd597$export$a7ffda257898c103;
module.exports["prefetchThirdPartyProducts"] = $eea32afc295dd597$export$ba83558707df5bbe;

});

parcelRegister("6M59K", function(module, exports) {
const $2f56beac7a7ac72a$export$fb4230f160368c88 = typeof window !== 'undefined' && window.performance && window.performance.now.bind(performance) || Date.now;
module.exports["performanceNow"] = $2f56beac7a7ac72a$export$fb4230f160368c88;

});

parcelRegister("1hcxO", function(module, exports) {

var $ellLO = parcelRequire("ellLO");

function $e0e2b2d76e6889ae$export$3ac4e94b194cd647(experience) {
    return (0, $ellLO.EXPERIENCES_TO_MARKS)[experience].map($e0e2b2d76e6889ae$var$generateUFOTiming);
}
function $e0e2b2d76e6889ae$var$generateUFOTiming(mark) {
    return {
        key: mark,
        startMark: $e0e2b2d76e6889ae$export$504463c8409cf4d7(mark, (0, $ellLO.ExperienceMarkPhase).START),
        endMark: $e0e2b2d76e6889ae$export$504463c8409cf4d7(mark, (0, $ellLO.ExperienceMarkPhase).END)
    };
}
const $e0e2b2d76e6889ae$export$504463c8409cf4d7 = (mark, phase)=>`${mark}_${phase}`;
const $e0e2b2d76e6889ae$export$16539b434cec5cfb = ()=>{
    performance.mark((0, $ellLO.SWITCHER_RENDER_START_PERFORMANCE_MARK));
};
const $e0e2b2d76e6889ae$export$436b7aeb93937572 = ()=>{
    const renderStartPerformanceMarks = performance.getEntriesByName ? performance.getEntriesByName((0, $ellLO.SWITCHER_RENDER_START_PERFORMANCE_MARK)) : [];
    return renderStartPerformanceMarks[renderStartPerformanceMarks.length - 1]?.startTime;
};
module.exports["experienceTimingsOf"] = $e0e2b2d76e6889ae$export$3ac4e94b194cd647;
module.exports["generateUFOMarkName"] = $e0e2b2d76e6889ae$export$504463c8409cf4d7;
module.exports["setSwitcherRenderStartMark"] = $e0e2b2d76e6889ae$export$16539b434cec5cfb;
module.exports["getSwitcherRenderStartMark"] = $e0e2b2d76e6889ae$export$436b7aeb93937572;

});

parcelRegister("2A9d7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");


var $bLbuQ = parcelRequire("bLbuQ");


var $ac62U = parcelRequire("ac62U");


var $I7hWB = parcelRequire("I7hWB");

const $351c4a80e9b1d6a3$var$styles = {
    sectionBase: "_4bt5LAnQyn _2WAcuGnQyn _2bqfgdOeNX _0Of8r22ADO _1ZnuxbdnbC _1wydGWgVvo _2Zuz6QdnbC _313842A17z",
    list: "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0aNu0LYbGa",
    box: "_2XsHFM8HPE _0adFHs8HPE _313842dnbC _1DCdHi1Y8M",
    titleBase: "_4bt5LAnQyn _2WAcuGnQyn _313842gVvo _2XsHFM2ADO _1DCdHigVvo _39HuIbz8Lp _1ANEUSLRg7 _1UtDYzKGUX _1kk5Tkf7mX",
    chevron: "_3iDTPbQ4SZ _0Of8r2gVvo _1ZnuxbgVvo _1wydGWgVvo _2Zuz6QgVvo _37wbyuDIqT _0hPCNLDIqT"
};
const $351c4a80e9b1d6a3$var$triggerStyles = {
    root: "_2mHwu88HPE _0bjKvDKTcp _3iDTPbQ4SZ _0jFU0VUofl _0hPCNLDIqT _4xdlr0FlnN _39xV02N91d _0Of8r21Y8M _1ZnuxbPgdg _1wydGW1Y8M _2Zuz6Q2ADO _0KLXru66of",
    titleBase: "_2sNsIgd8bj _4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _1UtDYzKGUX _1kk5Tkmb2E _2l4i3rzUZr"
};
const $351c4a80e9b1d6a3$var$CollapsibleSectionHeader = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { isCollapsed: isCollapsed, listId: listId, onToggle: onToggle, sectionId: sectionId, title: title } = t0;
    const t1 = !isCollapsed;
    const t2 = `${sectionId}__section-toggle`;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $351c4a80e9b1d6a3$var$styles.chevron
        ]);
        $[0] = t3;
    } else t3 = $[0];
    let t4;
    if ($[1] !== isCollapsed) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t3
        }, isCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: "",
            color: "currentColor",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            color: "currentColor",
            size: "small"
        }));
        $[1] = isCollapsed;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== title) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $351c4a80e9b1d6a3$var$triggerStyles.titleBase
        }, title);
        $[3] = title;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== listId || $[6] !== onToggle || $[7] !== t1 || $[8] !== t2 || $[9] !== t4 || $[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "xxsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $351c4a80e9b1d6a3$var$triggerStyles.root,
            "aria-expanded": t1,
            "aria-controls": listId,
            onClick: onToggle,
            testId: t2
        }, t4, t5));
        $[5] = listId;
        $[6] = onToggle;
        $[7] = t1;
        $[8] = t2;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ isCollapsed: isCollapsed, listId: listId, onToggle: onToggle, sectionId: sectionId, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "xxsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $351c4a80e9b1d6a3$var$triggerStyles.root,
        "aria-expanded": !isCollapsed,
        "aria-controls": listId,
        onClick: onToggle,
        testId: `${sectionId}__section-toggle`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $351c4a80e9b1d6a3$var$styles.chevron
        ])
    }, isCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: "",
        color: "currentColor",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: "",
        color: "currentColor",
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $351c4a80e9b1d6a3$var$triggerStyles.titleBase
    }, title)));
const $351c4a80e9b1d6a3$var$SectionContainerComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { sectionId: sectionId, title: title, children: children, xcss: xcss, tag: t1, isCollapsible: t2 } = t0;
    const Tag = t1 === undefined ? "ul" : t1;
    const isCollapsible = t2 === undefined ? false : t2;
    const [isCollapsed, setIsCollapsed] = (0, $cozmU.useState)(false);
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsCollapsed($351c4a80e9b1d6a3$var$_temp);
        $[0] = t3;
    } else t3 = $[0];
    const handleToggle = t3;
    const hasChildren = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children).some(Boolean);
    if (!hasChildren) return null;
    const listId = `${sectionId}__section-list`;
    const showCollapsibleHeader = isCollapsible && Boolean(title);
    let t4;
    if ($[1] !== xcss) {
        t4 = (0, $hekY6.default)([
            $351c4a80e9b1d6a3$var$styles.sectionBase,
            xcss
        ]);
        $[1] = xcss;
        $[2] = t4;
    } else t4 = $[2];
    const t5 = `${sectionId}__section`;
    let t6;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            $351c4a80e9b1d6a3$var$styles.box
        ]);
        $[3] = t6;
    } else t6 = $[3];
    let t7;
    if ($[4] !== isCollapsed || $[5] !== listId || $[6] !== sectionId || $[7] !== showCollapsibleHeader || $[8] !== title) {
        t7 = showCollapsibleHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($351c4a80e9b1d6a3$var$CollapsibleSectionHeader, {
            isCollapsed: isCollapsed,
            listId: listId,
            onToggle: handleToggle,
            sectionId: sectionId,
            title: title
        }) : title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "xxsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $351c4a80e9b1d6a3$var$styles.titleBase
        }, title));
        $[4] = isCollapsed;
        $[5] = listId;
        $[6] = sectionId;
        $[7] = showCollapsibleHeader;
        $[8] = title;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ac62U.FadeIn), null, t7);
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    const t9 = showCollapsibleHeader && isCollapsed;
    const t10 = `${sectionId}__section-list`;
    let t11;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $hekY6.default)([
            $351c4a80e9b1d6a3$var$styles.list
        ]);
        $[12] = t11;
    } else t11 = $[12];
    let t12;
    if ($[13] !== Tag || $[14] !== children || $[15] !== listId || $[16] !== t10 || $[17] !== t11 || $[18] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Tag, {
            id: listId,
            hidden: t9,
            "data-testid": t10,
            className: t11
        }, children);
        $[13] = Tag;
        $[14] = children;
        $[15] = listId;
        $[16] = t10;
        $[17] = t11;
        $[18] = t9;
        $[19] = t12;
    } else t12 = $[19];
    let t13;
    if ($[20] !== t12 || $[21] !== t6 || $[22] !== t8) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t6
        }, t8, t12);
        $[20] = t12;
        $[21] = t6;
        $[22] = t8;
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== t13 || $[25] !== t4 || $[26] !== t5) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("section", {
            className: t4,
            "data-testid": t5
        }, t13);
        $[24] = t13;
        $[25] = t4;
        $[26] = t5;
        $[27] = t14;
    } else t14 = $[27];
    return t14;
} : ({ sectionId: sectionId, title: title, children: children, xcss: xcss, tag: Tag = 'ul', isCollapsible: isCollapsible = false })=>{
    const [isCollapsed, setIsCollapsed] = (0, $cozmU.useState)(false);
    const handleToggle = (0, $cozmU.useCallback)(()=>setIsCollapsed((prev)=>!prev), []);
    const hasChildren = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children).some(Boolean);
    if (!hasChildren) return null;
    const listId = `${sectionId}__section-list`;
    const showCollapsibleHeader = isCollapsible && Boolean(title);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("section" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- required with `xcss`
    , {
        className: (0, $hekY6.default)([
            $351c4a80e9b1d6a3$var$styles.sectionBase,
            xcss
        ]),
        "data-testid": `${sectionId}__section`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $351c4a80e9b1d6a3$var$styles.box
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ac62U.FadeIn), null, showCollapsibleHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($351c4a80e9b1d6a3$var$CollapsibleSectionHeader, {
        isCollapsed: isCollapsed,
        listId: listId,
        onToggle: handleToggle,
        sectionId: sectionId,
        title: title
    }) : title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "xxsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $351c4a80e9b1d6a3$var$styles.titleBase
    }, title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Tag, {
        id: listId,
        hidden: showCollapsibleHeader && isCollapsed,
        "data-testid": `${sectionId}__section-list`,
        className: (0, $hekY6.default)([
            $351c4a80e9b1d6a3$var$styles.list
        ])
    }, children)));
};
const $351c4a80e9b1d6a3$export$be4c8679ebfd988 = (0, $bLbuQ.withAnalyticsContextData)((props)=>({
        ...(0, $bLbuQ.analyticsAttributes)({
            group: props.sectionId,
            groupItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(props.children).filter((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement).length
        })
    }))($351c4a80e9b1d6a3$var$SectionContainerComponent);
function $351c4a80e9b1d6a3$var$_temp(prev) {
    return !prev;
}
module.exports["SectionContainer"] = $351c4a80e9b1d6a3$export$be4c8679ebfd988;

});

parcelRegister("ac62U", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $2ddf65617fc1309c$var$fadeIn = null;
const $2ddf65617fc1309c$var$fadeInStyles = {
    noFade: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _1YKVNs7dHp _1UtDYzy7kJ",
    root: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _1gBibyvRYT _0nFVCGwiJJ _43vdfTUtCU _3Y6bKpgRhm _1YKVNsdnbC _1UtDYzy7kJ"
};
const $2ddf65617fc1309c$export$bd7370ffb2917ab7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, className: className, disableAnimation: disableAnimation, tag: t1 } = t0;
    const Tag = t1 === undefined ? "div" : t1;
    const t2 = disableAnimation && $2ddf65617fc1309c$var$fadeInStyles.noFade || !disableAnimation && $2ddf65617fc1309c$var$fadeInStyles.root;
    let t3;
    if ($[0] !== className || $[1] !== t2) {
        t3 = (0, $hekY6.default)([
            t2,
            className
        ]);
        $[0] = className;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== Tag || $[4] !== children || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Tag, {
            className: t3
        }, children);
        $[3] = Tag;
        $[4] = children;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ children: children, className: className, disableAnimation: disableAnimation, tag: Tag = 'div' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Tag // FadeIn breaks the drag preview, so we need a way to disable it
    , {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hekY6.default)([
            disableAnimation && $2ddf65617fc1309c$var$fadeInStyles.noFade || !disableAnimation && $2ddf65617fc1309c$var$fadeInStyles.root,
            className
        ])
    }, children);
module.exports["FadeIn"] = $2ddf65617fc1309c$export$bd7370ffb2917ab7;

});

parcelRegister("a2EbF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $5T9cw = parcelRequire("5T9cw");

// temp workaround to fix mix usage of emotion and compiled css: https://hello.jira.atlassian.cloud/browse/NAVX-551
const $b49648615d5d6e72$var$styles = {
    item: "_0bjKvDMe11 _00uqCYxTF4 _3xtjKNOiJt _0H9qDFp3yX _0Of8r2WfES _1ZnuxbWfES _1wydGWWfES _2Zuz6QWfES _0CMRbkOLYo _10n1R5OLYo _22XfGnOLYo _0clgaMOLYo",
    itemWithDescription: "_0Of8r2z9XV _1wydGWz9XV",
    icon: "_0adFHs5UaJ"
};
const $b49648615d5d6e72$var$_default_1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, focusRef)=>{
    const $ = (0, $bDgLe.c)(6);
    let t0;
    if ($[0] !== focusRef || $[1] !== props) {
        const { icon: icon, isDraggable: isDraggable, setIsLinkItemHovered: setIsLinkItemHovered, isOverflowButton: isOverflowButton, is1pApp: is1pApp, lozenges: lozenges, ...rest } = props;
        let t1;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = (0, $hekY6.default)([
                $b49648615d5d6e72$var$styles.icon
            ]);
            $[3] = t1;
        } else t1 = $[3];
        let t2;
        if ($[4] !== icon) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                className: t1
            }, icon);
            $[4] = icon;
            $[5] = t2;
        } else t2 = $[5];
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5T9cw.default), {
            icon: t2,
            ...rest,
            lozenges: lozenges,
            isDraggable: isDraggable,
            setIsLinkItemHovered: setIsLinkItemHovered,
            ref: focusRef,
            isOverflowButton: isOverflowButton,
            is1pApp: is1pApp,
            className: (0, $hekY6.default)([
                $b49648615d5d6e72$var$styles.item,
                lozenges?.length && rest.description && $b49648615d5d6e72$var$styles.itemWithDescription
            ])
        });
        $[0] = focusRef;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, focusRef)=>{
    const { icon: icon, isDraggable: isDraggable, setIsLinkItemHovered: setIsLinkItemHovered, isOverflowButton: isOverflowButton, is1pApp: is1pApp, lozenges: lozenges, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5T9cw.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $b49648615d5d6e72$var$styles.icon
            ])
        }, icon),
        ...rest,
        lozenges: lozenges,
        isDraggable: isDraggable,
        setIsLinkItemHovered: setIsLinkItemHovered,
        ref: focusRef,
        isOverflowButton: isOverflowButton,
        is1pApp: is1pApp,
        className: (0, $hekY6.default)([
            $b49648615d5d6e72$var$styles.item,
            lozenges?.length && rest.description && $b49648615d5d6e72$var$styles.itemWithDescription
        ])
    });
});
var $b49648615d5d6e72$export$2e2bcd8739ae039 = $b49648615d5d6e72$var$_default_1;
module.exports["default"] = $b49648615d5d6e72$export$2e2bcd8739ae039;

});

parcelRegister("5T9cw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $8oBbn = parcelRequire("8oBbn");


var $bLbuQ = parcelRequire("bLbuQ");


var $ac62U = parcelRequire("ac62U");


var $9KSWX = parcelRequire("9KSWX");


var $kSwu1 = parcelRequire("kSwu1");


var $4oYn7 = parcelRequire("4oYn7");


var $a4Rk2 = parcelRequire("a4Rk2");


var $iMnC5 = parcelRequire("iMnC5");








var $aIlZA = parcelRequire("aIlZA");


var $852mP = parcelRequire("852mP");


var $9DHhW = parcelRequire("9DHhW");

const $0cd310592a0c0a8e$export$e0e5234bc51fe848 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (product, subProduct)=>{
    const $ = (0, $bDgLe.c)(7);
    const isAssets = subProduct === "assets";
    const t0 = isAssets ? "assets" : product ?? "appSwitcher";
    const t1 = !isAssets ? subProduct : undefined;
    let t2;
    if ($[0] !== t0 || $[1] !== t1) {
        t2 = {
            bridge: "appSwitcher",
            product: t0,
            subProduct: t1
        };
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    const analyticsUrlWrapper = (0, $aIlZA.default)(t2);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t3;
    if ($[3] !== analyticsUrlWrapper || $[4] !== createAnalyticsEvent || $[5] !== product) {
        t3 = (url)=>{
            try {
                const parsedUrl = new URL(url);
                const continueParam = parsedUrl.searchParams.get("continue");
                if (!continueParam) return analyticsUrlWrapper(url);
                const wrappedContinueUrl = analyticsUrlWrapper(continueParam);
                parsedUrl.searchParams.set("continue", wrappedContinueUrl);
                return parsedUrl.toString();
            } catch (t4) {
                createAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    action: "failed",
                    actionSubject: "analyticsUrlWrapping",
                    attributes: {
                        url: url,
                        product: product
                    }
                }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
                return url;
            }
        };
        $[3] = analyticsUrlWrapper;
        $[4] = createAnalyticsEvent;
        $[5] = product;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : (product, subProduct)=>{
    // Assets still uses the switcher in Jira so its product is "jira".
    // However, for XPC we want the source to be "assets" to match the implementation in GAS.
    const isAssets = subProduct === 'assets';
    const analyticsUrlWrapper = (0, $aIlZA.default)({
        bridge: 'appSwitcher',
        product: isAssets ? 'assets' : product ?? 'appSwitcher',
        subProduct: !isAssets ? subProduct : undefined
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    return (url)=>{
        try {
            const parsedUrl = new URL(url);
            const continueParam = parsedUrl.searchParams.get('continue');
            if (!continueParam) // If there is no continue param, we just wrap the whole URL
            return analyticsUrlWrapper(url);
            // Safely deserialize identity links e.g: https://id.atlassian.com/login?login_hint=...
            const wrappedContinueUrl = analyticsUrlWrapper(continueParam);
            // Reconstruct the original URL with the wrapped continue param
            parsedUrl.searchParams.set('continue', wrappedContinueUrl);
            return parsedUrl.toString();
        } catch (e) {
            createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                actionSubject: 'analyticsUrlWrapping',
                attributes: {
                    url: url,
                    product: product
                }
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
            return url;
        }
    };
};



var $6q8XG = parcelRequire("6q8XG");


var $7ske2 = parcelRequire("7ske2");

var $696c5f2250ea38c4$export$b95b532653e2b7f6 = /*#__PURE__*/ function(LozengeType) {
    LozengeType["New"] = "new";
    LozengeType["Try"] = "try";
    return LozengeType;
}({});
const $696c5f2250ea38c4$var$lozengeData = {
    ["new"]: {
        label: (0, $4oYn7.default).newLozenge,
        componentProps: {
            appearance: 'new'
        }
    },
    ["try"]: {
        label: (0, $4oYn7.default).tryLozenge,
        componentProps: {
            appearance: 'new'
        }
    }
};
const $696c5f2250ea38c4$var$styles = {
    fadeIn: "_39xV02N91d",
    itemDescription: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _39HuIbz8Lp _0adFHsVa5s",
    hoveredDescription: "_0adFHsGXk2",
    titleWrapper: "_3iDTPbQ4SZ",
    overflowTitleWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39xV02oBHb _1ANEUSLRg7 _39HuIbz8Lp",
    hasDescription: "_313842Ll21 _1DCdHiLl21",
    lozengeWrapper: "_3iDTPbQ4SZ _4xdlr0DIqT _2XsHFM2ADO"
};
const $696c5f2250ea38c4$var$SwitcherItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, focusRef)=>{
    const $ = (0, $bDgLe.c)(82);
    let children;
    let description;
    let disableAnimation;
    let elemAfter;
    let href;
    let icon;
    let is1pApp;
    let isDraggable;
    let isHovered;
    let isOverflowButton;
    let lozenges;
    let onClick;
    let onContextMenu;
    let product;
    let rest;
    let setIsLinkItemHovered;
    let tag;
    if ($[0] !== t0) {
        ({ icon: icon, description: description, elemAfter: elemAfter, onClick: onClick, children: children, lozenges: lozenges, product: product, tag: tag, href: href, isDraggable: isDraggable, isHovered: isHovered, setIsLinkItemHovered: setIsLinkItemHovered, disableAnimation: disableAnimation, isOverflowButton: isOverflowButton, onContextMenu: onContextMenu, is1pApp: is1pApp, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = description;
        $[3] = disableAnimation;
        $[4] = elemAfter;
        $[5] = href;
        $[6] = icon;
        $[7] = is1pApp;
        $[8] = isDraggable;
        $[9] = isHovered;
        $[10] = isOverflowButton;
        $[11] = lozenges;
        $[12] = onClick;
        $[13] = onContextMenu;
        $[14] = product;
        $[15] = rest;
        $[16] = setIsLinkItemHovered;
        $[17] = tag;
    } else {
        children = $[1];
        description = $[2];
        disableAnimation = $[3];
        elemAfter = $[4];
        href = $[5];
        icon = $[6];
        is1pApp = $[7];
        isDraggable = $[8];
        isHovered = $[9];
        isOverflowButton = $[10];
        lozenges = $[11];
        onClick = $[12];
        onContextMenu = $[13];
        product = $[14];
        rest = $[15];
        setIsLinkItemHovered = $[16];
        tag = $[17];
    }
    const cursorTimeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const { productSwitcher: productSwitcher, subProduct: subProduct } = (0, $6q8XG.useUnifiedAnalyticsContext)();
    const { fireMenuStateChanged: fireMenuStateChanged } = (0, $7ske2.useUnifiedAnalytics)();
    const getAnalyticsWrappedURL = (0, $0cd310592a0c0a8e$export$e0e5234bc51fe848)(productSwitcher ?? "appSwitcher", subProduct);
    let t1;
    if ($[18] !== getAnalyticsWrappedURL || $[19] !== href || $[20] !== is1pApp) {
        t1 = href && is1pApp ? getAnalyticsWrappedURL(href) : href;
        $[18] = getAnalyticsWrappedURL;
        $[19] = href;
        $[20] = is1pApp;
        $[21] = t1;
    } else t1 = $[21];
    const analyticsWrappedURL = t1;
    let t2;
    let t3;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>()=>{
                if (cursorTimeoutRef.current) clearTimeout(cursorTimeoutRef.current);
            };
        t3 = [];
        $[22] = t2;
        $[23] = t3;
    } else {
        t2 = $[22];
        t3 = $[23];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t2, t3);
    let t4;
    bb0: {
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(description) || typeof description === "string") {
            const t5 = isHovered && $696c5f2250ea38c4$var$styles.hoveredDescription;
            let t6;
            if ($[24] !== t5) {
                t6 = (0, $hekY6.default)([
                    $696c5f2250ea38c4$var$styles.itemDescription,
                    t5
                ]);
                $[24] = t5;
                $[25] = t6;
            } else t6 = $[25];
            let t7;
            if ($[26] !== description || $[27] !== t6) {
                t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    className: t6
                }, description);
                $[26] = description;
                $[27] = t6;
                $[28] = t7;
            } else t7 = $[28];
            t4 = t7;
            break bb0;
        }
        t4 = undefined;
    }
    const itemDescription = t4;
    let t5;
    bb1: {
        if (!lozenges?.length) {
            t5 = null;
            break bb1;
        }
        let t6;
        if ($[29] !== children) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(children) ? {
                key: children.key ?? null,
                props: children.props ?? {},
                type: children.type ?? null
            } : children;
            $[29] = children;
            $[30] = t6;
        } else t6 = $[30];
        const filteredChildren = t6;
        let t7;
        if ($[31] !== lozenges) {
            t7 = lozenges.map($696c5f2250ea38c4$var$_temp);
            $[31] = lozenges;
            $[32] = t7;
        } else t7 = $[32];
        let t8;
        if ($[33] !== description || $[34] !== filteredChildren || $[35] !== lozenges || $[36] !== product) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bLbuQ.RenderTracker), {
                subject: (0, $bLbuQ.SWITCHER_ITEM_LOZENGES_SUBJECT),
                data: {
                    product: product,
                    lozenges: lozenges,
                    children: filteredChildren,
                    description: description
                }
            });
            $[33] = description;
            $[34] = filteredChildren;
            $[35] = lozenges;
            $[36] = product;
            $[37] = t8;
        } else t8 = $[37];
        let t9;
        if ($[38] !== t7 || $[39] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t7, t8);
            $[38] = t7;
            $[39] = t8;
            $[40] = t9;
        } else t9 = $[40];
        let t10;
        if ($[41] !== product || $[42] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a4Rk2.default), {
                product: product,
                triggerSubject: "switcherItemLozengeErrorBoundary",
                hideFallbackUI: true
            }, t9);
            $[41] = product;
            $[42] = t9;
            $[43] = t10;
        } else t10 = $[43];
        t5 = t10;
    }
    const renderLozenges = t5;
    let t6;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            $696c5f2250ea38c4$var$styles.fadeIn
        ]);
        $[44] = t6;
    } else t6 = $[44];
    let t7;
    let t8;
    if ($[45] !== isDraggable || $[46] !== setIsLinkItemHovered) {
        t7 = (e)=>{
            setIsLinkItemHovered?.(true);
            if (e.target && isDraggable) {
                if (cursorTimeoutRef.current) clearTimeout(cursorTimeoutRef.current);
                cursorTimeoutRef.current = window.setTimeout(()=>{
                    e.target.style.cursor = "grab";
                    cursorTimeoutRef.current = null;
                }, 800);
            }
        };
        t8 = (e_0)=>{
            setIsLinkItemHovered?.(false);
            if (e_0.target && isDraggable) {
                if (cursorTimeoutRef.current) {
                    clearTimeout(cursorTimeoutRef.current);
                    cursorTimeoutRef.current = null;
                }
                e_0.target.style.cursor = "";
            }
        };
        $[45] = isDraggable;
        $[46] = setIsLinkItemHovered;
        $[47] = t7;
        $[48] = t8;
    } else {
        t7 = $[47];
        t8 = $[48];
    }
    let t9;
    if ($[49] !== onContextMenu) {
        t9 = (event)=>{
            if (onContextMenu) onContextMenu(event);
        };
        $[49] = onContextMenu;
        $[50] = t9;
    } else t9 = $[50];
    const t10 = rest.target ?? "_blank";
    const t11 = analyticsWrappedURL ?? "#";
    let t12;
    if ($[51] !== fireMenuStateChanged || $[52] !== href || $[53] !== isOverflowButton || $[54] !== onClick) {
        t12 = (event_0)=>{
            if (!href) event_0.preventDefault();
            if (onClick) onClick(event_0);
            if (!isOverflowButton) fireMenuStateChanged({
                itemState: "taskCompleted"
            });
        };
        $[51] = fireMenuStateChanged;
        $[52] = href;
        $[53] = isOverflowButton;
        $[54] = onClick;
        $[55] = t12;
    } else t12 = $[55];
    const t13 = !lozenges?.length && itemDescription && $696c5f2250ea38c4$var$styles.hasDescription;
    const t14 = isDraggable && isHovered && $696c5f2250ea38c4$var$styles.overflowTitleWrapper;
    let t15;
    if ($[56] !== t13 || $[57] !== t14) {
        t15 = (0, $hekY6.default)([
            $696c5f2250ea38c4$var$styles.titleWrapper,
            t13,
            t14
        ]);
        $[56] = t13;
        $[57] = t14;
        $[58] = t15;
    } else t15 = $[58];
    let t16;
    if ($[59] !== children || $[60] !== renderLozenges || $[61] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t15
        }, children, renderLozenges);
        $[59] = children;
        $[60] = renderLozenges;
        $[61] = t15;
        $[62] = t16;
    } else t16 = $[62];
    let t17;
    if ($[63] !== elemAfter || $[64] !== focusRef || $[65] !== icon || $[66] !== itemDescription || $[67] !== rest || $[68] !== t10 || $[69] !== t11 || $[70] !== t12 || $[71] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
            testId: "switcher-base-item",
            description: itemDescription,
            iconBefore: icon,
            shouldTitleWrap: false,
            shouldDescriptionWrap: false,
            iconAfter: elemAfter,
            target: t10,
            href: t11,
            onClick: t12,
            ref: focusRef,
            ...rest
        }, t16);
        $[63] = elemAfter;
        $[64] = focusRef;
        $[65] = icon;
        $[66] = itemDescription;
        $[67] = rest;
        $[68] = t10;
        $[69] = t11;
        $[70] = t12;
        $[71] = t16;
        $[72] = t17;
    } else t17 = $[72];
    let t18;
    if ($[73] !== t17 || $[74] !== t7 || $[75] !== t8 || $[76] !== t9) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            onMouseEnter: t7,
            onMouseLeave: t8,
            onContextMenu: t9
        }, t17);
        $[73] = t17;
        $[74] = t7;
        $[75] = t8;
        $[76] = t9;
        $[77] = t18;
    } else t18 = $[77];
    let t19;
    if ($[78] !== disableAnimation || $[79] !== t18 || $[80] !== tag) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ac62U.FadeIn), {
            disableAnimation: disableAnimation,
            tag: tag,
            className: t6
        }, t18);
        $[78] = disableAnimation;
        $[79] = t18;
        $[80] = tag;
        $[81] = t19;
    } else t19 = $[81];
    return t19;
} : ({ icon: icon, description: description, elemAfter: elemAfter, onClick: onClick, children: children, lozenges: lozenges, product: product, tag: tag, href: href, isDraggable: isDraggable, isHovered: isHovered, setIsLinkItemHovered: setIsLinkItemHovered, disableAnimation: disableAnimation, isOverflowButton: isOverflowButton, onContextMenu: onContextMenu, is1pApp: is1pApp, ...rest }, focusRef)=>{
    const cursorTimeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const { productSwitcher: productSwitcher, subProduct: subProduct } = (0, $6q8XG.useUnifiedAnalyticsContext)();
    const { fireMenuStateChanged: fireMenuStateChanged } = (0, $7ske2.useUnifiedAnalytics)();
    const getAnalyticsWrappedURL = (0, $0cd310592a0c0a8e$export$e0e5234bc51fe848)(productSwitcher ?? 'appSwitcher', subProduct);
    const analyticsWrappedURL = href && is1pApp ? getAnalyticsWrappedURL(href) : href; // Cleanup timeout on unmount
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        return ()=>{
            if (cursorTimeoutRef.current) clearTimeout(cursorTimeoutRef.current);
        };
    }, []);
    const itemDescription = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(description) || typeof description === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $696c5f2250ea38c4$var$styles.itemDescription,
                isHovered && $696c5f2250ea38c4$var$styles.hoveredDescription
            ])
        }, description);
        return undefined;
    }, [
        description,
        isHovered
    ]);
    const renderLozenges = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (!lozenges?.length) return null;
         // Only pick out necessary properties from the children element to prevent infinite re-renders
        const filteredChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(children) ? {
            key: children.key ?? null,
            props: children.props ?? {},
            type: children.type ?? null
        } : children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a4Rk2.default), {
            product: product,
            triggerSubject: "switcherItemLozengeErrorBoundary",
            hideFallbackUI: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, lozenges.map((lozenge, index)=>{
            const { componentProps: componentProps, label: label } = $696c5f2250ea38c4$var$lozengeData[lozenge];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                key: index,
                className: (0, $hekY6.default)([
                    $696c5f2250ea38c4$var$styles.lozengeWrapper
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
                ...componentProps,
                testId: "switcher-item-lozenge"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label)));
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bLbuQ.RenderTracker), {
            subject: (0, $bLbuQ.SWITCHER_ITEM_LOZENGES_SUBJECT),
            data: {
                product: product,
                lozenges: lozenges,
                children: filteredChildren,
                description: description
            }
        })));
    }, [
        lozenges,
        product,
        children,
        description
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ac62U.FadeIn), {
        disableAnimation: disableAnimation,
        tag: tag,
        className: (0, $hekY6.default)([
            $696c5f2250ea38c4$var$styles.fadeIn
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        onMouseEnter: (e)=>{
            setIsLinkItemHovered?.(true);
            if (e.target && isDraggable) {
                // Clear any existing timeout
                if (cursorTimeoutRef.current) clearTimeout(cursorTimeoutRef.current);
                 // Set new timeout
                cursorTimeoutRef.current = window.setTimeout(()=>{
                    e.target.style.cursor = 'grab';
                    cursorTimeoutRef.current = null;
                }, 800);
            }
        },
        onMouseLeave: (e_0)=>{
            setIsLinkItemHovered?.(false);
            if (e_0.target && isDraggable) {
                // Clear timeout if still pending
                if (cursorTimeoutRef.current) {
                    clearTimeout(cursorTimeoutRef.current);
                    cursorTimeoutRef.current = null;
                } // Reset cursor
                e_0.target.style.cursor = '';
            }
        },
        onContextMenu: (event)=>{
            if (onContextMenu) onContextMenu(event);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
        testId: "switcher-base-item",
        description: itemDescription,
        iconBefore: icon,
        shouldTitleWrap: false,
        shouldDescriptionWrap: false,
        iconAfter: elemAfter,
        target: rest.target ?? '_blank',
        href: analyticsWrappedURL ?? '#',
        onClick: (event_0)=>{
            // To prevent the page from reloading when using a fallback '#' in href, make sure to use preventDefault.
            if (!href) event_0.preventDefault();
            if (onClick) onClick(event_0);
             // this event should only be fired when clicking on an item closes the switcher menu
            if (!isOverflowButton) fireMenuStateChanged({
                itemState: 'taskCompleted'
            });
        },
        ref: focusRef,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $696c5f2250ea38c4$var$styles.titleWrapper,
            !lozenges?.length && itemDescription && $696c5f2250ea38c4$var$styles.hasDescription,
            isDraggable && isHovered && $696c5f2250ea38c4$var$styles.overflowTitleWrapper
        ])
    }, children, renderLozenges))));
});
var $696c5f2250ea38c4$export$2e2bcd8739ae039 = $696c5f2250ea38c4$var$SwitcherItem;
function $696c5f2250ea38c4$var$_temp(lozenge, index) {
    const { componentProps: componentProps, label: label } = $696c5f2250ea38c4$var$lozengeData[lozenge];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        key: index,
        className: (0, $hekY6.default)([
            $696c5f2250ea38c4$var$styles.lozengeWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        ...componentProps,
        testId: "switcher-item-lozenge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label)));
}
module.exports["LozengeType"] = $696c5f2250ea38c4$export$b95b532653e2b7f6;
module.exports["default"] = $696c5f2250ea38c4$export$2e2bcd8739ae039;

});

parcelRegister("a4Rk2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $I7hWB = parcelRequire("I7hWB");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $bLbuQ = parcelRequire("bLbuQ");
var $852mP = parcelRequire("852mP");
var $lzgC6 = parcelRequire("lzgC6");


var $9QZAl = parcelRequire("9QZAl");


var $05jWx = parcelRequire("05jWx");


var $lVbtQ = parcelRequire("lVbtQ");


var $fb5K7 = parcelRequire("fb5K7");

var $5b19f4764fcbf958$export$2e2bcd8739ae039 = 'data:image/svg+xml;base64,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';


var $dd8d5eda0ed4d920$export$2e2bcd8739ae039 = `data:image/svg+xml;base64,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`;


function $ee796b1ec4a54aa5$var$_defineProperty(e, r, t) {
    return (r = $ee796b1ec4a54aa5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ee796b1ec4a54aa5$var$_toPropertyKey(t) {
    var i = $ee796b1ec4a54aa5$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ee796b1ec4a54aa5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $ee796b1ec4a54aa5$var$TRIGGER_SUBJECT = 'errorBoundary';
const $ee796b1ec4a54aa5$var$ACTION_SUBJECT = 'rendered';
const $ee796b1ec4a54aa5$var$styles = {
    robotsImg: "_0jFU0VgZxp",
    trelloErrorImg: "_39xV02Vazu _0jFU0VFFh0",
    unverifiedUserImg: "_0jFU0Vb1xp",
    errorBoundaryBox: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _39xV02EbV8 _24h04i2Njc _37wbyuDIqT _0aFT5vbt8w _313842p0Oa _1DCdHip0Oa _2Zuz6Q2ADO _1Znuxb2ADO",
    errorContent: "_3iDTPbQ4SZ _0hPCNLDIqT _0aFT5vbt8w _2fwxA5DIqT",
    errorHeading: "_313842Va5s",
    errorMessage: "_313842NHnM"
};
const $ee796b1ec4a54aa5$var$ErrorMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props.children) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $ee796b1ec4a54aa5$var$styles.errorMessage
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p"
        }, props.children));
        $[0] = props.children;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ee796b1ec4a54aa5$var$styles.errorMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, props.children));
class $ee796b1ec4a54aa5$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch(error) {
        const reason = error instanceof (0, $lVbtQ.SwitcherLoadError) ? error.reason() : (0, $9QZAl.errorToReason)(error);
        this.setState({
            hasError: true,
            reason: reason
        }, ()=>{
            this.fireOperationalEvent({
                action: $ee796b1ec4a54aa5$var$ACTION_SUBJECT,
                attributes: {
                    ...reason,
                    ...this.props.extraAnalyticProps
                }
            });
        });
        this.props.onErrorCallback?.(error);
    }
    renderErrorBody() {
        const { reason: reason } = this.state;
        if (!reason) return;
        if (reason.name === (0, $fb5K7.FETCH_ERROR_NAME)) {
            if (reason.status === 403) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ee796b1ec4a54aa5$var$ErrorMessage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $iDrrr.fg)('product-terminology-refresh') ? (0, $05jWx.default).errorTextUnverifiedAppify : (0, $05jWx.default).errorTextUnverified));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ee796b1ec4a54aa5$var$ErrorMessage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $05jWx.default).errorTextNetwork));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ee796b1ec4a54aa5$var$ErrorMessage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $05jWx.default).errorText));
    }
    renderErrorHeading() {
        const { reason: reason } = this.state;
        if (!reason) return;
        if (reason.name === (0, $fb5K7.FETCH_ERROR_NAME) && reason.status === 401) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $05jWx.default).errorHeadingLoggedOut);
        if (reason.name === (0, $fb5K7.FETCH_ERROR_NAME) && reason.status === 403) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $05jWx.default).errorHeadingUnverified);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $05jWx.default).errorHeading);
    }
    renderErrorImage() {
        const { intl: intl, product: product } = this.props;
        const { reason: reason } = this.state;
        if (product === 'trello') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: (0, $5b19f4764fcbf958$export$2e2bcd8739ae039),
            alt: intl.formatMessage((0, $05jWx.default).errorImageAltText),
            className: (0, $hekY6.default)([
                $ee796b1ec4a54aa5$var$styles.trelloErrorImg
            ])
        });
        if (reason.status === 403) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: (0, $dd8d5eda0ed4d920$export$2e2bcd8739ae039),
            alt: intl.formatMessage((0, $05jWx.default).errorImageAltText),
            className: (0, $hekY6.default)([
                $ee796b1ec4a54aa5$var$styles.unverifiedUserImg
            ])
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ee796b1ec4a54aa5$var$RobotImage, {
            alt: intl.formatMessage((0, $05jWx.default).errorImageAltText),
            className: (0, $hekY6.default)([
                $ee796b1ec4a54aa5$var$styles.robotsImg
            ])
        });
    }
    render() {
        const { hideFallbackUI: hideFallbackUI, children: children } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && hideFallbackUI) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
        if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "error-boundary",
            className: (0, $hekY6.default)([
                $ee796b1ec4a54aa5$var$styles.errorBoundaryBox
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $ee796b1ec4a54aa5$var$styles.errorContent
            ])
        }, this.renderErrorImage(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $ee796b1ec4a54aa5$var$styles.errorHeading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium"
        }, this.renderErrorHeading())), this.renderErrorBody()));
        return children;
    }
    constructor(...args){
        super(...args);
        $ee796b1ec4a54aa5$var$_defineProperty(this, "state", {
            hasError: false
        });
        $ee796b1ec4a54aa5$var$_defineProperty(this, "fireOperationalEvent", (payload)=>{
            if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                actionSubject: this.props.triggerSubject || $ee796b1ec4a54aa5$var$TRIGGER_SUBJECT,
                ...payload
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
        });
    }
}

const $ee796b1ec4a54aa5$var$RobotImage = (props)=>{
    const [imgSrc, setImgSrc] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        (parcelRequire("9NzkT")).then((src)=>setImgSrc(src.default));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        alt: "",
        ...props,
        src: imgSrc
    });
};
const $ee796b1ec4a54aa5$var$_default_1 = (0, $lzgC6.default)()((0, $kSwu1.injectIntl)($ee796b1ec4a54aa5$var$ErrorBoundary));
var $ee796b1ec4a54aa5$export$2e2bcd8739ae039 = $ee796b1ec4a54aa5$var$_default_1;
module.exports["default"] = $ee796b1ec4a54aa5$export$2e2bcd8739ae039;

});

parcelRegister("lVbtQ", function(module, exports) {

var $9QZAl = parcelRequire("9QZAl");

var $f1818f2039ed1bbf$export$2c6136f6e27d3fdd = /*#__PURE__*/ function(SwitcherLoadErrorReason) {
    SwitcherLoadErrorReason["AVAILABLE_PRODUCTS"] = "availableProducts";
    SwitcherLoadErrorReason["PRODUCT_CONFIGURATION"] = "productConfiguration";
    SwitcherLoadErrorReason["THIRD_PARTY_CONFIG"] = "thirdPartyConfig";
    return SwitcherLoadErrorReason;
}({});
class $f1818f2039ed1bbf$export$ff0950b3c2e7f03e extends Error {
    reason() {
        const potentialResultError = this.resultError;
        return {
            ...(0, $9QZAl.errorToReason)(potentialResultError.error ? potentialResultError.error : this.resultError),
            source: this.errorReason
        };
    }
    constructor(errorReason, resultError){
        super();
        this.errorReason = void 0;
        this.resultError = void 0;
        this.errorReason = errorReason;
        this.resultError = resultError;
    }
}
module.exports["SwitcherLoadErrorReason"] = $f1818f2039ed1bbf$export$2c6136f6e27d3fdd;
module.exports["SwitcherLoadError"] = $f1818f2039ed1bbf$export$ff0950b3c2e7f03e;

});

parcelRegister("9NzkT", function(module, exports) {

let $722419a6c223b74b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $722419a6c223b74b$var$load("efXtb").then(()=>parcelRequire('4qMWN'));

});

parcelRegister("6q8XG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $3e42d7cdef102cbe$var$UnifiedAnalyticsContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $3e42d7cdef102cbe$export$3a404fd74faec077 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { productSwitcher: t1, cloudId: t2, hasSwitcherAnalytics: t3, hasDiscoverySection: t4, subProduct: t5, switcherLinks: t6, children: children } = t0;
    const productSwitcher = t1 === undefined ? "appSwitcher" : t1;
    const cloudId = t2 === undefined ? "unknown" : t2;
    const hasSwitcherAnalytics = t3 === undefined ? false : t3;
    const hasDiscoverySection = t4 === undefined ? false : t4;
    const subProduct = t5 === undefined ? undefined : t5;
    const switcherLinks = t6 === undefined ? undefined : t6;
    let t7;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {};
        $[0] = t7;
    } else t7 = $[0];
    const [values, setValues] = (0, $cozmU.useState)(t7);
    let t8;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (updates)=>{
            setValues((prev)=>({
                    ...prev,
                    ...updates
                }));
        };
        $[1] = t8;
    } else t8 = $[1];
    const handleUpdateContext = t8;
    const t9 = switcherLinks?.currentSiteOrgWithUnit?.orgId;
    const t10 = switcherLinks?.currentSiteOrgWithUnit?.unitId;
    const t11 = switcherLinks?.thirdPartyConfig;
    const t12 = switcherLinks?.customLinks;
    const t13 = switcherLinks?.organisations;
    const t14 = values.hasDiscoverySection ?? hasDiscoverySection;
    const t15 = switcherLinks?.tryRovoChatCohort;
    let t16;
    if ($[2] !== cloudId || $[3] !== hasSwitcherAnalytics || $[4] !== productSwitcher || $[5] !== subProduct || $[6] !== t10 || $[7] !== t11 || $[8] !== t12 || $[9] !== t13 || $[10] !== t14 || $[11] !== t15 || $[12] !== t9) {
        t16 = {
            productSwitcher: productSwitcher,
            cloudId: cloudId,
            hasSwitcherAnalytics: hasSwitcherAnalytics,
            subProduct: subProduct,
            currentOrg: t9,
            currentUnit: t10,
            thirdPartyConfig: t11,
            customLinks: t12,
            organisations: t13,
            hasDiscoverySection: t14,
            updateContext: handleUpdateContext,
            tryRovoChatCohort: t15
        };
        $[2] = cloudId;
        $[3] = hasSwitcherAnalytics;
        $[4] = productSwitcher;
        $[5] = subProduct;
        $[6] = t10;
        $[7] = t11;
        $[8] = t12;
        $[9] = t13;
        $[10] = t14;
        $[11] = t15;
        $[12] = t9;
        $[13] = t16;
    } else t16 = $[13];
    const contextValue = t16;
    let t17;
    if ($[14] !== children || $[15] !== contextValue) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3e42d7cdef102cbe$var$UnifiedAnalyticsContext.Provider, {
            value: contextValue
        }, children);
        $[14] = children;
        $[15] = contextValue;
        $[16] = t17;
    } else t17 = $[16];
    return t17;
} : ({ productSwitcher: productSwitcher = 'appSwitcher', cloudId: cloudId = 'unknown', hasSwitcherAnalytics: hasSwitcherAnalytics = false, hasDiscoverySection: hasDiscoverySection = false, subProduct: subProduct, switcherLinks: switcherLinks, children: children })=>{
    const [values, setValues] = (0, $cozmU.useState)({});
    const handleUpdateContext = (0, $cozmU.useCallback)((updates)=>{
        setValues((prev)=>({
                ...prev,
                ...updates
            }));
    }, []);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            productSwitcher: productSwitcher,
            cloudId: cloudId,
            hasSwitcherAnalytics: hasSwitcherAnalytics,
            subProduct: subProduct,
            currentOrg: switcherLinks?.currentSiteOrgWithUnit?.orgId,
            currentUnit: switcherLinks?.currentSiteOrgWithUnit?.unitId,
            thirdPartyConfig: switcherLinks?.thirdPartyConfig,
            customLinks: switcherLinks?.customLinks,
            organisations: switcherLinks?.organisations,
            hasDiscoverySection: values.hasDiscoverySection ?? hasDiscoverySection,
            updateContext: handleUpdateContext,
            tryRovoChatCohort: switcherLinks?.tryRovoChatCohort
        }), [
        productSwitcher,
        cloudId,
        hasSwitcherAnalytics,
        subProduct,
        switcherLinks,
        values.hasDiscoverySection,
        hasDiscoverySection,
        handleUpdateContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3e42d7cdef102cbe$var$UnifiedAnalyticsContext.Provider, {
        value: contextValue
    }, children);
};
const $3e42d7cdef102cbe$export$a997a4a152a38427 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const context = (0, $cozmU.useContext)($3e42d7cdef102cbe$var$UnifiedAnalyticsContext);
    let t0;
    if ($[0] !== context) {
        t0 = context ?? {
            productSwitcher: "appSwitcher",
            cloudId: "unknown",
            hasSwitcherAnalytics: false,
            thirdPartyConfig: undefined,
            hasDiscoverySection: false,
            customLinks: undefined,
            organisations: undefined,
            currentOrg: undefined,
            currentUnit: undefined
        };
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const context = (0, $cozmU.useContext)($3e42d7cdef102cbe$var$UnifiedAnalyticsContext);
    return context ?? {
        productSwitcher: 'appSwitcher',
        cloudId: 'unknown',
        hasSwitcherAnalytics: false,
        thirdPartyConfig: undefined,
        hasDiscoverySection: false,
        customLinks: undefined,
        organisations: undefined,
        currentOrg: undefined,
        currentUnit: undefined
    };
};
const $3e42d7cdef102cbe$export$caf7a76f5a1ef4b7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($3e42d7cdef102cbe$var$UnifiedAnalyticsContext);
    return context?.updateContext;
} : ()=>{
    const context = (0, $cozmU.useContext)($3e42d7cdef102cbe$var$UnifiedAnalyticsContext);
    return context?.updateContext;
};
module.exports["UnifiedAnalyticsContextProvider"] = $3e42d7cdef102cbe$export$3a404fd74faec077;
module.exports["useUnifiedAnalyticsContext"] = $3e42d7cdef102cbe$export$a997a4a152a38427;
module.exports["useUpdateUnifiedAnalyticsContext"] = $3e42d7cdef102cbe$export$caf7a76f5a1ef4b7;

});

parcelRegister("7ske2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bLbuQ = parcelRequire("bLbuQ");
var $852mP = parcelRequire("852mP");


var $9DHhW = parcelRequire("9DHhW");


var $6q8XG = parcelRequire("6q8XG");


var $9eceO = parcelRequire("9eceO");

const $a5800aea1409eb6c$export$a26402899a5435f8 = 'topNav';
const $a5800aea1409eb6c$export$b20f588755c3941 = 'unknown_org';
const $a5800aea1409eb6c$export$462de9de99767288 = 'unknown_unit';
const $a5800aea1409eb6c$var$UNDEFINED_PRODUCT = 'UNDEFINED_PRODUCT';
const $a5800aea1409eb6c$var$UNDEFINED_SITE = 'unknown_site';
const $a5800aea1409eb6c$export$4e8a5375557b8b4e = {
    '1pApp': 0,
    '3pApp': 1,
    discoverMore: 2,
    customLink: 3
};
const $a5800aea1409eb6c$var$baseAttributes = {
    navLayer: 'global',
    navContainer: 'top',
    navVersion: 4
};
const $a5800aea1409eb6c$export$b994de3a6486f6d5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useUnifiedAnalytics() {
    const $ = (0, $bDgLe.c)(104);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { productSwitcher: productSwitcher, hasDiscoverySection: hasDiscoverySection, thirdPartyConfig: thirdPartyConfig, currentOrg: currentOrg, currentUnit: currentUnit, organisations: organisations, customLinks: customLinks, cloudId: cloudId, tryRovoChatCohort: tryRovoChatCohort } = (0, $6q8XG.useUnifiedAnalyticsContext)();
    const hasThirdPartySection = (thirdPartyConfig?.length ?? 0) > 0;
    const hasFiredMenuViewed = (0, $cozmU.useRef)(false);
    let t0;
    if ($[0] !== hasDiscoverySection || $[1] !== hasThirdPartySection) {
        t0 = (identifier)=>{
            const baseIndex = $a5800aea1409eb6c$export$4e8a5375557b8b4e[identifier];
            if (identifier === "customLink" && hasThirdPartySection && !hasDiscoverySection) return baseIndex - 1;
            else {
                if (identifier === "customLink" && !hasThirdPartySection && !hasDiscoverySection) return baseIndex - 2;
            }
            return baseIndex;
        };
        $[0] = hasDiscoverySection;
        $[1] = hasThirdPartySection;
        $[2] = t0;
    } else t0 = $[2];
    const getGroupIndex = t0;
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "navigationExperiences"
        ];
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== productSwitcher) {
        t2 = {
            actionSubject: "atlassianSwitcher",
            eventType: "ui",
            source: "topNav",
            product: productSwitcher,
            tags: t1
        };
        $[4] = productSwitcher;
        $[5] = t2;
    } else t2 = $[5];
    const topLevelAttributes = t2;
    let t3;
    if ($[6] !== createAnalyticsEvent || $[7] !== topLevelAttributes) {
        t3 = (attributes)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: "changed",
                actionSubjectId: "atlassianSwitcherMenuState",
                attributes: {
                    ...$a5800aea1409eb6c$var$baseAttributes,
                    ...attributes
                }
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
        };
        $[6] = createAnalyticsEvent;
        $[7] = topLevelAttributes;
        $[8] = t3;
    } else t3 = $[8];
    const fireMenuStateChanged = t3;
    let t4;
    if ($[9] !== createAnalyticsEvent || $[10] !== topLevelAttributes) {
        t4 = ()=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: "clicked",
                actionSubjectId: "atlassianSwitcherOrgExpand",
                attributes: {
                    ...$a5800aea1409eb6c$var$baseAttributes
                }
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
        };
        $[9] = createAnalyticsEvent;
        $[10] = topLevelAttributes;
        $[11] = t4;
    } else t4 = $[11];
    const fireOrgDropdownClicked = t4;
    let t5;
    if ($[12] !== createAnalyticsEvent || $[13] !== topLevelAttributes) {
        t5 = (attributes_0)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: "viewed",
                actionSubjectId: "atlassianSwitcherOrgExpandList",
                attributes: {
                    ...$a5800aea1409eb6c$var$baseAttributes,
                    ...attributes_0
                }
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
        };
        $[12] = createAnalyticsEvent;
        $[13] = topLevelAttributes;
        $[14] = t5;
    } else t5 = $[14];
    const fireOrgDropdownViewed = t5;
    let t6;
    if ($[15] !== createAnalyticsEvent || $[16] !== topLevelAttributes) {
        t6 = (attributes_1)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: "clicked",
                actionSubjectId: "atlassianSwitcherOrgExpandItem",
                attributes: {
                    ...$a5800aea1409eb6c$var$baseAttributes,
                    ...attributes_1
                }
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
        };
        $[15] = createAnalyticsEvent;
        $[16] = topLevelAttributes;
        $[17] = t6;
    } else t6 = $[17];
    const fireOrgListItemClicked = t6;
    let t7;
    if ($[18] !== createAnalyticsEvent || $[19] !== topLevelAttributes) {
        t7 = (attributes_2)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: "clicked",
                actionSubjectId: "atlassianSwitcherUnitExpandItem",
                attributes: {
                    ...$a5800aea1409eb6c$var$baseAttributes,
                    ...attributes_2
                }
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
        };
        $[18] = createAnalyticsEvent;
        $[19] = topLevelAttributes;
        $[20] = t7;
    } else t7 = $[20];
    const fireUnitListItemClicked = t7;
    let t8;
    if ($[21] !== createAnalyticsEvent || $[22] !== topLevelAttributes) {
        t8 = (attributes_3)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: "dragged",
                actionSubjectId: "atlassianSwitcherUnitRailResize",
                attributes: {
                    ...$a5800aea1409eb6c$var$baseAttributes,
                    ...attributes_3
                }
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
        };
        $[21] = createAnalyticsEvent;
        $[22] = topLevelAttributes;
        $[23] = t8;
    } else t8 = $[23];
    const fireRailResized = t8;
    let t9;
    if ($[24] !== cloudId || $[25] !== createAnalyticsEvent || $[26] !== getGroupIndex || $[27] !== topLevelAttributes) {
        t9 = (attributes_4)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: "clicked",
                actionSubjectId: "atlassianSwitcherItemExpand",
                attributes: {
                    ...$a5800aea1409eb6c$var$baseAttributes,
                    ...attributes_4,
                    groupIndex: getGroupIndex(attributes_4.groupIdentifier),
                    groupItemProduct: attributes_4.groupItemProduct ?? $a5800aea1409eb6c$var$UNDEFINED_PRODUCT,
                    groupItemSiteId: cloudId ?? $a5800aea1409eb6c$var$UNDEFINED_SITE
                }
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
        };
        $[24] = cloudId;
        $[25] = createAnalyticsEvent;
        $[26] = getGroupIndex;
        $[27] = topLevelAttributes;
        $[28] = t9;
    } else t9 = $[28];
    const fireSwitcherItemExpandClicked = t9;
    let t10;
    if ($[29] !== cloudId || $[30] !== createAnalyticsEvent || $[31] !== getGroupIndex || $[32] !== topLevelAttributes) {
        t10 = (attributes_5)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: "viewed",
                actionSubjectId: "atlassianSwitcherItemExpandList",
                attributes: {
                    ...$a5800aea1409eb6c$var$baseAttributes,
                    ...attributes_5,
                    groupIndex: getGroupIndex(attributes_5.groupIdentifier),
                    groupItemProduct: attributes_5.groupItemProduct ?? $a5800aea1409eb6c$var$UNDEFINED_PRODUCT,
                    groupItemSiteId: cloudId ?? $a5800aea1409eb6c$var$UNDEFINED_SITE
                }
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
        };
        $[29] = cloudId;
        $[30] = createAnalyticsEvent;
        $[31] = getGroupIndex;
        $[32] = topLevelAttributes;
        $[33] = t10;
    } else t10 = $[33];
    const fireSwitcherItemExpandListViewed = t10;
    let t11;
    if ($[34] !== cloudId || $[35] !== createAnalyticsEvent || $[36] !== getGroupIndex || $[37] !== topLevelAttributes) {
        t11 = (attributes_6)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: "clicked",
                actionSubjectId: "atlassianSwitcherItemExpandItem",
                attributes: {
                    ...$a5800aea1409eb6c$var$baseAttributes,
                    ...attributes_6,
                    groupIndex: getGroupIndex(attributes_6.groupIdentifier),
                    groupItemProduct: attributes_6.groupItemProduct ?? $a5800aea1409eb6c$var$UNDEFINED_PRODUCT,
                    groupItemSiteId: cloudId ?? $a5800aea1409eb6c$var$UNDEFINED_SITE,
                    expandItemCloudId: attributes_6.expandItemCloudId ?? $a5800aea1409eb6c$var$UNDEFINED_SITE
                }
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
        };
        $[34] = cloudId;
        $[35] = createAnalyticsEvent;
        $[36] = getGroupIndex;
        $[37] = topLevelAttributes;
        $[38] = t11;
    } else t11 = $[38];
    const fireSwitcherItemExpandItemClicked = t11;
    let t12;
    if ($[39] !== createAnalyticsEvent || $[40] !== currentOrg || $[41] !== currentUnit || $[42] !== customLinks?.length || $[43] !== hasDiscoverySection || $[44] !== hasThirdPartySection || $[45] !== organisations || $[46] !== thirdPartyConfig || $[47] !== topLevelAttributes || $[48] !== tryRovoChatCohort) {
        t12 = (attributes_7)=>{
            if (hasFiredMenuViewed.current) return;
            const customLinksLength = customLinks?.length;
            const hasOverflow = attributes_7.firstPartyProducts.length > (0, $9eceO.MAX_ITEMS_TO_SHOW);
            createAnalyticsEvent({
                ...topLevelAttributes,
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: "viewed",
                actionSubjectId: "atlassianSwitcherMenu",
                attributes: {
                    ...$a5800aea1409eb6c$var$baseAttributes,
                    isOrderCustomized: attributes_7.isOrderCustomized,
                    selectedOrg: currentOrg ?? $a5800aea1409eb6c$export$b20f588755c3941,
                    currentOrg: currentOrg ?? $a5800aea1409eb6c$export$b20f588755c3941,
                    selectedUnit: currentUnit ?? $a5800aea1409eb6c$export$462de9de99767288,
                    currentUnit: currentUnit ?? $a5800aea1409eb6c$export$462de9de99767288,
                    orgCount: organisations?.size ?? 0,
                    orgList: Array.from(organisations?.keys() ?? []),
                    tryRovoChatCohort: tryRovoChatCohort,
                    groupList: [
                        {
                            groupIdentifier: "1pApp",
                            groupItemCount: hasOverflow ? (0, $9eceO.MAX_ITEMS_TO_SHOW) : attributes_7.firstPartyProducts.length,
                            groupItemList: hasOverflow ? attributes_7.firstPartyProducts.slice(0, (0, $9eceO.MAX_ITEMS_TO_SHOW)).map($a5800aea1409eb6c$var$_temp) : attributes_7.firstPartyProducts.map($a5800aea1409eb6c$var$_temp2),
                            showMoreButton: hasOverflow,
                            inMoreItemCount: hasOverflow ? attributes_7.firstPartyProducts.length - (0, $9eceO.MAX_ITEMS_TO_SHOW) : 0,
                            inMoreItemList: hasOverflow ? attributes_7.firstPartyProducts.slice((0, $9eceO.MAX_ITEMS_TO_SHOW)).map($a5800aea1409eb6c$var$_temp3) : []
                        },
                        ...hasThirdPartySection ? [
                            {
                                groupIdentifier: "3pApp",
                                groupItemCount: thirdPartyConfig?.length ?? 0,
                                groupItemList: thirdPartyConfig?.map($a5800aea1409eb6c$var$_temp4) ?? [],
                                showMoreButton: false,
                                inMoreItemCount: 0,
                                inMoreItemList: []
                            }
                        ] : [],
                        ...hasDiscoverySection ? [
                            {
                                groupIdentifier: "discoverMore",
                                groupItemCount: 1,
                                groupItemList: [
                                    "moreAtlassianApps"
                                ],
                                showMoreButton: false,
                                inMoreItemCount: 0,
                                inMoreItemList: []
                            }
                        ] : [],
                        ...(customLinksLength ?? 0) > 0 ? [
                            {
                                groupIdentifier: "customLink",
                                groupItemCount: customLinksLength,
                                showMoreButton: false,
                                inMoreItemCount: 0
                            }
                        ] : []
                    ].map($a5800aea1409eb6c$var$_temp5)
                }
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
            hasFiredMenuViewed.current = true;
        };
        $[39] = createAnalyticsEvent;
        $[40] = currentOrg;
        $[41] = currentUnit;
        $[42] = customLinks?.length;
        $[43] = hasDiscoverySection;
        $[44] = hasThirdPartySection;
        $[45] = organisations;
        $[46] = thirdPartyConfig;
        $[47] = topLevelAttributes;
        $[48] = tryRovoChatCohort;
        $[49] = t12;
    } else t12 = $[49];
    const fireMenuViewed = t12;
    let t13;
    if ($[50] !== cloudId || $[51] !== createAnalyticsEvent || $[52] !== getGroupIndex || $[53] !== topLevelAttributes || $[54] !== tryRovoChatCohort) {
        t13 = (attributes_8)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: "clicked",
                actionSubjectId: "atlassianSwitcherItem",
                attributes: {
                    ...$a5800aea1409eb6c$var$baseAttributes,
                    ...attributes_8,
                    groupIndex: getGroupIndex(attributes_8.groupIdentifier),
                    groupItemProduct: attributes_8.groupItemProduct ?? $a5800aea1409eb6c$var$UNDEFINED_PRODUCT,
                    groupItemSiteId: cloudId ?? $a5800aea1409eb6c$var$UNDEFINED_SITE,
                    tryRovoChatCohort: tryRovoChatCohort
                }
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
        };
        $[50] = cloudId;
        $[51] = createAnalyticsEvent;
        $[52] = getGroupIndex;
        $[53] = topLevelAttributes;
        $[54] = tryRovoChatCohort;
        $[55] = t13;
    } else t13 = $[55];
    const fireItemClicked = t13;
    let t14;
    if ($[56] !== createAnalyticsEvent || $[57] !== currentOrg || $[58] !== currentUnit || $[59] !== topLevelAttributes) {
        t14 = (attributes_9)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: "scrolled",
                actionSubjectId: "atlassianSwitcherMenu",
                attributes: {
                    ...$a5800aea1409eb6c$var$baseAttributes,
                    ...attributes_9,
                    selectedOrg: currentOrg ?? $a5800aea1409eb6c$export$b20f588755c3941,
                    selectedUnit: currentUnit ?? $a5800aea1409eb6c$export$462de9de99767288
                }
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
        };
        $[56] = createAnalyticsEvent;
        $[57] = currentOrg;
        $[58] = currentUnit;
        $[59] = topLevelAttributes;
        $[60] = t14;
    } else t14 = $[60];
    const fireMenuScrolled = t14;
    let t15;
    if ($[61] !== cloudId || $[62] !== createAnalyticsEvent || $[63] !== getGroupIndex || $[64] !== topLevelAttributes) {
        t15 = (attributes_10)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: "clicked",
                actionSubjectId: "atlassianSwitcherItemReorderDropdown",
                attributes: {
                    ...$a5800aea1409eb6c$var$baseAttributes,
                    ...attributes_10,
                    groupIndex: getGroupIndex(attributes_10.groupIdentifier),
                    groupItemProduct: attributes_10.groupItemProduct ?? $a5800aea1409eb6c$var$UNDEFINED_PRODUCT,
                    groupItemSiteId: cloudId ?? $a5800aea1409eb6c$var$UNDEFINED_SITE
                }
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
        };
        $[61] = cloudId;
        $[62] = createAnalyticsEvent;
        $[63] = getGroupIndex;
        $[64] = topLevelAttributes;
        $[65] = t15;
    } else t15 = $[65];
    const fireReorderDropdownClicked = t15;
    let t16;
    if ($[66] !== createAnalyticsEvent || $[67] !== topLevelAttributes) {
        t16 = (attributes_11)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: "clicked",
                actionSubjectId: "atlassianSwitcherOverflowButton",
                attributes: {
                    ...$a5800aea1409eb6c$var$baseAttributes,
                    ...attributes_11
                }
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
        };
        $[66] = createAnalyticsEvent;
        $[67] = topLevelAttributes;
        $[68] = t16;
    } else t16 = $[68];
    const fireOverflowButtonClicked = t16;
    let t17;
    if ($[69] !== cloudId || $[70] !== createAnalyticsEvent || $[71] !== getGroupIndex || $[72] !== topLevelAttributes) {
        t17 = (attributes_12)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: "viewed",
                actionSubjectId: "atlassianSwitcherItemReorderDropdownList",
                attributes: {
                    ...$a5800aea1409eb6c$var$baseAttributes,
                    ...attributes_12,
                    groupIndex: getGroupIndex(attributes_12.groupIdentifier),
                    groupItemProduct: attributes_12.groupItemProduct ?? $a5800aea1409eb6c$var$UNDEFINED_PRODUCT,
                    groupItemSiteId: cloudId ?? $a5800aea1409eb6c$var$UNDEFINED_SITE
                }
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
        };
        $[69] = cloudId;
        $[70] = createAnalyticsEvent;
        $[71] = getGroupIndex;
        $[72] = topLevelAttributes;
        $[73] = t17;
    } else t17 = $[73];
    const fireReorderDropdownViewed = t17;
    let t18;
    if ($[74] !== cloudId || $[75] !== createAnalyticsEvent || $[76] !== getGroupIndex || $[77] !== topLevelAttributes || $[78] !== tryRovoChatCohort) {
        t18 = (attributes_13)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: "clicked",
                actionSubjectId: "atlassianSwitcherItemReorderDropdownListItem",
                attributes: {
                    ...$a5800aea1409eb6c$var$baseAttributes,
                    ...attributes_13,
                    groupIndex: getGroupIndex(attributes_13.groupIdentifier),
                    groupItemProduct: attributes_13.groupItemProduct ?? $a5800aea1409eb6c$var$UNDEFINED_PRODUCT,
                    groupItemSiteId: cloudId ?? $a5800aea1409eb6c$var$UNDEFINED_SITE,
                    tryRovoChatCohort: tryRovoChatCohort
                }
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
        };
        $[74] = cloudId;
        $[75] = createAnalyticsEvent;
        $[76] = getGroupIndex;
        $[77] = topLevelAttributes;
        $[78] = tryRovoChatCohort;
        $[79] = t18;
    } else t18 = $[79];
    const fireReorderDropdownItemClicked = t18;
    let t19;
    if ($[80] !== cloudId || $[81] !== createAnalyticsEvent || $[82] !== getGroupIndex || $[83] !== topLevelAttributes || $[84] !== tryRovoChatCohort) {
        t19 = (attributes_14)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                eventType: (0, $852mP.UI_EVENT_TYPE),
                action: "dragged",
                actionSubjectId: "atlassianSwitcherItem",
                attributes: {
                    ...$a5800aea1409eb6c$var$baseAttributes,
                    ...attributes_14,
                    groupIndex: getGroupIndex(attributes_14.groupIdentifier),
                    groupItemProduct: attributes_14.groupItemProduct ?? $a5800aea1409eb6c$var$UNDEFINED_PRODUCT,
                    groupItemSiteId: cloudId ?? $a5800aea1409eb6c$var$UNDEFINED_SITE,
                    tryRovoChatCohort: tryRovoChatCohort
                }
            }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
        };
        $[80] = cloudId;
        $[81] = createAnalyticsEvent;
        $[82] = getGroupIndex;
        $[83] = topLevelAttributes;
        $[84] = tryRovoChatCohort;
        $[85] = t19;
    } else t19 = $[85];
    const fireItemDragged = t19;
    let t20;
    if ($[86] !== fireItemClicked || $[87] !== fireItemDragged || $[88] !== fireMenuScrolled || $[89] !== fireMenuStateChanged || $[90] !== fireMenuViewed || $[91] !== fireOrgDropdownClicked || $[92] !== fireOrgDropdownViewed || $[93] !== fireOrgListItemClicked || $[94] !== fireOverflowButtonClicked || $[95] !== fireRailResized || $[96] !== fireReorderDropdownClicked || $[97] !== fireReorderDropdownItemClicked || $[98] !== fireReorderDropdownViewed || $[99] !== fireSwitcherItemExpandClicked || $[100] !== fireSwitcherItemExpandItemClicked || $[101] !== fireSwitcherItemExpandListViewed || $[102] !== fireUnitListItemClicked) {
        t20 = {
            fireItemClicked: fireItemClicked,
            fireItemDragged: fireItemDragged,
            fireMenuStateChanged: fireMenuStateChanged,
            fireMenuViewed: fireMenuViewed,
            fireMenuScrolled: fireMenuScrolled,
            fireOrgDropdownClicked: fireOrgDropdownClicked,
            fireOrgDropdownViewed: fireOrgDropdownViewed,
            fireOrgListItemClicked: fireOrgListItemClicked,
            fireUnitListItemClicked: fireUnitListItemClicked,
            fireRailResized: fireRailResized,
            fireOverflowButtonClicked: fireOverflowButtonClicked,
            fireReorderDropdownClicked: fireReorderDropdownClicked,
            fireReorderDropdownItemClicked: fireReorderDropdownItemClicked,
            fireReorderDropdownViewed: fireReorderDropdownViewed,
            fireSwitcherItemExpandClicked: fireSwitcherItemExpandClicked,
            fireSwitcherItemExpandListViewed: fireSwitcherItemExpandListViewed,
            fireSwitcherItemExpandItemClicked: fireSwitcherItemExpandItemClicked
        };
        $[86] = fireItemClicked;
        $[87] = fireItemDragged;
        $[88] = fireMenuScrolled;
        $[89] = fireMenuStateChanged;
        $[90] = fireMenuViewed;
        $[91] = fireOrgDropdownClicked;
        $[92] = fireOrgDropdownViewed;
        $[93] = fireOrgListItemClicked;
        $[94] = fireOverflowButtonClicked;
        $[95] = fireRailResized;
        $[96] = fireReorderDropdownClicked;
        $[97] = fireReorderDropdownItemClicked;
        $[98] = fireReorderDropdownViewed;
        $[99] = fireSwitcherItemExpandClicked;
        $[100] = fireSwitcherItemExpandItemClicked;
        $[101] = fireSwitcherItemExpandListViewed;
        $[102] = fireUnitListItemClicked;
        $[103] = t20;
    } else t20 = $[103];
    return t20;
} : function useUnifiedAnalytics() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { productSwitcher: productSwitcher, hasDiscoverySection: hasDiscoverySection, thirdPartyConfig: thirdPartyConfig, currentOrg: currentOrg, currentUnit: currentUnit, organisations: organisations, customLinks: customLinks, cloudId: cloudId, tryRovoChatCohort: tryRovoChatCohort } = (0, $6q8XG.useUnifiedAnalyticsContext)();
    const hasThirdPartySection = (thirdPartyConfig?.length ?? 0) > 0;
    // Track if menu viewed event has already fired (fire once per mount)
    const hasFiredMenuViewed = (0, $cozmU.useRef)(false);
    const getGroupIndex = (0, $cozmU.useCallback)((identifier)=>{
        const baseIndex = $a5800aea1409eb6c$export$4e8a5375557b8b4e[identifier];
        // For customLink group, if there is 3p section but no discovery section, shift up one position
        if (identifier === 'customLink' && hasThirdPartySection && !hasDiscoverySection) return baseIndex - 1;
        else if (identifier === 'customLink' && !hasThirdPartySection && !hasDiscoverySection) return baseIndex - 2;
        return baseIndex;
    }, [
        hasDiscoverySection,
        hasThirdPartySection
    ]);
    const topLevelAttributes = (0, $cozmU.useMemo)(()=>({
            actionSubject: 'atlassianSwitcher',
            eventType: 'ui',
            source: 'topNav',
            product: productSwitcher,
            tags: [
                'navigationExperiences'
            ]
        }), [
        productSwitcher
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/91979
    const fireMenuStateChanged = (0, $cozmU.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: 'changed',
            actionSubjectId: 'atlassianSwitcherMenuState',
            attributes: {
                ...$a5800aea1409eb6c$var$baseAttributes,
                ...attributes
            }
        }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92754
    const fireOrgDropdownClicked = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'atlassianSwitcherOrgExpand',
            attributes: {
                ...$a5800aea1409eb6c$var$baseAttributes
            }
        }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92276
    const fireOrgDropdownViewed = (0, $cozmU.useCallback)((attributes_0)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: 'viewed',
            actionSubjectId: 'atlassianSwitcherOrgExpandList',
            attributes: {
                ...$a5800aea1409eb6c$var$baseAttributes,
                ...attributes_0
            }
        }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92214
    const fireOrgListItemClicked = (0, $cozmU.useCallback)((attributes_1)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'atlassianSwitcherOrgExpandItem',
            attributes: {
                ...$a5800aea1409eb6c$var$baseAttributes,
                ...attributes_1
            }
        }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes
    ]);
    const fireUnitListItemClicked = (0, $cozmU.useCallback)((attributes_2)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'atlassianSwitcherUnitExpandItem',
            attributes: {
                ...$a5800aea1409eb6c$var$baseAttributes,
                ...attributes_2
            }
        }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/107393
    const fireRailResized = (0, $cozmU.useCallback)((attributes_3)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: 'dragged',
            actionSubjectId: 'atlassianSwitcherUnitRailResize',
            attributes: {
                ...$a5800aea1409eb6c$var$baseAttributes,
                ...attributes_3
            }
        }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92343
    const fireSwitcherItemExpandClicked = (0, $cozmU.useCallback)((attributes_4)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'atlassianSwitcherItemExpand',
            attributes: {
                ...$a5800aea1409eb6c$var$baseAttributes,
                ...attributes_4,
                groupIndex: getGroupIndex(attributes_4.groupIdentifier),
                groupItemProduct: attributes_4.groupItemProduct ?? $a5800aea1409eb6c$var$UNDEFINED_PRODUCT,
                groupItemSiteId: cloudId ?? $a5800aea1409eb6c$var$UNDEFINED_SITE
            }
        }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes,
        getGroupIndex,
        cloudId
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92607
    const fireSwitcherItemExpandListViewed = (0, $cozmU.useCallback)((attributes_5)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: 'viewed',
            actionSubjectId: 'atlassianSwitcherItemExpandList',
            attributes: {
                ...$a5800aea1409eb6c$var$baseAttributes,
                ...attributes_5,
                groupIndex: getGroupIndex(attributes_5.groupIdentifier),
                groupItemProduct: attributes_5.groupItemProduct ?? $a5800aea1409eb6c$var$UNDEFINED_PRODUCT,
                groupItemSiteId: cloudId ?? $a5800aea1409eb6c$var$UNDEFINED_SITE
            }
        }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes,
        getGroupIndex,
        cloudId
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92277
    const fireSwitcherItemExpandItemClicked = (0, $cozmU.useCallback)((attributes_6)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'atlassianSwitcherItemExpandItem',
            attributes: {
                ...$a5800aea1409eb6c$var$baseAttributes,
                ...attributes_6,
                groupIndex: getGroupIndex(attributes_6.groupIdentifier),
                groupItemProduct: attributes_6.groupItemProduct ?? $a5800aea1409eb6c$var$UNDEFINED_PRODUCT,
                groupItemSiteId: cloudId ?? $a5800aea1409eb6c$var$UNDEFINED_SITE,
                expandItemCloudId: attributes_6.expandItemCloudId ?? $a5800aea1409eb6c$var$UNDEFINED_SITE
            }
        }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes,
        getGroupIndex,
        cloudId
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92268
    const fireMenuViewed = (0, $cozmU.useCallback)((attributes_7)=>{
        if (hasFiredMenuViewed.current) return;
        const customLinksLength = customLinks?.length;
        const hasOverflow = attributes_7.firstPartyProducts.length > (0, $9eceO.MAX_ITEMS_TO_SHOW);
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: 'viewed',
            actionSubjectId: 'atlassianSwitcherMenu',
            attributes: {
                ...$a5800aea1409eb6c$var$baseAttributes,
                isOrderCustomized: attributes_7.isOrderCustomized,
                selectedOrg: currentOrg ?? $a5800aea1409eb6c$export$b20f588755c3941,
                currentOrg: currentOrg ?? $a5800aea1409eb6c$export$b20f588755c3941,
                selectedUnit: currentUnit ?? $a5800aea1409eb6c$export$462de9de99767288,
                currentUnit: currentUnit ?? $a5800aea1409eb6c$export$462de9de99767288,
                orgCount: organisations?.size ?? 0,
                orgList: Array.from(organisations?.keys() ?? []),
                tryRovoChatCohort: tryRovoChatCohort,
                groupList: [
                    {
                        groupIdentifier: '1pApp',
                        groupItemCount: hasOverflow ? (0, $9eceO.MAX_ITEMS_TO_SHOW) : attributes_7.firstPartyProducts.length,
                        groupItemList: hasOverflow ? attributes_7.firstPartyProducts.slice(0, (0, $9eceO.MAX_ITEMS_TO_SHOW)).map((item)=>item.productType) : attributes_7.firstPartyProducts.map((item_0)=>item_0.productType),
                        showMoreButton: hasOverflow,
                        inMoreItemCount: hasOverflow ? attributes_7.firstPartyProducts.length - (0, $9eceO.MAX_ITEMS_TO_SHOW) : 0,
                        inMoreItemList: hasOverflow ? attributes_7.firstPartyProducts.slice((0, $9eceO.MAX_ITEMS_TO_SHOW)).map((item_1)=>item_1.productType) : []
                    },
                    ...hasThirdPartySection ? [
                        {
                            groupIdentifier: '3pApp',
                            groupItemCount: thirdPartyConfig?.length ?? 0,
                            groupItemList: thirdPartyConfig?.map((item_2)=>item_2.type) ?? [],
                            showMoreButton: false,
                            inMoreItemCount: 0,
                            inMoreItemList: []
                        }
                    ] : [],
                    ...hasDiscoverySection ? [
                        {
                            groupIdentifier: 'discoverMore',
                            groupItemCount: 1,
                            groupItemList: [
                                'moreAtlassianApps'
                            ],
                            showMoreButton: false,
                            inMoreItemCount: 0,
                            inMoreItemList: []
                        }
                    ] : [],
                    ...(customLinksLength ?? 0) > 0 ? [
                        {
                            groupIdentifier: 'customLink',
                            groupItemCount: customLinksLength,
                            showMoreButton: false,
                            inMoreItemCount: 0
                        }
                    ] : []
                ].map((group, index)=>({
                        ...group,
                        groupIndex: index
                    }))
            }
        }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
        hasFiredMenuViewed.current = true;
    }, [
        createAnalyticsEvent,
        topLevelAttributes,
        currentOrg,
        currentUnit,
        organisations,
        customLinks,
        thirdPartyConfig,
        hasThirdPartySection,
        hasDiscoverySection,
        tryRovoChatCohort
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92441
    const fireItemClicked = (0, $cozmU.useCallback)((attributes_8)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'atlassianSwitcherItem',
            attributes: {
                ...$a5800aea1409eb6c$var$baseAttributes,
                ...attributes_8,
                groupIndex: getGroupIndex(attributes_8.groupIdentifier),
                groupItemProduct: attributes_8.groupItemProduct ?? $a5800aea1409eb6c$var$UNDEFINED_PRODUCT,
                groupItemSiteId: cloudId ?? $a5800aea1409eb6c$var$UNDEFINED_SITE,
                tryRovoChatCohort: tryRovoChatCohort
            }
        }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes,
        getGroupIndex,
        cloudId,
        tryRovoChatCohort
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92497
    const fireMenuScrolled = (0, $cozmU.useCallback)((attributes_9)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: 'scrolled',
            actionSubjectId: 'atlassianSwitcherMenu',
            attributes: {
                ...$a5800aea1409eb6c$var$baseAttributes,
                ...attributes_9,
                selectedOrg: currentOrg ?? $a5800aea1409eb6c$export$b20f588755c3941,
                selectedUnit: currentUnit ?? $a5800aea1409eb6c$export$462de9de99767288
            }
        }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes,
        currentOrg,
        currentUnit
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92971
    const fireReorderDropdownClicked = (0, $cozmU.useCallback)((attributes_10)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'atlassianSwitcherItemReorderDropdown',
            attributes: {
                ...$a5800aea1409eb6c$var$baseAttributes,
                ...attributes_10,
                groupIndex: getGroupIndex(attributes_10.groupIdentifier),
                groupItemProduct: attributes_10.groupItemProduct ?? $a5800aea1409eb6c$var$UNDEFINED_PRODUCT,
                groupItemSiteId: cloudId ?? $a5800aea1409eb6c$var$UNDEFINED_SITE
            }
        }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes,
        getGroupIndex,
        cloudId
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92878
    const fireOverflowButtonClicked = (0, $cozmU.useCallback)((attributes_11)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'atlassianSwitcherOverflowButton',
            attributes: {
                ...$a5800aea1409eb6c$var$baseAttributes,
                ...attributes_11
            }
        }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92973
    const fireReorderDropdownViewed = (0, $cozmU.useCallback)((attributes_12)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: 'viewed',
            actionSubjectId: 'atlassianSwitcherItemReorderDropdownList',
            attributes: {
                ...$a5800aea1409eb6c$var$baseAttributes,
                ...attributes_12,
                groupIndex: getGroupIndex(attributes_12.groupIdentifier),
                groupItemProduct: attributes_12.groupItemProduct ?? $a5800aea1409eb6c$var$UNDEFINED_PRODUCT,
                groupItemSiteId: cloudId ?? $a5800aea1409eb6c$var$UNDEFINED_SITE
            }
        }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes,
        getGroupIndex,
        cloudId
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92975
    const fireReorderDropdownItemClicked = (0, $cozmU.useCallback)((attributes_13)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'atlassianSwitcherItemReorderDropdownListItem',
            attributes: {
                ...$a5800aea1409eb6c$var$baseAttributes,
                ...attributes_13,
                groupIndex: getGroupIndex(attributes_13.groupIdentifier),
                groupItemProduct: attributes_13.groupItemProduct ?? $a5800aea1409eb6c$var$UNDEFINED_PRODUCT,
                groupItemSiteId: cloudId ?? $a5800aea1409eb6c$var$UNDEFINED_SITE,
                tryRovoChatCohort: tryRovoChatCohort
            }
        }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes,
        getGroupIndex,
        cloudId,
        tryRovoChatCohort
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92879
    const fireItemDragged = (0, $cozmU.useCallback)((attributes_14)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: 'dragged',
            actionSubjectId: 'atlassianSwitcherItem',
            attributes: {
                ...$a5800aea1409eb6c$var$baseAttributes,
                ...attributes_14,
                groupIndex: getGroupIndex(attributes_14.groupIdentifier),
                groupItemProduct: attributes_14.groupItemProduct ?? $a5800aea1409eb6c$var$UNDEFINED_PRODUCT,
                groupItemSiteId: cloudId ?? $a5800aea1409eb6c$var$UNDEFINED_SITE,
                tryRovoChatCohort: tryRovoChatCohort
            }
        }).fire((0, $bLbuQ.NAVIGATION_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes,
        getGroupIndex,
        cloudId,
        tryRovoChatCohort
    ]);
    return {
        fireItemClicked: fireItemClicked,
        fireItemDragged: fireItemDragged,
        fireMenuStateChanged: fireMenuStateChanged,
        fireMenuViewed: fireMenuViewed,
        fireMenuScrolled: fireMenuScrolled,
        fireOrgDropdownClicked: fireOrgDropdownClicked,
        fireOrgDropdownViewed: fireOrgDropdownViewed,
        fireOrgListItemClicked: fireOrgListItemClicked,
        fireUnitListItemClicked: fireUnitListItemClicked,
        fireRailResized: fireRailResized,
        fireOverflowButtonClicked: fireOverflowButtonClicked,
        fireReorderDropdownClicked: fireReorderDropdownClicked,
        fireReorderDropdownItemClicked: fireReorderDropdownItemClicked,
        fireReorderDropdownViewed: fireReorderDropdownViewed,
        fireSwitcherItemExpandClicked: fireSwitcherItemExpandClicked,
        fireSwitcherItemExpandListViewed: fireSwitcherItemExpandListViewed,
        fireSwitcherItemExpandItemClicked: fireSwitcherItemExpandItemClicked
    };
};
function $a5800aea1409eb6c$var$_temp5(group, index) {
    return {
        ...group,
        groupIndex: index
    };
}
function $a5800aea1409eb6c$var$_temp4(item_2) {
    return item_2.type;
}
function $a5800aea1409eb6c$var$_temp3(item_1) {
    return item_1.productType;
}
function $a5800aea1409eb6c$var$_temp2(item_0) {
    return item_0.productType;
}
function $a5800aea1409eb6c$var$_temp(item) {
    return item.productType;
}
module.exports["UNIFIED_INSTRUMENTATION_SOURCE"] = $a5800aea1409eb6c$export$a26402899a5435f8;
module.exports["UNDEFINED_ORG"] = $a5800aea1409eb6c$export$b20f588755c3941;
module.exports["UNDEFINED_UNIT"] = $a5800aea1409eb6c$export$462de9de99767288;
module.exports["useUnifiedAnalytics"] = $a5800aea1409eb6c$export$b994de3a6486f6d5;

});

parcelRegister("9eceO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $04f4d21ce6bfdf9b$export$57f25bb04a62384 = 7;
const $04f4d21ce6bfdf9b$export$9723eb754c7a24e1 = /*#__PURE__*/ (0, $cozmU.createContext)({
    itemListLength: 0,
    reorderItem: undefined,
    numNonDraggableItems: 0
});
const $04f4d21ce6bfdf9b$var$DraggableItemListProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    const reorderItem = $04f4d21ce6bfdf9b$var$_temp;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            itemListLength: 0,
            reorderItem: reorderItem,
            numNonDraggableItems: 0
        };
        $[0] = t1;
    } else t1 = $[0];
    const draggableItemListProviderState = t1;
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($04f4d21ce6bfdf9b$export$9723eb754c7a24e1.Provider, {
            value: draggableItemListProviderState
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>{
    const reorderItem = (0, $cozmU.useCallback)((args)=>{}, []);
    const draggableItemListProviderState = (0, $cozmU.useMemo)(()=>({
            itemListLength: 0,
            reorderItem: reorderItem,
            numNonDraggableItems: 0
        }), [
        reorderItem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($04f4d21ce6bfdf9b$export$9723eb754c7a24e1.Provider, {
        value: draggableItemListProviderState
    }, children);
};
const $04f4d21ce6bfdf9b$export$f1e8bef54a1b1829 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($04f4d21ce6bfdf9b$export$9723eb754c7a24e1);
} : ()=>(0, $cozmU.useContext)($04f4d21ce6bfdf9b$export$9723eb754c7a24e1);
var $04f4d21ce6bfdf9b$export$2e2bcd8739ae039 = $04f4d21ce6bfdf9b$var$DraggableItemListProvider;
function $04f4d21ce6bfdf9b$var$_temp(args) {}
module.exports["MAX_ITEMS_TO_SHOW"] = $04f4d21ce6bfdf9b$export$57f25bb04a62384;
module.exports["DraggableItemListContext"] = $04f4d21ce6bfdf9b$export$9723eb754c7a24e1;
module.exports["useDraggableItemListProvider"] = $04f4d21ce6bfdf9b$export$f1e8bef54a1b1829;

});

parcelRegister("8aJgK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $5d1f11712cc26a4f$export$ebe3847b1b8f8d1f = 'discovery-section-rendered';
const $5d1f11712cc26a4f$export$5472c721726ec1eb = (renderedContent)=>{
    // Also dispatch event for currently mounted listeners
    if (typeof globalThis?.document !== 'undefined') {
        const event = new CustomEvent($5d1f11712cc26a4f$export$ebe3847b1b8f8d1f, {
            detail: {
                renderedContent: renderedContent
            }
        });
        globalThis.document.dispatchEvent(event);
    }
};
const $5d1f11712cc26a4f$export$537ef385cd362c6a = (callback)=>{
    // Use ref to always point to latest callback without triggering effect re-runs
    const callbackRef = (0, $cozmU.useRef)(callback);
    callbackRef.current = callback;
    (0, $cozmU.useEffect)(()=>{
        const handleEvent = (event)=>{
            callbackRef.current(event);
        };
        globalThis?.document?.addEventListener($5d1f11712cc26a4f$export$ebe3847b1b8f8d1f, handleEvent);
        return ()=>{
            globalThis?.document?.removeEventListener($5d1f11712cc26a4f$export$ebe3847b1b8f8d1f, handleEvent);
        };
    }, []);
};
module.exports["notifyDiscoverySectionRendered"] = $5d1f11712cc26a4f$export$5472c721726ec1eb;
module.exports["useDiscoverySectionEventListener"] = $5d1f11712cc26a4f$export$537ef385cd362c6a;

});

parcelRegister("6a9Mm", function(module, exports) {

var $bGVJw = parcelRequire("bGVJw");

const $90f555d2be5f2099$export$55ed4fa25efa6fad = {
    WAC: 'marketing'
};
const $90f555d2be5f2099$export$40cd2d71062b3400 = 'segment_confluence_mau_not_mcu_with_user_tenure_greater_than_90_days_siteuser';
const $90f555d2be5f2099$export$527ac0900a40b0c0 = 'segment_paying_sites_less_than_2_months_old_siteid';
const $90f555d2be5f2099$export$bf0b0c402d9ebd25 = 'segment_partner_managed_tenants_siteid';
const $90f555d2be5f2099$export$e4025b4a2a2f1a21 = 'segment_jira_recently_inactive_peu_non_mau_siteuser';
const $90f555d2be5f2099$export$e3e34056deab7ac7 = 'post-office-jira-assigned-nudge-tap-aud-check-gate';


const $5d92cfa246ad2af5$export$4e9304272964deb6 = ()=>{
    const context = (0, $bGVJw.usePostOfficeContext)();
    return context.product === (0, $90f555d2be5f2099$export$55ed4fa25efa6fad).WAC;
};
const $5d92cfa246ad2af5$export$631ba87ff5b9e288 = (microsEnvType)=>{
    switch(microsEnvType){
        case 'dev':
            return 'https://admin.dev.atlassian.com';
        case 'staging':
            return 'https://admin.stg.atlassian.com';
        default:
            return 'https://admin.atlassian.com';
    }
};
const $5d92cfa246ad2af5$export$22f3f17829eee7e0 = (microsEnvType)=>{
    switch(microsEnvType){
        case 'dev':
            return 'https://studio.dev.atlassian.com';
        case 'staging':
            return 'https://studio.stg.atlassian.com';
        default:
            return 'https://studio.atlassian.com';
    }
};
module.exports["useIsWacContext"] = $5d92cfa246ad2af5$export$4e9304272964deb6;

});

parcelRegister("cnXyf", function(module, exports) {

let $9045d3b28bfff5fd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9045d3b28bfff5fd$var$load("73CiP").then(()=>parcelRequire('leAo0'));

});

parcelRegister("9huZ8", function(module, exports) {

let $6c1dbc98325ae434$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6c1dbc98325ae434$var$load("6wr18"),
    $6c1dbc98325ae434$var$load("hhss7"),
    $6c1dbc98325ae434$var$load("6yDMn"),
    $6c1dbc98325ae434$var$load("ffEVr"),
    $6c1dbc98325ae434$var$load("eHgxr"),
    $6c1dbc98325ae434$var$load("ccAQf"),
    $6c1dbc98325ae434$var$load("Wowvf"),
    $6c1dbc98325ae434$var$load("hFF8G")
]).then(()=>parcelRequire('0ALxL'));

});

parcelRegister("3MLtk", function(module, exports) {

let $2c1aadbec6b0178f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2c1aadbec6b0178f$var$load("6wr18"),
    $2c1aadbec6b0178f$var$load("hhss7"),
    $2c1aadbec6b0178f$var$load("6yDMn"),
    $2c1aadbec6b0178f$var$load("ffEVr"),
    $2c1aadbec6b0178f$var$load("eHgxr"),
    $2c1aadbec6b0178f$var$load("ccAQf"),
    $2c1aadbec6b0178f$var$load("Wowvf"),
    $2c1aadbec6b0178f$var$load("aICYE")
]).then(()=>parcelRequire('gQkt8'));

});

parcelRegister("er7VU", function(module, exports) {

let $a829bda6b4ecd286$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a829bda6b4ecd286$var$load("6wr18"),
    $a829bda6b4ecd286$var$load("hhss7"),
    $a829bda6b4ecd286$var$load("6yDMn"),
    $a829bda6b4ecd286$var$load("ffEVr"),
    $a829bda6b4ecd286$var$load("eHgxr"),
    $a829bda6b4ecd286$var$load("ccAQf"),
    $a829bda6b4ecd286$var$load("Wowvf"),
    $a829bda6b4ecd286$var$load("1vBMH")
]).then(()=>parcelRequire('8srfF'));

});

parcelRegister("gpigJ", function(module, exports) {

let $bf1d26fa86db12b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bf1d26fa86db12b7$var$load("6wr18"),
    $bf1d26fa86db12b7$var$load("hhss7"),
    $bf1d26fa86db12b7$var$load("6yDMn"),
    $bf1d26fa86db12b7$var$load("ffEVr"),
    $bf1d26fa86db12b7$var$load("eHgxr"),
    $bf1d26fa86db12b7$var$load("ccAQf"),
    $bf1d26fa86db12b7$var$load("Wowvf"),
    $bf1d26fa86db12b7$var$load("1de1X")
]).then(()=>parcelRequire('7YQEz'));

});

parcelRegister("7IGW9", function(module, exports) {

let $0173525e3c2dcdb2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0173525e3c2dcdb2$var$load("6wr18"),
    $0173525e3c2dcdb2$var$load("hhss7"),
    $0173525e3c2dcdb2$var$load("6yDMn"),
    $0173525e3c2dcdb2$var$load("ffEVr"),
    $0173525e3c2dcdb2$var$load("eHgxr"),
    $0173525e3c2dcdb2$var$load("ccAQf"),
    $0173525e3c2dcdb2$var$load("Wowvf"),
    $0173525e3c2dcdb2$var$load("5AelE")
]).then(()=>parcelRequire('1s9Mi'));

});

parcelRegister("hyia5", function(module, exports) {

let $cc73b32a46f36dc5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cc73b32a46f36dc5$var$load("6wr18"),
    $cc73b32a46f36dc5$var$load("hhss7"),
    $cc73b32a46f36dc5$var$load("6yDMn"),
    $cc73b32a46f36dc5$var$load("ffEVr"),
    $cc73b32a46f36dc5$var$load("eHgxr"),
    $cc73b32a46f36dc5$var$load("ccAQf"),
    $cc73b32a46f36dc5$var$load("Wowvf"),
    $cc73b32a46f36dc5$var$load("1C8Ih")
]).then(()=>parcelRequire('3cWBo'));

});

parcelRegister("atoRk", function(module, exports) {

let $79ffe558c26e9e90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $79ffe558c26e9e90$var$load("6wr18"),
    $79ffe558c26e9e90$var$load("hhss7"),
    $79ffe558c26e9e90$var$load("6yDMn"),
    $79ffe558c26e9e90$var$load("ffEVr"),
    $79ffe558c26e9e90$var$load("eHgxr"),
    $79ffe558c26e9e90$var$load("ccAQf"),
    $79ffe558c26e9e90$var$load("Wowvf"),
    $79ffe558c26e9e90$var$load("fOvyX")
]).then(()=>parcelRequire('lePW5'));

});

parcelRegister("2Zk3H", function(module, exports) {

let $22d0d67f0880b4a3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $22d0d67f0880b4a3$var$load("6wr18"),
    $22d0d67f0880b4a3$var$load("hhss7"),
    $22d0d67f0880b4a3$var$load("6yDMn"),
    $22d0d67f0880b4a3$var$load("ffEVr"),
    $22d0d67f0880b4a3$var$load("eHgxr"),
    $22d0d67f0880b4a3$var$load("ccAQf"),
    $22d0d67f0880b4a3$var$load("Wowvf"),
    $22d0d67f0880b4a3$var$load("6OLxW")
]).then(()=>parcelRequire('fbHGS'));

});

parcelRegister("bsU9z", function(module, exports) {

let $858dde21ee705233$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $858dde21ee705233$var$load("6wr18"),
    $858dde21ee705233$var$load("hhss7"),
    $858dde21ee705233$var$load("6yDMn"),
    $858dde21ee705233$var$load("ffEVr"),
    $858dde21ee705233$var$load("eHgxr"),
    $858dde21ee705233$var$load("ccAQf"),
    $858dde21ee705233$var$load("Wowvf"),
    $858dde21ee705233$var$load("c0KDc")
]).then(()=>parcelRequire('5AllB'));

});

parcelRegister("39FyK", function(module, exports) {

let $24c273348a1f4dfd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $24c273348a1f4dfd$var$load("6wr18"),
    $24c273348a1f4dfd$var$load("hhss7"),
    $24c273348a1f4dfd$var$load("6yDMn"),
    $24c273348a1f4dfd$var$load("ffEVr"),
    $24c273348a1f4dfd$var$load("eHgxr"),
    $24c273348a1f4dfd$var$load("ccAQf"),
    $24c273348a1f4dfd$var$load("Wowvf"),
    $24c273348a1f4dfd$var$load("ipEce")
]).then(()=>parcelRequire('e8r3I'));

});

parcelRegister("55Kux", function(module, exports) {

let $3b517ba772bcb149$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3b517ba772bcb149$var$load("dRt7c").then(()=>parcelRequire('5fHjZ'));

});

parcelRegister("44Ci1", function(module, exports) {

let $2f753cafda1b27db$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2f753cafda1b27db$var$load("jtFlE").then(()=>parcelRequire('5N2YU'));

});

parcelRegister("9Jv6I", function(module, exports) {

let $7160724d72412fa6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7160724d72412fa6$var$load("aJhfw").then(()=>parcelRequire('iPbs3'));

});

parcelRegister("h5VH3", function(module, exports) {
module.exports = JSON.parse('{"trailblazers.recommendation-jsw-jtbd.generic.description":[{"type":0,"value":"Track work from start to finish"}],"trailblazers.recommendation-jsw-jtbd.generic.jtbd":[{"type":0,"value":"Project board"}],"trailblazers.recommendation-jsw-jtbd.lozenge.try":[{"type":0,"value":"Try"}],"trailblazers.recommendation-jsw-jtbd.marketing.description":[{"type":0,"value":"Easily plan and prioritize work"}],"trailblazers.recommendation-jsw-jtbd.marketing.jtbd":[{"type":0,"value":"Marketing project"}],"trailblazers.recommendation-jsw-jtbd.operations.description":[{"type":0,"value":"Visualize, plan, and finish work"}],"trailblazers.recommendation-jsw-jtbd.operations.jtbd":[{"type":0,"value":"Operations project"}],"trailblazers.recommendation-jsw-jtbd.pm.description":[{"type":0,"value":"See work in to-do, doing, done"}],"trailblazers.recommendation-jsw-jtbd.pm.jtbd":[{"type":0,"value":"Plan and track work"}],"trailblazers.recommendation-jsw-jtbd.swe.description":[{"type":0,"value":"Track work from start to finish"}],"trailblazers.recommendation-jsw-jtbd.swe.jtbd":[{"type":0,"value":"Project tracker"}],"trailblazers.xflow-notification-end-user-added-jira.message-template.email.subject":[{"type":0,"value":"\uD83C\uDF89 "},{"type":1,"value":"name"},{"type":0,"value":" has started using Jira"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.admin-url.no-translate":[{"type":0,"value":"admin.atlassian.com"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.headline":[{"type":1,"value":"name"},{"type":0,"value":" has started using Jira!"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.lead-paragraph":[{"type":0,"value":"Jira has been added to "},{"type":1,"value":"instanceUrl"},{"type":0,"value":". You don\u2019t need to do anything. "},{"children":[{"type":0,"value":"Jira is free for up to 10 users."}],"type":8,"value":"b"},{"type":0,"value":" You can cancel any time at "}],"trailblazers.xflow-notification-end-user-added-jira.message.email.sent-by-atlassian":[{"type":0,"value":"This message has been sent to you by Atlassian Cloud"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.take-tour.button":[{"type":0,"value":"Take a tour"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.value-prop.achievable-tasks":[{"type":0,"value":"\uD83D\uDE80 Jira is a tool designed to break down any idea into achievable tasks."}],"trailblazers.xflow-notification-end-user-added-jira.message.email.value-prop.connect-realtime":[{"type":0,"value":"\u2194\uFE0F Connect real-time data from Jira to any document in Confluence, no more copy paste."}],"trailblazers.xflow-notification-end-user-added-jira.message.email.value-prop.visualise":[{"type":0,"value":"\uD83D\uDC40 Visualize your projects in lists, boards, backlogs, and more."}]}');

});

parcelRegister("4ngEZ", function(module, exports) {

let $32f63bc80be3a6dc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32f63bc80be3a6dc$var$load("9DbAi").then(()=>parcelRequire('gVB5T'));

});

parcelRegister("b7yt9", function(module, exports) {

let $818b1602ad7d3a9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $818b1602ad7d3a9b$var$load("ejGZK").then(()=>parcelRequire('atyKF'));

});

parcelRegister("5UkiO", function(module, exports) {

let $44d1ee5f9adfa4eb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44d1ee5f9adfa4eb$var$load("cfvVp").then(()=>parcelRequire('bLasg'));

});

parcelRegister("i8gVe", function(module, exports) {

let $d33619b4f4da1b3b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d33619b4f4da1b3b$var$load("8mBRT").then(()=>parcelRequire('5pwyu'));

});

parcelRegister("j8LPM", function(module, exports) {

let $def3de9128c9f2dc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $def3de9128c9f2dc$var$load("jiSSK").then(()=>parcelRequire('ebDBK'));

});

parcelRegister("8AId7", function(module, exports) {

let $6413fad4c40049b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6413fad4c40049b0$var$load("hsFVf").then(()=>parcelRequire('4JvvK'));

});

parcelRegister("3V0Ug", function(module, exports) {

let $2da765fad68d5cfb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2da765fad68d5cfb$var$load("7guX3").then(()=>parcelRequire('47jtC'));

});

parcelRegister("exgCq", function(module, exports) {

let $a95109e46723c454$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a95109e46723c454$var$load("aKD5F").then(()=>parcelRequire('el920'));

});

parcelRegister("fhx7R", function(module, exports) {

let $b202239f67855ab6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b202239f67855ab6$var$load("jvgjd").then(()=>parcelRequire('a7Bsi'));

});

parcelRegister("6n8A6", function(module, exports) {

let $4a3b8c2113d3455a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a3b8c2113d3455a$var$load("lGy3h").then(()=>parcelRequire('cpo7m'));

});

parcelRegister("jSUAm", function(module, exports) {

let $e79ef425e2bddbff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e79ef425e2bddbff$var$load("lYetd").then(()=>parcelRequire('1LBSB'));

});

parcelRegister("9tcEy", function(module, exports) {

let $6e50a3264f12de30$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e50a3264f12de30$var$load("dlbSV").then(()=>parcelRequire('7MvD1'));

});

parcelRegister("l36rh", function(module, exports) {

let $f52edf6c40c0cff1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f52edf6c40c0cff1$var$load("9LVq3").then(()=>parcelRequire('bnc7c'));

});

parcelRegister("1miw5", function(module, exports) {

let $0fd6357f78941436$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0fd6357f78941436$var$load("adqtR").then(()=>parcelRequire('bHRqy'));

});

parcelRegister("7GTVh", function(module, exports) {

let $5997d5c97a6eddcb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5997d5c97a6eddcb$var$load("a0NzW").then(()=>parcelRequire('lBirq'));

});

parcelRegister("iPj3F", function(module, exports) {

let $db4bc5fd2ded3fbb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $db4bc5fd2ded3fbb$var$load("8yyJa").then(()=>parcelRequire('5xTKu'));

});

parcelRegister("bAqCy", function(module, exports) {

let $86f7b4df5d02d419$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86f7b4df5d02d419$var$load("3LEY2").then(()=>parcelRequire('3BKAv'));

});

parcelRegister("6HUw8", function(module, exports) {

let $4e229963847ced21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e229963847ced21$var$load("3NQjk").then(()=>parcelRequire('d4FM7'));

});

parcelRegister("iJTTu", function(module, exports) {

let $da47c959b245df89$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $da47c959b245df89$var$load("ic5wL").then(()=>parcelRequire('dujWj'));

});

parcelRegister("jSqU0", function(module, exports) {

let $e787edb9070b839f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e787edb9070b839f$var$load("7VH50").then(()=>parcelRequire('lc5ip'));

});

parcelRegister("8L3mt", function(module, exports) {

let $6605520dac3766c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6605520dac3766c5$var$load("aPQ3H").then(()=>parcelRequire('7cyGb'));

});

parcelRegister("kyUN0", function(module, exports) {

let $ef8308cee98f2095$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ef8308cee98f2095$var$load("1dQMq").then(()=>parcelRequire('hkQX6'));

});

parcelRegister("kmxaJ", function(module, exports) {

let $ed2f9802446494ec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ed2f9802446494ec$var$load("jGpGm").then(()=>parcelRequire('4NntP'));

});

parcelRegister("hx1vI", function(module, exports) {

let $cc36b0b6c3d7ca2f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cc36b0b6c3d7ca2f$var$load("8k6Ko").then(()=>parcelRequire('kKj32'));

});

parcelRegister("5Z0GS", function(module, exports) {

let $45b32f6742fee38f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $45b32f6742fee38f$var$load("b0A02").then(()=>parcelRequire('f7ROM'));

});

parcelRegister("fZDBp", function(module, exports) {

let $ba4b45be213febdc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ba4b45be213febdc$var$load("8pFJI").then(()=>parcelRequire('fv62g'));

});

parcelRegister("cAxqr", function(module, exports) {

let $92a2c66bb2145674$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $92a2c66bb2145674$var$load("lDAOF").then(()=>parcelRequire('daQKr'));

});

parcelRegister("iN4pl", function(module, exports) {

let $dae038e4978bdfa5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dae038e4978bdfa5$var$load("lMsb0").then(()=>parcelRequire('10Tlv'));

});

parcelRegister("9uJOz", function(module, exports) {

let $6e9a743ee4ce52ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e9a743ee4ce52ea$var$load("9JoIX").then(()=>parcelRequire('1vrPt'));

});

parcelRegister("3Qc9A", function(module, exports) {

let $2cbfa7dd89d9646b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2cbfa7dd89d9646b$var$load("a4pYM").then(()=>parcelRequire('6Z2OL'));

});

parcelRegister("l1yFU", function(module, exports) {

let $f4e496b198e4853d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f4e496b198e4853d$var$load("6JBkA").then(()=>parcelRequire('1ASRh'));

});

parcelRegister("eZvR2", function(module, exports) {

let $ae9f78d6d87a8455$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae9f78d6d87a8455$var$load("SFsFB").then(()=>parcelRequire('d7p1X'));

});

parcelRegister("civeX", function(module, exports) {

let $8f3f661e1cf08616$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8f3f661e1cf08616$var$load("aDD1K").then(()=>parcelRequire('inTNY'));

});

parcelRegister("4iJNL", function(module, exports) {

let $321c5f240b3c43b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $321c5f240b3c43b6$var$load("1GjJ2").then(()=>parcelRequire('d9Z2J'));

});

parcelRegister("eug7u", function(module, exports) {
var $7228d4cdb25cf1e4$export$2d41982586bbb6be = /*#__PURE__*/ function(Permissions) {
    Permissions["MANAGE"] = "manage";
    return Permissions;
}({});
var $7228d4cdb25cf1e4$export$77f267162e8983fb = /*#__PURE__*/ function(AnalyticsItemType) {
    AnalyticsItemType["PRODUCT"] = "product";
    AnalyticsItemType["ADMIN"] = "admin";
    AnalyticsItemType["TRY"] = "try";
    AnalyticsItemType["JOIN"] = "join";
    AnalyticsItemType["CUSTOM_LINK"] = "customLink";
    AnalyticsItemType["EMPTY_STATE_EXPLORE_PRODUCTS"] = "empty-state-explore-products";
    AnalyticsItemType["OVERFLOW"] = "overflow";
    return AnalyticsItemType;
}({});
var $7228d4cdb25cf1e4$export$f3a53bd43617a593 = /*#__PURE__*/ function(ProductKey) {
    ProductKey["CONFLUENCE"] = "confluence.ondemand";
    ProductKey["JIRA_CORE"] = "jira-core.ondemand";
    ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    ProductKey["BITBUCKET"] = "bitbucket";
    ProductKey["OPSGENIE"] = "opsgenie";
    ProductKey["STATUSPAGE"] = "statuspage";
    ProductKey["TRELLO"] = "trello";
    ProductKey["COMPASS"] = "compass";
    ProductKey["TEAM_CENTRAL"] = "townsquare";
    ProductKey["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    return ProductKey;
}({});
module.exports["AnalyticsItemType"] = $7228d4cdb25cf1e4$export$77f267162e8983fb;
module.exports["ProductKey"] = $7228d4cdb25cf1e4$export$f3a53bd43617a593;

});

parcelRegister("1B659", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $cXtTj = parcelRequire("cXtTj");


var $jmjWc = parcelRequire("jmjWc");


var $gLUd5 = parcelRequire("gLUd5");


const $967ca22ab943ad07$var$BranchDeployLogoLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K2D1k",
    name: "BranchDeployLogoLoader",
    loader: async ()=>(await (parcelRequire("6UoqX"))).BranchDeployLogo,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))), {
            label: "Loading..."
        })
});

const $967ca22ab943ad07$var$FeatureFlagLogoLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gfVJ0",
    name: "FeatureFlagLogoLoader",
    loader: async ()=>(await (parcelRequire("72N3J"))).FeatureFlagLogo
});
const $967ca22ab943ad07$export$55e9396bf1b75bb0 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { isAtlassianStaff: t1 } = t0;
    const isAtlassianStaff = t1 === undefined ? false : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gLUd5.isBranchDeployFn)();
        $[0] = t2;
    } else t2 = $[0];
    const isBranchDeploy = t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $cXtTj.default).getOverrides();
        $[1] = t3;
    } else t3 = $[1];
    const featureGateOverrides = t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = Object.keys(featureGateOverrides.gates).length > 0 || Object.keys(featureGateOverrides.configs).length > 0;
        $[2] = t4;
    } else t4 = $[2];
    const hasOverrides = t4;
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = isBranchDeploy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($967ca22ab943ad07$var$BranchDeployLogoLoader, null);
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== isAtlassianStaff) {
        t6 = isAtlassianStaff && hasOverrides && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($967ca22ab943ad07$var$FeatureFlagLogoLoader, {
            featureGateOverrides: featureGateOverrides
        });
        $[4] = isAtlassianStaff;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t5, t6);
        $[6] = t6;
        $[7] = t7;
    } else t7 = $[7];
    return t7;
};
module.exports["DeveloperButtons"] = $967ca22ab943ad07$export$55e9396bf1b75bb0;

});

parcelRegister("6UoqX", function(module, exports) {

let $507aed11e987f809$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $507aed11e987f809$var$load("kI3I7"),
    $507aed11e987f809$var$load("8dYdP")
]).then(()=>parcelRequire('gef2L'));

});

parcelRegister("72N3J", function(module, exports) {

let $520ec6719ebcff71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $520ec6719ebcff71$var$load("aJFHK"),
    $520ec6719ebcff71$var$load("bkswC")
]).then(()=>parcelRequire('lhO3J'));

});

parcelRegister("9MAeh", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $74VX5 = parcelRequire("74VX5");


var $cozmU = parcelRequire("cozmU");


var $KDAt0 = parcelRequire("KDAt0");


var $kSwu1 = parcelRequire("kSwu1");


var $4nIKB = parcelRequire("4nIKB");


var $9DHhW = parcelRequire("9DHhW");


var $4n1IT = parcelRequire("4n1IT");


var $ej46P = parcelRequire("ej46P");


var $gABt9 = parcelRequire("gABt9");

const $44b843011f7daa6b$export$b055de0e665cb20c = 'atlaskitNotificationLogClient';
const $44b843011f7daa6b$export$a61d46c15216c8a4 = '/gateway/api/graphql';
class $44b843011f7daa6b$export$2e2bcd8739ae039 {
    async countUnseenNotifications(options = {}) {
        const query = /* GraphQL */ `
			query NotificationLogClientUnseenCount(
				$workspaceId: String
				$collabContextRoutingAri: String
			) {
				notifications {
					unseenNotificationCount(
						workspaceId: $workspaceId
						collabContextRoutingAri: $collabContextRoutingAri
					)
				}
			}
		`;
        const response = await (0, $gABt9.utils).requestService({
            url: this.graphQLBaseUrl
        }, {
            // Don't add trailing slash, it causes 404s
            path: '',
            ...options,
            queryParams: {
                q: this.source,
                ...options.queryParams
            },
            requestInit: {
                mode: 'cors',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...options.requestInit?.headers
                },
                body: JSON.stringify({
                    query: query,
                    variables: {
                        workspaceId: this.cloudId,
                        collabContextRoutingAri: this.collabContextRoutingAri
                    }
                }),
                ...options.requestInit
            }
        });
        return {
            count: response.data.notifications.unseenNotificationCount
        };
    }
    constructor({ graphQLBaseUrl: graphQLBaseUrl = $44b843011f7daa6b$export$a61d46c15216c8a4, cloudId: cloudId, source: source = $44b843011f7daa6b$export$b055de0e665cb20c, collabContextRoutingAri: collabContextRoutingAri } = {}){
        this.graphQLBaseUrl = void 0;
        this.cloudId = void 0;
        this.source = void 0;
        this.collabContextRoutingAri = void 0;
        this.graphQLBaseUrl = graphQLBaseUrl;
        this.cloudId = cloudId;
        this.source = source;
        this.collabContextRoutingAri = collabContextRoutingAri;
    }
}



var $frwle = parcelRequire("frwle");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $dPJCf = parcelRequire("dPJCf");


var $jmjWc = parcelRequire("jmjWc");


var $epLE5 = parcelRequire("epLE5");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $jMyy4 = parcelRequire("jMyy4");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $6mKj3 = parcelRequire("6mKj3");











var $JCGnt = parcelRequire("JCGnt");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $jb2R2 = parcelRequire("jb2R2");

const $9fd5227288655254$export$85ba2fb4f10720a7 = ()=>{
    const $ = (0, $bDgLe.c)(6);
    const { isLoggedIn: isLoggedIn, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            activeDaysThreshold: 28
        };
        $[0] = t0;
    } else t0 = $[0];
    const { isNewUser: isNewUser, loading: isNewUserLoading } = (0, $JCGnt.useIsNewUser)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP
        ];
        $[1] = t1;
    } else t1 = $[1];
    const { data: onboardingStateData, loading: isOnboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)(t1, !isNewUserLoading && typeof isNewUser === "boolean");
    let t2;
    if ($[2] !== onboardingStateData) {
        t2 = (0, $ivb8S.deserializeState)(onboardingStateData);
        $[2] = onboardingStateData;
        $[3] = t2;
    } else t2 = $[3];
    const { nthUserOnboardingCompletedTimestamp: nthUserOnboardingCompletedTimestamp } = t2;
    const completedTimestamp = Number(nthUserOnboardingCompletedTimestamp);
    let t3;
    if ($[4] !== completedTimestamp) {
        t3 = Boolean(completedTimestamp) && (0, $jb2R2.default)(new Date(), new Date(completedTimestamp)) <= 28;
        $[4] = completedTimestamp;
        $[5] = t3;
    } else t3 = $[5];
    const isUserOnboardedRecently = t3;
    if (!isLoggedIn || !isLicensed || isNewUserLoading || isOnboardingStateLoading) return false;
    if (typeof isNewUser === "boolean") return isNewUser;
    return isUserOnboardedRecently;
};



var $9WGde = parcelRequire("9WGde");














var $2ZJmt = parcelRequire("2ZJmt");


var $9wGTI = parcelRequire("9wGTI");

const $704173a03d8ffca7$export$94931606b6900781 = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { onConfirm: onConfirm } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intl || $[1] !== onConfirm) {
        t1 = (0, $9wGTI.fg)("confluence_frontend_transition_preloading_system") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ZJmt.NavigationLockout), {
            message: intl.formatMessage($704173a03d8ffca7$var$i18n.unsavedChanges),
            onConfirm: onConfirm
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KDAt0.Prompt), {
            message: ()=>{
                if (confirm(intl.formatMessage($704173a03d8ffca7$var$i18n.unsavedChanges))) {
                    onConfirm();
                    return true;
                }
                return false;
            }
        });
        $[0] = intl;
        $[1] = onConfirm;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
const $704173a03d8ffca7$var$i18n = (0, $kSwu1.defineMessages)({
    unsavedChanges: {
        id: "app-navigation.notifications.unsaved-changes.confirm",
        defaultMessage: "Do you want to discard this comment? Your comment will be lost if you do."
    }
});


const $e427a1545778ede9$export$8ceafede401119f2 = (intl)=>{
    const confirmMessage = intl.formatMessage({
        id: "app-navigation.notifications.unsaved-changes.confirm",
        defaultMessage: "Do you want to discard this comment? Your comment will be lost if you do."
    });
    return window.confirm(confirmMessage);
};
const $e427a1545778ede9$export$7bc0d27643cb0f0 = (event)=>{
    // Check if the close event was triggered by a link click
    if (event && event.type === 'click') {
        const target = event.target;
        const link = target.closest('a');
        if (link && link.href && !link.href.startsWith('javascript:')) // If it's a link click, don't show confirmation - let Prompt handle it
        return true;
    }
    return false;
};
const $e427a1545778ede9$export$5e3c850ff2c69d53 = (event, intl, onClose)=>{
    if ($e427a1545778ede9$export$7bc0d27643cb0f0(event)) return;
    if (event && event.type === 'keydown') {
        const keyboardEvent = event;
        if (keyboardEvent.key === 'Escape' || keyboardEvent.key === 'Esc') {
            if (!$e427a1545778ede9$export$8ceafede401119f2(intl)) return;
        }
    }
    onClose();
};


const $a25a74f29b49c48c$var$REFRESH_INTERVAL = 60000;
const $a25a74f29b49c48c$var$CLEAR_BADGE_TIME = 10000;
const $a25a74f29b49c48c$var$MAX_NOTIFICATION_COUNT = 9;

const $a25a74f29b49c48c$export$bae4076b81272f49 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "MEiTH",
    name: "NotificationsContentLoader",
    loader: async ()=>(await (parcelRequire("3RHmh"))).NotificationsContent
});

const $a25a74f29b49c48c$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("eNWR0"))).fireNotificationsClickedAnalytics);
class $a25a74f29b49c48c$var$EmptyNotificationLogClient {
    countUnseenNotifications() {
        return Promise.resolve({
            count: 0
        });
    }
}
const $a25a74f29b49c48c$var$useNotificationLogClient = (collabContextRoutingAri)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== collabContextRoutingAri) {
        t0 = new (0, $44b843011f7daa6b$export$2e2bcd8739ae039)({
            collabContextRoutingAri: collabContextRoutingAri
        });
        $[0] = collabContextRoutingAri;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $a25a74f29b49c48c$var$NotificationsButtonQuery = (0, $74VX5.default);
const $a25a74f29b49c48c$export$40e326b1271b1326 = ()=>{
    const notificationsButtonRef = (0, $cozmU.useRef)(null);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [isCleared, setIsCleared] = (0, $cozmU.useState)(false);
    const wasAutoOpened = (0, $cozmU.useRef)(false);
    const { userId: userId, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const shouldShowButton = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const intl = (0, $kSwu1.useIntl)();
    const collabContextRoutingAri = (0, $9WGde.useWorkspaceARI)();
    const notificationLogClient = $a25a74f29b49c48c$var$useNotificationLogClient(collabContextRoutingAri);
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const location = (0, $KDAt0.useLocation)();
    const [hasUnsavedCommentDraft, setHasUnsavedCommentDraft] = (0, $cozmU.useState)(false);
    const { data: data } = (0, $jMyy4.useQueryInterop)($a25a74f29b49c48c$var$NotificationsButtonQuery, {
        interopApolloAggClient: true,
        skip: !userId,
        __callerPackage__: "app-navigation"
    });
    const [unreadCount, setUnreadCount] = (0, $cozmU.useState)(data?.notifications?.unseenNotificationCount || 0);
    const hasNotificationsAutoOpenedBefore = (0, $17wUi.confluenceLocalStorageInstance) && (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_NOTIFICATIONS_DRAWER_AUTO_OPENED) === 'true';
    const isEligibleForExperiment = (0, $9fd5227288655254$export$85ba2fb4f10720a7)();
    const isEligibleForAutoOpen = isEligibleForExperiment && unreadCount > 0 && !hasNotificationsAutoOpenedBefore;
    const fireClickedAnalytics = $a25a74f29b49c48c$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef.current?.routeName);
    (0, $cozmU.useEffect)(()=>{
        if (isCleared) {
            const timeout = setTimeout(()=>{
                setIsCleared(false);
            }, $a25a74f29b49c48c$var$CLEAR_BADGE_TIME);
            return ()=>{
                clearTimeout(timeout);
            };
        }
    }, [
        isCleared
    ]);
    const onClick = ()=>{
        if (isOpen) {
            if (hasUnsavedCommentDraft) {
                if (!(0, $e427a1545778ede9$export$8ceafede401119f2)(intl)) return;
            }
            closeNotificationsPopup();
        } else {
            wasAutoOpened.current = false;
            performance.mark('notification.list.render.start');
            setIsCleared(true);
            setIsOpen(true);
        }
        fireClickedAnalytics();
    };
    const closeNotificationsPopup = (0, $cozmU.useCallback)(()=>{
        wasAutoOpened.current = false;
        setHasUnsavedCommentDraft(false);
        notificationsButtonRef.current?.focus();
        setIsOpen(false);
        performance.clearMarks('notification.list.render.start');
    }, []);
    const handlePopupCloseEvent = (0, $cozmU.useCallback)((event)=>{
        if (hasUnsavedCommentDraft) {
            (0, $e427a1545778ede9$export$5e3c850ff2c69d53)(event, intl, closeNotificationsPopup);
            return;
        }
        closeNotificationsPopup();
    }, [
        hasUnsavedCommentDraft,
        closeNotificationsPopup,
        intl
    ]);
    // Auto-open notifications when eligible and there are unread notifications
    (0, $cozmU.useEffect)(()=>{
        if (isEligibleForAutoOpen && !isOpen) {
            if ((0, $6mKj3.expValEquals)('cc-flywheel-auto-open-notifications-exp', 'cohort', 'experiment')) {
                // Preload the lazy-loaded NotificationsContent component, then open
                const preloadAndOpen = async ()=>{
                    await $a25a74f29b49c48c$export$bae4076b81272f49.preload();
                    performance.mark('notification.list.render.start');
                    setIsCleared(true);
                    setIsOpen(true);
                    wasAutoOpened.current = true;
                    // Persist to backend so it only auto-opens once
                    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_NOTIFICATIONS_DRAWER_AUTO_OPENED, 'true');
                };
                preloadAndOpen();
            }
        }
    }, [
        isEligibleForAutoOpen,
        isOpen
    ]);
    // Close popup when navigation occurs
    (0, $cozmU.useEffect)(()=>{
        if (isOpen && location) closeNotificationsPopup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        closeNotificationsPopup,
        location
    ]);
    (0, $cozmU.useEffect)(()=>{
        notificationLogClient.countUnseenNotifications().then((res)=>{
            setUnreadCount(res.count);
            if (res.count >= 9) createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'unseenNotificationsOver9'
                }
            }).fire();
        }).catch(()=>{});
    }, [
        createAnalyticsEvent,
        notificationLogClient
    ]);
    const NotificationsBadge = (0, $cozmU.useMemo)(()=>()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ej46P.NotificationIndicator), {
                onCountUpdated: (count)=>{
                    setUnreadCount(count.newCount);
                },
                notificationLogProvider: Promise.resolve(isCleared || isOpen ? new $a25a74f29b49c48c$var$EmptyNotificationLogClient() : notificationLogClient),
                refreshRate: $a25a74f29b49c48c$var$REFRESH_INTERVAL,
                ssrInitialValue: data?.notifications?.unseenNotificationCount
            });
        }, [
        isOpen,
        isCleared,
        notificationLogClient,
        data?.notifications?.unseenNotificationCount
    ]);
    const notificationsLabel = unreadCount <= $a25a74f29b49c48c$var$MAX_NOTIFICATION_COUNT ? intl.formatMessage($a25a74f29b49c48c$var$i18n.notifications, {
        count: unreadCount
    }) : intl.formatMessage($a25a74f29b49c48c$var$i18n.overNineNotifications);
    const shortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_NOTIFICATIONS_SHORTCUT)
    });
    return !shouldShowButton ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isOpen && hasUnsavedCommentDraft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $704173a03d8ffca7$export$94931606b6900781), {
        onConfirm: closeNotificationsPopup
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        placement: "bottom-end",
        shouldFlip: true,
        rootBoundary: "viewport",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a25a74f29b49c48c$export$bae4076b81272f49, {
                onUnsavedCommentDraft: setHasUnsavedCommentDraft,
                wasAutoOpened: wasAutoOpened.current
            }),
        isOpen: isOpen,
        onClose: handlePopupCloseEvent,
        shouldRenderToParent: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $frwle.Notifications), {
                ...triggerProps,
                badge: NotificationsBadge,
                onClick: onClick,
                isSelected: isOpen,
                label: notificationsLabel,
                shortcut: // No shortcut on edit pages
                !isLiveEditMode && !isOnEditRoute ? shortcutStrings : undefined,
                ref: (0, $4nIKB.mergeRefs)([
                    triggerProps.ref,
                    notificationsButtonRef
                ]),
                testId: "top-nav-notifications-button"
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.NOTIFICATIONS_SHORTCUT) : undefined,
        accelerator: (0, $gnkil.UNIVERSAL_NOTIFICATIONS_SHORTCUT),
        listener: onClick,
        isAppNavigationShortcut: true
    }));
};
const $a25a74f29b49c48c$var$i18n = (0, $kSwu1.defineMessages)({
    notifications: {
        id: "app-navigation.top-navigation.notifications",
        defaultMessage: "{count, plural, =0{ Notifications} one{{count, number} Notification} other{{count, number} Notifications}}"
    },
    overNineNotifications: {
        id: "app-navigation.top-navigation.notifications.over-nine-notifications",
        defaultMessage: "Over 9 Notifications"
    },
    unsavedChanges: {
        id: "app-navigation.notifications.unsaved-changes.confirm",
        defaultMessage: "Do you want to discard this comment? Your comment will be lost if you do."
    }
});
module.exports["NotificationsButton"] = $a25a74f29b49c48c$export$40e326b1271b1326;

});

parcelRegister("9WGde", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $5Wig1 = parcelRequire("5Wig1");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

function $861b0f5338c29120$export$3c417c5065f4ac35() {
    const $ = (0, $bDgLe.c)(3);
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    if (!(0, $9wGTI.fg)("post-office_enable_routing_workspace_id_prop") || !cloudId || !activationId) return;
    let t0;
    if ($[0] !== activationId || $[1] !== cloudId) {
        t0 = (0, $5Wig1.ConfluenceWorkspaceAri).create({
            siteId: cloudId,
            activationId: activationId
        }).toString();
        $[0] = activationId;
        $[1] = cloudId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
}
module.exports["useWorkspaceARI"] = $861b0f5338c29120$export$3c417c5065f4ac35;

});

parcelRegister("3RHmh", function(module, exports) {

let $2d07f46bf918525c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2d07f46bf918525c$var$load("aMsb0"),
    $2d07f46bf918525c$var$load("2PXrC"),
    $2d07f46bf918525c$var$load("aLwQm"),
    $2d07f46bf918525c$var$load("2HGoF"),
    $2d07f46bf918525c$var$load("5J2OS"),
    $2d07f46bf918525c$var$load("1f0Jg"),
    $2d07f46bf918525c$var$load("aQ52k"),
    $2d07f46bf918525c$var$load("eHgxr"),
    $2d07f46bf918525c$var$load("35Mi3"),
    $2d07f46bf918525c$var$load("fHb94"),
    $2d07f46bf918525c$var$load("llPQO"),
    $2d07f46bf918525c$var$load("hUbK8"),
    $2d07f46bf918525c$var$load("kujst"),
    $2d07f46bf918525c$var$load("bAgKB"),
    $2d07f46bf918525c$var$load("jomLJ"),
    $2d07f46bf918525c$var$load("ignwK"),
    $2d07f46bf918525c$var$load("ZJW9D"),
    $2d07f46bf918525c$var$load("agaLh"),
    $2d07f46bf918525c$var$load("1Gr4q"),
    $2d07f46bf918525c$var$load("16zlP"),
    $2d07f46bf918525c$var$load("cFGXM"),
    $2d07f46bf918525c$var$load("gGcbZ"),
    $2d07f46bf918525c$var$load("kccW9"),
    $2d07f46bf918525c$var$load("TfSzW"),
    $2d07f46bf918525c$var$load("lHEqj"),
    $2d07f46bf918525c$var$load("7G12e"),
    $2d07f46bf918525c$var$load("h4Nf7"),
    $2d07f46bf918525c$var$load("bGvBs"),
    $2d07f46bf918525c$var$load("7YvWq"),
    $2d07f46bf918525c$var$load("4XoWv"),
    $2d07f46bf918525c$var$load("59hV4"),
    $2d07f46bf918525c$var$load("2la9m"),
    $2d07f46bf918525c$var$load("9pQri"),
    $2d07f46bf918525c$var$load("hhss7"),
    $2d07f46bf918525c$var$load("3iw68"),
    $2d07f46bf918525c$var$load("agq8T"),
    $2d07f46bf918525c$var$load("8MPlE"),
    $2d07f46bf918525c$var$load("ccAQf"),
    $2d07f46bf918525c$var$load("4x9Jx"),
    $2d07f46bf918525c$var$load("kHXvF"),
    $2d07f46bf918525c$var$load("ipIDQ"),
    $2d07f46bf918525c$var$load("fuOfV"),
    $2d07f46bf918525c$var$load("jL1Ke"),
    $2d07f46bf918525c$var$load("5MQ0D"),
    $2d07f46bf918525c$var$load("cvcNg"),
    $2d07f46bf918525c$var$load("iZR3N"),
    $2d07f46bf918525c$var$load("jXM1T"),
    $2d07f46bf918525c$var$load("6wr18"),
    $2d07f46bf918525c$var$load("4N1MY"),
    $2d07f46bf918525c$var$load("ffEVr"),
    $2d07f46bf918525c$var$load("jT7h0"),
    $2d07f46bf918525c$var$load("gsQ9D"),
    $2d07f46bf918525c$var$load("fizmj"),
    $2d07f46bf918525c$var$load("1bffd"),
    $2d07f46bf918525c$var$load("bwLq7"),
    $2d07f46bf918525c$var$load("fH3TJ"),
    $2d07f46bf918525c$var$load("Wowvf"),
    $2d07f46bf918525c$var$load("2l8zo"),
    $2d07f46bf918525c$var$load("7EorR"),
    $2d07f46bf918525c$var$load("5j5Dl")
]).then(()=>parcelRequire('h4ISV'));

});

parcelRegister("eNWR0", function(module, exports) {

let $ac734b754071bd04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ac734b754071bd04$var$load("60m6Z").then(()=>parcelRequire('1FDBc'));

});

parcelRegister("5db0E", function(module, exports) {
const $9ef906c5044a6f02$export$515664faa1398f37 = 'navigation';
const $9ef906c5044a6f02$export$3cbe56a0cabcff38 = {
    source: 'atlassianAccountMenu',
    componentName: 'atlassianAccountMenu',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
module.exports["NAVIGATION_CHANNEL"] = $9ef906c5044a6f02$export$515664faa1398f37;
module.exports["ANALYTICS_CONTEXT"] = $9ef906c5044a6f02$export$3cbe56a0cabcff38;

});

parcelRegister("7T8Gs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $c9b4d597f70310f0$export$b495e6c63a3a03c1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
    id: "identity.account-menu.account-menu-logged-out-state.log-in",
    defaultMessage: "Log in"
});
module.exports["logInTooltip"] = $c9b4d597f70310f0$export$b495e6c63a3a03c1;

});

parcelRegister("3G59f", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $18f750d2e13f7214$export$2c1df3428fc3264c = (src)=>{
    const [state, setState] = (0, $cozmU.useState)('pending');
    const imgRef = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        if (!imgRef.current) {
            imgRef.current = new Image();
            imgRef.current.onload = ()=>setState('loaded');
            imgRef.current.onerror = ()=>setState('error');
        }
        setState('pending');
        imgRef.current.src = src;
    }, [
        src
    ]);
    return state;
};
module.exports["useImageState"] = $18f750d2e13f7214$export$2c1df3428fc3264c;

});

parcelRegister("5lAlH", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a73611d625129e6a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    triggerTooltip: {
        id: "identity.account-menu.account-menu-popup.skeleton.tooltip",
        defaultMessage: "Account"
    }
});
module.exports["messages"] = $a73611d625129e6a$export$defe85febe8b728c;

});

parcelRegister("dbxd9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $eq1BO = parcelRequire("eq1BO");


var $5db0E = parcelRequire("5db0E");

/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $852mP = parcelRequire("852mP");


var $9DHhW = parcelRequire("9DHhW");


var $vkiEA = parcelRequire("vkiEA");


var $fBqzD = parcelRequire("fBqzD");


var $g9ioO = parcelRequire("g9ioO");


var $11OF7 = parcelRequire("11OF7");


var $8oBbn = parcelRequire("8oBbn");

var $6IL1T = parcelRequire("6IL1T");

var $8FgJC = parcelRequire("8FgJC");


var $iDrrr = parcelRequire("iDrrr");








var $3vgx3 = parcelRequire("3vgx3");

var $is1T6 = parcelRequire("is1T6");

var $9erVg = parcelRequire("9erVg");

var $eTXLl = parcelRequire("eTXLl");


var $aDSIl = parcelRequire("aDSIl");


var $V3JOP = parcelRequire("V3JOP");


var $lEBcH = parcelRequire("lEBcH");


var $cJ0FD = parcelRequire("cJ0FD");


var $9d7Pd = parcelRequire("9d7Pd");





var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");

var $09d0b49ec6616c7e$exports = {};
$09d0b49ec6616c7e$exports = new URL("dark-mode.c2768bcf.svg", import.meta.url).toString();


var $7f91700bcae08e86$exports = {};
$7f91700bcae08e86$exports = new URL("light-mode.e7c3914f.svg", import.meta.url).toString();


var $8a91d970a855dbea$exports = {};
$8a91d970a855dbea$exports = new URL("match-browser.a2bb9bea.svg", import.meta.url).toString();


const $09f7308424c0ab1c$var$messages = (0, $kSwu1.defineMessages)({
    appDisplayMode: {
        id: "design-system.theme-switcher.app-display-mode",
        defaultMessage: "App display mode"
    },
    themeButton: {
        id: "design-system.theme-switcher.theme-button",
        defaultMessage: "Theme"
    },
    appearanceButton: {
        id: "design-system.theme-switcher.appearance-button",
        defaultMessage: "Appearance"
    },
    light: {
        id: "design-system.theme-switcher.light.option",
        defaultMessage: "Light"
    },
    dark: {
        id: "design-system.theme-switcher.dark.option",
        defaultMessage: "Dark"
    },
    matchBrowser: {
        id: "design-system.theme-switcher.match-browser.option",
        defaultMessage: "Match browser"
    },
    matchSystem: {
        id: "design-system.theme-switcher.match-system.option",
        defaultMessage: "Match system"
    },
    syncedAcrossApps: {
        id: "design-system.theme-switcher.synced-across-apps",
        defaultMessage: "Synced across apps"
    },
    personalize: {
        id: "design-system.theme-switcher.personalize",
        defaultMessage: "Customize display settings"
    },
    openInNewTab: {
        id: "design-system.theme-switcher.open-in-new-tab",
        defaultMessage: ", opens in new tab"
    }
});
const $09f7308424c0ab1c$var$themeOptions = [
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $09f7308424c0ab1c$var$messages.light),
        value: 'light',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($7f91700bcae08e86$exports)))
    },
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $09f7308424c0ab1c$var$messages.dark),
        value: 'dark',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($09d0b49ec6616c7e$exports)))
    },
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $09f7308424c0ab1c$var$messages.matchBrowser),
        value: 'auto',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($8a91d970a855dbea$exports)))
    }
];
const $09f7308424c0ab1c$var$themeOptionsAutoFirst = [
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $09f7308424c0ab1c$var$messages.matchSystem),
        value: 'auto',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($8a91d970a855dbea$exports)))
    },
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $09f7308424c0ab1c$var$messages.light),
        value: 'light',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($7f91700bcae08e86$exports)))
    },
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $09f7308424c0ab1c$var$messages.dark),
        value: 'dark',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($09d0b49ec6616c7e$exports)))
    }
];
/**
 * ThemeSwitcher is a dropdown menu component for users to select between light, dark, and auto (match browser) color mode themes.
 */ const $09f7308424c0ab1c$var$ThemeSwitcher = ({ testId: testId, onThemeChange: onThemeChange, currentColorMode: currentColorMode, accountColorMode: accountColorMode, appearancePreferencesLink: appearancePreferencesLink, onOpenChange: onOpenChange, shouldInvokeOnOpenChangeOnFocusAndMouseEnter: shouldInvokeOnOpenChangeOnFocusAndMouseEnter = true })=>{
    const intl = (0, $kSwu1.useIntl)();
    const options = (0, $iDrrr.fg)('shared-user-preferences') ? $09f7308424c0ab1c$var$themeOptionsAutoFirst : $09f7308424c0ab1c$var$themeOptions;
    const shouldInvokeOnOpenChangeOnFocusAndMouseEnterWithCallback = shouldInvokeOnOpenChangeOnFocusAndMouseEnter && Boolean(onOpenChange);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, options.map(({ value: value, thumbnail: thumbnail })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("link", {
            rel: "preload",
            href: thumbnail,
            as: "image",
            key: value
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        testId: testId,
        placement: "auto-start",
        onOpenChange: onOpenChange,
        trigger: ({ triggerRef: triggerRef, ...props })=>{
            const handleOpenChangeOnFocusOrMouseEnter = (event)=>{
                if (!shouldInvokeOnOpenChangeOnFocusAndMouseEnterWithCallback) return;
                onOpenChange?.({
                    isOpen: true,
                    event: event.nativeEvent
                });
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                onMouseEnter: handleOpenChangeOnFocusOrMouseEnter,
                onFocus: handleOpenChangeOnFocusOrMouseEnter
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                ref: triggerRef,
                onClick: (event)=>event.stopPropagation(),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lEBcH))), {
                    color: "currentColor",
                    label: ""
                }),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    color: "currentColor",
                    label: "",
                    size: "small"
                }),
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $iDrrr.fg)('shared-user-preferences') ? $09f7308424c0ab1c$var$messages.appearanceButton : $09f7308424c0ab1c$var$messages.themeButton)));
        },
        shouldRenderToParent: (0, $iDrrr.fg)('set-should-render-to-parent-to-true-theme-switcher')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), {
        title: (0, $iDrrr.fg)('shared-user-preferences') ? intl.formatMessage($09f7308424c0ab1c$var$messages.appDisplayMode) : undefined
    }, options.map(({ label: label, value: value, thumbnail: thumbnail })=>{
        const isSynced = accountColorMode !== undefined && accountColorMode === value;
        const isSelected = currentColorMode === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eTXLl.default), {
            testId: `${testId}--radio-${value}`,
            id: value,
            key: value,
            onClick: ()=>onThemeChange(value),
            isSelected: isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.150",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: thumbnail,
            width: 64,
            height: 48,
            alt: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.025"
        }, label, isSynced && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $09f7308424c0ab1c$var$messages.syncedAcrossApps)))));
    })), appearancePreferencesLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        href: appearancePreferencesLink,
        target: "_blank",
        rel: "noopener",
        testId: testId && `${testId}--personalize`,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
            color: "currentColor",
            label: intl.formatMessage($09f7308424c0ab1c$var$messages.openInNewTab),
            size: "small"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $09f7308424c0ab1c$var$messages.personalize)))));
};
var $09f7308424c0ab1c$export$2e2bcd8739ae039 = $09f7308424c0ab1c$var$ThemeSwitcher;





/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 





var $9aYkv = parcelRequire("9aYkv");










/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-disable-next-line no-restricted-imports







var $k12R1 = parcelRequire("k12R1");


var $iITVA = parcelRequire("iITVA");


var $iMnC5 = parcelRequire("iMnC5");


var $3G59f = parcelRequire("3G59f");

const $f3a1efad7b5c1103$var$styles = {
    imgContainer: "_39xV029LX5 _0jFU0V9LX5 _1tJeXf9LX5 _27VeLC9LX5 _0LETLX9LX5 _2Qxi4n9LX5",
    imgContainerSkeleton: "_0bjKvDS5Zs _0KLXruDMqu",
    img: "_0bjKvDS5Zs _3iDTPbvLZJ",
    overlayWrapper: "_1mT5xdRAKS _3iDTPbvbI6"
};
const $f3a1efad7b5c1103$export$2d75367b6e042d67 = ({ testId: testId, src: src, avatarOverlay: avatarOverlay })=>{
    const state = (0, $3G59f.useImageState)(src || '');
    const displayImage = src && state === 'loaded';
    const displayFallback = src && state === 'error';
    const displaySkeleton = !displayImage && !displayFallback;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: avatarOverlay ? $f3a1efad7b5c1103$var$styles.overlayWrapper : undefined
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: testId,
        xcss: (0, $k12R1.cx)($f3a1efad7b5c1103$var$styles.imgContainer, displaySkeleton && $f3a1efad7b5c1103$var$styles.imgContainerSkeleton)
    }, displayImage && /*#__PURE__*/ $cozmU.createElement("img", {
        "data-testid": testId && `${testId}--img`,
        src: src,
        alt: "",
        className: (0, $hekY6.default)([
            $f3a1efad7b5c1103$var$styles.img
        ])
    }), displayFallback && /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iITVA))), {
        spacing: "spacious",
        testId: testId && `${testId}--fallback`,
        label: "",
        color: "var(--ds-text-subtlest, #6B6E76)"
    })), avatarOverlay);
};


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $a9aSv = parcelRequire("a9aSv");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $763dcadd99620f16$var$SkeletonWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6",
            __cmplp.className
        ])
    });
});
const $763dcadd99620f16$export$cb6ddd830302c2a8 = ({ length: length })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($763dcadd99620f16$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: length,
        height: "1em",
        borderRadius: "var(--ds-radius-full, 9999px)"
    }));


const $c7e62d6061ac81a1$export$66e04d0aacdb3b2 = ({ testId: testId, name: name, picture: picture, email: email, managedBy: managedBy, avatarOverlay: avatarOverlay })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7e62d6061ac81a1$var$Container, {
        "data-testid": testId
    }, managedBy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7e62d6061ac81a1$var$ManagedBy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7e62d6061ac81a1$var$PersonIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g9ioO))), {
        color: "currentColor",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "identity.account-menu.account-menu-details.managed-account",
        defaultMessage: "This account is managed by <b>{managedBy}</b>",
        values: {
            b: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    as: "strong",
                    size: "small",
                    color: "inherit"
                }, text),
            managedBy: managedBy
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7e62d6061ac81a1$var$Content, {
        hasHeader: !!managedBy
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7e62d6061ac81a1$var$Profile, {
        testId: testId,
        name: name,
        picture: picture,
        email: email,
        avatarOverlay: avatarOverlay
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7e62d6061ac81a1$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _313842dnbC _0adFHs2ADO _1DCdHidnbC _2XsHFM2ADO",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7e62d6061ac81a1$var$ManagedBy = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _3iDTPbgAon _0Of8r2FQfX _1Znuxb2ADO _1wydGWFQfX _2Zuz6Q2ADO _2fwxA5DIqT _2C2kUQzXzM _1Lz9lozXzM _1v9SsVdnbC _3XDz3BdnbC _0KLXrugNg3 _1UtDYzZpcK",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7e62d6061ac81a1$var$PersonIconWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0adFHs1Y8M _1xqa3lxpxF _3mHFB0xpxF",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7e62d6061ac81a1$var$Content = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasHeader: hasHeader, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1xsu82h": (0, $9aYkv.default)(__cmplp.hasHeader ? `0 0 ${"var(--ds-radius-small, 3px)"} ${"var(--ds-radius-small, 3px)"}` : "var(--ds-radius-small, 3px)")
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDdQm0 _3iDTPbQ4SZ _0aFT5vbt8w _0KLXrunmFW",
            __cmplp.className
        ])
    });
});
const $c7e62d6061ac81a1$var$Profile = ({ name: name, email: email, picture: picture, testId: testId, avatarOverlay: avatarOverlay })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7e62d6061ac81a1$var$ProfileWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f3a1efad7b5c1103$export$2d75367b6e042d67), {
        src: picture,
        testId: testId && `${testId}--picture`,
        avatarOverlay: avatarOverlay
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7e62d6061ac81a1$var$NameAndEmail, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "large",
        weight: "bold",
        testId: testId && `${testId}--name`
    }, name || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $763dcadd99620f16$export$cb6ddd830302c2a8), {
        length: "6em"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7e62d6061ac81a1$var$EmailAddress, {
        "data-testid": testId && `${testId}--email`
    }, email || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $763dcadd99620f16$export$cb6ddd830302c2a8), {
        length: "10em"
    })))); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7e62d6061ac81a1$var$ProfileWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5v1qpb _3138425zaO _0adFHs5zaO _1DCdHi5zaO _2XsHFM5zaO",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7e62d6061ac81a1$var$NameAndEmail = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _313842IZbP _0adFHsdnbC _1DCdHiIZbP _2XsHFM5zaO",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7e62d6061ac81a1$var$EmailAddress = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842FQfX _1UtDYzKGUX _1kk5Tku7m9",
            __cmplp.className
        ])
    });
});




































var $d2dd10f5b2586683$exports = {};
$d2dd10f5b2586683$exports = new URL("dark-mode.c2768bcf.svg", import.meta.url).toString();


var $951812873daa05ea$exports = {};
$951812873daa05ea$exports = new URL("light-mode.e7c3914f.svg", import.meta.url).toString();


var $1115d39bf6e56da2$exports = {};
$1115d39bf6e56da2$exports = new URL("match-browser.a2bb9bea.svg", import.meta.url).toString();


const $98b2ba2ad8be86b0$export$9d63163ee2173b37 = ({ testId: testId, onThemeChange: onThemeChange, currentTheme: currentTheme, globalColorMode: globalColorMode, appearancePreferencesLink: appearancePreferencesLink, onThemeSwitcherOpenChange: onThemeSwitcherOpenChange })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, $98b2ba2ad8be86b0$var$themeOptions.map(({ value: value, thumbnail: thumbnail })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("link", {
            rel: "preload",
            href: thumbnail,
            as: "image",
            key: value
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        testId: testId,
        placement: "auto-start",
        onOpenChange: onThemeSwitcherOpenChange,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                ref: triggerRef,
                onClick: (event)=>event.stopPropagation(),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lEBcH))), {
                    color: "currentColor",
                    label: ""
                }),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    color: "currentColor",
                    label: "",
                    size: "small"
                }),
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "identity.account-menu.theme-switcher.theme-button",
                defaultMessage: "Theme"
            })),
        shouldRenderToParent: false
    }, $98b2ba2ad8be86b0$var$themeOptions.map(({ label: label, value: value, thumbnail: thumbnail })=>{
        const isSynced = globalColorMode !== undefined && globalColorMode === value;
        const isSelected = currentTheme === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eTXLl.default), {
            testId: `${testId}--radio-${value}`,
            id: value,
            key: value,
            onClick: ()=>onThemeChange(value),
            isSelected: isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.150",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: thumbnail,
            width: 64,
            height: 48,
            alt: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.025"
        }, label, isSynced && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $98b2ba2ad8be86b0$var$messages.syncedAcrossApps)))));
    }), appearancePreferencesLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        href: appearancePreferencesLink,
        target: "_blank",
        rel: "noopener",
        testId: testId && `${testId}--personalize`,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
            color: "currentColor",
            label: "",
            size: "small"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $98b2ba2ad8be86b0$var$messages.personalize)))));
};
const $98b2ba2ad8be86b0$var$messages = (0, $kSwu1.defineMessages)({
    light: {
        id: "identity.account-menu.theme-switcher.light.option",
        defaultMessage: "Light"
    },
    dark: {
        id: "identity.account-menu.theme-switcher.dark.option",
        defaultMessage: "Dark"
    },
    matchBrowser: {
        id: "identity.account-menu.theme-switcher.match-browser.option",
        defaultMessage: "Match browser"
    },
    syncedAcrossApps: {
        id: "identity.account-menu.theme-switcher.synced-across-apps",
        defaultMessage: "Synced across apps"
    },
    personalize: {
        id: "identity.account-menu.theme-switcher.personalize",
        defaultMessage: "Personalize"
    }
});
const $98b2ba2ad8be86b0$var$themeOptions = [
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $98b2ba2ad8be86b0$var$messages.light),
        value: 'light',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($951812873daa05ea$exports)))
    },
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $98b2ba2ad8be86b0$var$messages.dark),
        value: 'dark',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($d2dd10f5b2586683$exports)))
    },
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $98b2ba2ad8be86b0$var$messages.matchBrowser),
        value: 'auto',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($1115d39bf6e56da2$exports)))
    }
];


const $5ee192c63317f7d7$export$49c2771125e1e9f1 = ({ testId: testId, closePopup: closePopup, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, logOutLink: logOutLink, onThemeChange: onThemeChange, currentTheme: currentTheme, globalColorMode: globalColorMode, extraMenuItems: extraMenuItems = null, onLogoutClick: onLogoutClick, onThemeSwitcherOpenChange: onThemeSwitcherOpenChange, avatarOverlay: avatarOverlay })=>{
    const themeSwitcherProps = onThemeChange && currentTheme;
    const shouldRenderProfileThemeSwitcherSection = Boolean(viewProfileLink || manageProfileLink || themeSwitcherProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5ee192c63317f7d7$var$Container, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c7e62d6061ac81a1$export$66e04d0aacdb3b2), {
        testId: testId && `${testId}--details`,
        name: name,
        picture: picture,
        email: email,
        managedBy: managedBy,
        avatarOverlay: avatarOverlay
    })), shouldRenderProfileThemeSwitcherSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, viewProfileLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5ee192c63317f7d7$var$ViewProfileLink, {
        onClick: onViewProfileClick,
        testId: testId && `${testId}--view-profile`,
        href: viewProfileLink,
        closePopup: closePopup
    }), manageProfileLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5ee192c63317f7d7$var$ManageProfileLink, {
        testId: testId && `${testId}--manage-profile`,
        href: manageProfileLink,
        closePopup: closePopup
    }), themeSwitcherProps && ((0, $iDrrr.fg)('replace-account-menu-theme-switcher') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $09f7308424c0ab1c$export$2e2bcd8739ae039), {
        testId: testId && `${testId}--theme-switcher`,
        onThemeChange: onThemeChange,
        currentColorMode: currentTheme,
        accountColorMode: globalColorMode ?? undefined,
        onOpenChange: onThemeSwitcherOpenChange,
        appearancePreferencesLink: globalColorMode !== undefined ? manageProfileLink?.replace(/(%2F|\/)manage-profile[^&]*/g, '$1manage-profile$1appearance-preferences') : undefined
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $98b2ba2ad8be86b0$export$9d63163ee2173b37), {
        testId: testId && `${testId}--theme-switcher`,
        onThemeChange: onThemeChange,
        currentTheme: currentTheme,
        globalColorMode: globalColorMode,
        onThemeSwitcherOpenChange: onThemeSwitcherOpenChange,
        appearancePreferencesLink: globalColorMode !== undefined ? manageProfileLink?.replace(/(%2F|\/)manage-profile[^&]*/g, '$1manage-profile$1appearance-preferences') : undefined
    }))), extraMenuItems, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
        hasSeparator: shouldRenderProfileThemeSwitcherSection
    }, switchAccountLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5ee192c63317f7d7$var$SwitchAccountLink, {
        testId: testId && `${testId}--switch-account`,
        href: switchAccountLink,
        closePopup: closePopup
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5ee192c63317f7d7$var$LogOutLink, {
        testId: testId && `${testId}--log-out`,
        href: logOutLink,
        closePopup: closePopup,
        onClick: onLogoutClick
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5ee192c63317f7d7$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_24h04i2Njc _4ouGXIAef5",
            __cmplp.className
        ])
    });
});
const $5ee192c63317f7d7$var$ViewProfileLink = ({ testId: testId, href: href, onClick: onClick, closePopup: closePopup })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5ee192c63317f7d7$var$Link, {
        testId: testId,
        href: href,
        onClick: onClick,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g9ioO))), {
            color: "currentColor",
            label: ""
        }),
        closePopup: closePopup,
        actionSubjectId: "viewProfileLink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "identity.account-menu.account-details.view-profile-tooltip",
        defaultMessage: "Profile"
    }));
const $5ee192c63317f7d7$var$ManageProfileLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5ee192c63317f7d7$var$Link, {
        testId: testId,
        href: href,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($11OF7))), {
            color: "currentColor",
            label: ""
        }),
        closePopup: closePopup,
        actionSubjectId: "manageProfileLink",
        target: "_blank",
        rel: "noopener"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "identity.account-menu.account-details.manage-profile-link",
        defaultMessage: "Account settings"
    }));
const $5ee192c63317f7d7$var$SwitchAccountLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5ee192c63317f7d7$var$Link, {
        testId: testId,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
            color: "currentColor",
            label: ""
        }),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "switchAccountLink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "identity.account-menu.account-menu-content.switch-account-button",
        defaultMessage: "Switch account"
    }));
const $5ee192c63317f7d7$var$LogOutLink = ({ testId: testId, href: href, closePopup: closePopup, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5ee192c63317f7d7$var$Link, {
        testId: testId,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($vkiEA))), {
            color: "currentColor",
            label: ""
        }),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "logOutLink",
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "identity.account-menu.account-menu-content.log-out-button",
        defaultMessage: "Log out"
    }));
const $5ee192c63317f7d7$var$Link = ({ testId: testId, closePopup: closePopup, icon: icon, href: href, onClick: onClick, actionSubjectId: actionSubjectId, children: children, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleClick = (0, $cozmU.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            eventType: (0, $852mP.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'menuLinkItem',
            actionSubjectId: actionSubjectId
        });
        const clone = analyticsEvent.clone();
        if (clone) clone.fire((0, $5db0E.NAVIGATION_CHANNEL));
        onClick?.(event, analyticsEvent);
        closePopup?.(event);
    }, [
        createAnalyticsEvent,
        onClick,
        closePopup,
        actionSubjectId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
        testId: testId,
        iconBefore: icon,
        href: href,
        onClick: handleClick,
        ...props
    }, children);
};








/**
 * NOTE:
 *
 * This file is automatically generated by scripts/generate-i18n-index.ts.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index.
 */ 










































const $576d72b1bec33934$var$lazyMessages = {
    cs: ()=>(parcelRequire("iHuz6")),
    cs_CZ: ()=>(parcelRequire("5aQBk")),
    da: ()=>(parcelRequire("g7MKQ")),
    da_DK: ()=>(parcelRequire("24Sff")),
    de: ()=>(parcelRequire("5nPBN")),
    de_DE: ()=>(parcelRequire("edcjn")),
    en_GB: ()=>(parcelRequire("gBJMt")),
    en_ZZ: ()=>(parcelRequire("1cHrp")),
    es: ()=>(parcelRequire("a7rUd")),
    fi: ()=>(parcelRequire("Lh4pj")),
    fi_FI: ()=>(parcelRequire("keF9N")),
    fr: ()=>(parcelRequire("fUxP5")),
    fr_FR: ()=>(parcelRequire("avlJC")),
    hu: ()=>(parcelRequire("kboxG")),
    hu_HU: ()=>(parcelRequire("fw4r6")),
    it: ()=>(parcelRequire("6kJ2c")),
    it_IT: ()=>(parcelRequire("aom5B")),
    ja: ()=>(parcelRequire("1ZEWC")),
    ja_JP: ()=>(parcelRequire("5DU26")),
    ko: ()=>(parcelRequire("hkJN7")),
    ko_KR: ()=>(parcelRequire("9LzS2")),
    nb: ()=>(parcelRequire("dCwOA")),
    nb_NO: ()=>(parcelRequire("aPKp1")),
    nl: ()=>(parcelRequire("hGmtY")),
    nl_NL: ()=>(parcelRequire("49RQE")),
    pl: ()=>(parcelRequire("9ES79")),
    pl_PL: ()=>(parcelRequire("2tkrO")),
    pt_BR: ()=>(parcelRequire("9z64K")),
    ru: ()=>(parcelRequire("hT6n0")),
    ru_RU: ()=>(parcelRequire("fU6zb")),
    sv: ()=>(parcelRequire("aneWy")),
    sv_SE: ()=>(parcelRequire("eEV1D")),
    th: ()=>(parcelRequire("eWA9V")),
    th_TH: ()=>(parcelRequire("7QeSA")),
    tr: ()=>(parcelRequire("dTvjE")),
    tr_TR: ()=>(parcelRequire("1xU2G")),
    uk: ()=>(parcelRequire("aoJsk")),
    uk_UA: ()=>(parcelRequire("6WQ9y")),
    vi: ()=>(parcelRequire("6H0iL")),
    vi_VN: ()=>(parcelRequire("gdCdk")),
    zh: ()=>(parcelRequire("1wUXh")),
    zh_CN: ()=>(parcelRequire("j0Xol")),
    zh_TW: ()=>(parcelRequire("kunpY"))
};
var $576d72b1bec33934$export$2e2bcd8739ae039 = $576d72b1bec33934$var$lazyMessages;



var $1P2f3 = parcelRequire("1P2f3");

const $29bb7ee4df329290$export$6c1f1571e3dd1b34 = ({ children: children })=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const messages = $29bb7ee4df329290$var$useMessages(locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: locale,
        messages: messages,
        onError: (err)=>{
            // Do not spam local devloop with missing translation errors
            //
            // See: https://github.com/formatjs/formatjs/issues/465#issuecomment-643887472
            // Note the default error handler: https://github.com/formatjs/formatjs/blob/d0b80fd9a814d1427b73577aebb7ccdb80b9ae94/packages/intl/src/utils.ts#L43
            if ($1P2f3?.env?.NODE_ENV !== 'production' && err?.code !== 'MISSING_TRANSLATION') // eslint-disable-next-line no-console
            console.error(err);
        }
    }, children);
};
const $29bb7ee4df329290$var$useMessages = (locale)=>{
    const [messages, setMessages] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        if (/^en(-US)?$/i.exec(locale)) // Use fallback messages, which are already US English
        setMessages(undefined);
        else {
            let cancelled = false;
            $29bb7ee4df329290$var$loadMessages(locale).catch((_error)=>undefined) // TODO: Log error somehow (analytics?)
            .then((messages)=>{
                if (!cancelled) setMessages(messages);
            });
            return ()=>{
                cancelled = true;
            };
        }
    }, [
        locale,
        setMessages
    ]);
    return messages;
};
const $29bb7ee4df329290$var$loadMessages = async (locale)=>{
    let [language, region = ''] = locale.split('-', 2);
    language = language.toLowerCase();
    region = region.toUpperCase();
    return (await ((0, $576d72b1bec33934$export$2e2bcd8739ae039)[`${language}_${region}`] || (0, $576d72b1bec33934$export$2e2bcd8739ae039)[language])?.())?.default;
};









var $ggg0l = parcelRequire("ggg0l");


var $5wHqn = parcelRequire("5wHqn");




const $840da3a49b97df62$export$473cb05bf335b0e1 = ({ testId: testId, picture: picture, email: email, content: content, trustPicture: trustPicture = false, AccountMenuTrigger: AccountMenuTrigger })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const close = (0, $ggg0l.useCallbackWithAnalytics)(()=>setIsOpen(false), {
        eventType: (0, $852mP.UI_EVENT_TYPE),
        action: 'closed',
        actionSubject: 'popup',
        actionSubjectId: 'accountMenu'
    }, (0, $5db0E.NAVIGATION_CHANNEL));
    const open = (0, $ggg0l.useCallbackWithAnalytics)(()=>setIsOpen(true), {
        eventType: (0, $852mP.UI_EVENT_TYPE),
        action: 'opened',
        actionSubject: 'popup',
        actionSubjectId: 'accountMenu'
    }, (0, $5db0E.NAVIGATION_CHANNEL));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        isOpen: isOpen,
        onClose: close,
        testId: testId,
        placement: "bottom",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AccountMenuTrigger, {
                onClick: isOpen ? close : open,
                testId: testId && `${testId}--trigger`,
                picture: picture,
                email: email,
                trustPicture: trustPicture,
                ...triggerProps
            }),
        content: content
    });
};


const $695698fab0fa3a68$export$ff20d75d5eda4388 = ({ testId: testId, globalColorMode: globalColorMode, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, logOutLink: logOutLink, logInLink: logInLink, onThemeChange: onThemeChange, currentTheme: currentTheme, extraMenuItems: extraMenuItems, trustPicture: trustPicture = false, onLogoutClick: onLogoutClick, onThemeSwitcherOpenChange: onThemeSwitcherOpenChange, avatarOverlay: avatarOverlay, AccountMenuLoggedOutState: AccountMenuLoggedOutState, AccountMenuTrigger: AccountMenuTrigger })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eq1BO.NavigationAnalyticsContext), {
        data: (0, $5db0E.ANALYTICS_CONTEXT)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $29bb7ee4df329290$export$6c1f1571e3dd1b34), null, logInLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AccountMenuLoggedOutState, {
        testId: testId && `${testId}--logged-out-state`,
        logInLink: logInLink
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $840da3a49b97df62$export$473cb05bf335b0e1), {
        testId: testId,
        picture: picture,
        trustPicture: trustPicture,
        email: email,
        AccountMenuTrigger: AccountMenuTrigger,
        content: ({ onClose: closePopup })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ee192c63317f7d7$export$49c2771125e1e9f1), {
                testId: testId && `${testId}--content`,
                closePopup: closePopup,
                globalColorMode: globalColorMode,
                name: name,
                picture: picture,
                email: email,
                managedBy: managedBy,
                manageProfileLink: manageProfileLink,
                viewProfileLink: viewProfileLink,
                onViewProfileClick: onViewProfileClick,
                switchAccountLink: switchAccountLink,
                logOutLink: logOutLink,
                onThemeChange: onThemeChange,
                currentTheme: currentTheme,
                extraMenuItems: extraMenuItems,
                onLogoutClick: onLogoutClick,
                onThemeSwitcherOpenChange: onThemeSwitcherOpenChange,
                avatarOverlay: avatarOverlay
            })
    })));
module.exports["AccountMenu"] = $695698fab0fa3a68$export$ff20d75d5eda4388;

});

parcelRegister("iHuz6", function(module, exports) {

let $d9d3f3bc566deb8d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d9d3f3bc566deb8d$var$load("1zsjI").then(()=>parcelRequire('gCnxE'));

});

parcelRegister("5aQBk", function(module, exports) {

let $3c46b061bde42dbf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c46b061bde42dbf$var$load("cTmwI").then(()=>parcelRequire('6BxAb'));

});

parcelRegister("g7MKQ", function(module, exports) {

let $bbd31e70b6c61a75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bbd31e70b6c61a75$var$load("6jNfV").then(()=>parcelRequire('d4D3v'));

});

parcelRegister("24Sff", function(module, exports) {

let $18360865455c30c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $18360865455c30c6$var$load("6zaIg").then(()=>parcelRequire('2MGGk'));

});

parcelRegister("5nPBN", function(module, exports) {

let $3eb7221e3b1c00ca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3eb7221e3b1c00ca$var$load("fpNCY").then(()=>parcelRequire('ceiW7'));

});

parcelRegister("edcjn", function(module, exports) {

let $a58bd4694857fcb0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a58bd4694857fcb0$var$load("aA2zw").then(()=>parcelRequire('dMpao'));

});

parcelRegister("gBJMt", function(module, exports) {

let $c1739d2ff25b6de7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c1739d2ff25b6de7$var$load("b88LO").then(()=>parcelRequire('8qHkO'));

});

parcelRegister("1cHrp", function(module, exports) {

let $0e089bea0c35bd1e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0e089bea0c35bd1e$var$load("j3BEH").then(()=>parcelRequire('bwIlD'));

});

parcelRegister("a7rUd", function(module, exports) {

let $75e03451ab119b73$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $75e03451ab119b73$var$load("5zVFV").then(()=>parcelRequire('ldSk4'));

});

parcelRegister("Lh4pj", function(module, exports) {

let $08e1a1aa0e7901be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $08e1a1aa0e7901be$var$load("cnoKZ").then(()=>parcelRequire('ghGhf'));

});

parcelRegister("keF9N", function(module, exports) {

let $ebb50a642fde0766$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ebb50a642fde0766$var$load("9oxti").then(()=>parcelRequire('d0Hnw'));

});

parcelRegister("fUxP5", function(module, exports) {

let $b9565283cc8bfab2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9565283cc8bfab2$var$load("nB3c8").then(()=>parcelRequire('2r0V8'));

});

parcelRegister("avlJC", function(module, exports) {

let $7a5da8afb9ab3be4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a5da8afb9ab3be4$var$load("jmOjY").then(()=>parcelRequire('g4Lya'));

});

parcelRegister("kboxG", function(module, exports) {

let $eb17df50cb6b6574$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eb17df50cb6b6574$var$load("bN8CF").then(()=>parcelRequire('gOmY9'));

});

parcelRegister("fw4r6", function(module, exports) {

let $b4bd4919b64344c0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b4bd4919b64344c0$var$load("lJxeZ").then(()=>parcelRequire('VfW7D'));

});

parcelRegister("6kJ2c", function(module, exports) {

let $49c78b44b3bf82d5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49c78b44b3bf82d5$var$load("37KnO").then(()=>parcelRequire('JKnrs'));

});

parcelRegister("aom5B", function(module, exports) {

let $790d47c8078a42c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $790d47c8078a42c2$var$load("5MR8f").then(()=>parcelRequire('47VRo'));

});

parcelRegister("1ZEWC", function(module, exports) {

let $173b3fa69f62283c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $173b3fa69f62283c$var$load("ejLls").then(()=>parcelRequire('4BOOh'));

});

parcelRegister("5DU26", function(module, exports) {

let $41bc0f38115a0099$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $41bc0f38115a0099$var$load("aSjwh").then(()=>parcelRequire('2VSoe'));

});

parcelRegister("hkJN7", function(module, exports) {

let $c9e7d31fa9039e78$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c9e7d31fa9039e78$var$load("igU7g").then(()=>parcelRequire('9Uf79'));

});

parcelRegister("9LzS2", function(module, exports) {

let $71c453f864bd6ea2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $71c453f864bd6ea2$var$load("eqkVn").then(()=>parcelRequire('dbAei'));

});

parcelRegister("dCwOA", function(module, exports) {

let $9ea847518a3992f2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9ea847518a3992f2$var$load("lqIb9").then(()=>parcelRequire('emEfa'));

});

parcelRegister("aPKp1", function(module, exports) {

let $7e32a9668a09d956$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7e32a9668a09d956$var$load("4zPI6").then(()=>parcelRequire('fU7id'));

});

parcelRegister("hGmtY", function(module, exports) {

let $cdf7cc7a2086fc65$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cdf7cc7a2086fc65$var$load("fG8fT").then(()=>parcelRequire('aLhne'));

});

parcelRegister("49RQE", function(module, exports) {

let $3071c5d39aac6de3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3071c5d39aac6de3$var$load("bgyOm").then(()=>parcelRequire('1oNYr'));

});

parcelRegister("9ES79", function(module, exports) {

let $7081d373579b2942$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7081d373579b2942$var$load("if6rA").then(()=>parcelRequire('4KyAJ'));

});

parcelRegister("2tkrO", function(module, exports) {

let $1cce26aad7f243f5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1cce26aad7f243f5$var$load("b02IN").then(()=>parcelRequire('kmyZQ'));

});

parcelRegister("9z64K", function(module, exports) {

let $6f6c186d7d598cad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6f6c186d7d598cad$var$load("7gNSn").then(()=>parcelRequire('cYkWd'));

});

parcelRegister("hT6n0", function(module, exports) {

let $d05c83b2ddca479e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d05c83b2ddca479e$var$load("l0SiR").then(()=>parcelRequire('k0nbT'));

});

parcelRegister("fU6zb", function(module, exports) {

let $b9412dec4e36e367$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9412dec4e36e367$var$load("gJIJo").then(()=>parcelRequire('7pX0M'));

});

parcelRegister("aneWy", function(module, exports) {

let $78d7a4cd06d7e455$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78d7a4cd06d7e455$var$load("aVzv3").then(()=>parcelRequire('inTEf'));

});

parcelRegister("eEV1D", function(module, exports) {

let $aac109279d3b6133$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aac109279d3b6133$var$load("9Nzt7").then(()=>parcelRequire('9D1jg'));

});

parcelRegister("eWA9V", function(module, exports) {

let $ae1287e2fced3660$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae1287e2fced3660$var$load("FASsj").then(()=>parcelRequire('00P6x'));

});

parcelRegister("7QeSA", function(module, exports) {

let $5b58ee78b6e33028$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5b58ee78b6e33028$var$load("herio").then(()=>parcelRequire('hA8sT'));

});

parcelRegister("dTvjE", function(module, exports) {

let $a1d8b41ab18e0a8e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a1d8b41ab18e0a8e$var$load("aAOsH").then(()=>parcelRequire('cdlXm'));

});

parcelRegister("1xU2G", function(module, exports) {

let $1204585b4590c15d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1204585b4590c15d$var$load("3c0Wp").then(()=>parcelRequire('cD20O'));

});

parcelRegister("aoJsk", function(module, exports) {

let $791f67df18c38d5c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $791f67df18c38d5c$var$load("fNENT").then(()=>parcelRequire('4y6Hf'));

});

parcelRegister("6WQ9y", function(module, exports) {

let $50f09d636852849e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $50f09d636852849e$var$load("7WSSr").then(()=>parcelRequire('hX0bW'));

});

parcelRegister("6H0iL", function(module, exports) {

let $4df6fe2303b92a68$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4df6fe2303b92a68$var$load("5fibI").then(()=>parcelRequire('hUygt'));

});

parcelRegister("gdCdk", function(module, exports) {

let $bceb80b825e8b4a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bceb80b825e8b4a4$var$load("k8FLU").then(()=>parcelRequire('hOMzj'));

});

parcelRegister("1wUXh", function(module, exports) {

let $11d4f5aea1f5bac7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11d4f5aea1f5bac7$var$load("cXwYn").then(()=>parcelRequire('5Xf2k'));

});

parcelRegister("j0Xol", function(module, exports) {

let $dd7c165ad00684a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dd7c165ad00684a6$var$load("VOgq2").then(()=>parcelRequire('cIM4J'));

});

parcelRegister("kunpY", function(module, exports) {

let $eea8c6507d0b8a47$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eea8c6507d0b8a47$var$load("kp4QU").then(()=>parcelRequire('9LcQc'));

});

parcelRegister("ictHB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jIrdU = parcelRequire("jIrdU");


var $9wGTI = parcelRequire("9wGTI");


var $l7ck4 = parcelRequire("l7ck4");

/**
 * @generated SignedSource<<fedd97b19456c1ddeae0762b7ab60e18>>
 * @relayHash b8a2613526e645f6a3643b08f3e887dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 547ca1ad44eb417eb914e8fef9e36525294b63c74b4061a09d60cd80efbd14cb
const $a6d17ba774a599ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                }
            ],
            "concreteType": "SettingsUserPreferences",
            "kind": "LinkedField",
            "name": "settings_userPreferencesGlobal",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "theme"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GlobalThemePreferenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GlobalThemePreferenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "b8a2613526e645f6a3643b08f3e887dd",
            "id": "547ca1ad44eb417eb914e8fef9e36525294b63c74b4061a09d60cd80efbd14cb",
            "metadata": {},
            "name": "GlobalThemePreferenceQuery",
            "operationKind": "query",
            "text": "query GlobalThemePreferenceQuery($accountId:ID!){settings_userPreferencesGlobal(accountId:$accountId){theme}}"
        }
    };
}();
$a6d17ba774a599ae$var$node.hash = "c8d4cb97c65faed29a84ec972a289552";
var $a6d17ba774a599ae$export$2e2bcd8739ae039 = $a6d17ba774a599ae$var$node;



var $c0rhi = parcelRequire("c0rhi");

const $15802750adf7cbc3$var$DEFAULT_COLOR_MODE = 'auto';
const $15802750adf7cbc3$export$812fe4c912218d94 = async (accountId)=>{
    // Return undefined if no account ID
    if (!accountId) return undefined;
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $a6d17ba774a599ae$export$2e2bcd8739ae039),
            interopApolloAggClient: true,
            variables: {
                accountId: accountId
            },
            fetchPolicy: 'cache-first',
            __callerPackage__: "theming"
        });
        const themeString = data?.settings_userPreferencesGlobal?.theme;
        if (themeString) {
            const themeObject = (0, $jIrdU.themeStringToObject)(themeString);
            return {
                colorMode: themeObject.colorMode || $15802750adf7cbc3$var$DEFAULT_COLOR_MODE
            };
        } else // Data loaded but no theme string
        return {
            colorMode: $15802750adf7cbc3$var$DEFAULT_COLOR_MODE
        };
    } catch (error) {
        // Report query errors to analytics
        (0, $l7ck4.reportThemingError)((0, $l7ck4.ErrorSubjects).useGlobalColorMode, (0, $l7ck4.ErrorSubjectIds).apolloQueryErrors, {
            accountId: accountId,
            error: error.message,
            errorName: error.name
        });
        return {
            colorMode: $15802750adf7cbc3$var$DEFAULT_COLOR_MODE
        };
    }
};
const $15802750adf7cbc3$export$b766b4e8fd5a2dbe = (accountId)=>{
    const [colorMode, setColorMode] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useEffect)(()=>{
        // Skip if feature flag is disabled or no account ID
        if (!(0, $9wGTI.fg)('shared-user-preferences') || !accountId) return;
        // Use the extracted fetch function
        $15802750adf7cbc3$export$812fe4c912218d94(accountId).then((theme)=>{
            if (theme?.colorMode) setColorMode(theme.colorMode);
            else setColorMode($15802750adf7cbc3$var$DEFAULT_COLOR_MODE);
        }).catch((error)=>{
            // This shouldn't happen as fetchGlobalColorMode handles errors internally,
            // but handle it just in case
            (0, $l7ck4.reportThemingError)((0, $l7ck4.ErrorSubjects).useGlobalColorMode, (0, $l7ck4.ErrorSubjectIds).apolloQueryErrors, {
                accountId: accountId,
                error: error.message,
                errorName: error.name
            });
            setColorMode($15802750adf7cbc3$var$DEFAULT_COLOR_MODE);
        });
    }, [
        accountId
    ]);
    // Return undefined if feature flag is disabled
    return (0, $9wGTI.fg)('shared-user-preferences') ? colorMode : undefined;
};
module.exports["fetchGlobalColorMode"] = $15802750adf7cbc3$export$812fe4c912218d94;

});

parcelRegister("2YyKb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<8fedf5c8c0c9b25abb7dc266c3e5a7ec>>
 * @relayHash de15b354a95e769123fe60dd15a7f8cc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c25b80273fbbe1163657875e0d88e9dc3cbe805468bd71ed9c234670648be2d1
const $38913773163b2879$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                }
            ],
            "concreteType": "SettingsUserPreferences",
            "kind": "LinkedField",
            "name": "settings_userPreferencesGlobal",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "theme"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "globalThemeManagementGetPreferenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "globalThemeManagementGetPreferenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "c25b80273fbbe1163657875e0d88e9dc3cbe805468bd71ed9c234670648be2d1",
            "metadata": {},
            "name": "globalThemeManagementGetPreferenceQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$38913773163b2879$var$node.hash = "82db627aaf32cacee0220d3e6d6a9c59";
var $38913773163b2879$export$2e2bcd8739ae039 = $38913773163b2879$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $2YXPz = parcelRequire("2YXPz");


var $jIrdU = parcelRequire("jIrdU");




const $b2807eed83a69142$export$bc77b52491b156d8 = (themeString)=>(0, $2YXPz.updateThemeObjectWithDefaultValues)((0, $jIrdU.themeStringToObject)(themeString));


const $e6172371ce6ed97e$export$9bf52df5fffb920b = async (relayEnvironment, accountId)=>{
    if (!(0, $iDrrr.fg)('shared-user-preferences') || !accountId) return undefined;
    const response = await (0, $6SsN4.fetchQuery)(relayEnvironment, (0, $38913773163b2879$export$2e2bcd8739ae039), {
        accountId: accountId
    }).toPromise();
    const themeString = response?.settings_userPreferencesGlobal?.theme;
    if (themeString === null || themeString === undefined) return undefined;
    return (0, $b2807eed83a69142$export$bc77b52491b156d8)(themeString);
};
const $e6172371ce6ed97e$export$abf86ee3fd8175bb = (loadGlobalTheme, accountId)=>{
    // null value is needed to indicate that the color mode has not been loaded yet - this way the theme switcher should render the appearancePreferencesLink.
    const [colorMode, setColorMode] = (0, $cozmU.useState)(null);
    const hasLoaded = (0, $cozmU.useRef)(false);
    const loadOnce = (0, $cozmU.useCallback)(async ({ isOpen: isOpen })=>{
        if (isOpen && !hasLoaded.current) {
            hasLoaded.current = true;
            try {
                const theme = await loadGlobalTheme();
                if (theme !== undefined && theme !== null) {
                    const themeWithDefaults = (0, $2YXPz.updateThemeObjectWithDefaultValues)(theme);
                    setColorMode(themeWithDefaults.colorMode ?? null); // colorMode should be always set after updateThemeObjectWithDefaultValues, ?? null here is for the type safety
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Failed to load theme preference:', error);
            }
        }
    }, [
        loadGlobalTheme
    ]);
    // Return early if feature flag is disabled or accountId is null/undefined (after all hooks are called)
    if (!(0, $iDrrr.fg)('shared-user-preferences') || !accountId) return [
        undefined,
        undefined
    ];
    return [
        colorMode,
        loadOnce
    ];
};
const $e6172371ce6ed97e$export$7e4f60ea87c9d425 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (relayEnvironment, accountId)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== accountId || $[1] !== relayEnvironment) {
        t0 = ()=>$e6172371ce6ed97e$export$9bf52df5fffb920b(relayEnvironment, accountId);
        $[0] = accountId;
        $[1] = relayEnvironment;
        $[2] = t0;
    } else t0 = $[2];
    const loadGlobalTheme = t0;
    return $e6172371ce6ed97e$export$abf86ee3fd8175bb(loadGlobalTheme, accountId);
} : (relayEnvironment, accountId)=>{
    const loadGlobalTheme = (0, $cozmU.useCallback)(()=>$e6172371ce6ed97e$export$9bf52df5fffb920b(relayEnvironment, accountId), [
        relayEnvironment,
        accountId
    ]);
    return $e6172371ce6ed97e$export$abf86ee3fd8175bb(loadGlobalTheme, accountId);
};
const $e6172371ce6ed97e$export$84de5a44b184e0f1 = $e6172371ce6ed97e$export$abf86ee3fd8175bb;
module.exports["useColorModeState"] = $e6172371ce6ed97e$export$84de5a44b184e0f1;

});

parcelRegister("3yPEN", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hPGQU = parcelRequire("hPGQU");


var $9DHhW = parcelRequire("9DHhW");


var $c8bwf = parcelRequire("c8bwf");


var $56QzY = parcelRequire("56QzY");


var $dPJCf = parcelRequire("dPJCf");


var $jlIaF = parcelRequire("jlIaF");

const $bb152153185cb6ba$var$LOGIN_URL = typeof window !== 'undefined' ? `${0, $jlIaF.CONTEXT_PATH}/login.action?os_destination=${window.location.pathname.replace((0, $jlIaF.CONTEXT_PATH), '')}` : '';
const $bb152153185cb6ba$export$b78a3abd8101bea6 = ()=>{
    const $ = (0, $bDgLe.c)(7);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== push || $[2] !== routeDataRef) {
        t0 = (e)=>{
            if (e.metaKey) window.open($bb152153185cb6ba$var$LOGIN_URL, "_blank", "noreferrer");
            else push($bb152153185cb6ba$var$LOGIN_URL);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "globalNavigation",
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "login",
                    attributes: {
                        selectedItemPageContext: routeDataRef.current?.routeName,
                        navigationLayer: "global",
                        navVersion: "4",
                        navdexPointType: (0, $56QzY.START_TOUCH)
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = push;
        $[2] = routeDataRef;
        $[3] = t0;
    } else t0 = $[3];
    const onClick = t0;
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bb152153185cb6ba$var$i18n.login);
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== onClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8bwf.EndItem), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hPGQU))),
            onClick: onClick,
            label: t1
        });
        $[5] = onClick;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
const $bb152153185cb6ba$var$i18n = (0, $kSwu1.defineMessages)({
    login: {
        id: "app-navigation.top-navigation.login",
        defaultMessage: "Log in"
    }
});
module.exports["LoginButton"] = $bb152153185cb6ba$export$b78a3abd8101bea6;

});

parcelRegister("eDVeb", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $4Ucqd = parcelRequire("4Ucqd");


var $gtMdU = parcelRequire("gtMdU");

















var $1lt9F = parcelRequire("1lt9F");


var $bdD4k = parcelRequire("bdD4k");


var $6k4Fw = parcelRequire("6k4Fw");


var $aqHiZ = parcelRequire("aqHiZ");


var $6YETc = parcelRequire("6YETc");


var $1h7wg = parcelRequire("1h7wg");


var $l4LD3 = parcelRequire("l4LD3");


var $dbFea = parcelRequire("dbFea");


var $e9sgo = parcelRequire("e9sgo");

const $67ac91087161083f$export$ed08cb5579938462 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { advancedSearchUrl: advancedSearchUrl, placeholder: placeholder, customScriptDataAttributes: customScriptDataAttributes, shouldFillContainer: shouldFillContainer } = t0;
    const theme = (0, $e9sgo.useTheme)();
    let t1;
    if ($[0] !== theme) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aqHiZ.SSRmobileSearchIconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l4LD3.SearchIcon), {
            theme: theme,
            isExpanded: false
        }));
        $[0] = theme;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== theme) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6k4Fw.SSRdesktopSearchIconWrapper), {
            id: "ssr-search-icon-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l4LD3.SearchIcon), {
            theme: theme,
            isExpanded: false
        }));
        $[2] = theme;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== placeholder) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1lt9F.SSRsearchInputField), {
            id: "ssr-search-input",
            name: "text",
            placeholder: placeholder,
            autoComplete: "off",
            "aria-label": placeholder
        });
        $[4] = placeholder;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== shouldFillContainer || $[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bdD4k.SSRsearchInputContainer), {
            shouldFillContainer: shouldFillContainer,
            id: "ssr-input-container",
            role: "search"
        }, t1, t2, t3);
        $[6] = shouldFillContainer;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            __html: (0, $dbFea.script)
        };
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== customScriptDataAttributes) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", {
            "data-test-id": "ssr-scripts-init",
            dangerouslySetInnerHTML: t5,
            ...customScriptDataAttributes
        });
        $[12] = customScriptDataAttributes;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== advancedSearchUrl || $[15] !== t4 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            id: "ssr-search-input-popout-container",
            "data-ssr-placeholder": "search-input"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6YETc.SSRformContainer), {
            id: "ssr-form-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", {
            method: "get",
            action: advancedSearchUrl
        }, t4, t6)));
        $[14] = advancedSearchUrl;
        $[15] = t4;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== shouldFillContainer || $[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1h7wg.SSRsearchInputWrapper), {
            shouldFillContainer: shouldFillContainer
        }, t7);
        $[18] = shouldFillContainer;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ advancedSearchUrl: advancedSearchUrl, placeholder: placeholder, customScriptDataAttributes: customScriptDataAttributes, shouldFillContainer: shouldFillContainer })=>{
    const theme = (0, $e9sgo.useTheme)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1h7wg.SSRsearchInputWrapper), {
        shouldFillContainer: shouldFillContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: "ssr-search-input-popout-container",
        "data-ssr-placeholder": "search-input"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6YETc.SSRformContainer), {
        id: "ssr-form-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", {
        method: "get",
        action: advancedSearchUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bdD4k.SSRsearchInputContainer), {
        shouldFillContainer: shouldFillContainer,
        id: "ssr-input-container",
        role: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aqHiZ.SSRmobileSearchIconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l4LD3.SearchIcon), {
        theme: theme,
        isExpanded: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6k4Fw.SSRdesktopSearchIconWrapper), {
        id: "ssr-search-icon-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l4LD3.SearchIcon), {
        theme: theme,
        isExpanded: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1lt9F.SSRsearchInputField), {
        id: "ssr-search-input",
        name: "text",
        placeholder: placeholder,
        autoComplete: "off",
        "aria-label": placeholder
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", {
        "data-test-id": "ssr-scripts-init",
        dangerouslySetInnerHTML: {
            __html: (0, $dbFea.script)
        },
        ...customScriptDataAttributes
    })))));
};





const $73ee2b9bd33fd3e6$export$fa4a5af93371d2d1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67ac91087161083f$export$ed08cb5579938462), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.theme || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e9sgo.ThemeProvider), {
            partialSearchCSS: props.theme
        }, t0);
        $[2] = props.theme;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e9sgo.ThemeProvider), {
        partialSearchCSS: props.theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67ac91087161083f$export$ed08cb5579938462), props));
};



var $5bPOK = parcelRequire("5bPOK");





var $j1oLb = parcelRequire("j1oLb");


var $jmjWc = parcelRequire("jmjWc");


var $dPJCf = parcelRequire("dPJCf");


var $jlIaF = parcelRequire("jlIaF");


var $kysoj = parcelRequire("kysoj");

const $fdb2500e60d25720$export$8f0d616c2469c6b6 = ()=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const inputRef = (0, $cozmU.useRef)(null);
    const [customPlaceholder] = (0, $cozmU.useState)(()=>(0, $kysoj.getPersistedGhostText)(inputRef));
    const onEnter = (0, $cozmU.useCallback)((e)=>{
        const input = e.target;
        input.blur();
        push(`${(0, $jlIaF.CONTEXT_PATH)}/search/?text=${input.value}`);
    }, [
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j1oLb.QuickFindSkeleton), {
        onEnter: onEnter,
        isNav4Enabled: true,
        customPlaceholder: customPlaceholder,
        inputRef: inputRef
    });
};

const $fdb2500e60d25720$export$96939788a99e8cd1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CSp8g",
    name: "QuickFindAsync",
    loader: async ()=>(await (parcelRequire("Mb4xU"))).QuickFind,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fdb2500e60d25720$export$8f0d616c2469c6b6, null)
});









var $e4o8D = parcelRequire("e4o8D");


const $eb2a5d9806ae71d8$var$NavigationSearchDialogLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nMxeM",
    name: "NavigationSearchDialogLoader",
    loader: async ()=>(await (parcelRequire("cpwGg"))).NavigationSearchDialog
});
const $eb2a5d9806ae71d8$export$79d13b60110f33be = ()=>{
    const $ = (0, $bDgLe.c)(11);
    const theme = (0, $4Ucqd.useLegacySearchTheme)();
    const [isQuickFindEnabled] = (0, $5bPOK.useQuickFindEnabled)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t0;
    if ($[0] !== renderServerPlaceholder || $[1] !== theme) {
        t0 = ()=>renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $73ee2b9bd33fd3e6$export$fa4a5af93371d2d1), {
                placeholder: "Search",
                advancedSearchUrl: `${(0, $jlIaF.CONTEXT_PATH)}/search`,
                shouldFillContainer: true
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eb2a5d9806ae71d8$var$NavigationSearchDialogLoader, {
                shouldFillContainer: true,
                theme: theme
            });
        $[0] = renderServerPlaceholder;
        $[1] = theme;
        $[2] = t0;
    } else t0 = $[2];
    const renderSearchBar = t0;
    const renderQuickFind = $eb2a5d9806ae71d8$var$_temp;
    const t1 = isQuickFindEnabled && $eb2a5d9806ae71d8$var$flexStyles;
    let t2;
    if ($[3] !== t1) {
        t2 = [
            $eb2a5d9806ae71d8$var$searchBarWrapper,
            t1
        ];
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== isQuickFindEnabled || $[6] !== renderSearchBar) {
        t3 = isQuickFindEnabled ? renderQuickFind() : renderSearchBar();
        $[5] = isQuickFindEnabled;
        $[6] = renderSearchBar;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t2 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t2
        }, t3);
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};
const $eb2a5d9806ae71d8$var$searchBarWrapper = (0, $buxP3.xcss)({
    position: 'relative',
    width: '100%',
    maxWidth: '780px'
});
const $eb2a5d9806ae71d8$var$flexStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center'
});
function $eb2a5d9806ae71d8$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fdb2500e60d25720$export$96939788a99e8cd1), null);
}
module.exports["SearchBar"] = $eb2a5d9806ae71d8$export$79d13b60110f33be;

});

parcelRegister("1lt9F", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6JxPX = parcelRequire("6JxPX");


var $c8XQL = parcelRequire("c8XQL");

const $f7991b42bf0bd305$export$6d53dccb772ed720 = /*#__PURE__*/ (0, $c8XQL.default)('input', {
    target: "e1tlzr8c0"
})("height:", (0, $6JxPX.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:var(--ds-radius-medium, 6px);font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);border:", ()=>`${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-input, #8C8F97)"}`, ";background-color:var(--ds-background-input, #FFFFFF);color:var(--ds-text-subtlest, #6B6E76);:hover{background-color:var(--ds-background-input-hovered, #F8F8F8);}:focus{color:var(--ds-text, #292A2E);box-shadow:", ()=>`inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${"var(--ds-border-input, #8C8F97)"}`, ";}@media screen and (max-width: ", (0, $6JxPX.dialogPageTakeoverWidth), "px){display:none;}");
module.exports["SSRsearchInputField"] = $f7991b42bf0bd305$export$6d53dccb772ed720;

});

parcelRegister("bdD4k", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6JxPX = parcelRequire("6JxPX");


var $c8XQL = parcelRequire("c8XQL");

const $2ba887e8a801c53b$export$b40f2abde293e8e4 = /*#__PURE__*/ (0, $c8XQL.default)('div', {
    target: "e1rxq6i70"
})("position:relative;max-width:100%;@media screen and (max-width: ", (0, $6JxPX.dialogPageTakeoverWidth), "px){width:100%;}width:", (props)=>{
    if (props.shouldFillContainer) return '100%';
    return 0, $6JxPX.collapsedSearchInputWidth;
}, ";");
module.exports["SSRsearchInputContainer"] = $2ba887e8a801c53b$export$b40f2abde293e8e4;

});

parcelRegister("6k4Fw", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6JxPX = parcelRequire("6JxPX");


var $c8XQL = parcelRequire("c8XQL");

const $d7f3083433951d0b$export$eb4e9f55bbe045df = /*#__PURE__*/ (0, $c8XQL.default)('span', {
    target: "ex7lok0"
})("width:", (0, $6JxPX.grid).multiple(2).px, ";height:", (0, $6JxPX.grid).multiple(2).px, ";position:absolute;top:", (0, $6JxPX.grid).px, ";left:", (0, $6JxPX.grid).px, ";color:rgb(107, 119, 140);display:inline-flex;align-items:baseline;@media screen and (max-width: ", (0, $6JxPX.dialogPageTakeoverWidth), "px){display:none;}");
module.exports["SSRdesktopSearchIconWrapper"] = $d7f3083433951d0b$export$eb4e9f55bbe045df;

});

parcelRegister("aqHiZ", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6JxPX = parcelRequire("6JxPX");


var $c8XQL = parcelRequire("c8XQL");

const $a4ce97ba8ad613d3$export$3f33ed4b273b43d = /*#__PURE__*/ (0, $c8XQL.default)('span', {
    target: "e12qszb40"
})("display:none;padding:", (0, $6JxPX.grid).multiple(0.5).px, ";padding-right:var(--ds-space-025, 2px);color:rgb(52, 69, 99);@media screen and (max-width: ", (0, $6JxPX.dialogPageTakeoverWidth), "px){display:flex;}");
module.exports["SSRmobileSearchIconWrapper"] = $a4ce97ba8ad613d3$export$3f33ed4b273b43d;

});

parcelRegister("6YETc", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $c8XQL = parcelRequire("c8XQL");

function $a350f8aa2787abfe$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a350f8aa2787abfe$export$58ae19ee1fc7be8a = /*#__PURE__*/ (0, $c8XQL.default)('div', {
    target: "ehrlot50"
})({
    name: "bjn8wh",
    styles: "position:relative"
});
module.exports["SSRformContainer"] = $a350f8aa2787abfe$export$58ae19ee1fc7be8a;

});

parcelRegister("1h7wg", function(module, exports) {

var $c8XQL = parcelRequire("c8XQL");

const $9c135e8f28886e6e$export$c47d4a3e1f1297f1 = /*#__PURE__*/ (0, $c8XQL.default)('div', {
    target: "e4ak8mg0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
(props)=>({
        position: 'relative',
        height: '32px',
        '@media screen and (min-width: 781px)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            minWidth: props.shouldFillContainer ? '100%' : '200px'
        }
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
(props)=>props.shouldFillContainer ? 'width: 100%;' : '');
module.exports["SSRsearchInputWrapper"] = $9c135e8f28886e6e$export$c47d4a3e1f1297f1;

});

parcelRegister("dbFea", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable */ const $dc46fd75db85fe8e$export$bc237d627614fc48 = `(function(document,window){var _a;var getWeakRef=function(queryId){var element=document.getElementById(queryId);if(!element){return null}return new WeakRef(element)};var currentInput=getWeakRef("ssr-search-input");var container=getWeakRef("ssr-input-container");var topContainer=getWeakRef("ssr-search-input-popout-container");var iconWrapper=getWeakRef("ssr-search-icon-wrapper");var formContainer=getWeakRef("ssr-form-container");var pageWidth=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;if(window["inputSkeletonState"]){for(var _i=0,_b=window["inputSkeletonState"].listeners;_i<_b.length;_i++){var listener=_b[_i];var target=listener[0],event_1=listener[1],handler=listener[2];target.removeEventListener(event_1,handler)}window["inputSkeletonState"].listeners=[]}function setExpandedStyles(){var _a,_b,_c,_d,_e,_f;(_a=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_a===void 0?void 0:_a.setAttribute("style","color: rgb(9, 30, 66);");if(pageWidth<=1130){(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_c=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_d=container===null||container===void 0?void 0:container.deref())===null||_d===void 0?void 0:_d.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}else{(_e=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_e===void 0?void 0:_e.setAttribute("style","position: absolute; right:0px; z-index:300;");(_f=container===null||container===void 0?void 0:container.deref())===null||_f===void 0?void 0:_f.setAttribute("style","width: 780px;")}}function resetInputSkeleton(){window["inputSkeletonState"]={query:"",placeholder:"",isFocused:false,selectionStart:0,selectionEnd:0,selectionDirection:"none",listeners:[]}}if(window["inputSkeletonState"]){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(window.inputSkeletonState.isFocused&&inputRef){inputRef.value=window.inputSkeletonState.query;inputRef.placeholder=window.inputSkeletonState.placeholder;inputRef.focus();inputRef.setSelectionRange(window.inputSkeletonState.selectionStart,window.inputSkeletonState.selectionEnd,window.inputSkeletonState.selectionDirection);setExpandedStyles()}}else{resetInputSkeleton()}var queryValue=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!queryValue){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){inputRef.value=queryValue}}var mediaQuery=window.matchMedia("(max-width: 1130px)");function handleSmallScreen(){var _a,_b,_c;if(window["inputSkeletonState"]){if(window.inputSkeletonState.isFocused){(_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_b=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}}}(_a=mediaQuery===null||mediaQuery===void 0?void 0:mediaQuery.addEventListener)===null||_a===void 0?void 0:_a.call(mediaQuery,"change",function(){return handleSmallScreen()});function changeHandler(e){var input=e.target;if(window.inputSkeletonState){window.inputSkeletonState.query=input===null||input===void 0?void 0:input.value;if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"){window.sessionStorage.setItem("atlassian.search-dialog-query",input.value)}var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none"}}}function focusHandler(e){if(window.inputSkeletonState){window.inputSkeletonState.isFocused=true;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.placeholder=inputRef.placeholder}}setExpandedStyles()}function blurClickHandler(e){var _a,_b,_c,_d,_e;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(!inputRef){return}if(currentInput&&e.target===inputRef&&window.inputSkeletonState){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none";if(!((_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.hasAttribute("style"))){window.inputSkeletonState.isFocused=true;setExpandedStyles()}}if(currentInput&&e.target!==inputRef){resetInputSkeleton();var sessionQuery=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!sessionQuery){inputRef.value=sessionQuery}else{inputRef.value=""}(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.removeAttribute("style");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.removeAttribute("style");(_d=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_d===void 0?void 0:_d.removeAttribute("style");inputRef.removeAttribute("style");(_e=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_e===void 0?void 0:_e.removeAttribute("style")}}function addListener(target,event,handler){var _a;target.addEventListener(event,handler);(_a=window===null||window===void 0?void 0:window.inputSkeletonState)===null||_a===void 0?void 0:_a.listeners.push([target,event,handler])}{var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){addListener(inputRef,"input",changeHandler);addListener(inputRef,"select",changeHandler);addListener(inputRef,"keydown",changeHandler);addListener(inputRef,"focus",focusHandler)}}addListener(document,"click",blurClickHandler)})(document,window);`;
module.exports["script"] = $dc46fd75db85fe8e$export$bc237d627614fc48;

});

parcelRegister("5bPOK", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

var $c6bf0727a21a02b6$export$2ad518e2a6db5d40 = /*#__PURE__*/ function(ExperimentParameterValues) {
    ExperimentParameterValues["CONTROL"] = "quick-find-control";
    ExperimentParameterValues["EXPERIMENT"] = "quick-find-experiment";
    ExperimentParameterValues["NOT_ENROLLED"] = "not-enrolled";
    return ExperimentParameterValues;
}({});
const $c6bf0727a21a02b6$export$b627fae0f53cc74b = 'confluence_frontend_quick_find';
const $c6bf0727a21a02b6$export$a5c820d7542f98bf = ()=>{
    const { isRovoEnabled: isRovoEnabledInTCS } = (0, $bQm3c.useSessionData)();
    // A user sees Quick Find if:
    // - They have Rovo or the FG for Unified Search beta (in development)
    // For now, the Rovo Opt Out also overrides the Unified Search FG
    // Opting out overrides all other checks
    if ((0, $9wGTI.fg)('confluence_rovo_search_opt_out')) return [
        false,
        null
    ];
    // A user sees Quick Find if:
    // - They have Rovo or the FG for Unified Search beta (in development)
    // For now, the Rovo Opt Out also overrides the Unified Search FG
    if (isRovoEnabledInTCS || (0, $9wGTI.fg)('unified_search_in_confluence')) return [
        true,
        {
            abTestId: $c6bf0727a21a02b6$export$b627fae0f53cc74b,
            controlId: "quick-find-control",
            experimentId: "quick-find-experiment"
        }
    ];
    if ((0, $6mKj3.expVal)('confluence_frontend_quick_find', 'cohort', 'not-enrolled') !== "not-enrolled") // this check ensures that we don't overwrite the /experiment API response for users who are not in the Quick Find experiment
    return [
        // today we are overriding the ab context only for quick find. In future when this becomes the standard we wouldnt need this condition
        (0, $6mKj3.expValEquals)('confluence_frontend_quick_find', 'cohort', 'quick-find-experiment'),
        {
            abTestId: $c6bf0727a21a02b6$export$b627fae0f53cc74b,
            controlId: "quick-find-control",
            experimentId: (0, $6mKj3.expVal)('confluence_frontend_quick_find', 'cohort', 'not-enrolled')
        }
    ];
    return [
        // today we are overriding the ab context only for quick find. In future when this becomes the standard we wouldnt need this condition
        (0, $6mKj3.expValEquals)('confluence_frontend_quick_find', 'cohort', 'quick-find-experiment'),
        null
    ];
};
module.exports["useQuickFindEnabled"] = $c6bf0727a21a02b6$export$a5c820d7542f98bf;

});

parcelRegister("j1oLb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6JrSr = parcelRequire("6JrSr");


var $2DhFV = parcelRequire("2DhFV");


var $6JEx2 = parcelRequire("6JEx2");


var $54yUd = parcelRequire("54yUd");


var $8BkJa = parcelRequire("8BkJa");


var $6s3PG = parcelRequire("6s3PG");




const $a00bd9859925d3e9$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    placeholder: {
        id: "search_dialog_aria_label",
        defaultMessage: "Search"
    }
});


if (!window.inputSkeletonState) (0, $2DhFV.resetInputSkeletonState)();
const $277856a4c9e14492$export$8f0d616c2469c6b6 = ({ onEnter: onEnter, isNav4Enabled: isNav4Enabled, injectValue: injectValue, customPlaceholder: customPlaceholder, inputRef: inputRef })=>{
    const dialogId = (0, $6JrSr.useId)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const initialSearchQuery = (0, $8BkJa.getInitialQuery)();
    // Use the stored state as initial values for expansion and query
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)((0, $2DhFV.getInputSkeletonFocus)());
    const [value, setValue] = (0, $cozmU.useState)(()=>injectValue ?? initialSearchQuery);
    const ghostTextData = (0, $cozmU.useMemo)(()=>(0, $6s3PG.parseGhostTextData)(customPlaceholder), [
        customPlaceholder
    ]);
    const onFocus = (e)=>{
        setIsExpanded(true);
        (0, $2DhFV.setInputSkeletonIsFocus)(true);
        const target = e.currentTarget;
        (0, $2DhFV.setInputSkeletonSelection)(target.selectionStart || 0, target.selectionEnd || 0, target.selectionDirection || 'none');
    };
    const onBlur = ()=>{
        setIsExpanded(false);
        (0, $2DhFV.setInputSkeletonIsFocus)(false);
        (0, $2DhFV.setInputSkeletonSelection)(0, 0, 'none');
    };
    const onKeyDown = (e)=>{
        const target = e.currentTarget;
        if (e.key === 'Escape') {
            target.blur();
            onBlur();
        }
    };
    const onChange = (e)=>{
        const newValue = e.currentTarget.value;
        setValue(newValue);
        (0, $2DhFV.setInputSkeletonQuery)(newValue);
        const target = e.currentTarget;
        (0, $2DhFV.setInputSkeletonSelection)(target.selectionStart || 0, target.selectionEnd || 0, target.selectionDirection || 'none');
        (0, $6JEx2.setSessionItem)((0, $6JEx2.SEARCH_QUERY_KEY), newValue);
    };
    const onSelect = (e)=>{
        const target = e.currentTarget;
        (0, $2DhFV.setInputSkeletonSelection)(target.selectionStart || 0, target.selectionEnd || 0, target.selectionDirection || 'none');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $54yUd.Textfield), {
        value: value,
        placeholder: ghostTextData?.text ?? formatMessage((0, $a00bd9859925d3e9$export$defe85febe8b728c).placeholder),
        dialogId: dialogId,
        quickFindOpen: isExpanded,
        onEnter: onEnter,
        onClick: onFocus,
        onFocus: onFocus,
        onBlur: onBlur,
        onSelect: onSelect,
        onKeyDown: onKeyDown,
        onChange: onChange,
        isNav4Enabled: isNav4Enabled,
        inputRef: inputRef
    });
};
module.exports["QuickFindSkeleton"] = $277856a4c9e14492$export$8f0d616c2469c6b6;

});

parcelRegister("2DhFV", function(module, exports) {
const $94ba7155083efffb$var$getWindow = ()=>typeof window !== 'undefined' ? window : null;
const $94ba7155083efffb$export$b8b6c2e7a0664212 = ()=>{
    return $94ba7155083efffb$var$getWindow()?.inputSkeletonState?.query ?? '';
};
const $94ba7155083efffb$export$baa1c819dd4691f3 = (newQuery)=>{
    const { inputSkeletonState: inputSkeletonState } = $94ba7155083efffb$var$getWindow() ?? {};
    if (inputSkeletonState) inputSkeletonState.query = newQuery;
};
const $94ba7155083efffb$export$38fcbc98be180790 = ()=>{
    return $94ba7155083efffb$var$getWindow()?.inputSkeletonState?.isFocused || false;
};
const $94ba7155083efffb$export$d3c6894b4e9af000 = (newIsFocused)=>{
    const { inputSkeletonState: inputSkeletonState } = $94ba7155083efffb$var$getWindow() ?? {};
    if (inputSkeletonState) inputSkeletonState.isFocused = newIsFocused;
};
const $94ba7155083efffb$export$a0c71b3bd9ec143c = ()=>{
    const { inputSkeletonState: inputSkeletonState } = $94ba7155083efffb$var$getWindow() ?? {};
    return {
        selectionStart: inputSkeletonState?.selectionStart ?? 0,
        selectionEnd: inputSkeletonState?.selectionEnd ?? 0,
        selectionDirection: inputSkeletonState?.selectionDirection ?? 'none'
    };
};
const $94ba7155083efffb$export$e0d745255b135363 = (newSelectionStart, newSelectionEnd, newSelectionDirection)=>{
    const { inputSkeletonState: inputSkeletonState } = $94ba7155083efffb$var$getWindow() ?? {};
    if (inputSkeletonState) {
        inputSkeletonState.selectionStart = newSelectionStart;
        inputSkeletonState.selectionEnd = newSelectionEnd;
        inputSkeletonState.selectionDirection = newSelectionDirection;
    }
};
const $94ba7155083efffb$export$c89dd2d5d4024c5e = ()=>{
    const safeWindow = $94ba7155083efffb$var$getWindow();
    if (safeWindow) safeWindow.inputSkeletonState = {
        query: '',
        placeholder: '',
        isFocused: false,
        selectionStart: 0,
        selectionEnd: 0,
        selectionDirection: 'none',
        listeners: []
    };
};
const $94ba7155083efffb$export$166ce39761ad7743 = ()=>{
    const { inputSkeletonState: inputSkeletonState } = $94ba7155083efffb$var$getWindow() ?? {};
    if (inputSkeletonState) {
        inputSkeletonState.listeners.forEach(([target, event, handler])=>{
            target.removeEventListener(event, handler);
        });
        inputSkeletonState.listeners = [];
    }
};
const $94ba7155083efffb$export$c830bcf42e072a93 = ()=>{
    $94ba7155083efffb$export$166ce39761ad7743();
    delete $94ba7155083efffb$var$getWindow()?.inputSkeletonState;
};
module.exports["getInputSkeletonQuery"] = $94ba7155083efffb$export$b8b6c2e7a0664212;
module.exports["setInputSkeletonQuery"] = $94ba7155083efffb$export$baa1c819dd4691f3;
module.exports["getInputSkeletonFocus"] = $94ba7155083efffb$export$38fcbc98be180790;
module.exports["setInputSkeletonIsFocus"] = $94ba7155083efffb$export$d3c6894b4e9af000;
module.exports["getInputSkeletonSelection"] = $94ba7155083efffb$export$a0c71b3bd9ec143c;
module.exports["setInputSkeletonSelection"] = $94ba7155083efffb$export$e0d745255b135363;
module.exports["resetInputSkeletonState"] = $94ba7155083efffb$export$c89dd2d5d4024c5e;
module.exports["removeInputSkeletonEventListeners"] = $94ba7155083efffb$export$166ce39761ad7743;
module.exports["removeInputSkeletonState"] = $94ba7155083efffb$export$c830bcf42e072a93;

});

parcelRegister("54yUd", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");


var $hAgam = parcelRequire("hAgam");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");

/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $jmUhx = parcelRequire("jmUhx");


var $4aRua = parcelRequire("4aRua");


var $kb3cs = parcelRequire("kb3cs");


var $ez9xU = parcelRequire("ez9xU");


var $dvVWp = parcelRequire("dvVWp");




const $cc78a1ecba052a23$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    connectAppsLabel: {
        id: "quick_find_connect_apps_label",
        defaultMessage: "Connect apps"
    },
    connectAppsButtonAriaLabel: {
        id: "quick_find_connect_apps_button_aria_label",
        defaultMessage: "Open app connections"
    }
});



var $fR63l = parcelRequire("fR63l");

const $cfe1029486d1631d$export$cf5dbd29f0fc9bcc = [
    (0, $fR63l.ProductKeys3P).GoogleDrive,
    (0, $fR63l.ProductKeys3P).Salesforce,
    (0, $fR63l.ProductKeys3P).Slack,
    (0, $fR63l.ProductKeys3P).Github,
    (0, $fR63l.ProductKeys3P).Figma
];





/**
 * Timing & easing constants for the Connect Apps animation.
 *
 * Single source of truth for both the JS phase machine
 * (`useConnectAppsAnimation`) and the CSS transitions in `index.tsx`.
 * Tests import these to derive total run time without hardcoding magic numbers.
 */ /** Duration of the pill background fade in/out at each end of the animation. */ const $03dea82ffc345606$export$db0699d3bbb5c21 = 200;
const $03dea82ffc345606$export$7ed54f99843287d = 350;
const $03dea82ffc345606$export$fad50bf971d7fa0e = 420;
const $03dea82ffc345606$export$9f0b035597bf40dd = 300;
const $03dea82ffc345606$export$cb49a8c4d0e244f2 = $03dea82ffc345606$export$fad50bf971d7fa0e + $03dea82ffc345606$export$9f0b035597bf40dd;
const $03dea82ffc345606$export$f5cb186d9c55308b = 1200;
const $03dea82ffc345606$export$cf94430de8ea1fba = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
const $03dea82ffc345606$export$3ded9395204bb852 = 'cubic-bezier(0.45, 0, 0.55, 1)';


const $3d81ffb8388c1d5b$export$58fbd07a68af8e16 = (phase)=>phase === 'bg-fade-in' || phase === 'sliding-out' || phase === 'icon-cycling' || phase === 'sliding-back';
const $3d81ffb8388c1d5b$export$918c1c59a77a7524 = (phase)=>phase === 'sliding-out' || phase === 'icon-cycling';
/** Maximum number of animation runs allowed per icon-component mount. */ const $3d81ffb8388c1d5b$var$MAX_STARTS = 2;
const $3d81ffb8388c1d5b$export$3fdaf24cc938081f = ({ start: start, sequenceLength: sequenceLength, canStart: canStart, onStart: onStart })=>{
    const [phase, setPhase] = (0, $cozmU.useState)('idle');
    const [activeIndex, setActiveIndex] = (0, $cozmU.useState)(0);
    const timersRef = (0, $cozmU.useRef)([]);
    const rafRef = (0, $cozmU.useRef)(null);
    const startCountRef = (0, $cozmU.useRef)(0);
    // Mirror `sequenceLength` in a ref so the start-effect can read the latest
    // value without re-firing whenever the prop reference changes. This prevents
    // an in-flight animation from being torn down + restarted (visually a "rewind")
    // and from incrementing the cooldown counter twice for the same play.
    const sequenceLengthRef = (0, $cozmU.useRef)(sequenceLength);
    sequenceLengthRef.current = sequenceLength;
    const cancelTimers = (0, $cozmU.useCallback)(()=>{
        timersRef.current.forEach(clearTimeout);
        timersRef.current = [];
        if (rafRef.current !== null) {
            cancelAnimationFrame(rafRef.current);
            rafRef.current = null;
        }
    }, []);
    const scheduleAfter = (0, $cozmU.useCallback)((delayMs, fn)=>{
        timersRef.current.push(setTimeout(fn, delayMs));
    }, []);
    const playReverseTail = (0, $cozmU.useCallback)(()=>{
        setActiveIndex(0);
        setPhase('sliding-back');
        scheduleAfter((0, $03dea82ffc345606$export$7ed54f99843287d), ()=>{
            setPhase('bg-fade-out');
            scheduleAfter((0, $03dea82ffc345606$export$db0699d3bbb5c21), ()=>setPhase('done'));
        });
    }, [
        scheduleAfter
    ]);
    const exitEarly = (0, $cozmU.useCallback)(()=>{
        cancelTimers();
        playReverseTail();
    }, [
        cancelTimers,
        playReverseTail
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!start) {
            cancelTimers();
            setPhase('idle');
            setActiveIndex(0);
            return;
        }
        // Cap the per-mount play count and consult the per-week cooldown.
        // Visual overlap between consecutive runs is prevented separately —
        // the parent must transition `start` back to `false` (the branch
        // above cancels in-flight timers + resets to `idle`) before raising
        // `start` again for the next play.
        if (startCountRef.current >= $3d81ffb8388c1d5b$var$MAX_STARTS || !canStart()) return;
        // We split the start over two animation frames so the DOM has enough
        // time to flush the idle styles before CSS transitions begin. Without
        // this, opening QuickFind during the initial render burst (e.g. mouse
        // already over QF on refresh) causes the pill to snap to bg-fade-in
        // and freeze because the transition has no painted "from" value.
        // Mirrors the canonical pattern in @atlaskit/motion (resizing, shrink-out).
        rafRef.current = requestAnimationFrame(()=>{
            rafRef.current = requestAnimationFrame(()=>{
                rafRef.current = null;
                // Consume the per-mount play slot and weekly cooldown only once
                // the animation actually begins. Done here (inside the inner rAF)
                // so a fast open-then-close in the ~16ms before paint cancels the
                // rAF without burning the user's budget.
                startCountRef.current += 1;
                onStart();
                // Snapshot the latest sequence length once per run so all
                // timeline math is internally consistent.
                const sequenceLength = sequenceLengthRef.current;
                // Build the full timeline up-front so forward & reverse share one schedule.
                const cycleStart = (0, $03dea82ffc345606$export$db0699d3bbb5c21) + (0, $03dea82ffc345606$export$7ed54f99843287d);
                const cycleDuration = (sequenceLength - 1) * (0, $03dea82ffc345606$export$cb49a8c4d0e244f2) + (0, $03dea82ffc345606$export$fad50bf971d7fa0e);
                const reverseStart = cycleStart + cycleDuration + (0, $03dea82ffc345606$export$f5cb186d9c55308b);
                const steps = [
                    {
                        atMs: 0,
                        apply: ()=>setPhase('bg-fade-in')
                    },
                    {
                        atMs: (0, $03dea82ffc345606$export$db0699d3bbb5c21),
                        apply: ()=>setPhase('sliding-out')
                    },
                    {
                        atMs: cycleStart,
                        apply: ()=>setPhase('icon-cycling')
                    }
                ];
                // Icon i (1..N-1) becomes active HOLD ms after icon-cycling starts,
                // then every ICON_STEP ms thereafter.
                for(let i = 1; i < sequenceLength; i++)steps.push({
                    atMs: cycleStart + (0, $03dea82ffc345606$export$fad50bf971d7fa0e) + (i - 1) * (0, $03dea82ffc345606$export$cb49a8c4d0e244f2),
                    apply: ()=>setActiveIndex(i)
                });
                steps.push({
                    atMs: reverseStart,
                    apply: ()=>{
                        setActiveIndex(0);
                        setPhase('sliding-back');
                    }
                }, {
                    atMs: reverseStart + (0, $03dea82ffc345606$export$7ed54f99843287d),
                    apply: ()=>setPhase('bg-fade-out')
                }, {
                    atMs: reverseStart + (0, $03dea82ffc345606$export$7ed54f99843287d) + (0, $03dea82ffc345606$export$db0699d3bbb5c21),
                    apply: ()=>setPhase('done')
                });
                steps.forEach(({ atMs: atMs, apply: apply })=>scheduleAfter(atMs, apply));
            });
        });
        return cancelTimers;
    // `sequenceLength` is intentionally omitted from the deps; it's read from
    // `sequenceLengthRef` inside the rAF callback so a mid-flight prop change
    // doesn't tear down + restart the animation (see comment on the ref above).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        start,
        canStart,
        onStart,
        cancelTimers,
        scheduleAfter
    ]);
    return {
        phase: phase,
        activeIndex: activeIndex,
        exitEarly: exitEarly
    };
};



var $lj9HS = parcelRequire("lj9HS");

const $6d8b7954f30f242e$var$MAX_APP_ICONS = 5;
const $6d8b7954f30f242e$var$STATIC_SEQUENCE = [
    {
        type: 'ads'
    },
    ...(0, $cfe1029486d1631d$export$cf5dbd29f0fc9bcc).map((slug)=>({
            type: 'img',
            slug: slug
        })),
    {
        type: 'ads'
    }
]; /**
     * Rank icons by smartlink usage from any 3P app that has a config (icon).
     * Backfill with the static fallback order, deduping.
     */ 
const $6d8b7954f30f242e$var$useIconSequence = (smartLinkUsage, thirdPartyConfigs)=>{
    return (0, $cozmU.useMemo)(()=>{
        if (!smartLinkUsage || !thirdPartyConfigs) return $6d8b7954f30f242e$var$STATIC_SEQUENCE;
        const rankedByUsage = Object.entries(smartLinkUsage).filter(([key])=>(0, $dvVWp.is3pProductKey)(key) && thirdPartyConfigs[key]?.icon).sort((a, b)=>b[1] - a[1]).map(([key])=>key);
        const seen = new Set(rankedByUsage);
        const backfill = (0, $cfe1029486d1631d$export$cf5dbd29f0fc9bcc).filter((key)=>!seen.has(key) && thirdPartyConfigs[key]?.icon);
        const combined = [
            ...rankedByUsage,
            ...backfill
        ].slice(0, $6d8b7954f30f242e$var$MAX_APP_ICONS);
        return [
            {
                type: 'ads'
            },
            ...combined.map((slug)=>({
                    type: 'img',
                    slug: slug
                })),
            {
                type: 'ads'
            }
        ];
    }, [
        smartLinkUsage,
        thirdPartyConfigs
    ]);
};
// --- Layout / styling constants -------------------------------------------
const $6d8b7954f30f242e$var$PILL_GAP_PX = 6;
const $6d8b7954f30f242e$var$PILL_HORIZONTAL_PADDING_PX = 8;
const $6d8b7954f30f242e$var$LABEL_MAX_WIDTH_PX = 160; // CSS strings cannot interpolate imported values (compiled `no-imported-style-values`),
// so we redeclare the durations here and assert they match `./timing` at compile time.
const $6d8b7954f30f242e$var$BG_DURATION_MS = 200;
const $6d8b7954f30f242e$var$SLIDE_DURATION_MS = 350;
const $6d8b7954f30f242e$var$FADE_DURATION_MS = 300;
const $6d8b7954f30f242e$var$EASE_PILL = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
const $6d8b7954f30f242e$var$EASE_ICON_CROSSFADE = 'cubic-bezier(0.45, 0, 0.55, 1)'; // Compile-time guard: drift between the timing module and the CSS values would
// silently desync animations and tests. This fails to typecheck if either side
// changes without the other.
const $6d8b7954f30f242e$var$_cssTimingMatchesTimingModule = [
    $6d8b7954f30f242e$var$BG_DURATION_MS,
    $6d8b7954f30f242e$var$SLIDE_DURATION_MS,
    $6d8b7954f30f242e$var$FADE_DURATION_MS
];
const $6d8b7954f30f242e$var$pillButtonStyles = null;
const $6d8b7954f30f242e$var$pillButtonElevatedStyles = null;
const $6d8b7954f30f242e$var$labelWrapperStyles = null;
const $6d8b7954f30f242e$var$iconStackStyles = null;
const $6d8b7954f30f242e$var$iconLayerStyles = null;
const $6d8b7954f30f242e$var$appsIconLayerStyles = null;
const $6d8b7954f30f242e$var$appIconWrapperStyles = null;
const $6d8b7954f30f242e$var$appIconInnerStyles = null; // --- Subcomponents --------------------------------------------------------
const $6d8b7954f30f242e$var$IconStack = ({ sequence: sequence, activeIndex: activeIndex, elevated: elevated, thirdPartyConfigs: thirdPartyConfigs })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_39xV02NHnM _0jFU0VNHnM _1mT5xdRAKS _3YEZNOdnbC _1pp6NdYbGa"
        ])
    }, sequence.map((entry, i)=>{
        const isActive = i === activeIndex;
        const key = entry.type === 'ads' ? `ads-${i}` : entry.slug;
        const Icon = entry.type === 'img' ? thirdPartyConfigs?.[entry.slug]?.icon : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            key: key,
            style: {
                opacity: isActive ? 1 : 0
            },
            className: (0, $hekY6.default)([
                "_49OCfRdnbC _23rrnHZRqI _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
            ])
        }, Icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                "_0bjKvDKTcp _4bt5LAnQyn _2WAcuGnQyn _30huDKba0w _39xV02oWWg _0jFU0VoWWg _24h04i2Njc _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbccYA"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            size: "small"
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d8b7954f30f242e$var$AdsIconCrossfade, {
            elevated: elevated
        }));
    })); /**
           * Crossfades between the inverse-color and subtle variants of the Apps icon
           * based on whether the pill is elevated. Both labels are empty because the
           * stack is decorative — accessibility comes from the button's `aria-label`.
           */ 
const $6d8b7954f30f242e$var$AdsIconCrossfade = ({ elevated: elevated })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            opacity: elevated ? 1 : 0
        },
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _23rrnHDC8A _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
        label: "",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            opacity: elevated ? 0 : 1
        },
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _23rrnHDC8A _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    })));
const $6d8b7954f30f242e$var$PillButton = ({ spanRef: spanRef, ariaLabel: ariaLabel, label: label, sequence: sequence, activeIndex: activeIndex, elevated: elevated, textOut: textOut, onClick: onClick, thirdPartyConfigs: thirdPartyConfigs })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ref: spanRef,
        role: "button",
        tabIndex: 0,
        onClick: (e)=>{
            e.stopPropagation();
            onClick();
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                onClick();
            }
        },
        "aria-label": ariaLabel,
        "data-testid": "quick-find-connect-apps-pill",
        style: {
            gap: textOut ? $6d8b7954f30f242e$var$PILL_GAP_PX : 0,
            paddingLeft: elevated ? $6d8b7954f30f242e$var$PILL_HORIZONTAL_PADDING_PX : 0
        },
        className: (0, $hekY6.default)([
            "_0bjKvDKTcp _2sNsIgOLYo _23rrnHbDiT _3hxITiYbGa _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _46hvQmdnbC _0xmtkodnbC _03SyCPdnbC _0wOv4Q7zJH _0KLXrujOvk _4EiLyUujt8 _34b3D2FQfX _1eOmH6o126",
            elevated && "_0KLXrugozt _1eOmH6kTlo"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": "true",
        style: {
            maxWidth: textOut ? $6d8b7954f30f242e$var$LABEL_MAX_WIDTH_PX : 0,
            opacity: textOut ? 1 : 0
        },
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _23rrnHBJlW _3iDTPbccYA _0hPCNLDIqT _1ANEUSLRg7 _20VacPYbGa _1pp6NdYbGa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "medium",
        color: "color.text.inverse"
    }, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d8b7954f30f242e$var$IconStack, {
        sequence: sequence,
        activeIndex: activeIndex,
        elevated: elevated,
        thirdPartyConfigs: thirdPartyConfigs
    })); // --- Public component -----------------------------------------------------
const $6d8b7954f30f242e$export$c3ce9d4249b1b4b1 = ({ start: start = false, onAppsClick: onAppsClick, spanRef: spanRef, cloudId: cloudId, primaryProduct: primaryProduct, smartLinkUsage: smartLinkUsage, thirdPartyConfigs: thirdPartyConfigs })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const sequence = $6d8b7954f30f242e$var$useIconSequence(smartLinkUsage, thirdPartyConfigs);
    const { canAnimate: canAnimate, recordAnimation: recordAnimation, dismissPermanently: dismissPermanently } = (0, $lj9HS.useConnectAppsCooldown)();
    const { phase: phase, activeIndex: activeIndex, exitEarly: exitEarly } = (0, $3d81ffb8388c1d5b$export$3fdaf24cc938081f)({
        start: start,
        sequenceLength: sequence.length,
        canStart: canAnimate,
        onStart: recordAnimation
    });
    const elevated = (0, $3d81ffb8388c1d5b$export$58fbd07a68af8e16)(phase);
    const textOut = (0, $3d81ffb8388c1d5b$export$918c1c59a77a7524)(phase);
    const renderPill = (openModal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d8b7954f30f242e$var$PillButton, {
            spanRef: spanRef,
            ariaLabel: formatMessage((0, $cc78a1ecba052a23$export$a7357cdd1f0b0168).connectAppsButtonAriaLabel),
            label: formatMessage((0, $cc78a1ecba052a23$export$a7357cdd1f0b0168).connectAppsLabel),
            sequence: sequence,
            activeIndex: activeIndex,
            elevated: elevated,
            textOut: textOut,
            thirdPartyConfigs: thirdPartyConfigs,
            onClick: ()=>{
                onAppsClick?.();
                openModal?.();
                dismissPermanently();
                if (textOut) exitEarly();
            }
        });
    if (cloudId && primaryProduct) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ez9xU.RovoSettingsModal), {
        product: primaryProduct,
        cloudId: cloudId,
        surface: (0, $kb3cs.RovoSettingsModalSurface).SEARCH_QF_PILL
    }, ({ open: open })=>renderPill(()=>open({
                defaultTab: 'discovery'
            })));
    return renderPill();
};








const $d1c7f4ffd6609d55$export$c3bd67ecc5ebe519 = ({ isExpanded: isExpanded, primaryColor: primaryColor = "var(--ds-text, #292A2E)", defaultColor: defaultColor = "var(--ds-text-subtlest, #6B6E76)", label: label = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
        label: label,
        // NOTE: color do not accept string type but here primaryColor is string, so need to use any
        color: isExpanded ? primaryColor : defaultColor
    });





const $3f97cbb295ca078b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    clearIconLabel: {
        id: "input_clear_icon_label",
        defaultMessage: "Clear search"
    },
    inputPlaceholder: {
        id: "input_placeholder",
        defaultMessage: "Search"
    },
    inputAriaLabel: {
        id: "input_aria_label",
        defaultMessage: "Search, press enter to navigate to advanced search with your text query"
    }
});


const $51c8dfbe23f03ecf$var$textFieldBoxBaseStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: 'size.300',
    ':focus': {
        height: 'size.400'
    },
    width: '100%',
    paddingRight: 'space.200'
});
const $51c8dfbe23f03ecf$var$textFieldBoxStyles = (0, $buxP3.xcss)({
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $51c8dfbe23f03ecf$var$textFieldBoxStylesT26Shape = (0, $buxP3.xcss)({
    borderRadius: 'radius.medium'
});
const $51c8dfbe23f03ecf$var$textFieldBoxFocusedStyles = (0, $buxP3.xcss)({
    height: 'size.400',
    border: 'none',
    paddingRight: '0'
});
const $51c8dfbe23f03ecf$var$textFieldBoxFocusedElevationStyles = (0, $buxP3.xcss)({
    boxShadow: 'elevation.shadow.overlay'
});
const $51c8dfbe23f03ecf$var$textFieldInDialogStyles = (0, $buxP3.xcss)({
    marginTop: 'space.075',
    position: 'relative',
    zIndex: 'layer'
});
const $51c8dfbe23f03ecf$var$inputStyles = null;
const $51c8dfbe23f03ecf$var$inputFocusedStyles = null;
const $51c8dfbe23f03ecf$var$iconWrapperStyles = (0, $buxP3.xcss)({
    minWidth: 'size.300',
    minHeight: 'size.300',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'color.text.subtlest'
});
const $51c8dfbe23f03ecf$var$iconWrapperFocusedStyles = (0, $buxP3.xcss)({
    marginInlineStart: 'space.200',
    marginInlineEnd: 'space.150',
    minWidth: 'size.200'
});
const $51c8dfbe23f03ecf$var$clearIconFadeInAnimation = null;
const $51c8dfbe23f03ecf$var$clearIconFadeInWrapperStyles = null; // Styles for the trailing Connect Apps icon slot.
const $51c8dfbe23f03ecf$var$connectAppsIconStyles = (0, $buxP3.xcss)({
    marginRight: 'space.050',
    display: 'flex',
    alignItems: 'center'
}); // When QuickFind is open, align the pill with where the close icon sits.
const $51c8dfbe23f03ecf$var$connectAppsIconOpenStyles = (0, $buxP3.xcss)({
    marginRight: 'space.100'
});
const $51c8dfbe23f03ecf$var$textFieldBoxNoRightPaddingStyles = (0, $buxP3.xcss)({
    paddingRight: 'space.0'
}); // Nav3 style overrides
// Can be removed once all supported products use Nav4
const $51c8dfbe23f03ecf$var$nav3StyleOverrides = {
    textFieldBoxStyles: (0, $buxP3.xcss)({
        borderColor: 'color.border.input',
        backgroundColor: 'color.background.input',
        borderRadius: 'radius.medium',
        width: '200px'
    }),
    textFieldBoxFocusedStyles: (0, $buxP3.xcss)({
        backgroundColor: 'elevation.surface.overlay',
        borderRadius: 'radius.large',
        width: '780px'
    }),
    iconWrapperStyles: (0, $buxP3.xcss)({
        minWidth: '30px'
    }),
    inputStyles: null
};
const $51c8dfbe23f03ecf$export$d66ddc2063fc70a7 = ({ value: value, dialogId: dialogId, quickFindOpen: quickFindOpen, isNav4Enabled: isNav4Enabled, onEnter: onEnter, onFocus: onFocus, onBlur: onBlur, onSelect: onSelect, onKeyDown: onKeyDown, onChange: onChange, onClick: onClick, onClear: onClear, onAppsClick: onAppsClick, inputRef: inputRef, clearIconRef: clearIconRef, placeholder: placeholder, intentRouterEnabled: intentRouterEnabled, activeDescendantId: activeDescendantId, cloudId: cloudId, primaryProduct: primaryProduct, smartLinkUsage: smartLinkUsage, thirdPartyConfigs: thirdPartyConfigs })=>{
    const intl = (0, $kSwu1.useIntl)();
    const handleKeyDown = (e)=>{
        if (!e.defaultPrevented && e.key === 'Enter') {
            e.preventDefault();
            onEnter && onEnter(e);
        }
        if (typeof onKeyDown === 'function') onKeyDown(e);
    };
    const clearIconButton = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        ref: clearIconRef,
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)",
                label: ""
            }),
        spacing: 'compact',
        onClick: onClear,
        label: intl.formatMessage((0, $3f97cbb295ca078b$export$defe85febe8b728c).clearIconLabel),
        appearance: "subtle",
        testId: "search-input-clear-button"
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        xcss: [
            $51c8dfbe23f03ecf$var$textFieldBoxBaseStyles,
            (!intentRouterEnabled || !quickFindOpen) && $51c8dfbe23f03ecf$var$textFieldBoxStyles,
            intentRouterEnabled && quickFindOpen && $51c8dfbe23f03ecf$var$textFieldInDialogStyles,
            (0, $iDrrr.fg)('platform-dst-shape-theme-default') && $51c8dfbe23f03ecf$var$textFieldBoxStylesT26Shape,
            quickFindOpen ? $51c8dfbe23f03ecf$var$textFieldBoxFocusedStyles : false,
            !intentRouterEnabled && quickFindOpen && $51c8dfbe23f03ecf$var$textFieldBoxFocusedElevationStyles,
            !isNav4Enabled && $51c8dfbe23f03ecf$var$nav3StyleOverrides.textFieldBoxStyles,
            !isNav4Enabled && quickFindOpen && $51c8dfbe23f03ecf$var$nav3StyleOverrides.textFieldBoxFocusedStyles,
            $51c8dfbe23f03ecf$var$textFieldBoxNoRightPaddingStyles
        ],
        onClick: (e)=>{
            // React's synthetic events bubble through the JSX tree, not the DOM. The Rovo
            // Settings modal is a portal, so clicks inside it bubble to this onClick even
            // though they're outside this DOM subtree. Guard against that here, otherwise
            // closing the modal re-focuses the input and reopens Quick Find.
            if (!e.currentTarget.contains(e.target)) return;
            inputRef?.current?.click();
            inputRef?.current?.focus();
        },
        testId: "search-input-container",
        role: "search"
    }, /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        xcss: [
            $51c8dfbe23f03ecf$var$iconWrapperStyles,
            quickFindOpen && $51c8dfbe23f03ecf$var$iconWrapperFocusedStyles,
            !isNav4Enabled && $51c8dfbe23f03ecf$var$nav3StyleOverrides.iconWrapperStyles
        ]
    }, isNav4Enabled || quickFindOpen ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
        color: "currentColor",
        label: "",
        "aria-hidden": "true"
    }) : /*#__PURE__*/ $cozmU.createElement((0, $d1c7f4ffd6609d55$export$c3bd67ecc5ebe519), {
        isExpanded: !!quickFindOpen
    })), /*#__PURE__*/ $cozmU.createElement("input", {
        ref: inputRef,
        onFocus: onFocus,
        onBlur: onBlur,
        onSelect: onSelect,
        onKeyDown: handleKeyDown,
        onClick: onClick,
        placeholder: placeholder || intl.formatMessage((0, $3f97cbb295ca078b$export$defe85febe8b728c).inputPlaceholder),
        onChange: onChange,
        value: value,
        "data-testid": "search-input",
        autoComplete: "off",
        "aria-label": intl.formatMessage((0, $3f97cbb295ca078b$export$defe85febe8b728c).inputAriaLabel),
        "aria-expanded": quickFindOpen,
        "aria-controls": dialogId,
        "aria-activedescendant": activeDescendantId ?? '',
        "aria-haspopup": "true",
        role: "combobox",
        className: (0, $hekY6.default)([
            "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _2uo31fYbGa _2sNsIgmnOE _30huDKYbGa _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _4bt5LAnQyn _2WAcuGnQyn _1UtDYzKGUX _39xV02N91d _39HuIbz8Lp _1ANEUSLRg7 _3AxjleKGUX",
            quickFindOpen && "_1UtDYzy7kJ",
            !isNav4Enabled && "_2sNsIgmnOE"
        ])
    }), quickFindOpen && value && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2fBhtei355 _0adFHs2ADO _3Y6bKpgRhm"
        ])
    }, clearIconButton), /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        xcss: [
            $51c8dfbe23f03ecf$var$connectAppsIconStyles,
            quickFindOpen && $51c8dfbe23f03ecf$var$connectAppsIconOpenStyles
        ]
    }, /*#__PURE__*/ $cozmU.createElement((0, $6d8b7954f30f242e$export$c3ce9d4249b1b4b1), {
        start: quickFindOpen && !!thirdPartyConfigs,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        smartLinkUsage: smartLinkUsage,
        thirdPartyConfigs: thirdPartyConfigs,
        onAppsClick: onAppsClick
    }))));
};
module.exports["Textfield"] = $51c8dfbe23f03ecf$export$d66ddc2063fc70a7;

});

parcelRegister("8BkJa", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2DhFV = parcelRequire("2DhFV");

// The query is stored in module scope to persist across remounts
let $9cd8e20c023d2b12$var$initialQueryValue;
const $9cd8e20c023d2b12$export$ed7270bd966434af = (searchQueryParams)=>{
    const stickySearch = $9cd8e20c023d2b12$var$initialQueryValue;
    return searchQueryParams || stickySearch || (0, $2DhFV.getInputSkeletonQuery)() || '';
};
const $9cd8e20c023d2b12$export$67de3a75cbe82e14 = ({ localQuery: localQuery, inputRef: inputRef })=>{
    // Focus input if skeleton is focused
    (0, $cozmU.useEffect)(()=>{
        const skeletonFocused = (0, $2DhFV.getInputSkeletonFocus)();
        if (skeletonFocused) {
            const input = inputRef?.current;
            if (input) {
                input.focus();
                input.click();
                const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, $2DhFV.getInputSkeletonSelection)();
                input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
            }
        }
        (0, $2DhFV.removeInputSkeletonState)();
    }, [
        inputRef
    ]);
    // Push local query to session storage
    (0, $cozmU.useEffect)(()=>{
        // Update the module-scoped variable to make it available for remounts
        $9cd8e20c023d2b12$var$initialQueryValue = localQuery;
    }, [
        localQuery
    ]);
};
module.exports["getInitialQuery"] = $9cd8e20c023d2b12$export$ed7270bd966434af;
module.exports["useInputSkeleton"] = $9cd8e20c023d2b12$export$67de3a75cbe82e14;

});

parcelRegister("6s3PG", function(module, exports) {

var $kqM1N = parcelRequire("kqM1N");

var $9863b5a56454bfb2$export$6891b88a23696d = /*#__PURE__*/ function(GhostTextExperimentCohort) {
    GhostTextExperimentCohort["CONTROL"] = "control";
    GhostTextExperimentCohort["THREE_P"] = "3p";
    return GhostTextExperimentCohort;
}({});
const $9863b5a56454bfb2$export$73fd7fc6fed7f9d9 = 3;
const $9863b5a56454bfb2$export$bd8829925eef3cc2 = (customPlaceholder)=>{
    if (!customPlaceholder) return undefined;
    try {
        const result = (0, $kqM1N.GhostTextDataV2Schema).safeParse(JSON.parse(customPlaceholder));
        if (result.success) return result.data;
        return undefined;
    } catch  {
        return undefined;
    }
};
module.exports["GhostTextExperimentCohort"] = $9863b5a56454bfb2$export$6891b88a23696d;
module.exports["ROTATION_THRESHOLD"] = $9863b5a56454bfb2$export$73fd7fc6fed7f9d9;
module.exports["parseGhostTextData"] = $9863b5a56454bfb2$export$bd8829925eef3cc2;

});

parcelRegister("kysoj", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $9a64fd0ce05b42e8$export$3977b992ec7f3f3b = (inputRef)=>{
    let ghostText;
    const searchInput = inputRef?.current;
    if (typeof HTMLInputElement !== 'undefined' && searchInput instanceof HTMLInputElement && searchInput?.placeholder) ghostText = searchInput.placeholder;
    // If found in DOM/ref and valid, use it
    if (ghostText && ghostText.length > 0) return ghostText;
    return (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_PLATFORM_QUICKFIND_GHOSTTEXT);
};
module.exports["getPersistedGhostText"] = $9a64fd0ce05b42e8$export$3977b992ec7f3f3b;

});

parcelRegister("Mb4xU", function(module, exports) {

let $090d128ab8a37dbb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $090d128ab8a37dbb$var$load("kSgPY"),
    $090d128ab8a37dbb$var$load("2la9m"),
    $090d128ab8a37dbb$var$load("9pQri"),
    $090d128ab8a37dbb$var$load("1f0Jg"),
    $090d128ab8a37dbb$var$load("aQ52k"),
    $090d128ab8a37dbb$var$load("35Mi3"),
    $090d128ab8a37dbb$var$load("fHb94"),
    $090d128ab8a37dbb$var$load("llPQO"),
    $090d128ab8a37dbb$var$load("6wr18"),
    $090d128ab8a37dbb$var$load("wSRKD"),
    $090d128ab8a37dbb$var$load("7BGZT"),
    $090d128ab8a37dbb$var$load("jSDsV"),
    $090d128ab8a37dbb$var$load("aPaBe"),
    $090d128ab8a37dbb$var$load("4AElS"),
    $090d128ab8a37dbb$var$load("hhss7"),
    $090d128ab8a37dbb$var$load("ffEVr"),
    $090d128ab8a37dbb$var$load("9BBvG"),
    $090d128ab8a37dbb$var$load("6iaIB"),
    $090d128ab8a37dbb$var$load("cYv6T"),
    $090d128ab8a37dbb$var$load("11yNG"),
    $090d128ab8a37dbb$var$load("gQYVn"),
    $090d128ab8a37dbb$var$load("9RGBF"),
    $090d128ab8a37dbb$var$load("2iL13"),
    $090d128ab8a37dbb$var$load("cpTbC"),
    $090d128ab8a37dbb$var$load("fhT77"),
    $090d128ab8a37dbb$var$load("jvUhP"),
    $090d128ab8a37dbb$var$load("7sOKp"),
    $090d128ab8a37dbb$var$load("7Ysw6"),
    $090d128ab8a37dbb$var$load("3xL2F"),
    $090d128ab8a37dbb$var$load("kMyku"),
    $090d128ab8a37dbb$var$load("hG1ar"),
    $090d128ab8a37dbb$var$load("5d2zd"),
    $090d128ab8a37dbb$var$load("7zQG2"),
    $090d128ab8a37dbb$var$load("dq8fV"),
    $090d128ab8a37dbb$var$load("h7ECu"),
    $090d128ab8a37dbb$var$load("3gK8W"),
    $090d128ab8a37dbb$var$load("bwLq7"),
    $090d128ab8a37dbb$var$load("fH3TJ"),
    $090d128ab8a37dbb$var$load("Wowvf"),
    $090d128ab8a37dbb$var$load("2l8zo"),
    $090d128ab8a37dbb$var$load("7EorR"),
    $090d128ab8a37dbb$var$load("lkRpX")
]).then(()=>parcelRequire('4jplB'));

});

parcelRegister("cpwGg", function(module, exports) {

let $90912b83cb4096ac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $90912b83cb4096ac$var$load("gD8Xs"),
    $90912b83cb4096ac$var$load("6bCkf"),
    $90912b83cb4096ac$var$load("cM2Sb"),
    $90912b83cb4096ac$var$load("1GCFv"),
    $90912b83cb4096ac$var$load("GkwJK"),
    $90912b83cb4096ac$var$load("gkVge"),
    $90912b83cb4096ac$var$load("aaRXj"),
    $90912b83cb4096ac$var$load("4QwAJ"),
    $90912b83cb4096ac$var$load("3i44s"),
    $90912b83cb4096ac$var$load("geXPZ"),
    $90912b83cb4096ac$var$load("kSgPY"),
    $90912b83cb4096ac$var$load("2la9m"),
    $90912b83cb4096ac$var$load("9pQri"),
    $90912b83cb4096ac$var$load("1f0Jg"),
    $90912b83cb4096ac$var$load("aQ52k"),
    $90912b83cb4096ac$var$load("35Mi3"),
    $90912b83cb4096ac$var$load("fHb94"),
    $90912b83cb4096ac$var$load("llPQO"),
    $90912b83cb4096ac$var$load("6wr18"),
    $90912b83cb4096ac$var$load("wSRKD"),
    $90912b83cb4096ac$var$load("7BGZT"),
    $90912b83cb4096ac$var$load("jSDsV"),
    $90912b83cb4096ac$var$load("aPaBe"),
    $90912b83cb4096ac$var$load("4AElS"),
    $90912b83cb4096ac$var$load("hhss7"),
    $90912b83cb4096ac$var$load("ffEVr"),
    $90912b83cb4096ac$var$load("9BBvG"),
    $90912b83cb4096ac$var$load("6iaIB"),
    $90912b83cb4096ac$var$load("cYv6T"),
    $90912b83cb4096ac$var$load("11yNG"),
    $90912b83cb4096ac$var$load("gQYVn"),
    $90912b83cb4096ac$var$load("9RGBF"),
    $90912b83cb4096ac$var$load("2iL13"),
    $90912b83cb4096ac$var$load("cpTbC"),
    $90912b83cb4096ac$var$load("fhT77"),
    $90912b83cb4096ac$var$load("jvUhP"),
    $90912b83cb4096ac$var$load("7sOKp"),
    $90912b83cb4096ac$var$load("7Ysw6"),
    $90912b83cb4096ac$var$load("3xL2F"),
    $90912b83cb4096ac$var$load("kMyku"),
    $90912b83cb4096ac$var$load("hG1ar"),
    $90912b83cb4096ac$var$load("5d2zd"),
    $90912b83cb4096ac$var$load("7zQG2"),
    $90912b83cb4096ac$var$load("dq8fV"),
    $90912b83cb4096ac$var$load("h7ECu"),
    $90912b83cb4096ac$var$load("3gK8W"),
    $90912b83cb4096ac$var$load("bwLq7"),
    $90912b83cb4096ac$var$load("fH3TJ"),
    $90912b83cb4096ac$var$load("Wowvf"),
    $90912b83cb4096ac$var$load("2l8zo"),
    $90912b83cb4096ac$var$load("lkRpX"),
    $90912b83cb4096ac$var$load("7EorR"),
    $90912b83cb4096ac$var$load("iI96V")
]).then(()=>parcelRequire('2vmwN'));

});

parcelRegister("cAMBp", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $blg7q = parcelRequire("blg7q");


var $8lt5O = parcelRequire("8lt5O");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $6mKj3 = parcelRequire("6mKj3");

const $a043f210edc9881e$export$268af8ca93822c63 = ()=>{
    const $ = (0, $bDgLe.c)(10);
    const { isLoggedIn: isLoggedIn, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isRovoEnabled = isRovoLLMEnabled && isLoggedIn && accessStatus !== (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
    let t0;
    let t1;
    if ($[0] !== isRovoEnabled) {
        t0 = ()=>{
            if (isRovoEnabled) (0, $6mKj3.expValEquals)("cc-aifc-databases-experiment", "isEnabled", true);
        };
        t1 = [
            isRovoEnabled
        ];
        $[0] = isRovoEnabled;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[3] !== isRovoEnabled) {
        t2 = isRovoEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $blg7q.ConversationAssistantNavBarButton), null);
        $[3] = isRovoEnabled;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== isRovoEnabled) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt5O.RovoEntitlementSetter), {
            isRovoEnabled: isRovoEnabled
        });
        $[5] = isRovoEnabled;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2, t3);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
};
module.exports["RovoButton"] = $a043f210edc9881e$export$268af8ca93822c63;

});

parcelRegister("2iFcu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $de8408b1e5a725a9$export$55f0a642b785fb1f = /*#__PURE__*/ (0, $cozmU.createContext)((0, $dpsRj.default));
module.exports["TopNavStartAttachRef"] = $de8408b1e5a725a9$export$55f0a642b785fb1f;

});

parcelRegister("f8DhE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $76fa10f58a0e09dc$export$e4314fea1a98d918 = /*#__PURE__*/ (0, $cozmU.createContext)(true);
module.exports["HasDefaultBackgroundColorContext"] = $76fa10f58a0e09dc$export$e4314fea1a98d918;

});

parcelRegister("fb5K7", function(module, exports) {
const $6b3668d5de18e4cb$export$83179404a61b001a = 'FetchError';
class $6b3668d5de18e4cb$export$26e841bcf1aeb894 extends Error {
    static isFetchError(value) {
        return value instanceof $6b3668d5de18e4cb$export$26e841bcf1aeb894;
    }
    constructor(message, status){
        super(message);
        this.status = void 0;
        this.name = $6b3668d5de18e4cb$export$83179404a61b001a;
        this.status = status;
    }
}
module.exports["FETCH_ERROR_NAME"] = $6b3668d5de18e4cb$export$83179404a61b001a;
module.exports["FetchError"] = $6b3668d5de18e4cb$export$26e841bcf1aeb894;

});

parcelRegister("bOMi3", function(module, exports) {
const $1954a3f70857e57b$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $1954a3f70857e57b$export$1d94629c94e7a17f = async (invokeOperation, config)=>{
    let nextMSInterval = 0;
    let error = new Error('No calls made');
    const retries = config.intervalsMS.length;
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) {
            await $1954a3f70857e57b$export$5c069c93d2b7493f(nextMSInterval);
            if (config.onRetry) config.onRetry(error, retries - config.intervalsMS.length);
        }
        return await invokeOperation();
    } catch (e) {
        error = e;
        if (config.shouldRetryOnException && !config.shouldRetryOnException(error)) throw error;
        nextMSInterval = config.intervalsMS.shift();
    }
    throw error;
};
module.exports["retryOnException"] = $1954a3f70857e57b$export$1d94629c94e7a17f;

});

parcelRegister("veDrf", function(module, exports) {
const $8c29506b05721e02$var$packageName = "platform-pkg";
const $8c29506b05721e02$var$packageVersion = "0.0.0-use.local";
const $8c29506b05721e02$var$_default_1 = {
    packageName: $8c29506b05721e02$var$packageName,
    packageVersion: $8c29506b05721e02$var$packageVersion
};
var $8c29506b05721e02$export$2e2bcd8739ae039 = $8c29506b05721e02$var$_default_1;
module.exports["default"] = $8c29506b05721e02$export$2e2bcd8739ae039;

});

parcelRegister("3ezGS", function(module, exports) {

var $eeq36 = parcelRequire("eeq36");


var $ellLO = parcelRequire("ellLO");

const $0e65254580b7155f$export$62986affcccd56a5 = ()=>Promise.resolve({
        sites: undefined
    });
const $0e65254580b7155f$export$c3b6af53f1ca17d8 = (fetchData = $0e65254580b7155f$export$62986affcccd56a5, retryConfig)=>{
    return (0, $eeq36.createProviderWithCustomFetchData)('joinableSites', (0, $ellLO.ExperienceMark).API_JOINABLE_SITES, fetchData, retryConfig);
};
module.exports["createJoinableSitesProvider"] = $0e65254580b7155f$export$c3b6af53f1ca17d8;

});

parcelRegister("9QZAl", function(module, exports) {
function $96bbfe81b96031d5$export$a3e288208721751b(error) {
    const { name: name = 'Unknown', status: status } = error || {};
    return {
        name: name,
        status: status
    };
}
module.exports["errorToReason"] = $96bbfe81b96031d5$export$a3e288208721751b;

});

parcelRegister("2YXPz", function(module, exports) {
const $e0a6c86fadf3862a$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
const $e0a6c86fadf3862a$export$854b45b62d1eb6d4 = 'auto';
const $e0a6c86fadf3862a$export$2faeed762aac6741 = {
    dark: 'dark',
    light: 'light',
    colorMode: $e0a6c86fadf3862a$export$854b45b62d1eb6d4,
    typography: 'typography'
};


const $70c30e145a1986eb$export$830acc849806885d = (themeObject)=>({
        ...(0, $e0a6c86fadf3862a$export$2faeed762aac6741),
        ...themeObject
    });
module.exports["updateThemeObjectWithDefaultValues"] = $70c30e145a1986eb$export$830acc849806885d;

});

parcelRegister("4Ucqd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $6cyWf = parcelRequire("6cyWf");

const $becf12de66cccc0b$export$ae6fbf5ba3a7a784 = '--ds-top-bar-search-border';
const $becf12de66cccc0b$export$ee42b8430f4c19bd = '--ds-top-bar-search-border-focused';
/**
 * Theme object intended for use with Search Platform components while transitioning to nav4.
 *
 * This is for backwards compatibility with the legacy theming API that was designed for nav3.
 *
 * As nav4 matures we will ideally evolve the theming solution inside Search Platform,
 * at which point this legacy theme object will not be needed.
 */ const $becf12de66cccc0b$var$legacySearchTheme = {
    default: {
        backgroundColor: 'transparent',
        color: 'currentColor',
        borderColor: `var(${$becf12de66cccc0b$export$ae6fbf5ba3a7a784})`
    },
    focus: {
        /**
     * When expanded the input ignores the custom theme,
     * except for its border which is derived from the highlight color.
     */ color: "var(--ds-text, #292A2E)",
        backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
        borderColor: `var(${$becf12de66cccc0b$export$ee42b8430f4c19bd})`,
        boxShadow: `inset 0px 0px 0px 1px var(${$becf12de66cccc0b$export$ee42b8430f4c19bd})`
    },
    hover: {
        /**
     * This is not actually used for the search bar input (at least by the Search Platform components).
     *
     * Instead it's used as the hover background color for a close button when on mobile.
     */ backgroundColor: `var(--ds-top-bar-button-background-hovered)`
    }
};
const $becf12de66cccc0b$export$18a29b1ed2212823 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useLegacySearchTheme() {
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    if (hasCustomTheme) return $becf12de66cccc0b$var$legacySearchTheme;
} : function useLegacySearchTheme() {
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    if (hasCustomTheme) return $becf12de66cccc0b$var$legacySearchTheme;
    return undefined;
};
module.exports["themedSearchBorder"] = $becf12de66cccc0b$export$ae6fbf5ba3a7a784;
module.exports["themedSearchBorderFocused"] = $becf12de66cccc0b$export$ee42b8430f4c19bd;
module.exports["useLegacySearchTheme"] = $becf12de66cccc0b$export$18a29b1ed2212823;

});

parcelRegister("kqM1N", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $de9c8fa4a4564ad0$export$9bcc9fe305679f00 = (0, $87Lnp.z).object({
    /** Unique key identifying the current ghost text set */ id: (0, $87Lnp.z).string(),
    /** Locale of the ghost text */ locale: (0, $87Lnp.z).string(),
    /** The placeholder text to display */ text: (0, $87Lnp.z).string(),
    /** Number of times this text has been shown (0-2, resets after 3) */ occurrence: (0, $87Lnp.z).number().optional().default(0)
});
module.exports["GhostTextDataV2Schema"] = $de9c8fa4a4564ad0$export$9bcc9fe305679f00;

});


//# sourceMappingURL=PageLayout.71ec5453.js.map
